const features = [
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4OBJLual30L7gRl5UkeRcT" },
						href: "https://api.spotify.com/v1/artists/4OBJLual30L7gRl5UkeRcT",
						id: "4OBJLual30L7gRl5UkeRcT",
						name: "T.I.",
						type: "artist",
						uri: "spotify:artist:4OBJLual30L7gRl5UkeRcT"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/46VWDbmWmzvPBTmkSr25gM" },
						href: "https://api.spotify.com/v1/artists/46VWDbmWmzvPBTmkSr25gM",
						id: "46VWDbmWmzvPBTmkSr25gM",
						name: "Marsha Ambrosius",
						type: "artist",
						uri: "spotify:artist:46VWDbmWmzvPBTmkSr25gM"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1JhAKVxvY2sJR5OfmhyPgb" },
				href: "https://api.spotify.com/v1/albums/1JhAKVxvY2sJR5OfmhyPgb",
				id: "1JhAKVxvY2sJR5OfmhyPgb",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27342dae3af78d32f195bc94e31", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0242dae3af78d32f195bc94e31", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485142dae3af78d32f195bc94e31", width: 64 }
				],
				name: "DOPE",
				release_date: "2016-05-16",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1JhAKVxvY2sJR5OfmhyPgb"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4OBJLual30L7gRl5UkeRcT" },
					href: "https://api.spotify.com/v1/artists/4OBJLual30L7gRl5UkeRcT",
					id: "4OBJLual30L7gRl5UkeRcT",
					name: "T.I.",
					type: "artist",
					uri: "spotify:artist:4OBJLual30L7gRl5UkeRcT"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/46VWDbmWmzvPBTmkSr25gM" },
					href: "https://api.spotify.com/v1/artists/46VWDbmWmzvPBTmkSr25gM",
					id: "46VWDbmWmzvPBTmkSr25gM",
					name: "Marsha Ambrosius",
					type: "artist",
					uri: "spotify:artist:46VWDbmWmzvPBTmkSr25gM"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 271000,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QZ2UA1600003" },
			external_urls: { spotify: "https://open.spotify.com/track/2MjPYefrQPVzIkTbDat5YG" },
			href: "https://api.spotify.com/v1/tracks/2MjPYefrQPVzIkTbDat5YG",
			id: "2MjPYefrQPVzIkTbDat5YG",
			is_local: false,
			name: "DOPE",
			popularity: 39,
			preview_url: "https://p.scdn.co/mp3-preview/199a1052bd1edb8ebb935ab167b9032f5b0feb0b?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2MjPYefrQPVzIkTbDat5YG"
		},
		features: {
			danceability: 0.654,
			energy: 0.818,
			key: 5,
			loudness: -4.944,
			mode: 0,
			speechiness: 0.296,
			acousticness: 0.00949,
			instrumentalness: 0,
			liveness: 0.0652,
			valence: 0.564,
			tempo: 95,
			type: "audio_features",
			id: "2MjPYefrQPVzIkTbDat5YG",
			uri: "spotify:track:2MjPYefrQPVzIkTbDat5YG",
			track_href: "https://api.spotify.com/v1/tracks/2MjPYefrQPVzIkTbDat5YG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2MjPYefrQPVzIkTbDat5YG",
			duration_ms: 271000,
			time_signature: 4,
			doubletime: 190
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3BYzEWh3pY0DZpMN0hFufv" },
						href: "https://api.spotify.com/v1/artists/3BYzEWh3pY0DZpMN0hFufv",
						id: "3BYzEWh3pY0DZpMN0hFufv",
						name: "Chaz French",
						type: "artist",
						uri: "spotify:artist:3BYzEWh3pY0DZpMN0hFufv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1KKCBmBSYyEWYsTC8NGO4k" },
				href: "https://api.spotify.com/v1/albums/1KKCBmBSYyEWYsTC8NGO4k",
				id: "1KKCBmBSYyEWYsTC8NGO4k",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736b1e19f01fcaa929b3fcc07c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026b1e19f01fcaa929b3fcc07c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516b1e19f01fcaa929b3fcc07c", width: 64 }
				],
				name: "Happy Belated (Deluxe Edition)",
				release_date: "2015-04-27",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:1KKCBmBSYyEWYsTC8NGO4k"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3BYzEWh3pY0DZpMN0hFufv" },
					href: "https://api.spotify.com/v1/artists/3BYzEWh3pY0DZpMN0hFufv",
					id: "3BYzEWh3pY0DZpMN0hFufv",
					name: "Chaz French",
					type: "artist",
					uri: "spotify:artist:3BYzEWh3pY0DZpMN0hFufv"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5XenQ7XfcvQdfIbpLEFaKQ" },
					href: "https://api.spotify.com/v1/artists/5XenQ7XfcvQdfIbpLEFaKQ",
					id: "5XenQ7XfcvQdfIbpLEFaKQ",
					name: "GoldLink",
					type: "artist",
					uri: "spotify:artist:5XenQ7XfcvQdfIbpLEFaKQ"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 254014,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCACF1552838" },
			external_urls: { spotify: "https://open.spotify.com/track/75EJl18TUl7yNJ3iQ3J3nD" },
			href: "https://api.spotify.com/v1/tracks/75EJl18TUl7yNJ3iQ3J3nD",
			id: "75EJl18TUl7yNJ3iQ3J3nD",
			is_local: false,
			name: "LMGLML (feat. Goldlink)",
			popularity: 9,
			preview_url: "https://p.scdn.co/mp3-preview/2abc2003a1b1ac051294e1d621b1cefb6bf3d0d0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:75EJl18TUl7yNJ3iQ3J3nD"
		},
		features: {
			danceability: 0.557,
			energy: 0.606,
			key: 2,
			loudness: -6.918,
			mode: 1,
			speechiness: 0.306,
			acousticness: 0.0428,
			instrumentalness: 0,
			liveness: 0.131,
			valence: 0.0387,
			tempo: 97,
			type: "audio_features",
			id: "75EJl18TUl7yNJ3iQ3J3nD",
			uri: "spotify:track:75EJl18TUl7yNJ3iQ3J3nD",
			track_href: "https://api.spotify.com/v1/tracks/75EJl18TUl7yNJ3iQ3J3nD",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/75EJl18TUl7yNJ3iQ3J3nD",
			duration_ms: 254015,
			time_signature: 4,
			doubletime: 194
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1HwM5zlC5qNWhJtM00yXzG" },
						href: "https://api.spotify.com/v1/artists/1HwM5zlC5qNWhJtM00yXzG",
						id: "1HwM5zlC5qNWhJtM00yXzG",
						name: "DMX",
						type: "artist",
						uri: "spotify:artist:1HwM5zlC5qNWhJtM00yXzG"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0IbOiWK2R1fCrtvS490dYO" },
				href: "https://api.spotify.com/v1/albums/0IbOiWK2R1fCrtvS490dYO",
				id: "0IbOiWK2R1fCrtvS490dYO",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27306942519670f38e42d070203", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0206942519670f38e42d070203", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485106942519670f38e42d070203", width: 64 }
				],
				name: "The Weigh In",
				release_date: "2012-09-11",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:0IbOiWK2R1fCrtvS490dYO"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1HwM5zlC5qNWhJtM00yXzG" },
					href: "https://api.spotify.com/v1/artists/1HwM5zlC5qNWhJtM00yXzG",
					id: "1HwM5zlC5qNWhJtM00yXzG",
					name: "DMX",
					type: "artist",
					uri: "spotify:artist:1HwM5zlC5qNWhJtM00yXzG"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 124133,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAE81380327" },
			external_urls: { spotify: "https://open.spotify.com/track/17rDsNXe6GRQEVpzWanbGL" },
			href: "https://api.spotify.com/v1/tracks/17rDsNXe6GRQEVpzWanbGL",
			id: "17rDsNXe6GRQEVpzWanbGL",
			is_local: false,
			name: "Were My Dogs At",
			popularity: 26,
			preview_url: "https://p.scdn.co/mp3-preview/52554c27a5593a803459dcbfbbd76a3c4ae3466a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:17rDsNXe6GRQEVpzWanbGL"
		},
		features: {
			danceability: 0.723,
			energy: 0.764,
			key: 9,
			loudness: -7.152,
			mode: 0,
			speechiness: 0.24,
			acousticness: 0.0192,
			instrumentalness: 0.0000381,
			liveness: 0.128,
			valence: 0.456,
			tempo: 93,
			type: "audio_features",
			id: "17rDsNXe6GRQEVpzWanbGL",
			uri: "spotify:track:17rDsNXe6GRQEVpzWanbGL",
			track_href: "https://api.spotify.com/v1/tracks/17rDsNXe6GRQEVpzWanbGL",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/17rDsNXe6GRQEVpzWanbGL",
			duration_ms: 124134,
			time_signature: 4,
			doubletime: 186
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7lm68Uw3UZDD1vlAWpLeDL" },
						href: "https://api.spotify.com/v1/artists/7lm68Uw3UZDD1vlAWpLeDL",
						id: "7lm68Uw3UZDD1vlAWpLeDL",
						name: "Falcons",
						type: "artist",
						uri: "spotify:artist:7lm68Uw3UZDD1vlAWpLeDL"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5XenQ7XfcvQdfIbpLEFaKQ" },
						href: "https://api.spotify.com/v1/artists/5XenQ7XfcvQdfIbpLEFaKQ",
						id: "5XenQ7XfcvQdfIbpLEFaKQ",
						name: "GoldLink",
						type: "artist",
						uri: "spotify:artist:5XenQ7XfcvQdfIbpLEFaKQ"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3BYzEWh3pY0DZpMN0hFufv" },
						href: "https://api.spotify.com/v1/artists/3BYzEWh3pY0DZpMN0hFufv",
						id: "3BYzEWh3pY0DZpMN0hFufv",
						name: "Chaz French",
						type: "artist",
						uri: "spotify:artist:3BYzEWh3pY0DZpMN0hFufv"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/6upQW7aaDdY5YVbSRi5T5v" },
				href: "https://api.spotify.com/v1/albums/6upQW7aaDdY5YVbSRi5T5v",
				id: "6upQW7aaDdY5YVbSRi5T5v",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bc3503ef4ccbf6ecf57a1cd1", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bc3503ef4ccbf6ecf57a1cd1", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bc3503ef4ccbf6ecf57a1cd1", width: 64 }
				],
				name: "Aquafina (feat. GoldLink & Chaz French)",
				release_date: "2015-06-17",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:6upQW7aaDdY5YVbSRi5T5v"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7lm68Uw3UZDD1vlAWpLeDL" },
					href: "https://api.spotify.com/v1/artists/7lm68Uw3UZDD1vlAWpLeDL",
					id: "7lm68Uw3UZDD1vlAWpLeDL",
					name: "Falcons",
					type: "artist",
					uri: "spotify:artist:7lm68Uw3UZDD1vlAWpLeDL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5XenQ7XfcvQdfIbpLEFaKQ" },
					href: "https://api.spotify.com/v1/artists/5XenQ7XfcvQdfIbpLEFaKQ",
					id: "5XenQ7XfcvQdfIbpLEFaKQ",
					name: "GoldLink",
					type: "artist",
					uri: "spotify:artist:5XenQ7XfcvQdfIbpLEFaKQ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3BYzEWh3pY0DZpMN0hFufv" },
					href: "https://api.spotify.com/v1/artists/3BYzEWh3pY0DZpMN0hFufv",
					id: "3BYzEWh3pY0DZpMN0hFufv",
					name: "Chaz French",
					type: "artist",
					uri: "spotify:artist:3BYzEWh3pY0DZpMN0hFufv"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 221349,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QMSDU1500094" },
			external_urls: { spotify: "https://open.spotify.com/track/3Iz719UC8q65BqDpJkL2ws" },
			href: "https://api.spotify.com/v1/tracks/3Iz719UC8q65BqDpJkL2ws",
			id: "3Iz719UC8q65BqDpJkL2ws",
			is_local: false,
			name: "Aquafina (feat. GoldLink & Chaz French)",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3Iz719UC8q65BqDpJkL2ws"
		},
		features: {
			danceability: 0.711,
			energy: 0.705,
			key: 10,
			loudness: -6.248,
			mode: 0,
			speechiness: 0.252,
			acousticness: 0.186,
			instrumentalness: 0,
			liveness: 0.148,
			valence: 0.406,
			tempo: 144,
			type: "audio_features",
			id: "3Iz719UC8q65BqDpJkL2ws",
			uri: "spotify:track:3Iz719UC8q65BqDpJkL2ws",
			track_href: "https://api.spotify.com/v1/tracks/3Iz719UC8q65BqDpJkL2ws",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3Iz719UC8q65BqDpJkL2ws",
			duration_ms: 221350,
			time_signature: 4,
			doubletime: 144
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5IcR3N7QB1j6KBL8eImZ8m" },
						href: "https://api.spotify.com/v1/artists/5IcR3N7QB1j6KBL8eImZ8m",
						id: "5IcR3N7QB1j6KBL8eImZ8m",
						name: "ScHoolboy Q",
						type: "artist",
						uri: "spotify:artist:5IcR3N7QB1j6KBL8eImZ8m"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7Et3bSTLLqdABO1qCxUplS" },
				href: "https://api.spotify.com/v1/albums/7Et3bSTLLqdABO1qCxUplS",
				id: "7Et3bSTLLqdABO1qCxUplS",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27336977e237a8f70ec6c990636", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0236977e237a8f70ec6c990636", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485136977e237a8f70ec6c990636", width: 64 }
				],
				name: "Oxymoron (Deluxe)",
				release_date: "2014-01-01",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:7Et3bSTLLqdABO1qCxUplS"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5IcR3N7QB1j6KBL8eImZ8m" },
					href: "https://api.spotify.com/v1/artists/5IcR3N7QB1j6KBL8eImZ8m",
					id: "5IcR3N7QB1j6KBL8eImZ8m",
					name: "ScHoolboy Q",
					type: "artist",
					uri: "spotify:artist:5IcR3N7QB1j6KBL8eImZ8m"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/07d5etnpjriczFBB8pxmRe" },
					href: "https://api.spotify.com/v1/artists/07d5etnpjriczFBB8pxmRe",
					id: "07d5etnpjriczFBB8pxmRe",
					name: "BJ The Chicago Kid",
					type: "artist",
					uri: "spotify:artist:07d5etnpjriczFBB8pxmRe"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 278066,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71400323" },
			external_urls: { spotify: "https://open.spotify.com/track/29gsi1zZrZxdStACmTQB0Z" },
			href: "https://api.spotify.com/v1/tracks/29gsi1zZrZxdStACmTQB0Z",
			id: "29gsi1zZrZxdStACmTQB0Z",
			is_local: false,
			name: "Studio",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/baf4f9fd9495cb269db6f858b5b884b3e56590ef?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 6,
			type: "track",
			uri: "spotify:track:29gsi1zZrZxdStACmTQB0Z"
		},
		features: {
			danceability: 0.709,
			energy: 0.589,
			key: 8,
			loudness: -7.776,
			mode: 0,
			speechiness: 0.0433,
			acousticness: 0.0507,
			instrumentalness: 0,
			liveness: 0.0585,
			valence: 0.58,
			tempo: 134,
			type: "audio_features",
			id: "29gsi1zZrZxdStACmTQB0Z",
			uri: "spotify:track:29gsi1zZrZxdStACmTQB0Z",
			track_href: "https://api.spotify.com/v1/tracks/29gsi1zZrZxdStACmTQB0Z",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/29gsi1zZrZxdStACmTQB0Z",
			duration_ms: 278067,
			time_signature: 3,
			doubletime: 134
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3q7HBObVc0L8jNeTe5Gofh" },
						href: "https://api.spotify.com/v1/artists/3q7HBObVc0L8jNeTe5Gofh",
						id: "3q7HBObVc0L8jNeTe5Gofh",
						name: "50 Cent",
						type: "artist",
						uri: "spotify:artist:3q7HBObVc0L8jNeTe5Gofh"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/5U3tO3xfGNvuq5FZ8SrZs9" },
				href: "https://api.spotify.com/v1/albums/5U3tO3xfGNvuq5FZ8SrZs9",
				id: "5U3tO3xfGNvuq5FZ8SrZs9",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273d0ebf1294e0aadf3a9ce6464", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02d0ebf1294e0aadf3a9ce6464", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851d0ebf1294e0aadf3a9ce6464", width: 64 }
				],
				name: "The Massacre",
				release_date: "2005-03-03",
				release_date_precision: "day",
				total_tracks: 21,
				type: "album",
				uri: "spotify:album:5U3tO3xfGNvuq5FZ8SrZs9"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3q7HBObVc0L8jNeTe5Gofh" },
					href: "https://api.spotify.com/v1/artists/3q7HBObVc0L8jNeTe5Gofh",
					id: "3q7HBObVc0L8jNeTe5Gofh",
					name: "50 Cent",
					type: "artist",
					uri: "spotify:artist:3q7HBObVc0L8jNeTe5Gofh"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 237706,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USIR10500279" },
			external_urls: { spotify: "https://open.spotify.com/track/68IM0wOuxlrbwk0zgmi9dk" },
			href: "https://api.spotify.com/v1/tracks/68IM0wOuxlrbwk0zgmi9dk",
			id: "68IM0wOuxlrbwk0zgmi9dk",
			is_local: false,
			name: "Just A Lil Bit",
			popularity: 2,
			preview_url: null,
			track: true,
			track_number: 14,
			type: "track",
			uri: "spotify:track:68IM0wOuxlrbwk0zgmi9dk"
		},
		features: {
			danceability: 0.724,
			energy: 0.692,
			key: 1,
			loudness: -6.75,
			mode: 1,
			speechiness: 0.324,
			acousticness: 0.0397,
			instrumentalness: 0.00477,
			liveness: 0.314,
			valence: 0.532,
			tempo: 97,
			type: "audio_features",
			id: "68IM0wOuxlrbwk0zgmi9dk",
			uri: "spotify:track:68IM0wOuxlrbwk0zgmi9dk",
			track_href: "https://api.spotify.com/v1/tracks/68IM0wOuxlrbwk0zgmi9dk",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/68IM0wOuxlrbwk0zgmi9dk",
			duration_ms: 237707,
			time_signature: 4,
			doubletime: 194
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2YZyLoL8N0Wb9xBt1NhZWg" },
						href: "https://api.spotify.com/v1/artists/2YZyLoL8N0Wb9xBt1NhZWg",
						id: "2YZyLoL8N0Wb9xBt1NhZWg",
						name: "Kendrick Lamar",
						type: "artist",
						uri: "spotify:artist:2YZyLoL8N0Wb9xBt1NhZWg"
					}
				],
				available_markets: ["AE", "AU", "BH", "CA", "DZ", "EG", "ID", "IN", "JO", "KW", "LB", "MA", "MY", "OM", "QA", "SA", "TN", "TR", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/0E47vczx9XVds1Lr2Y8rze" },
				href: "https://api.spotify.com/v1/albums/0E47vczx9XVds1Lr2Y8rze",
				id: "0E47vczx9XVds1Lr2Y8rze",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f6381af6ad695ef74de8ce7b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f6381af6ad695ef74de8ce7b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f6381af6ad695ef74de8ce7b", width: 64 }
				],
				name: "good kid, m.A.A.d city",
				release_date: "2012",
				release_date_precision: "year",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:0E47vczx9XVds1Lr2Y8rze"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2YZyLoL8N0Wb9xBt1NhZWg" },
					href: "https://api.spotify.com/v1/artists/2YZyLoL8N0Wb9xBt1NhZWg",
					id: "2YZyLoL8N0Wb9xBt1NhZWg",
					name: "Kendrick Lamar",
					type: "artist",
					uri: "spotify:artist:2YZyLoL8N0Wb9xBt1NhZWg"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/28ExwzUQsvgJooOI0X1mr3" },
					href: "https://api.spotify.com/v1/artists/28ExwzUQsvgJooOI0X1mr3",
					id: "28ExwzUQsvgJooOI0X1mr3",
					name: "Jay Rock",
					type: "artist",
					uri: "spotify:artist:28ExwzUQsvgJooOI0X1mr3"
				}
			],
			available_markets: ["AE", "AU", "BH", "CA", "DZ", "EG", "ID", "IN", "JO", "KW", "LB", "MA", "MY", "OM", "QA", "SA", "TN", "TR", "US"],
			disc_number: 1,
			duration_ms: 386906,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USUM71211179" },
			external_urls: { spotify: "https://open.spotify.com/track/16SIvLDCFALvBDTmepJMIA" },
			href: "https://api.spotify.com/v1/tracks/16SIvLDCFALvBDTmepJMIA",
			id: "16SIvLDCFALvBDTmepJMIA",
			is_local: false,
			name: "Money Trees",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/31ebb3b62c0f40b76561e22671d100363b324d69?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:16SIvLDCFALvBDTmepJMIA"
		},
		features: {
			danceability: 0.715,
			energy: 0.537,
			key: 7,
			loudness: -7.489,
			mode: 1,
			speechiness: 0.107,
			acousticness: 0.0671,
			instrumentalness: 0,
			liveness: 0.208,
			valence: 0.36,
			tempo: 72,
			type: "audio_features",
			id: "16SIvLDCFALvBDTmepJMIA",
			uri: "spotify:track:16SIvLDCFALvBDTmepJMIA",
			track_href: "https://api.spotify.com/v1/tracks/16SIvLDCFALvBDTmepJMIA",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/16SIvLDCFALvBDTmepJMIA",
			duration_ms: 386907,
			time_signature: 4,
			doubletime: 144
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3LLs28LJVlXAjWc8UDkcQZ" },
						href: "https://api.spotify.com/v1/artists/3LLs28LJVlXAjWc8UDkcQZ",
						id: "3LLs28LJVlXAjWc8UDkcQZ",
						name: "Zion I",
						type: "artist",
						uri: "spotify:artist:3LLs28LJVlXAjWc8UDkcQZ"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LK5WvQVQgLZFU4Qc9XtXl" },
						href: "https://api.spotify.com/v1/artists/0LK5WvQVQgLZFU4Qc9XtXl",
						id: "0LK5WvQVQgLZFU4Qc9XtXl",
						name: "Mikos Da Gawd",
						type: "artist",
						uri: "spotify:artist:0LK5WvQVQgLZFU4Qc9XtXl"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1KaryenI82nCGUw3rmvJpl" },
				href: "https://api.spotify.com/v1/albums/1KaryenI82nCGUw3rmvJpl",
				id: "1KaryenI82nCGUw3rmvJpl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273183e075ce7e6fc53c49472aa", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02183e075ce7e6fc53c49472aa", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851183e075ce7e6fc53c49472aa", width: 64 }
				],
				name: "Stay Woke",
				release_date: "2016-07-15",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:1KaryenI82nCGUw3rmvJpl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3LLs28LJVlXAjWc8UDkcQZ" },
					href: "https://api.spotify.com/v1/artists/3LLs28LJVlXAjWc8UDkcQZ",
					id: "3LLs28LJVlXAjWc8UDkcQZ",
					name: "Zion I",
					type: "artist",
					uri: "spotify:artist:3LLs28LJVlXAjWc8UDkcQZ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0LK5WvQVQgLZFU4Qc9XtXl" },
					href: "https://api.spotify.com/v1/artists/0LK5WvQVQgLZFU4Qc9XtXl",
					id: "0LK5WvQVQgLZFU4Qc9XtXl",
					name: "Mikos Da Gawd",
					type: "artist",
					uri: "spotify:artist:0LK5WvQVQgLZFU4Qc9XtXl"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 209453,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1107376" },
			external_urls: { spotify: "https://open.spotify.com/track/3veZxobsSBiBQ6sCs3ooUn" },
			href: "https://api.spotify.com/v1/tracks/3veZxobsSBiBQ6sCs3ooUn",
			id: "3veZxobsSBiBQ6sCs3ooUn",
			is_local: false,
			name: "Tech $",
			popularity: 26,
			preview_url: "https://p.scdn.co/mp3-preview/42b3a3b23ff0358faaf044b79ba394f77b82de1a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:3veZxobsSBiBQ6sCs3ooUn"
		},
		features: {
			danceability: 0.854,
			energy: 0.635,
			key: 2,
			loudness: -6.654,
			mode: 1,
			speechiness: 0.232,
			acousticness: 0.0199,
			instrumentalness: 0.00000358,
			liveness: 0.086,
			valence: 0.237,
			tempo: 83,
			type: "audio_features",
			id: "3veZxobsSBiBQ6sCs3ooUn",
			uri: "spotify:track:3veZxobsSBiBQ6sCs3ooUn",
			track_href: "https://api.spotify.com/v1/tracks/3veZxobsSBiBQ6sCs3ooUn",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3veZxobsSBiBQ6sCs3ooUn",
			duration_ms: 209454,
			time_signature: 4,
			doubletime: 166
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4cUfFbVZGSsJWdbfmkdxYq" },
						href: "https://api.spotify.com/v1/artists/4cUfFbVZGSsJWdbfmkdxYq",
						id: "4cUfFbVZGSsJWdbfmkdxYq",
						name: "Token",
						type: "artist",
						uri: "spotify:artist:4cUfFbVZGSsJWdbfmkdxYq"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4HRJXR4mF0k1334eVQMfQo" },
				href: "https://api.spotify.com/v1/albums/4HRJXR4mF0k1334eVQMfQo",
				id: "4HRJXR4mF0k1334eVQMfQo",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730e3043654f0d67bfedccf01b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020e3043654f0d67bfedccf01b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510e3043654f0d67bfedccf01b", width: 64 }
				],
				name: "Eraser Shavings",
				release_date: "2016-09-23",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:4HRJXR4mF0k1334eVQMfQo"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4cUfFbVZGSsJWdbfmkdxYq" },
					href: "https://api.spotify.com/v1/artists/4cUfFbVZGSsJWdbfmkdxYq",
					id: "4cUfFbVZGSsJWdbfmkdxYq",
					name: "Token",
					type: "artist",
					uri: "spotify:artist:4cUfFbVZGSsJWdbfmkdxYq"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 163227,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USKO11601620" },
			external_urls: { spotify: "https://open.spotify.com/track/2TE0OykGDo939JVrhwZGWN" },
			href: "https://api.spotify.com/v1/tracks/2TE0OykGDo939JVrhwZGWN",
			id: "2TE0OykGDo939JVrhwZGWN",
			is_local: false,
			name: "Mommas Favorite Chair",
			popularity: 30,
			preview_url: "https://p.scdn.co/mp3-preview/98aa90e4c50552758245c65d15863836cff1863c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:2TE0OykGDo939JVrhwZGWN"
		},
		features: {
			danceability: 0.836,
			energy: 0.542,
			key: 2,
			loudness: -4.309,
			mode: 1,
			speechiness: 0.279,
			acousticness: 0.0341,
			instrumentalness: 0,
			liveness: 0.0881,
			valence: 0.247,
			tempo: 84,
			type: "audio_features",
			id: "2TE0OykGDo939JVrhwZGWN",
			uri: "spotify:track:2TE0OykGDo939JVrhwZGWN",
			track_href: "https://api.spotify.com/v1/tracks/2TE0OykGDo939JVrhwZGWN",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2TE0OykGDo939JVrhwZGWN",
			duration_ms: 163228,
			time_signature: 4,
			doubletime: 168
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6C1ohJrd5VydigQtaGy5Wa" },
						href: "https://api.spotify.com/v1/artists/6C1ohJrd5VydigQtaGy5Wa",
						id: "6C1ohJrd5VydigQtaGy5Wa",
						name: "Joyner Lucas",
						type: "artist",
						uri: "spotify:artist:6C1ohJrd5VydigQtaGy5Wa"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5FNiUh6rfgogAensmq4c81" },
				href: "https://api.spotify.com/v1/albums/5FNiUh6rfgogAensmq4c81",
				id: "5FNiUh6rfgogAensmq4c81",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273fd7b755a21e19a36a79c8d0c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02fd7b755a21e19a36a79c8d0c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851fd7b755a21e19a36a79c8d0c", width: 64 }
				],
				name: "508-507-2209",
				release_date: "2017-06-16",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:5FNiUh6rfgogAensmq4c81"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6C1ohJrd5VydigQtaGy5Wa" },
					href: "https://api.spotify.com/v1/artists/6C1ohJrd5VydigQtaGy5Wa",
					id: "6C1ohJrd5VydigQtaGy5Wa",
					name: "Joyner Lucas",
					type: "artist",
					uri: "spotify:artist:6C1ohJrd5VydigQtaGy5Wa"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 275297,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21700976" },
			external_urls: { spotify: "https://open.spotify.com/track/3LHbk7L7mFQj0Wiv4dB9lR" },
			href: "https://api.spotify.com/v1/tracks/3LHbk7L7mFQj0Wiv4dB9lR",
			id: "3LHbk7L7mFQj0Wiv4dB9lR",
			is_local: false,
			name: "Winter Blues",
			popularity: 60,
			preview_url: "https://p.scdn.co/mp3-preview/22a41a12c64ad4aa424e17a5db1d3b4664a18a7c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:3LHbk7L7mFQj0Wiv4dB9lR"
		},
		features: {
			danceability: 0.643,
			energy: 0.766,
			key: 0,
			loudness: -6.141,
			mode: 0,
			speechiness: 0.425,
			acousticness: 0.843,
			instrumentalness: 0.00000314,
			liveness: 0.228,
			valence: 0.54,
			tempo: 131,
			type: "audio_features",
			id: "3LHbk7L7mFQj0Wiv4dB9lR",
			uri: "spotify:track:3LHbk7L7mFQj0Wiv4dB9lR",
			track_href: "https://api.spotify.com/v1/tracks/3LHbk7L7mFQj0Wiv4dB9lR",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3LHbk7L7mFQj0Wiv4dB9lR",
			duration_ms: 275298,
			time_signature: 4,
			doubletime: 131
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4LXBc13z5EWsc5N32bLxfH" },
						href: "https://api.spotify.com/v1/artists/4LXBc13z5EWsc5N32bLxfH",
						id: "4LXBc13z5EWsc5N32bLxfH",
						name: "Nekfeu",
						type: "artist",
						uri: "spotify:artist:4LXBc13z5EWsc5N32bLxfH"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/3jTg4M1B2uqVmJAXmKOB2Y" },
				href: "https://api.spotify.com/v1/albums/3jTg4M1B2uqVmJAXmKOB2Y",
				id: "3jTg4M1B2uqVmJAXmKOB2Y",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ad9f89c7cd76f76eb0c1fc3e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ad9f89c7cd76f76eb0c1fc3e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ad9f89c7cd76f76eb0c1fc3e", width: 64 }
				],
				name: "Cyborg",
				release_date: "2016-12-02",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:3jTg4M1B2uqVmJAXmKOB2Y"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4LXBc13z5EWsc5N32bLxfH" },
					href: "https://api.spotify.com/v1/artists/4LXBc13z5EWsc5N32bLxfH",
					id: "4LXBc13z5EWsc5N32bLxfH",
					name: "Nekfeu",
					type: "artist",
					uri: "spotify:artist:4LXBc13z5EWsc5N32bLxfH"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1cA379ILgR07m7XQVXyP6Q" },
					href: "https://api.spotify.com/v1/artists/1cA379ILgR07m7XQVXyP6Q",
					id: "1cA379ILgR07m7XQVXyP6Q",
					name: "Sneazzy",
					type: "artist",
					uri: "spotify:artist:1cA379ILgR07m7XQVXyP6Q"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5olcgTzelGdyP1rHRLyWgs" },
					href: "https://api.spotify.com/v1/artists/5olcgTzelGdyP1rHRLyWgs",
					id: "5olcgTzelGdyP1rHRLyWgs",
					name: "S.Pri Noir",
					type: "artist",
					uri: "spotify:artist:5olcgTzelGdyP1rHRLyWgs"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 363213,
			episode: false,
			explicit: true,
			external_ids: { isrc: "FR9W11619937" },
			external_urls: { spotify: "https://open.spotify.com/track/5t9fmZx0pcNxLykKTv6eOe" },
			href: "https://api.spotify.com/v1/tracks/5t9fmZx0pcNxLykKTv6eOe",
			id: "5t9fmZx0pcNxLykKTv6eOe",
			is_local: false,
			name: "Saturne",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 9,
			type: "track",
			uri: "spotify:track:5t9fmZx0pcNxLykKTv6eOe"
		},
		features: {
			danceability: 0.757,
			energy: 0.807,
			key: 5,
			loudness: -8.471,
			mode: 1,
			speechiness: 0.501,
			acousticness: 0.557,
			instrumentalness: 0,
			liveness: 0.126,
			valence: 0.0398,
			tempo: 91,
			type: "audio_features",
			id: "5t9fmZx0pcNxLykKTv6eOe",
			uri: "spotify:track:5t9fmZx0pcNxLykKTv6eOe",
			track_href: "https://api.spotify.com/v1/tracks/5t9fmZx0pcNxLykKTv6eOe",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5t9fmZx0pcNxLykKTv6eOe",
			duration_ms: 363213,
			time_signature: 4,
			doubletime: 182
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6Ha4aES39QiVjR0L2lwuwq" },
						href: "https://api.spotify.com/v1/artists/6Ha4aES39QiVjR0L2lwuwq",
						id: "6Ha4aES39QiVjR0L2lwuwq",
						name: "Yo Gotti",
						type: "artist",
						uri: "spotify:artist:6Ha4aES39QiVjR0L2lwuwq"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/5Tbq0fPPFF0NTu9JAp7TPX" },
				href: "https://api.spotify.com/v1/albums/5Tbq0fPPFF0NTu9JAp7TPX",
				id: "5Tbq0fPPFF0NTu9JAp7TPX",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273dc371ef9c9ad4c33b3fc130a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02dc371ef9c9ad4c33b3fc130a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851dc371ef9c9ad4c33b3fc130a", width: 64 }
				],
				name: "Rake It Up",
				release_date: "2017-06-23",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5Tbq0fPPFF0NTu9JAp7TPX"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6Ha4aES39QiVjR0L2lwuwq" },
					href: "https://api.spotify.com/v1/artists/6Ha4aES39QiVjR0L2lwuwq",
					id: "6Ha4aES39QiVjR0L2lwuwq",
					name: "Yo Gotti",
					type: "artist",
					uri: "spotify:artist:6Ha4aES39QiVjR0L2lwuwq"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 276333,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USSM11705366" },
			external_urls: { spotify: "https://open.spotify.com/track/6c7D34787LOtPm8tzhsLgH" },
			href: "https://api.spotify.com/v1/tracks/6c7D34787LOtPm8tzhsLgH",
			id: "6c7D34787LOtPm8tzhsLgH",
			is_local: false,
			name: "Rake It Up",
			popularity: 3,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6c7D34787LOtPm8tzhsLgH"
		},
		features: {
			danceability: 0.91,
			energy: 0.444,
			key: 1,
			loudness: -8.126,
			mode: 0,
			speechiness: 0.344,
			acousticness: 0.022,
			instrumentalness: 0,
			liveness: 0.137,
			valence: 0.53,
			tempo: 150,
			type: "audio_features",
			id: "6c7D34787LOtPm8tzhsLgH",
			uri: "spotify:track:6c7D34787LOtPm8tzhsLgH",
			track_href: "https://api.spotify.com/v1/tracks/6c7D34787LOtPm8tzhsLgH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6c7D34787LOtPm8tzhsLgH",
			duration_ms: 276333,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
						href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
						id: "3TVXtAsR1Inumwj472S9r4",
						name: "Drake",
						type: "artist",
						uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
					}
				],
				available_markets: ["CA"],
				external_urls: { spotify: "https://open.spotify.com/album/2RyXM4Q0b7Sn3KOS4subbU" },
				href: "https://api.spotify.com/v1/albums/2RyXM4Q0b7Sn3KOS4subbU",
				id: "2RyXM4Q0b7Sn3KOS4subbU",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2732d13024545c71f129c926043", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e022d13024545c71f129c926043", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048512d13024545c71f129c926043", width: 64 }
				],
				name: "Take Care (Deluxe)",
				release_date: "2011-11-15",
				release_date_precision: "day",
				total_tracks: 18,
				type: "album",
				uri: "spotify:album:2RyXM4Q0b7Sn3KOS4subbU"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
					href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
					id: "3TVXtAsR1Inumwj472S9r4",
					name: "Drake",
					type: "artist",
					uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
				}
			],
			available_markets: ["CA"],
			disc_number: 1,
			duration_ms: 212600,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USCM51100555" },
			external_urls: { spotify: "https://open.spotify.com/track/6AUotLBFQxA9bYJ07SjhgB" },
			href: "https://api.spotify.com/v1/tracks/6AUotLBFQxA9bYJ07SjhgB",
			id: "6AUotLBFQxA9bYJ07SjhgB",
			is_local: false,
			name: "Under Ground Kings",
			popularity: 12,
			preview_url: "https://p.scdn.co/mp3-preview/250a2c543a0fde549f1ffed5f93c863805a8ae37?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:6AUotLBFQxA9bYJ07SjhgB"
		},
		features: {
			danceability: 0.525,
			energy: 0.7,
			key: 8,
			loudness: -7.411,
			mode: 1,
			speechiness: 0.256,
			acousticness: 0.0000625,
			instrumentalness: 0,
			liveness: 0.187,
			valence: 0.489,
			tempo: 156,
			type: "audio_features",
			id: "6AUotLBFQxA9bYJ07SjhgB",
			uri: "spotify:track:6AUotLBFQxA9bYJ07SjhgB",
			track_href: "https://api.spotify.com/v1/tracks/6AUotLBFQxA9bYJ07SjhgB",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6AUotLBFQxA9bYJ07SjhgB",
			duration_ms: 212600,
			time_signature: 4,
			doubletime: 156
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6l3HvQ5sa6mXTsMTB19rO5" },
						href: "https://api.spotify.com/v1/artists/6l3HvQ5sa6mXTsMTB19rO5",
						id: "6l3HvQ5sa6mXTsMTB19rO5",
						name: "J. Cole",
						type: "artist",
						uri: "spotify:artist:6l3HvQ5sa6mXTsMTB19rO5"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3CCnGldVQ90c26aFATC1PW" },
				href: "https://api.spotify.com/v1/albums/3CCnGldVQ90c26aFATC1PW",
				id: "3CCnGldVQ90c26aFATC1PW",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f4ca75192df162f78a24023e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f4ca75192df162f78a24023e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f4ca75192df162f78a24023e", width: 64 }
				],
				name: "4 Your Eyez Only",
				release_date: "2016-12-09",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:3CCnGldVQ90c26aFATC1PW"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6l3HvQ5sa6mXTsMTB19rO5" },
					href: "https://api.spotify.com/v1/artists/6l3HvQ5sa6mXTsMTB19rO5",
					id: "6l3HvQ5sa6mXTsMTB19rO5",
					name: "J. Cole",
					type: "artist",
					uri: "spotify:artist:6l3HvQ5sa6mXTsMTB19rO5"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 264746,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QMJMT1601080" },
			external_urls: { spotify: "https://open.spotify.com/track/6I6NX6tjGsxFAsIfGzY9lJ" },
			href: "https://api.spotify.com/v1/tracks/6I6NX6tjGsxFAsIfGzY9lJ",
			id: "6I6NX6tjGsxFAsIfGzY9lJ",
			is_local: false,
			name: "Deja Vu",
			popularity: 69,
			preview_url: "https://p.scdn.co/mp3-preview/6329dec7ef2dc33f819f25fc474d25847284b4ea?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:6I6NX6tjGsxFAsIfGzY9lJ"
		},
		features: {
			danceability: 0.657,
			energy: 0.421,
			key: 9,
			loudness: -11.378,
			mode: 1,
			speechiness: 0.412,
			acousticness: 0.352,
			instrumentalness: 0.000218,
			liveness: 0.187,
			valence: 0.181,
			tempo: 174,
			type: "audio_features",
			id: "6I6NX6tjGsxFAsIfGzY9lJ",
			uri: "spotify:track:6I6NX6tjGsxFAsIfGzY9lJ",
			track_href: "https://api.spotify.com/v1/tracks/6I6NX6tjGsxFAsIfGzY9lJ",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6I6NX6tjGsxFAsIfGzY9lJ",
			duration_ms: 264747,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6nfYGe7IIuuP5bMY1jkJP6" },
						href: "https://api.spotify.com/v1/artists/6nfYGe7IIuuP5bMY1jkJP6",
						id: "6nfYGe7IIuuP5bMY1jkJP6",
						name: "Jermaine Dupri",
						type: "artist",
						uri: "spotify:artist:6nfYGe7IIuuP5bMY1jkJP6"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3ssplToLM7k3pX7wCyMSht" },
				href: "https://api.spotify.com/v1/albums/3ssplToLM7k3pX7wCyMSht",
				id: "3ssplToLM7k3pX7wCyMSht",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736b5be01dc9df0523f75f0f88", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026b5be01dc9df0523f75f0f88", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516b5be01dc9df0523f75f0f88", width: 64 }
				],
				name: "Instructions (Explicit Version)",
				release_date: "2001-10-30",
				release_date_precision: "day",
				total_tracks: 20,
				type: "album",
				uri: "spotify:album:3ssplToLM7k3pX7wCyMSht"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6nfYGe7IIuuP5bMY1jkJP6" },
					href: "https://api.spotify.com/v1/artists/6nfYGe7IIuuP5bMY1jkJP6",
					id: "6nfYGe7IIuuP5bMY1jkJP6",
					name: "Jermaine Dupri",
					type: "artist",
					uri: "spotify:artist:6nfYGe7IIuuP5bMY1jkJP6"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3ipn9JLAPI5GUEo4y4jcoi" },
					href: "https://api.spotify.com/v1/artists/3ipn9JLAPI5GUEo4y4jcoi",
					id: "3ipn9JLAPI5GUEo4y4jcoi",
					name: "Ludacris",
					type: "artist",
					uri: "spotify:artist:3ipn9JLAPI5GUEo4y4jcoi"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 200840,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USSM10109175" },
			external_urls: { spotify: "https://open.spotify.com/track/19VTqucnxJuH6kilNdweTh" },
			href: "https://api.spotify.com/v1/tracks/19VTqucnxJuH6kilNdweTh",
			id: "19VTqucnxJuH6kilNdweTh",
			is_local: false,
			name: "Welcome to Atlanta (feat. Ludacris)",
			popularity: 53,
			preview_url: "https://p.scdn.co/mp3-preview/c4a62b861b69458cd0396c9e4d91f05c807d0f56?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:19VTqucnxJuH6kilNdweTh"
		},
		features: {
			danceability: 0.751,
			energy: 0.786,
			key: 3,
			loudness: -7.441,
			mode: 0,
			speechiness: 0.383,
			acousticness: 0.0126,
			instrumentalness: 0,
			liveness: 0.107,
			valence: 0.679,
			tempo: 96,
			type: "audio_features",
			id: "19VTqucnxJuH6kilNdweTh",
			uri: "spotify:track:19VTqucnxJuH6kilNdweTh",
			track_href: "https://api.spotify.com/v1/tracks/19VTqucnxJuH6kilNdweTh",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/19VTqucnxJuH6kilNdweTh",
			duration_ms: 200840,
			time_signature: 4,
			doubletime: 192
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6O2zJ0tId7g07yzHtX0yap" },
						href: "https://api.spotify.com/v1/artists/6O2zJ0tId7g07yzHtX0yap",
						id: "6O2zJ0tId7g07yzHtX0yap",
						name: "Mobb Deep",
						type: "artist",
						uri: "spotify:artist:6O2zJ0tId7g07yzHtX0yap"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"EC",
					"EE",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JP",
					"LI",
					"LT",
					"LU",
					"LV",
					"MC",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"RO",
					"SE",
					"SG",
					"SK",
					"SV",
					"TR",
					"TW",
					"US",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/74jYy3DtyTfSVyxQUcsTFF" },
				href: "https://api.spotify.com/v1/albums/74jYy3DtyTfSVyxQUcsTFF",
				id: "74jYy3DtyTfSVyxQUcsTFF",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273019a89b674026f9227ac265d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02019a89b674026f9227ac265d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851019a89b674026f9227ac265d", width: 64 }
				],
				name: "Blood Money",
				release_date: "2006-05-02",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:74jYy3DtyTfSVyxQUcsTFF"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6O2zJ0tId7g07yzHtX0yap" },
					href: "https://api.spotify.com/v1/artists/6O2zJ0tId7g07yzHtX0yap",
					id: "6O2zJ0tId7g07yzHtX0yap",
					name: "Mobb Deep",
					type: "artist",
					uri: "spotify:artist:6O2zJ0tId7g07yzHtX0yap"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"EC",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JP",
				"LI",
				"LT",
				"LU",
				"LV",
				"MC",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"RO",
				"SE",
				"SG",
				"SK",
				"SV",
				"TR",
				"TW",
				"US",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 236680,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM70600152" },
			external_urls: { spotify: "https://open.spotify.com/track/1xv16OOHQcYUiS0y8pU9Kx" },
			href: "https://api.spotify.com/v1/tracks/1xv16OOHQcYUiS0y8pU9Kx",
			id: "1xv16OOHQcYUiS0y8pU9Kx",
			is_local: false,
			name: "Put 'Em In Their Place",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/e3e0eee695c2b5e0666688cf369e429cf08af9d3?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:1xv16OOHQcYUiS0y8pU9Kx"
		},
		features: {
			danceability: 0.661,
			energy: 0.819,
			key: 1,
			loudness: -2.15,
			mode: 0,
			speechiness: 0.263,
			acousticness: 0.0207,
			instrumentalness: 0,
			liveness: 0.32,
			valence: 0.558,
			tempo: 87,
			type: "audio_features",
			id: "1xv16OOHQcYUiS0y8pU9Kx",
			uri: "spotify:track:1xv16OOHQcYUiS0y8pU9Kx",
			track_href: "https://api.spotify.com/v1/tracks/1xv16OOHQcYUiS0y8pU9Kx",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1xv16OOHQcYUiS0y8pU9Kx",
			duration_ms: 236680,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
						href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
						id: "0hCNtLu0JehylgoiP8L4Gh",
						name: "Nicki Minaj",
						type: "artist",
						uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2D2rriWruRrRFq2AAholPp" },
				href: "https://api.spotify.com/v1/albums/2D2rriWruRrRFq2AAholPp",
				id: "2D2rriWruRrRFq2AAholPp",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bd6eee29c9fb9f9bfdb588ee", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bd6eee29c9fb9f9bfdb588ee", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bd6eee29c9fb9f9bfdb588ee", width: 64 }
				],
				name: "Pink Friday ... Roman Reloaded (Deluxe Edition)",
				release_date: "2012-04-03",
				release_date_precision: "day",
				total_tracks: 22,
				type: "album",
				uri: "spotify:album:2D2rriWruRrRFq2AAholPp"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7iMvwE8qANp3aIfAGKEAwS" },
					href: "https://api.spotify.com/v1/artists/7iMvwE8qANp3aIfAGKEAwS",
					id: "7iMvwE8qANp3aIfAGKEAwS",
					name: "Cam’ron",
					type: "artist",
					uri: "spotify:artist:7iMvwE8qANp3aIfAGKEAwS"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1sBkRIssrMs1AbVkOJbc7a" },
					href: "https://api.spotify.com/v1/artists/1sBkRIssrMs1AbVkOJbc7a",
					id: "1sBkRIssrMs1AbVkOJbc7a",
					name: "Rick Ross",
					type: "artist",
					uri: "spotify:artist:1sBkRIssrMs1AbVkOJbc7a"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 213733,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51200097" },
			external_urls: { spotify: "https://open.spotify.com/track/5iT6Ux1Fko5LKoMKjd9hhg" },
			href: "https://api.spotify.com/v1/tracks/5iT6Ux1Fko5LKoMKjd9hhg",
			id: "5iT6Ux1Fko5LKoMKjd9hhg",
			is_local: false,
			name: "I Am Your Leader",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/b8bf3c1f7de40ccdfb98505247f851136c2a11bc?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:5iT6Ux1Fko5LKoMKjd9hhg"
		},
		features: {
			danceability: 0.823,
			energy: 0.572,
			key: 7,
			loudness: -6.379,
			mode: 1,
			speechiness: 0.337,
			acousticness: 0.306,
			instrumentalness: 0,
			liveness: 0.099,
			valence: 0.739,
			tempo: 82,
			type: "audio_features",
			id: "5iT6Ux1Fko5LKoMKjd9hhg",
			uri: "spotify:track:5iT6Ux1Fko5LKoMKjd9hhg",
			track_href: "https://api.spotify.com/v1/tracks/5iT6Ux1Fko5LKoMKjd9hhg",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5iT6Ux1Fko5LKoMKjd9hhg",
			duration_ms: 213733,
			time_signature: 4,
			doubletime: 164
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
						href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
						id: "0hCNtLu0JehylgoiP8L4Gh",
						name: "Nicki Minaj",
						type: "artist",
						uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2D2rriWruRrRFq2AAholPp" },
				href: "https://api.spotify.com/v1/albums/2D2rriWruRrRFq2AAholPp",
				id: "2D2rriWruRrRFq2AAholPp",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bd6eee29c9fb9f9bfdb588ee", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bd6eee29c9fb9f9bfdb588ee", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bd6eee29c9fb9f9bfdb588ee", width: 64 }
				],
				name: "Pink Friday ... Roman Reloaded (Deluxe Edition)",
				release_date: "2012-04-03",
				release_date_precision: "day",
				total_tracks: 22,
				type: "album",
				uri: "spotify:album:2D2rriWruRrRFq2AAholPp"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp" },
					href: "https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp",
					id: "17lzZA2AlOHwCwFALHttmp",
					name: "2 Chainz",
					type: "artist",
					uri: "spotify:artist:17lzZA2AlOHwCwFALHttmp"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 268480,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51200099" },
			external_urls: { spotify: "https://open.spotify.com/track/3A0CjqZ5uOrrJrfEPq90HZ" },
			href: "https://api.spotify.com/v1/tracks/3A0CjqZ5uOrrJrfEPq90HZ",
			id: "3A0CjqZ5uOrrJrfEPq90HZ",
			is_local: false,
			name: "Beez In The Trap",
			popularity: 39,
			preview_url: "https://p.scdn.co/mp3-preview/432a225587b13d7aca3583203d08f91a12231cd4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:3A0CjqZ5uOrrJrfEPq90HZ"
		},
		features: {
			danceability: 0.814,
			energy: 0.77,
			key: 9,
			loudness: -6.014,
			mode: 1,
			speechiness: 0.216,
			acousticness: 0.0206,
			instrumentalness: 0.00158,
			liveness: 0.105,
			valence: 0.645,
			tempo: 150,
			type: "audio_features",
			id: "3A0CjqZ5uOrrJrfEPq90HZ",
			uri: "spotify:track:3A0CjqZ5uOrrJrfEPq90HZ",
			track_href: "https://api.spotify.com/v1/tracks/3A0CjqZ5uOrrJrfEPq90HZ",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3A0CjqZ5uOrrJrfEPq90HZ",
			duration_ms: 268480,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2r8r62VGJKGi463aH1HJUZ" },
						href: "https://api.spotify.com/v1/artists/2r8r62VGJKGi463aH1HJUZ",
						id: "2r8r62VGJKGi463aH1HJUZ",
						name: "Kirko Bangz",
						type: "artist",
						uri: "spotify:artist:2r8r62VGJKGi463aH1HJUZ"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HN",
					"HU",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"NI",
					"NL",
					"NO",
					"OM",
					"PA",
					"PE",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SK",
					"SV",
					"TN",
					"TR",
					"US",
					"UY",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0gcaegWwMXeOHgkOOSuoHy" },
				href: "https://api.spotify.com/v1/albums/0gcaegWwMXeOHgkOOSuoHy",
				id: "0gcaegWwMXeOHgkOOSuoHy",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273fe467c79aeb73463437608d3", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02fe467c79aeb73463437608d3", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851fe467c79aeb73463437608d3", width: 64 }
				],
				name: "Drank In My Cup EP",
				release_date: "2012-05-25",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:0gcaegWwMXeOHgkOOSuoHy"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2r8r62VGJKGi463aH1HJUZ" },
					href: "https://api.spotify.com/v1/artists/2r8r62VGJKGi463aH1HJUZ",
					id: "2r8r62VGJKGi463aH1HJUZ",
					name: "Kirko Bangz",
					type: "artist",
					uri: "spotify:artist:2r8r62VGJKGi463aH1HJUZ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp" },
					href: "https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp",
					id: "17lzZA2AlOHwCwFALHttmp",
					name: "2 Chainz",
					type: "artist",
					uri: "spotify:artist:17lzZA2AlOHwCwFALHttmp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6Uh8uJyN9g7oFjDK16nJgb" },
					href: "https://api.spotify.com/v1/artists/6Uh8uJyN9g7oFjDK16nJgb",
					id: "6Uh8uJyN9g7oFjDK16nJgb",
					name: "Juelz Santana",
					type: "artist",
					uri: "spotify:artist:6Uh8uJyN9g7oFjDK16nJgb"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HN",
				"HU",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"NI",
				"NL",
				"NO",
				"OM",
				"PA",
				"PE",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SK",
				"SV",
				"TN",
				"TR",
				"US",
				"UY",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 332560,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USWB11201098" },
			external_urls: { spotify: "https://open.spotify.com/track/7JmaiCwcoqQmFb063jHr6y" },
			href: "https://api.spotify.com/v1/tracks/7JmaiCwcoqQmFb063jHr6y",
			id: "7JmaiCwcoqQmFb063jHr6y",
			is_local: false,
			name: "Drank in My Cup Remix (feat. 2 Chainz & Juelz Santana)",
			popularity: 37,
			preview_url: "https://p.scdn.co/mp3-preview/5879aa013727b29c7ba828767e16fd857dc15c19?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:7JmaiCwcoqQmFb063jHr6y"
		},
		features: {
			danceability: 0.467,
			energy: 0.588,
			key: 11,
			loudness: -8.584,
			mode: 1,
			speechiness: 0.311,
			acousticness: 0.02,
			instrumentalness: 0,
			liveness: 0.0713,
			valence: 0.396,
			tempo: 133,
			type: "audio_features",
			id: "7JmaiCwcoqQmFb063jHr6y",
			uri: "spotify:track:7JmaiCwcoqQmFb063jHr6y",
			track_href: "https://api.spotify.com/v1/tracks/7JmaiCwcoqQmFb063jHr6y",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7JmaiCwcoqQmFb063jHr6y",
			duration_ms: 332560,
			time_signature: 4,
			doubletime: 133
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5dHt1vcEm9qb8fCyLcB3HL" },
						href: "https://api.spotify.com/v1/artists/5dHt1vcEm9qb8fCyLcB3HL",
						id: "5dHt1vcEm9qb8fCyLcB3HL",
						name: "A$AP Ferg",
						type: "artist",
						uri: "spotify:artist:5dHt1vcEm9qb8fCyLcB3HL"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0bVY8ZE63UQOyJQsjjidVn" },
				href: "https://api.spotify.com/v1/albums/0bVY8ZE63UQOyJQsjjidVn",
				id: "0bVY8ZE63UQOyJQsjjidVn",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27378f6399d94fc2b026d376b66", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0278f6399d94fc2b026d376b66", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485178f6399d94fc2b026d376b66", width: 64 }
				],
				name: "Plain Jane REMIX",
				release_date: "2017-12-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0bVY8ZE63UQOyJQsjjidVn"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5dHt1vcEm9qb8fCyLcB3HL" },
					href: "https://api.spotify.com/v1/artists/5dHt1vcEm9qb8fCyLcB3HL",
					id: "5dHt1vcEm9qb8fCyLcB3HL",
					name: "A$AP Ferg",
					type: "artist",
					uri: "spotify:artist:5dHt1vcEm9qb8fCyLcB3HL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 202636,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USRC11703649" },
			external_urls: { spotify: "https://open.spotify.com/track/2YzmfPLqUx5CJOaw5ThsBV" },
			href: "https://api.spotify.com/v1/tracks/2YzmfPLqUx5CJOaw5ThsBV",
			id: "2YzmfPLqUx5CJOaw5ThsBV",
			is_local: false,
			name: "Plain Jane REMIX",
			popularity: 68,
			preview_url: "https://p.scdn.co/mp3-preview/bce9850edcfeb519a3b621dcf787b5d871953953?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2YzmfPLqUx5CJOaw5ThsBV"
		},
		features: {
			danceability: 0.791,
			energy: 0.839,
			key: 11,
			loudness: -4.284,
			mode: 1,
			speechiness: 0.266,
			acousticness: 0.0588,
			instrumentalness: 0.0000626,
			liveness: 0.259,
			valence: 0.383,
			tempo: 170,
			type: "audio_features",
			id: "2YzmfPLqUx5CJOaw5ThsBV",
			uri: "spotify:track:2YzmfPLqUx5CJOaw5ThsBV",
			track_href: "https://api.spotify.com/v1/tracks/2YzmfPLqUx5CJOaw5ThsBV",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2YzmfPLqUx5CJOaw5ThsBV",
			duration_ms: 202636,
			time_signature: 4,
			doubletime: 170
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7hJcb9fa4alzcOq3EaNPoG" },
						href: "https://api.spotify.com/v1/artists/7hJcb9fa4alzcOq3EaNPoG",
						id: "7hJcb9fa4alzcOq3EaNPoG",
						name: "Snoop Dogg",
						type: "artist",
						uri: "spotify:artist:7hJcb9fa4alzcOq3EaNPoG"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7f9KDGqY7X2VLBM5aA66KM" },
				href: "https://api.spotify.com/v1/albums/7f9KDGqY7X2VLBM5aA66KM",
				id: "7f9KDGqY7X2VLBM5aA66KM",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e50059a623feb4eec8dcd668", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e50059a623feb4eec8dcd668", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e50059a623feb4eec8dcd668", width: 64 }
				],
				name: "Doggystyle",
				release_date: "1993",
				release_date_precision: "year",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:7f9KDGqY7X2VLBM5aA66KM"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7hJcb9fa4alzcOq3EaNPoG" },
					href: "https://api.spotify.com/v1/artists/7hJcb9fa4alzcOq3EaNPoG",
					id: "7hJcb9fa4alzcOq3EaNPoG",
					name: "Snoop Dogg",
					type: "artist",
					uri: "spotify:artist:7hJcb9fa4alzcOq3EaNPoG"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5Jz9kKRnCRLTodCH58MyB4" },
					href: "https://api.spotify.com/v1/artists/5Jz9kKRnCRLTodCH58MyB4",
					id: "5Jz9kKRnCRLTodCH58MyB4",
					name: "Daz Dillinger",
					type: "artist",
					uri: "spotify:artist:5Jz9kKRnCRLTodCH58MyB4"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 211493,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USKO10403590" },
			external_urls: { spotify: "https://open.spotify.com/track/0WKYRFtH6KKbaNWjsxqm70" },
			href: "https://api.spotify.com/v1/tracks/0WKYRFtH6KKbaNWjsxqm70",
			id: "0WKYRFtH6KKbaNWjsxqm70",
			is_local: false,
			name: "Gin And Juice (feat. Dat Nigga Daz)",
			popularity: 72,
			preview_url: "https://p.scdn.co/mp3-preview/1be6688fa7fad89ece38520610ffebd7c8fd2672?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:0WKYRFtH6KKbaNWjsxqm70"
		},
		features: {
			danceability: 0.549,
			energy: 0.853,
			key: 7,
			loudness: -4.293,
			mode: 1,
			speechiness: 0.188,
			acousticness: 0.0285,
			instrumentalness: 0.000296,
			liveness: 0.618,
			valence: 0.346,
			tempo: 95,
			type: "audio_features",
			id: "0WKYRFtH6KKbaNWjsxqm70",
			uri: "spotify:track:0WKYRFtH6KKbaNWjsxqm70",
			track_href: "https://api.spotify.com/v1/tracks/0WKYRFtH6KKbaNWjsxqm70",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0WKYRFtH6KKbaNWjsxqm70",
			duration_ms: 211493,
			time_signature: 4,
			doubletime: 190
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/77AiFEVeAVj2ORpC85QVJs" },
						href: "https://api.spotify.com/v1/artists/77AiFEVeAVj2ORpC85QVJs",
						id: "77AiFEVeAVj2ORpC85QVJs",
						name: "Steve Aoki",
						type: "artist",
						uri: "spotify:artist:77AiFEVeAVj2ORpC85QVJs"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz" },
						href: "https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz",
						id: "4O15NlyKLIASxsJ0PrXPfz",
						name: "Lil Uzi Vert",
						type: "artist",
						uri: "spotify:artist:4O15NlyKLIASxsJ0PrXPfz"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0KaQCJshy3j3TKCu59Yh6X" },
				href: "https://api.spotify.com/v1/albums/0KaQCJshy3j3TKCu59Yh6X",
				id: "0KaQCJshy3j3TKCu59Yh6X",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27341a71f6593771d37e6c11b28", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0241a71f6593771d37e6c11b28", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485141a71f6593771d37e6c11b28", width: 64 }
				],
				name: "Smoke My Dope (with Steve Aoki & Lil Uzi Vert) (From Bright: The Album)",
				release_date: "2017-12-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0KaQCJshy3j3TKCu59Yh6X"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/77AiFEVeAVj2ORpC85QVJs" },
					href: "https://api.spotify.com/v1/artists/77AiFEVeAVj2ORpC85QVJs",
					id: "77AiFEVeAVj2ORpC85QVJs",
					name: "Steve Aoki",
					type: "artist",
					uri: "spotify:artist:77AiFEVeAVj2ORpC85QVJs"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz" },
					href: "https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz",
					id: "4O15NlyKLIASxsJ0PrXPfz",
					name: "Lil Uzi Vert",
					type: "artist",
					uri: "spotify:artist:4O15NlyKLIASxsJ0PrXPfz"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 202653,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21704834" },
			external_urls: { spotify: "https://open.spotify.com/track/1BeTdfec8Kowv2QIU5o4IN" },
			href: "https://api.spotify.com/v1/tracks/1BeTdfec8Kowv2QIU5o4IN",
			id: "1BeTdfec8Kowv2QIU5o4IN",
			is_local: false,
			name: "Smoke My Dope (with Steve Aoki & Lil Uzi Vert)",
			popularity: 41,
			preview_url: "https://p.scdn.co/mp3-preview/298fdb86002bff9bccdc5c1f9357a78872ccadb5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1BeTdfec8Kowv2QIU5o4IN"
		},
		features: {
			danceability: 0.782,
			energy: 0.633,
			key: 8,
			loudness: -4.287,
			mode: 1,
			speechiness: 0.138,
			acousticness: 0.0183,
			instrumentalness: 0,
			liveness: 0.111,
			valence: 0.508,
			tempo: 128,
			type: "audio_features",
			id: "1BeTdfec8Kowv2QIU5o4IN",
			uri: "spotify:track:1BeTdfec8Kowv2QIU5o4IN",
			track_href: "https://api.spotify.com/v1/tracks/1BeTdfec8Kowv2QIU5o4IN",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1BeTdfec8Kowv2QIU5o4IN",
			duration_ms: 202653,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7abaqPX14i31AxrQ3lFQgv" },
						href: "https://api.spotify.com/v1/artists/7abaqPX14i31AxrQ3lFQgv",
						id: "7abaqPX14i31AxrQ3lFQgv",
						name: "Senbeï",
						type: "artist",
						uri: "spotify:artist:7abaqPX14i31AxrQ3lFQgv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4UGqNyHdbepDvOJmdSErDM" },
				href: "https://api.spotify.com/v1/albums/4UGqNyHdbepDvOJmdSErDM",
				id: "4UGqNyHdbepDvOJmdSErDM",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736582a63ee167c190a130d337", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026582a63ee167c190a130d337", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516582a63ee167c190a130d337", width: 64 }
				],
				name: "Nin",
				release_date: "2017-04-21",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:4UGqNyHdbepDvOJmdSErDM"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7abaqPX14i31AxrQ3lFQgv" },
					href: "https://api.spotify.com/v1/artists/7abaqPX14i31AxrQ3lFQgv",
					id: "7abaqPX14i31AxrQ3lFQgv",
					name: "Senbeï",
					type: "artist",
					uri: "spotify:artist:7abaqPX14i31AxrQ3lFQgv"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/23lZdIHegj2gmRu7byl4vG" },
					href: "https://api.spotify.com/v1/artists/23lZdIHegj2gmRu7byl4vG",
					id: "23lZdIHegj2gmRu7byl4vG",
					name: "Miscellaneous",
					type: "artist",
					uri: "spotify:artist:23lZdIHegj2gmRu7byl4vG"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 245517,
			episode: false,
			explicit: true,
			external_ids: { isrc: "FRPHC1700027" },
			external_urls: { spotify: "https://open.spotify.com/track/70JHZGYnpnHO8urKKm1vai" },
			href: "https://api.spotify.com/v1/tracks/70JHZGYnpnHO8urKKm1vai",
			id: "70JHZGYnpnHO8urKKm1vai",
			is_local: false,
			name: "Pictures",
			popularity: 14,
			preview_url: "https://p.scdn.co/mp3-preview/79d529d6514b74131996004f4c7cffb65427d9c5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:70JHZGYnpnHO8urKKm1vai"
		},
		features: {
			danceability: 0.537,
			energy: 0.787,
			key: 5,
			loudness: -7.466,
			mode: 1,
			speechiness: 0.451,
			acousticness: 0.225,
			instrumentalness: 0,
			liveness: 0.0922,
			valence: 0.515,
			tempo: 88,
			type: "audio_features",
			id: "70JHZGYnpnHO8urKKm1vai",
			uri: "spotify:track:70JHZGYnpnHO8urKKm1vai",
			track_href: "https://api.spotify.com/v1/tracks/70JHZGYnpnHO8urKKm1vai",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/70JHZGYnpnHO8urKKm1vai",
			duration_ms: 245517,
			time_signature: 4,
			doubletime: 176
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2iXdwLTWyFhlN1MQWIymvM" },
						href: "https://api.spotify.com/v1/artists/2iXdwLTWyFhlN1MQWIymvM",
						id: "2iXdwLTWyFhlN1MQWIymvM",
						name: "araabMUZIK",
						type: "artist",
						uri: "spotify:artist:2iXdwLTWyFhlN1MQWIymvM"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/34WlwSCfZ6inbDhgXqazxl" },
				href: "https://api.spotify.com/v1/albums/34WlwSCfZ6inbDhgXqazxl",
				id: "34WlwSCfZ6inbDhgXqazxl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e7cad2de59cb85e82d00b6fd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e7cad2de59cb85e82d00b6fd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e7cad2de59cb85e82d00b6fd", width: 64 }
				],
				name: "Orchestra Massacre",
				release_date: "2014-10-21",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:34WlwSCfZ6inbDhgXqazxl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2iXdwLTWyFhlN1MQWIymvM" },
					href: "https://api.spotify.com/v1/artists/2iXdwLTWyFhlN1MQWIymvM",
					id: "2iXdwLTWyFhlN1MQWIymvM",
					name: "araabMUZIK",
					type: "artist",
					uri: "spotify:artist:2iXdwLTWyFhlN1MQWIymvM"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 119024,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USUYG1162183" },
			external_urls: { spotify: "https://open.spotify.com/track/3tNTmXiQ67Pm55tNSandzx" },
			href: "https://api.spotify.com/v1/tracks/3tNTmXiQ67Pm55tNSandzx",
			id: "3tNTmXiQ67Pm55tNSandzx",
			is_local: false,
			name: "Orchestra Massacre",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3tNTmXiQ67Pm55tNSandzx"
		},
		features: {
			danceability: 0.366,
			energy: 0.994,
			key: 4,
			loudness: -0.763,
			mode: 0,
			speechiness: 0.683,
			acousticness: 0.332,
			instrumentalness: 0.206,
			liveness: 0.144,
			valence: 0.762,
			tempo: 71,
			type: "audio_features",
			id: "3tNTmXiQ67Pm55tNSandzx",
			uri: "spotify:track:3tNTmXiQ67Pm55tNSandzx",
			track_href: "https://api.spotify.com/v1/tracks/3tNTmXiQ67Pm55tNSandzx",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3tNTmXiQ67Pm55tNSandzx",
			duration_ms: 119024,
			time_signature: 4,
			doubletime: 142
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/20sxb77xiYeusSH8cVdatc" },
						href: "https://api.spotify.com/v1/artists/20sxb77xiYeusSH8cVdatc",
						id: "20sxb77xiYeusSH8cVdatc",
						name: "Meek Mill",
						type: "artist",
						uri: "spotify:artist:20sxb77xiYeusSH8cVdatc"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0A0FS04o6zMoto8OKPsDwY" },
						href: "https://api.spotify.com/v1/artists/0A0FS04o6zMoto8OKPsDwY",
						id: "0A0FS04o6zMoto8OKPsDwY",
						name: "YG",
						type: "artist",
						uri: "spotify:artist:0A0FS04o6zMoto8OKPsDwY"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7hJcb9fa4alzcOq3EaNPoG" },
						href: "https://api.spotify.com/v1/artists/7hJcb9fa4alzcOq3EaNPoG",
						id: "7hJcb9fa4alzcOq3EaNPoG",
						name: "Snoop Dogg",
						type: "artist",
						uri: "spotify:artist:7hJcb9fa4alzcOq3EaNPoG"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3wDMK9yGHVUEweHksZmGTU" },
				href: "https://api.spotify.com/v1/albums/3wDMK9yGHVUEweHksZmGTU",
				id: "3wDMK9yGHVUEweHksZmGTU",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2732a2f776c2c91ad03ae4fbed2", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e022a2f776c2c91ad03ae4fbed2", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048512a2f776c2c91ad03ae4fbed2", width: 64 }
				],
				name: "That's My N**** (with Meek Mill, YG & Snoop Dogg) [From Bright: The Album]",
				release_date: "2017-12-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:3wDMK9yGHVUEweHksZmGTU"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/20sxb77xiYeusSH8cVdatc" },
					href: "https://api.spotify.com/v1/artists/20sxb77xiYeusSH8cVdatc",
					id: "20sxb77xiYeusSH8cVdatc",
					name: "Meek Mill",
					type: "artist",
					uri: "spotify:artist:20sxb77xiYeusSH8cVdatc"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0A0FS04o6zMoto8OKPsDwY" },
					href: "https://api.spotify.com/v1/artists/0A0FS04o6zMoto8OKPsDwY",
					id: "0A0FS04o6zMoto8OKPsDwY",
					name: "YG",
					type: "artist",
					uri: "spotify:artist:0A0FS04o6zMoto8OKPsDwY"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7hJcb9fa4alzcOq3EaNPoG" },
					href: "https://api.spotify.com/v1/artists/7hJcb9fa4alzcOq3EaNPoG",
					id: "7hJcb9fa4alzcOq3EaNPoG",
					name: "Snoop Dogg",
					type: "artist",
					uri: "spotify:artist:7hJcb9fa4alzcOq3EaNPoG"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 199746,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21704833" },
			external_urls: { spotify: "https://open.spotify.com/track/3i1B1PnsfnOQPGVIzhf1lr" },
			href: "https://api.spotify.com/v1/tracks/3i1B1PnsfnOQPGVIzhf1lr",
			id: "3i1B1PnsfnOQPGVIzhf1lr",
			is_local: false,
			name: "That's My N**** (with Meek Mill, YG & Snoop Dogg)",
			popularity: 72,
			preview_url: "https://p.scdn.co/mp3-preview/c441c0dd911c52755375e4cd3ec7961599a85316?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3i1B1PnsfnOQPGVIzhf1lr"
		},
		features: {
			danceability: 0.723,
			energy: 0.732,
			key: 11,
			loudness: -5.514,
			mode: 1,
			speechiness: 0.0864,
			acousticness: 0.11,
			instrumentalness: 0,
			liveness: 0.484,
			valence: 0.503,
			tempo: 105,
			type: "audio_features",
			id: "3i1B1PnsfnOQPGVIzhf1lr",
			uri: "spotify:track:3i1B1PnsfnOQPGVIzhf1lr",
			track_href: "https://api.spotify.com/v1/tracks/3i1B1PnsfnOQPGVIzhf1lr",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3i1B1PnsfnOQPGVIzhf1lr",
			duration_ms: 199747,
			time_signature: 4,
			doubletime: 105
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4yBK75WVCQXej1p04GWqxH" },
						href: "https://api.spotify.com/v1/artists/4yBK75WVCQXej1p04GWqxH",
						id: "4yBK75WVCQXej1p04GWqxH",
						name: "Jeezy",
						type: "artist",
						uri: "spotify:artist:4yBK75WVCQXej1p04GWqxH"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4IJsz38bUJjUXkFBhU8icl" },
				href: "https://api.spotify.com/v1/albums/4IJsz38bUJjUXkFBhU8icl",
				id: "4IJsz38bUJjUXkFBhU8icl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730dfd492554c4e6aaf2fecf35", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020dfd492554c4e6aaf2fecf35", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510dfd492554c4e6aaf2fecf35", width: 64 }
				],
				name: "Pressure",
				release_date: "2017-12-15",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:4IJsz38bUJjUXkFBhU8icl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4yBK75WVCQXej1p04GWqxH" },
					href: "https://api.spotify.com/v1/artists/4yBK75WVCQXej1p04GWqxH",
					id: "4yBK75WVCQXej1p04GWqxH",
					name: "Jeezy",
					type: "artist",
					uri: "spotify:artist:4yBK75WVCQXej1p04GWqxH"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6AUl0ykLLpvTktob97x9hO" },
					href: "https://api.spotify.com/v1/artists/6AUl0ykLLpvTktob97x9hO",
					id: "6AUl0ykLLpvTktob97x9hO",
					name: "Tee Grizzley",
					type: "artist",
					uri: "spotify:artist:6AUl0ykLLpvTktob97x9hO"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 181346,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUG11701772" },
			external_urls: { spotify: "https://open.spotify.com/track/1ePdxyyF6tntoUAf8PZQuF" },
			href: "https://api.spotify.com/v1/tracks/1ePdxyyF6tntoUAf8PZQuF",
			id: "1ePdxyyF6tntoUAf8PZQuF",
			is_local: false,
			name: "Cold Summer (feat. Tee Grizzley)",
			popularity: 46,
			preview_url: "https://p.scdn.co/mp3-preview/6d231983571c521f851de03b536eb780bb50d04f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:1ePdxyyF6tntoUAf8PZQuF"
		},
		features: {
			danceability: 0.701,
			energy: 0.731,
			key: 11,
			loudness: -4.528,
			mode: 0,
			speechiness: 0.213,
			acousticness: 0.0355,
			instrumentalness: 0,
			liveness: 0.389,
			valence: 0.36,
			tempo: 90,
			type: "audio_features",
			id: "1ePdxyyF6tntoUAf8PZQuF",
			uri: "spotify:track:1ePdxyyF6tntoUAf8PZQuF",
			track_href: "https://api.spotify.com/v1/tracks/1ePdxyyF6tntoUAf8PZQuF",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1ePdxyyF6tntoUAf8PZQuF",
			duration_ms: 181347,
			time_signature: 4,
			doubletime: 180
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4yBK75WVCQXej1p04GWqxH" },
						href: "https://api.spotify.com/v1/artists/4yBK75WVCQXej1p04GWqxH",
						id: "4yBK75WVCQXej1p04GWqxH",
						name: "Jeezy",
						type: "artist",
						uri: "spotify:artist:4yBK75WVCQXej1p04GWqxH"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/00DKLvomMIGBjB3NvYDWfU" },
				href: "https://api.spotify.com/v1/albums/00DKLvomMIGBjB3NvYDWfU",
				id: "00DKLvomMIGBjB3NvYDWfU",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a3ace0df74e09278148a13db", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a3ace0df74e09278148a13db", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a3ace0df74e09278148a13db", width: 64 }
				],
				name: "Trap Or Die 3",
				release_date: "2016-10-28",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:00DKLvomMIGBjB3NvYDWfU"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4yBK75WVCQXej1p04GWqxH" },
					href: "https://api.spotify.com/v1/artists/4yBK75WVCQXej1p04GWqxH",
					id: "4yBK75WVCQXej1p04GWqxH",
					name: "Jeezy",
					type: "artist",
					uri: "spotify:artist:4yBK75WVCQXej1p04GWqxH"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6Ha4aES39QiVjR0L2lwuwq" },
					href: "https://api.spotify.com/v1/artists/6Ha4aES39QiVjR0L2lwuwq",
					id: "6Ha4aES39QiVjR0L2lwuwq",
					name: "Yo Gotti",
					type: "artist",
					uri: "spotify:artist:6Ha4aES39QiVjR0L2lwuwq"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 232426,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUG11601044" },
			external_urls: { spotify: "https://open.spotify.com/track/7x24RAzdkvH1Trz24HTYbx" },
			href: "https://api.spotify.com/v1/tracks/7x24RAzdkvH1Trz24HTYbx",
			id: "7x24RAzdkvH1Trz24HTYbx",
			is_local: false,
			name: "Where It At",
			popularity: 36,
			preview_url: "https://p.scdn.co/mp3-preview/ad65441c16961b4ce09d530c5af255ca1a5072c4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:7x24RAzdkvH1Trz24HTYbx"
		},
		features: {
			danceability: 0.673,
			energy: 0.76,
			key: 0,
			loudness: -4.391,
			mode: 0,
			speechiness: 0.0878,
			acousticness: 0.0278,
			instrumentalness: 0,
			liveness: 0.231,
			valence: 0.156,
			tempo: 76,
			type: "audio_features",
			id: "7x24RAzdkvH1Trz24HTYbx",
			uri: "spotify:track:7x24RAzdkvH1Trz24HTYbx",
			track_href: "https://api.spotify.com/v1/tracks/7x24RAzdkvH1Trz24HTYbx",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7x24RAzdkvH1Trz24HTYbx",
			duration_ms: 232427,
			time_signature: 4,
			doubletime: 152
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/43tAs3kRWvyu1B7eZOv2pp" },
						href: "https://api.spotify.com/v1/artists/43tAs3kRWvyu1B7eZOv2pp",
						id: "43tAs3kRWvyu1B7eZOv2pp",
						name: "Herobust",
						type: "artist",
						uri: "spotify:artist:43tAs3kRWvyu1B7eZOv2pp"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6zxguuGxV6KZLKPTNYyEfR" },
				href: "https://api.spotify.com/v1/albums/6zxguuGxV6KZLKPTNYyEfR",
				id: "6zxguuGxV6KZLKPTNYyEfR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c1278bea063b8d87efff2d94", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c1278bea063b8d87efff2d94", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c1278bea063b8d87efff2d94", width: 64 }
				],
				name: "I'm Aloud",
				release_date: "2016-01-22",
				release_date_precision: "day",
				total_tracks: 8,
				type: "album",
				uri: "spotify:album:6zxguuGxV6KZLKPTNYyEfR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/43tAs3kRWvyu1B7eZOv2pp" },
					href: "https://api.spotify.com/v1/artists/43tAs3kRWvyu1B7eZOv2pp",
					id: "43tAs3kRWvyu1B7eZOv2pp",
					name: "Herobust",
					type: "artist",
					uri: "spotify:artist:43tAs3kRWvyu1B7eZOv2pp"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 225103,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USZ4V1500236" },
			external_urls: { spotify: "https://open.spotify.com/track/6d1snl8uoYzP6cIuDlc2v2" },
			href: "https://api.spotify.com/v1/tracks/6d1snl8uoYzP6cIuDlc2v2",
			id: "6d1snl8uoYzP6cIuDlc2v2",
			is_local: false,
			name: "Skurt Reynolds",
			popularity: 42,
			preview_url: "https://p.scdn.co/mp3-preview/52000cf388d9c4ae7b8f783a82d4e88251ab1199?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6d1snl8uoYzP6cIuDlc2v2"
		},
		features: {
			danceability: 0.641,
			energy: 0.883,
			key: 11,
			loudness: -3.493,
			mode: 1,
			speechiness: 0.193,
			acousticness: 0.0631,
			instrumentalness: 0.00163,
			liveness: 0.506,
			valence: 0.551,
			tempo: 145,
			type: "audio_features",
			id: "6d1snl8uoYzP6cIuDlc2v2",
			uri: "spotify:track:6d1snl8uoYzP6cIuDlc2v2",
			track_href: "https://api.spotify.com/v1/tracks/6d1snl8uoYzP6cIuDlc2v2",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6d1snl8uoYzP6cIuDlc2v2",
			duration_ms: 225103,
			time_signature: 4,
			doubletime: 145
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/13ubrt8QOOCPljQ2FL1Kca" },
						href: "https://api.spotify.com/v1/artists/13ubrt8QOOCPljQ2FL1Kca",
						id: "13ubrt8QOOCPljQ2FL1Kca",
						name: "A$AP Rocky",
						type: "artist",
						uri: "spotify:artist:13ubrt8QOOCPljQ2FL1Kca"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/1E1eyI5uGllppJZCxNoF9w" },
				href: "https://api.spotify.com/v1/albums/1E1eyI5uGllppJZCxNoF9w",
				id: "1E1eyI5uGllppJZCxNoF9w",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733265ed162fa2dd5ec6434ee4", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023265ed162fa2dd5ec6434ee4", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513265ed162fa2dd5ec6434ee4", width: 64 }
				],
				name: "LONG.LIVE.A$AP (Deluxe Version)",
				release_date: "2013-01-11",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:1E1eyI5uGllppJZCxNoF9w"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/13ubrt8QOOCPljQ2FL1Kca" },
					href: "https://api.spotify.com/v1/artists/13ubrt8QOOCPljQ2FL1Kca",
					id: "13ubrt8QOOCPljQ2FL1Kca",
					name: "A$AP Rocky",
					type: "artist",
					uri: "spotify:artist:13ubrt8QOOCPljQ2FL1Kca"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
					href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
					id: "3TVXtAsR1Inumwj472S9r4",
					name: "Drake",
					type: "artist",
					uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp" },
					href: "https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp",
					id: "17lzZA2AlOHwCwFALHttmp",
					name: "2 Chainz",
					type: "artist",
					uri: "spotify:artist:17lzZA2AlOHwCwFALHttmp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2YZyLoL8N0Wb9xBt1NhZWg" },
					href: "https://api.spotify.com/v1/artists/2YZyLoL8N0Wb9xBt1NhZWg",
					id: "2YZyLoL8N0Wb9xBt1NhZWg",
					name: "Kendrick Lamar",
					type: "artist",
					uri: "spotify:artist:2YZyLoL8N0Wb9xBt1NhZWg"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 233786,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USRC11201220" },
			external_urls: { spotify: "https://open.spotify.com/track/4XoP1AkbOurU9CeZ2rMEz2" },
			href: "https://api.spotify.com/v1/tracks/4XoP1AkbOurU9CeZ2rMEz2",
			id: "4XoP1AkbOurU9CeZ2rMEz2",
			is_local: false,
			name: "F**kin' Problems (feat. Drake, 2 Chainz & Kendrick Lamar)",
			popularity: 14,
			preview_url: null,
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:4XoP1AkbOurU9CeZ2rMEz2"
		},
		features: {
			danceability: 0.869,
			energy: 0.687,
			key: 1,
			loudness: -6.816,
			mode: 1,
			speechiness: 0.263,
			acousticness: 0.0208,
			instrumentalness: 0.000001,
			liveness: 0.114,
			valence: 0.668,
			tempo: 96,
			type: "audio_features",
			id: "4XoP1AkbOurU9CeZ2rMEz2",
			uri: "spotify:track:4XoP1AkbOurU9CeZ2rMEz2",
			track_href: "https://api.spotify.com/v1/tracks/4XoP1AkbOurU9CeZ2rMEz2",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4XoP1AkbOurU9CeZ2rMEz2",
			duration_ms: 233787,
			time_signature: 4,
			doubletime: 192
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
						href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
						id: "4xRYI6VqpkE3UwrDrAZL8L",
						name: "Logic",
						type: "artist",
						uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1HiN2YXZcc3EjmVZ4WjfBk" },
				href: "https://api.spotify.com/v1/albums/1HiN2YXZcc3EjmVZ4WjfBk",
				id: "1HiN2YXZcc3EjmVZ4WjfBk",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273d5c8614eebc6752c0b8ec17a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02d5c8614eebc6752c0b8ec17a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851d5c8614eebc6752c0b8ec17a", width: 64 }
				],
				name: "Everybody",
				release_date: "2017-05-05",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:1HiN2YXZcc3EjmVZ4WjfBk"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
					href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
					id: "4xRYI6VqpkE3UwrDrAZL8L",
					name: "Logic",
					type: "artist",
					uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 400013,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71702804" },
			external_urls: { spotify: "https://open.spotify.com/track/6HN5XPJEV31RQJGoyqZ81K" },
			href: "https://api.spotify.com/v1/tracks/6HN5XPJEV31RQJGoyqZ81K",
			id: "6HN5XPJEV31RQJGoyqZ81K",
			is_local: false,
			name: "Take It Back",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/362fbbd2a3ddd76b22822ae9462379592f8266f3?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:6HN5XPJEV31RQJGoyqZ81K"
		},
		features: {
			danceability: 0.837,
			energy: 0.84,
			key: 7,
			loudness: -4.293,
			mode: 1,
			speechiness: 0.239,
			acousticness: 0.0629,
			instrumentalness: 0,
			liveness: 0.329,
			valence: 0.692,
			tempo: 135,
			type: "audio_features",
			id: "6HN5XPJEV31RQJGoyqZ81K",
			uri: "spotify:track:6HN5XPJEV31RQJGoyqZ81K",
			track_href: "https://api.spotify.com/v1/tracks/6HN5XPJEV31RQJGoyqZ81K",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6HN5XPJEV31RQJGoyqZ81K",
			duration_ms: 400013,
			time_signature: 4,
			doubletime: 135
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/31W5EY0aAly4Qieq6OFu6I" },
						href: "https://api.spotify.com/v1/artists/31W5EY0aAly4Qieq6OFu6I",
						id: "31W5EY0aAly4Qieq6OFu6I",
						name: "A Boogie Wit da Hoodie",
						type: "artist",
						uri: "spotify:artist:31W5EY0aAly4Qieq6OFu6I"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JP",
					"KW",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"RO",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3HHp5I6Q6SEyU5bkvoCtnV" },
				href: "https://api.spotify.com/v1/albums/3HHp5I6Q6SEyU5bkvoCtnV",
				id: "3HHp5I6Q6SEyU5bkvoCtnV",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273cdba7ee22968991250725ce1", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02cdba7ee22968991250725ce1", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851cdba7ee22968991250725ce1", width: 64 }
				],
				name: "The Bigger Artist",
				release_date: "2017-09-29",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:3HHp5I6Q6SEyU5bkvoCtnV"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/31W5EY0aAly4Qieq6OFu6I" },
					href: "https://api.spotify.com/v1/artists/31W5EY0aAly4Qieq6OFu6I",
					id: "31W5EY0aAly4Qieq6OFu6I",
					name: "A Boogie Wit da Hoodie",
					type: "artist",
					uri: "spotify:artist:31W5EY0aAly4Qieq6OFu6I"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/46SHBwWsqBkxI7EeeBEQG7" },
					href: "https://api.spotify.com/v1/artists/46SHBwWsqBkxI7EeeBEQG7",
					id: "46SHBwWsqBkxI7EeeBEQG7",
					name: "Kodak Black",
					type: "artist",
					uri: "spotify:artist:46SHBwWsqBkxI7EeeBEQG7"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JP",
				"KW",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"RO",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 209269,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21701817" },
			external_urls: { spotify: "https://open.spotify.com/track/1f5cbQtDrykjarZVrShaDI" },
			href: "https://api.spotify.com/v1/tracks/1f5cbQtDrykjarZVrShaDI",
			id: "1f5cbQtDrykjarZVrShaDI",
			is_local: false,
			name: "Drowning (feat. Kodak Black)",
			popularity: 76,
			preview_url: "https://p.scdn.co/mp3-preview/eddebe070cb8339e7f04ca7dce27052d090e277f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:1f5cbQtDrykjarZVrShaDI"
		},
		features: {
			danceability: 0.839,
			energy: 0.81,
			key: 5,
			loudness: -5.274,
			mode: 0,
			speechiness: 0.0568,
			acousticness: 0.501,
			instrumentalness: 0,
			liveness: 0.117,
			valence: 0.814,
			tempo: 129,
			type: "audio_features",
			id: "1f5cbQtDrykjarZVrShaDI",
			uri: "spotify:track:1f5cbQtDrykjarZVrShaDI",
			track_href: "https://api.spotify.com/v1/tracks/1f5cbQtDrykjarZVrShaDI",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1f5cbQtDrykjarZVrShaDI",
			duration_ms: 209269,
			time_signature: 4,
			doubletime: 129
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
						href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
						id: "4xRYI6VqpkE3UwrDrAZL8L",
						name: "Logic",
						type: "artist",
						uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4F87p1aiFwHeU4uu65MaPV" },
				href: "https://api.spotify.com/v1/albums/4F87p1aiFwHeU4uu65MaPV",
				id: "4F87p1aiFwHeU4uu65MaPV",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e19b1b51cdd35051e17cf6dc", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e19b1b51cdd35051e17cf6dc", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e19b1b51cdd35051e17cf6dc", width: 64 }
				],
				name: "Bobby Tarantino II",
				release_date: "2018-03-09",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:4F87p1aiFwHeU4uu65MaPV"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
					href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
					id: "4xRYI6VqpkE3UwrDrAZL8L",
					name: "Logic",
					type: "artist",
					uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 217146,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71802492" },
			external_urls: { spotify: "https://open.spotify.com/track/7u90MSvVyEjL0c8icaE7jl" },
			href: "https://api.spotify.com/v1/tracks/7u90MSvVyEjL0c8icaE7jl",
			id: "7u90MSvVyEjL0c8icaE7jl",
			is_local: false,
			name: "Contra",
			popularity: 59,
			preview_url: "https://p.scdn.co/mp3-preview/4b1b561f2103aba08b961006d857cdc4ee6795bd?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:7u90MSvVyEjL0c8icaE7jl"
		},
		features: {
			danceability: 0.804,
			energy: 0.823,
			key: 8,
			loudness: -5.837,
			mode: 1,
			speechiness: 0.0488,
			acousticness: 0.104,
			instrumentalness: 0,
			liveness: 0.2,
			valence: 0.616,
			tempo: 126,
			type: "audio_features",
			id: "7u90MSvVyEjL0c8icaE7jl",
			uri: "spotify:track:7u90MSvVyEjL0c8icaE7jl",
			track_href: "https://api.spotify.com/v1/tracks/7u90MSvVyEjL0c8icaE7jl",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7u90MSvVyEjL0c8icaE7jl",
			duration_ms: 217147,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7sfl4Xt5KmfyDs2T3SVSMK" },
						href: "https://api.spotify.com/v1/artists/7sfl4Xt5KmfyDs2T3SVSMK",
						id: "7sfl4Xt5KmfyDs2T3SVSMK",
						name: "Lil Jon",
						type: "artist",
						uri: "spotify:artist:7sfl4Xt5KmfyDs2T3SVSMK"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5ot3hAGLgvrmfZ3ddosFZf" },
				href: "https://api.spotify.com/v1/albums/5ot3hAGLgvrmfZ3ddosFZf",
				id: "5ot3hAGLgvrmfZ3ddosFZf",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273aa119fab1d342e3a7e4ddb2c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02aa119fab1d342e3a7e4ddb2c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851aa119fab1d342e3a7e4ddb2c", width: 64 }
				],
				name: "Snap Yo Fingers - Single",
				release_date: "2006-05-02",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5ot3hAGLgvrmfZ3ddosFZf"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2OqENqJFXPORP4BUGnu2Qq" },
					href: "https://api.spotify.com/v1/artists/2OqENqJFXPORP4BUGnu2Qq",
					id: "2OqENqJFXPORP4BUGnu2Qq",
					name: "Youngbloodz",
					type: "artist",
					uri: "spotify:artist:2OqENqJFXPORP4BUGnu2Qq"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3dwESUD2sahwxyFL6SYtEn" },
					href: "https://api.spotify.com/v1/artists/3dwESUD2sahwxyFL6SYtEn",
					id: "3dwESUD2sahwxyFL6SYtEn",
					name: "Sean Paul",
					type: "artist",
					uri: "spotify:artist:3dwESUD2sahwxyFL6SYtEn"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
					href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
					id: "3crnzLy8R4lVwaigKEOz7V",
					name: "E-40",
					type: "artist",
					uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7sfl4Xt5KmfyDs2T3SVSMK" },
					href: "https://api.spotify.com/v1/artists/7sfl4Xt5KmfyDs2T3SVSMK",
					id: "7sfl4Xt5KmfyDs2T3SVSMK",
					name: "Lil Jon",
					type: "artist",
					uri: "spotify:artist:7sfl4Xt5KmfyDs2T3SVSMK"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 274386,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USTV10600013" },
			external_urls: { spotify: "https://open.spotify.com/track/6o3s08kk2fQI37vxGZDrJ1" },
			href: "https://api.spotify.com/v1/tracks/6o3s08kk2fQI37vxGZDrJ1",
			id: "6o3s08kk2fQI37vxGZDrJ1",
			is_local: false,
			name: "Snap Yo Fingers",
			popularity: 67,
			preview_url: "https://p.scdn.co/mp3-preview/fa9b9ff0464a50c5ebf4ebf2fb089a96ff40d5c4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6o3s08kk2fQI37vxGZDrJ1"
		},
		features: {
			danceability: 0.835,
			energy: 0.757,
			key: 8,
			loudness: -5.029,
			mode: 0,
			speechiness: 0.23,
			acousticness: 0.00647,
			instrumentalness: 0,
			liveness: 0.29,
			valence: 0.626,
			tempo: 82,
			type: "audio_features",
			id: "6o3s08kk2fQI37vxGZDrJ1",
			uri: "spotify:track:6o3s08kk2fQI37vxGZDrJ1",
			track_href: "https://api.spotify.com/v1/tracks/6o3s08kk2fQI37vxGZDrJ1",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6o3s08kk2fQI37vxGZDrJ1",
			duration_ms: 274387,
			time_signature: 4,
			doubletime: 164
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW" },
						href: "https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW",
						id: "11gWrKZMBsGQWmobv3oNfW",
						name: "Alison Wonderland",
						type: "artist",
						uri: "spotify:artist:11gWrKZMBsGQWmobv3oNfW"
					}
				],
				available_markets: ["AU", "CA", "GB", "IE", "MX", "NZ", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/6ahNh15MTKTZb2IQJMnqBy" },
				href: "https://api.spotify.com/v1/albums/6ahNh15MTKTZb2IQJMnqBy",
				id: "6ahNh15MTKTZb2IQJMnqBy",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2737b84036a7c28fa9d3e49879b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e027b84036a7c28fa9d3e49879b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048517b84036a7c28fa9d3e49879b", width: 64 }
				],
				name: "Run (Deluxe Edition - Remixes)",
				release_date: "2015-10-30",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:6ahNh15MTKTZb2IQJMnqBy"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW" },
					href: "https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW",
					id: "11gWrKZMBsGQWmobv3oNfW",
					name: "Alison Wonderland",
					type: "artist",
					uri: "spotify:artist:11gWrKZMBsGQWmobv3oNfW"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4GQRAVwht11iG3QAsm7SVv" },
					href: "https://api.spotify.com/v1/artists/4GQRAVwht11iG3QAsm7SVv",
					id: "4GQRAVwht11iG3QAsm7SVv",
					name: "Tasker",
					type: "artist",
					uri: "spotify:artist:4GQRAVwht11iG3QAsm7SVv"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5Hbc9hz3YUoO1P8h8zuSit" },
					href: "https://api.spotify.com/v1/artists/5Hbc9hz3YUoO1P8h8zuSit",
					id: "5Hbc9hz3YUoO1P8h8zuSit",
					name: "Leaderboy",
					type: "artist",
					uri: "spotify:artist:5Hbc9hz3YUoO1P8h8zuSit"
				}
			],
			available_markets: ["AU", "CA", "GB", "IE", "MX", "NZ", "US"],
			disc_number: 1,
			duration_ms: 181145,
			episode: false,
			explicit: false,
			external_ids: { isrc: "AUUM71501300" },
			external_urls: { spotify: "https://open.spotify.com/track/3a4sSjHXjy1vHX4A1pM4EC" },
			href: "https://api.spotify.com/v1/tracks/3a4sSjHXjy1vHX4A1pM4EC",
			id: "3a4sSjHXjy1vHX4A1pM4EC",
			is_local: false,
			name: "Get Ready - Tasker & Leaderboy Remix",
			popularity: 44,
			preview_url: "https://p.scdn.co/mp3-preview/9f2f776fcde104cced0608bf1ed7d87993d36b4e?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 12,
			type: "track",
			uri: "spotify:track:3a4sSjHXjy1vHX4A1pM4EC"
		},
		features: {
			danceability: 0.51,
			energy: 0.684,
			key: 8,
			loudness: -7.352,
			mode: 1,
			speechiness: 0.115,
			acousticness: 0.0443,
			instrumentalness: 0.847,
			liveness: 0.171,
			valence: 0.116,
			tempo: 155,
			type: "audio_features",
			id: "3a4sSjHXjy1vHX4A1pM4EC",
			uri: "spotify:track:3a4sSjHXjy1vHX4A1pM4EC",
			track_href: "https://api.spotify.com/v1/tracks/3a4sSjHXjy1vHX4A1pM4EC",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3a4sSjHXjy1vHX4A1pM4EC",
			duration_ms: 181146,
			time_signature: 4,
			doubletime: 155
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/72rZmJbRFSY6IFJAysfOdr" },
						href: "https://api.spotify.com/v1/artists/72rZmJbRFSY6IFJAysfOdr",
						id: "72rZmJbRFSY6IFJAysfOdr",
						name: "Too Many Zooz",
						type: "artist",
						uri: "spotify:artist:72rZmJbRFSY6IFJAysfOdr"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0GvhshU38CjwxkvWAmbXS0" },
				href: "https://api.spotify.com/v1/albums/0GvhshU38CjwxkvWAmbXS0",
				id: "0GvhshU38CjwxkvWAmbXS0",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c4f859e21ed944c701354b01", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c4f859e21ed944c701354b01", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c4f859e21ed944c701354b01", width: 64 }
				],
				name: "Subway Gawdz",
				release_date: "2016-07-06",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:0GvhshU38CjwxkvWAmbXS0"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/72rZmJbRFSY6IFJAysfOdr" },
					href: "https://api.spotify.com/v1/artists/72rZmJbRFSY6IFJAysfOdr",
					id: "72rZmJbRFSY6IFJAysfOdr",
					name: "Too Many Zooz",
					type: "artist",
					uri: "spotify:artist:72rZmJbRFSY6IFJAysfOdr"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2qAwMsiIjTzlmfAkXKvhVA" },
					href: "https://api.spotify.com/v1/artists/2qAwMsiIjTzlmfAkXKvhVA",
					id: "2qAwMsiIjTzlmfAkXKvhVA",
					name: "Armani White",
					type: "artist",
					uri: "spotify:artist:2qAwMsiIjTzlmfAkXKvhVA"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 184005,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCACQ1614496" },
			external_urls: { spotify: "https://open.spotify.com/track/3gW1alU9iy29QDfAvzOA3u" },
			href: "https://api.spotify.com/v1/tracks/3gW1alU9iy29QDfAvzOA3u",
			id: "3gW1alU9iy29QDfAvzOA3u",
			is_local: false,
			name: "Talkin Bout (feat. Armani White)",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/ad3e787f4d1a06dc73285984a748b5b267bcd122?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 13,
			type: "track",
			uri: "spotify:track:3gW1alU9iy29QDfAvzOA3u"
		},
		features: {
			danceability: 0.805,
			energy: 0.942,
			key: 5,
			loudness: -7.011,
			mode: 1,
			speechiness: 0.241,
			acousticness: 0.0665,
			instrumentalness: 0,
			liveness: 0.1,
			valence: 0.325,
			tempo: 120,
			type: "audio_features",
			id: "3gW1alU9iy29QDfAvzOA3u",
			uri: "spotify:track:3gW1alU9iy29QDfAvzOA3u",
			track_href: "https://api.spotify.com/v1/tracks/3gW1alU9iy29QDfAvzOA3u",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3gW1alU9iy29QDfAvzOA3u",
			duration_ms: 184005,
			time_signature: 4,
			doubletime: 120
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
						href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
						id: "0EeQBlQJFiAfJeVN2vT9s0",
						name: "Nipsey Hussle",
						type: "artist",
						uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6rcbbhcm8Os7EiVRHP9Aef" },
				href: "https://api.spotify.com/v1/albums/6rcbbhcm8Os7EiVRHP9Aef",
				id: "6rcbbhcm8Os7EiVRHP9Aef",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ac271e5d670e92c42bf99237", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ac271e5d670e92c42bf99237", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ac271e5d670e92c42bf99237", width: 64 }
				],
				name: "Victory Lap",
				release_date: "2018-02-16",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:6rcbbhcm8Os7EiVRHP9Aef"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
					href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
					id: "0EeQBlQJFiAfJeVN2vT9s0",
					name: "Nipsey Hussle",
					type: "artist",
					uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 175040,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21705211" },
			external_urls: { spotify: "https://open.spotify.com/track/3R9j8urSPiBbapNbyuSYkE" },
			href: "https://api.spotify.com/v1/tracks/3R9j8urSPiBbapNbyuSYkE",
			id: "3R9j8urSPiBbapNbyuSYkE",
			is_local: false,
			name: "Grinding All My Life",
			popularity: 71,
			preview_url: "https://p.scdn.co/mp3-preview/e10643a368681e1d0dd46b02f693486c3b94f780?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 11,
			type: "track",
			uri: "spotify:track:3R9j8urSPiBbapNbyuSYkE"
		},
		features: {
			danceability: 0.6,
			energy: 0.716,
			key: 3,
			loudness: -5.554,
			mode: 0,
			speechiness: 0.384,
			acousticness: 0.0491,
			instrumentalness: 0,
			liveness: 0.109,
			valence: 0.246,
			tempo: 180,
			type: "audio_features",
			id: "3R9j8urSPiBbapNbyuSYkE",
			uri: "spotify:track:3R9j8urSPiBbapNbyuSYkE",
			track_href: "https://api.spotify.com/v1/tracks/3R9j8urSPiBbapNbyuSYkE",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3R9j8urSPiBbapNbyuSYkE",
			duration_ms: 175040,
			time_signature: 4,
			doubletime: 180
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1sBkRIssrMs1AbVkOJbc7a" },
						href: "https://api.spotify.com/v1/artists/1sBkRIssrMs1AbVkOJbc7a",
						id: "1sBkRIssrMs1AbVkOJbc7a",
						name: "Rick Ross",
						type: "artist",
						uri: "spotify:artist:1sBkRIssrMs1AbVkOJbc7a"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/08XXyTmAv1vNghZS4p0ng2" },
				href: "https://api.spotify.com/v1/albums/08XXyTmAv1vNghZS4p0ng2",
				id: "08XXyTmAv1vNghZS4p0ng2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2731f495241a4476b213b7ef76c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e021f495241a4476b213b7ef76c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048511f495241a4476b213b7ef76c", width: 64 }
				],
				name: "Rather You Than Me",
				release_date: "2017-03-17",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:08XXyTmAv1vNghZS4p0ng2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1sBkRIssrMs1AbVkOJbc7a" },
					href: "https://api.spotify.com/v1/artists/1sBkRIssrMs1AbVkOJbc7a",
					id: "1sBkRIssrMs1AbVkOJbc7a",
					name: "Rick Ross",
					type: "artist",
					uri: "spotify:artist:1sBkRIssrMs1AbVkOJbc7a"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/50co4Is1HCEo8bhOyUWKpn" },
					href: "https://api.spotify.com/v1/artists/50co4Is1HCEo8bhOyUWKpn",
					id: "50co4Is1HCEo8bhOyUWKpn",
					name: "Young Thug",
					type: "artist",
					uri: "spotify:artist:50co4Is1HCEo8bhOyUWKpn"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/67nwj3Y5sZQLl72VNUHEYE" },
					href: "https://api.spotify.com/v1/artists/67nwj3Y5sZQLl72VNUHEYE",
					id: "67nwj3Y5sZQLl72VNUHEYE",
					name: "Wale",
					type: "artist",
					uri: "spotify:artist:67nwj3Y5sZQLl72VNUHEYE"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 275720,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USSM11701695" },
			external_urls: { spotify: "https://open.spotify.com/track/1KZ0Xo6Mmeprp1Sw5xCHYz" },
			href: "https://api.spotify.com/v1/tracks/1KZ0Xo6Mmeprp1Sw5xCHYz",
			id: "1KZ0Xo6Mmeprp1Sw5xCHYz",
			is_local: false,
			name: "Trap Trap Trap (feat. Young Thug & Wale)",
			popularity: 49,
			preview_url: "https://p.scdn.co/mp3-preview/89b110cc64cc17f7a6e962d740da14cfaf1cad4f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:1KZ0Xo6Mmeprp1Sw5xCHYz"
		},
		features: {
			danceability: 0.729,
			energy: 0.838,
			key: 8,
			loudness: -4.476,
			mode: 0,
			speechiness: 0.313,
			acousticness: 0.00612,
			instrumentalness: 0,
			liveness: 0.0721,
			valence: 0.349,
			tempo: 137,
			type: "audio_features",
			id: "1KZ0Xo6Mmeprp1Sw5xCHYz",
			uri: "spotify:track:1KZ0Xo6Mmeprp1Sw5xCHYz",
			track_href: "https://api.spotify.com/v1/tracks/1KZ0Xo6Mmeprp1Sw5xCHYz",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1KZ0Xo6Mmeprp1Sw5xCHYz",
			duration_ms: 275720,
			time_signature: 4,
			doubletime: 137
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1LrWZc2qPhRCHyr6XtpBxq" },
						href: "https://api.spotify.com/v1/artists/1LrWZc2qPhRCHyr6XtpBxq",
						id: "1LrWZc2qPhRCHyr6XtpBxq",
						name: "Dizzy Wright",
						type: "artist",
						uri: "spotify:artist:1LrWZc2qPhRCHyr6XtpBxq"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4GVooTNycoU3LC8XvIHGbo" },
				href: "https://api.spotify.com/v1/albums/4GVooTNycoU3LC8XvIHGbo",
				id: "4GVooTNycoU3LC8XvIHGbo",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2732bfa365d944ad40d158ff800", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e022bfa365d944ad40d158ff800", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048512bfa365d944ad40d158ff800", width: 64 }
				],
				name: "State of Mind 2",
				release_date: "2017-11-24",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:4GVooTNycoU3LC8XvIHGbo"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1LrWZc2qPhRCHyr6XtpBxq" },
					href: "https://api.spotify.com/v1/artists/1LrWZc2qPhRCHyr6XtpBxq",
					id: "1LrWZc2qPhRCHyr6XtpBxq",
					name: "Dizzy Wright",
					type: "artist",
					uri: "spotify:artist:1LrWZc2qPhRCHyr6XtpBxq"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 207897,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1169419" },
			external_urls: { spotify: "https://open.spotify.com/track/6puuZHK2g0TTRymXXoQj1U" },
			href: "https://api.spotify.com/v1/tracks/6puuZHK2g0TTRymXXoQj1U",
			id: "6puuZHK2g0TTRymXXoQj1U",
			is_local: false,
			name: "Flatline",
			popularity: 46,
			preview_url: "https://p.scdn.co/mp3-preview/2d2fd7770b329ca22087b9ddd5dc94d0797e4739?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:6puuZHK2g0TTRymXXoQj1U"
		},
		features: {
			danceability: 0.651,
			energy: 0.441,
			key: 1,
			loudness: -9.361,
			mode: 1,
			speechiness: 0.309,
			acousticness: 0.141,
			instrumentalness: 0.000182,
			liveness: 0.0804,
			valence: 0.23,
			tempo: 85,
			type: "audio_features",
			id: "6puuZHK2g0TTRymXXoQj1U",
			uri: "spotify:track:6puuZHK2g0TTRymXXoQj1U",
			track_href: "https://api.spotify.com/v1/tracks/6puuZHK2g0TTRymXXoQj1U",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6puuZHK2g0TTRymXXoQj1U",
			duration_ms: 207897,
			time_signature: 4,
			doubletime: 170
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
						href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
						id: "0EeQBlQJFiAfJeVN2vT9s0",
						name: "Nipsey Hussle",
						type: "artist",
						uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6rcbbhcm8Os7EiVRHP9Aef" },
				href: "https://api.spotify.com/v1/albums/6rcbbhcm8Os7EiVRHP9Aef",
				id: "6rcbbhcm8Os7EiVRHP9Aef",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ac271e5d670e92c42bf99237", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ac271e5d670e92c42bf99237", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ac271e5d670e92c42bf99237", width: 64 }
				],
				name: "Victory Lap",
				release_date: "2018-02-16",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:6rcbbhcm8Os7EiVRHP9Aef"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
					href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
					id: "0EeQBlQJFiAfJeVN2vT9s0",
					name: "Nipsey Hussle",
					type: "artist",
					uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0A0FS04o6zMoto8OKPsDwY" },
					href: "https://api.spotify.com/v1/artists/0A0FS04o6zMoto8OKPsDwY",
					id: "0A0FS04o6zMoto8OKPsDwY",
					name: "YG",
					type: "artist",
					uri: "spotify:artist:0A0FS04o6zMoto8OKPsDwY"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 225573,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21705203" },
			external_urls: { spotify: "https://open.spotify.com/track/39xWBHPM4E9MwzEy5gbM7p" },
			href: "https://api.spotify.com/v1/tracks/39xWBHPM4E9MwzEy5gbM7p",
			id: "39xWBHPM4E9MwzEy5gbM7p",
			is_local: false,
			name: "Last Time That I Checc'd (feat. YG)",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/3c1aff4256822c342925cce6099ceaa14de0ca27?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:39xWBHPM4E9MwzEy5gbM7p"
		},
		features: {
			danceability: 0.711,
			energy: 0.746,
			key: 1,
			loudness: -4.224,
			mode: 1,
			speechiness: 0.253,
			acousticness: 0.0289,
			instrumentalness: 0,
			liveness: 0.371,
			valence: 0.279,
			tempo: 96,
			type: "audio_features",
			id: "39xWBHPM4E9MwzEy5gbM7p",
			uri: "spotify:track:39xWBHPM4E9MwzEy5gbM7p",
			track_href: "https://api.spotify.com/v1/tracks/39xWBHPM4E9MwzEy5gbM7p",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/39xWBHPM4E9MwzEy5gbM7p",
			duration_ms: 225573,
			time_signature: 4,
			doubletime: 192
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
						href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
						id: "0EeQBlQJFiAfJeVN2vT9s0",
						name: "Nipsey Hussle",
						type: "artist",
						uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6rcbbhcm8Os7EiVRHP9Aef" },
				href: "https://api.spotify.com/v1/albums/6rcbbhcm8Os7EiVRHP9Aef",
				id: "6rcbbhcm8Os7EiVRHP9Aef",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ac271e5d670e92c42bf99237", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ac271e5d670e92c42bf99237", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ac271e5d670e92c42bf99237", width: 64 }
				],
				name: "Victory Lap",
				release_date: "2018-02-16",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:6rcbbhcm8Os7EiVRHP9Aef"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0EeQBlQJFiAfJeVN2vT9s0" },
					href: "https://api.spotify.com/v1/artists/0EeQBlQJFiAfJeVN2vT9s0",
					id: "0EeQBlQJFiAfJeVN2vT9s0",
					name: "Nipsey Hussle",
					type: "artist",
					uri: "spotify:artist:0EeQBlQJFiAfJeVN2vT9s0"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2YZyLoL8N0Wb9xBt1NhZWg" },
					href: "https://api.spotify.com/v1/artists/2YZyLoL8N0Wb9xBt1NhZWg",
					id: "2YZyLoL8N0Wb9xBt1NhZWg",
					name: "Kendrick Lamar",
					type: "artist",
					uri: "spotify:artist:2YZyLoL8N0Wb9xBt1NhZWg"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 245813,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21705205" },
			external_urls: { spotify: "https://open.spotify.com/track/6fIjnWrv46njJHLDAY2JdC" },
			href: "https://api.spotify.com/v1/tracks/6fIjnWrv46njJHLDAY2JdC",
			id: "6fIjnWrv46njJHLDAY2JdC",
			is_local: false,
			name: "Dedication (feat. Kendrick Lamar)",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/18d76ba89f8718db9fd1511bc763930e8a658a1c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:6fIjnWrv46njJHLDAY2JdC"
		},
		features: {
			danceability: 0.512,
			energy: 0.734,
			key: 8,
			loudness: -5.448,
			mode: 0,
			speechiness: 0.438,
			acousticness: 0.431,
			instrumentalness: 0,
			liveness: 0.226,
			valence: 0.168,
			tempo: 94,
			type: "audio_features",
			id: "6fIjnWrv46njJHLDAY2JdC",
			uri: "spotify:track:6fIjnWrv46njJHLDAY2JdC",
			track_href: "https://api.spotify.com/v1/tracks/6fIjnWrv46njJHLDAY2JdC",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6fIjnWrv46njJHLDAY2JdC",
			duration_ms: 245813,
			time_signature: 4,
			doubletime: 188
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5ggQkaEdMsTB3TBzT7vQyc" },
						href: "https://api.spotify.com/v1/artists/5ggQkaEdMsTB3TBzT7vQyc",
						id: "5ggQkaEdMsTB3TBzT7vQyc",
						name: "P",
						type: "artist",
						uri: "spotify:artist:5ggQkaEdMsTB3TBzT7vQyc"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6ZJfhhjQhd8vJ8QUzfKYTS" },
				href: "https://api.spotify.com/v1/albums/6ZJfhhjQhd8vJ8QUzfKYTS",
				id: "6ZJfhhjQhd8vJ8QUzfKYTS",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27362f7860006da450a80b54e92", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0262f7860006da450a80b54e92", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485162f7860006da450a80b54e92", width: 64 }
				],
				name: "Suffer17",
				release_date: "2017-12-30",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:6ZJfhhjQhd8vJ8QUzfKYTS"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5ggQkaEdMsTB3TBzT7vQyc" },
					href: "https://api.spotify.com/v1/artists/5ggQkaEdMsTB3TBzT7vQyc",
					id: "5ggQkaEdMsTB3TBzT7vQyc",
					name: "P",
					type: "artist",
					uri: "spotify:artist:5ggQkaEdMsTB3TBzT7vQyc"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 157514,
			episode: false,
			explicit: true,
			external_ids: { isrc: "TCADK1783529" },
			external_urls: { spotify: "https://open.spotify.com/track/3Ucdac9270ejVhjrbrgaQ3" },
			href: "https://api.spotify.com/v1/tracks/3Ucdac9270ejVhjrbrgaQ3",
			id: "3Ucdac9270ejVhjrbrgaQ3",
			is_local: false,
			name: "17",
			popularity: 6,
			preview_url: "https://p.scdn.co/mp3-preview/d01ff1696106278462785ae326f968c9ae7d4d7a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:3Ucdac9270ejVhjrbrgaQ3"
		},
		features: {
			danceability: 0.507,
			energy: 0.719,
			key: 9,
			loudness: -9.321,
			mode: 0,
			speechiness: 0.045,
			acousticness: 0.0000236,
			instrumentalness: 0.707,
			liveness: 0.164,
			valence: 0.205,
			tempo: 91,
			type: "audio_features",
			id: "3Ucdac9270ejVhjrbrgaQ3",
			uri: "spotify:track:3Ucdac9270ejVhjrbrgaQ3",
			track_href: "https://api.spotify.com/v1/tracks/3Ucdac9270ejVhjrbrgaQ3",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3Ucdac9270ejVhjrbrgaQ3",
			duration_ms: 157515,
			time_signature: 4,
			doubletime: 182
		}
	},
	{
		track: {
			album: {
				album_type: "compilation",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/73eX2PJeM8IWF0HTJZm79e" },
				href: "https://api.spotify.com/v1/albums/73eX2PJeM8IWF0HTJZm79e",
				id: "73eX2PJeM8IWF0HTJZm79e",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27374fba4df2aad6fa261c32df0", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0274fba4df2aad6fa261c32df0", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485174fba4df2aad6fa261c32df0", width: 64 }
				],
				name: "Rubble Kings: The Album",
				release_date: "2016-01-15",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:73eX2PJeM8IWF0HTJZm79e"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/45a6gCQWq61lIUDmr1tKuO" },
					href: "https://api.spotify.com/v1/artists/45a6gCQWq61lIUDmr1tKuO",
					id: "45a6gCQWq61lIUDmr1tKuO",
					name: "Bun B",
					type: "artist",
					uri: "spotify:artist:45a6gCQWq61lIUDmr1tKuO"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2N4EYkIlG1kv25g6Wv8LGI" },
					href: "https://api.spotify.com/v1/artists/2N4EYkIlG1kv25g6Wv8LGI",
					id: "2N4EYkIlG1kv25g6Wv8LGI",
					name: "Killer Mike",
					type: "artist",
					uri: "spotify:artist:2N4EYkIlG1kv25g6Wv8LGI"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6xl2SrZDzQSJUYU9M1qkqL" },
					href: "https://api.spotify.com/v1/artists/6xl2SrZDzQSJUYU9M1qkqL",
					id: "6xl2SrZDzQSJUYU9M1qkqL",
					name: "Cuz Lightyear",
					type: "artist",
					uri: "spotify:artist:6xl2SrZDzQSJUYU9M1qkqL"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 228093,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QM8RL1400248" },
			external_urls: { spotify: "https://open.spotify.com/track/3KZzvyUNK3GcWSdyV8lQPM" },
			href: "https://api.spotify.com/v1/tracks/3KZzvyUNK3GcWSdyV8lQPM",
			id: "3KZzvyUNK3GcWSdyV8lQPM",
			is_local: false,
			name: "Savage Habits",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:3KZzvyUNK3GcWSdyV8lQPM"
		},
		features: {
			danceability: 0.756,
			energy: 0.851,
			key: 2,
			loudness: -5.113,
			mode: 1,
			speechiness: 0.052,
			acousticness: 0.00226,
			instrumentalness: 0,
			liveness: 0.68,
			valence: 0.16,
			tempo: 130,
			type: "audio_features",
			id: "3KZzvyUNK3GcWSdyV8lQPM",
			uri: "spotify:track:3KZzvyUNK3GcWSdyV8lQPM",
			track_href: "https://api.spotify.com/v1/tracks/3KZzvyUNK3GcWSdyV8lQPM",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3KZzvyUNK3GcWSdyV8lQPM",
			duration_ms: 228093,
			time_signature: 4,
			doubletime: 130
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp" },
						href: "https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp",
						id: "5LHRHt1k9lMyONurDHEdrp",
						name: "Tyga",
						type: "artist",
						uri: "spotify:artist:5LHRHt1k9lMyONurDHEdrp"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0yd01cU78rnlFXq6vRxPSR" },
				href: "https://api.spotify.com/v1/albums/0yd01cU78rnlFXq6vRxPSR",
				id: "0yd01cU78rnlFXq6vRxPSR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a4d73b32e40487605c73cffe", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a4d73b32e40487605c73cffe", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a4d73b32e40487605c73cffe", width: 64 }
				],
				name: "Taste (feat. Offset)",
				release_date: "2018-05-16",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0yd01cU78rnlFXq6vRxPSR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp" },
					href: "https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp",
					id: "5LHRHt1k9lMyONurDHEdrp",
					name: "Tyga",
					type: "artist",
					uri: "spotify:artist:5LHRHt1k9lMyONurDHEdrp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4DdkRBBYG6Yk9Ka8tdJ9BW" },
					href: "https://api.spotify.com/v1/artists/4DdkRBBYG6Yk9Ka8tdJ9BW",
					id: "4DdkRBBYG6Yk9Ka8tdJ9BW",
					name: "Offset",
					type: "artist",
					uri: "spotify:artist:4DdkRBBYG6Yk9Ka8tdJ9BW"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 232959,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1198481" },
			external_urls: { spotify: "https://open.spotify.com/track/5IaHrVsrferBYDm0bDyABy" },
			href: "https://api.spotify.com/v1/tracks/5IaHrVsrferBYDm0bDyABy",
			id: "5IaHrVsrferBYDm0bDyABy",
			is_local: false,
			name: "Taste (feat. Offset)",
			popularity: 80,
			preview_url: "https://p.scdn.co/mp3-preview/93d60b97736368a2dd3098c46b2a49c2bc762183?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5IaHrVsrferBYDm0bDyABy"
		},
		features: {
			danceability: 0.884,
			energy: 0.559,
			key: 0,
			loudness: -7.442,
			mode: 1,
			speechiness: 0.12,
			acousticness: 0.0236,
			instrumentalness: 0,
			liveness: 0.101,
			valence: 0.342,
			tempo: 98,
			type: "audio_features",
			id: "5IaHrVsrferBYDm0bDyABy",
			uri: "spotify:track:5IaHrVsrferBYDm0bDyABy",
			track_href: "https://api.spotify.com/v1/tracks/5IaHrVsrferBYDm0bDyABy",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5IaHrVsrferBYDm0bDyABy",
			duration_ms: 232959,
			time_signature: 4,
			doubletime: 196
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3QMhsuCNcW1BxgZ0m7a0hc" },
						href: "https://api.spotify.com/v1/artists/3QMhsuCNcW1BxgZ0m7a0hc",
						id: "3QMhsuCNcW1BxgZ0m7a0hc",
						name: "Tha Ynoe",
						type: "artist",
						uri: "spotify:artist:3QMhsuCNcW1BxgZ0m7a0hc"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0KxEEkHR5mmyc0fGezCKrD" },
				href: "https://api.spotify.com/v1/albums/0KxEEkHR5mmyc0fGezCKrD",
				id: "0KxEEkHR5mmyc0fGezCKrD",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2734945f53adcfcfdb407d7513e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e024945f53adcfcfdb407d7513e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048514945f53adcfcfdb407d7513e", width: 64 }
				],
				name: "Tapebaby",
				release_date: "2017-02-10",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:0KxEEkHR5mmyc0fGezCKrD"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3QMhsuCNcW1BxgZ0m7a0hc" },
					href: "https://api.spotify.com/v1/artists/3QMhsuCNcW1BxgZ0m7a0hc",
					id: "3QMhsuCNcW1BxgZ0m7a0hc",
					name: "Tha Ynoe",
					type: "artist",
					uri: "spotify:artist:3QMhsuCNcW1BxgZ0m7a0hc"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 164611,
			episode: false,
			explicit: true,
			external_ids: { isrc: "uscgh1737000" },
			external_urls: { spotify: "https://open.spotify.com/track/6Rm4mEvAJcYPtEHc42kWDy" },
			href: "https://api.spotify.com/v1/tracks/6Rm4mEvAJcYPtEHc42kWDy",
			id: "6Rm4mEvAJcYPtEHc42kWDy",
			is_local: false,
			name: "Cheers",
			popularity: 33,
			preview_url: "https://p.scdn.co/mp3-preview/ba236ba7acebf38c561a5ff9f897c9ffef7230a5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:6Rm4mEvAJcYPtEHc42kWDy"
		},
		features: {
			danceability: 0.48,
			energy: 0.687,
			key: 7,
			loudness: -11.032,
			mode: 1,
			speechiness: 0.598,
			acousticness: 0.0342,
			instrumentalness: 0.0000183,
			liveness: 0.167,
			valence: 0.263,
			tempo: 178,
			type: "audio_features",
			id: "6Rm4mEvAJcYPtEHc42kWDy",
			uri: "spotify:track:6Rm4mEvAJcYPtEHc42kWDy",
			track_href: "https://api.spotify.com/v1/tracks/6Rm4mEvAJcYPtEHc42kWDy",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6Rm4mEvAJcYPtEHc42kWDy",
			duration_ms: 164612,
			time_signature: 4,
			doubletime: 178
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
						href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
						id: "55Aa2cqylxrFIXC767Z865",
						name: "Lil Wayne",
						type: "artist",
						uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
					}
				],
				available_markets: ["CA", "CR", "MX", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/1uuSC0RCJB3dSp8Mb6GflZ" },
				href: "https://api.spotify.com/v1/albums/1uuSC0RCJB3dSp8Mb6GflZ",
				id: "1uuSC0RCJB3dSp8Mb6GflZ",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a1edbe4e3f3e3fe296816af4", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a1edbe4e3f3e3fe296816af4", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a1edbe4e3f3e3fe296816af4", width: 64 }
				],
				name: "Tha Carter IV (Deluxe)",
				release_date: "2011-01-01",
				release_date_precision: "day",
				total_tracks: 18,
				type: "album",
				uri: "spotify:album:1uuSC0RCJB3dSp8Mb6GflZ"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
					href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
					id: "55Aa2cqylxrFIXC767Z865",
					name: "Lil Wayne",
					type: "artist",
					uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7BAaznGSsqcksud4R5ou5z" },
					href: "https://api.spotify.com/v1/artists/7BAaznGSsqcksud4R5ou5z",
					id: "7BAaznGSsqcksud4R5ou5z",
					name: "Cory Gunz",
					type: "artist",
					uri: "spotify:artist:7BAaznGSsqcksud4R5ou5z"
				}
			],
			available_markets: ["CA", "CR", "MX", "US"],
			disc_number: 1,
			duration_ms: 248586,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51000869" },
			external_urls: { spotify: "https://open.spotify.com/track/0z5ZPs57J2KERwM1tBM2GF" },
			href: "https://api.spotify.com/v1/tracks/0z5ZPs57J2KERwM1tBM2GF",
			id: "0z5ZPs57J2KERwM1tBM2GF",
			is_local: false,
			name: "6 Foot 7 Foot",
			popularity: 69,
			preview_url: "https://p.scdn.co/mp3-preview/4ecb2a150a94e9964c42508416efd6fba1c3fa7e?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:0z5ZPs57J2KERwM1tBM2GF"
		},
		features: {
			danceability: 0.365,
			energy: 0.751,
			key: 2,
			loudness: -5.429,
			mode: 1,
			speechiness: 0.304,
			acousticness: 0.000707,
			instrumentalness: 0,
			liveness: 0.318,
			valence: 0.604,
			tempo: 79,
			type: "audio_features",
			id: "0z5ZPs57J2KERwM1tBM2GF",
			uri: "spotify:track:0z5ZPs57J2KERwM1tBM2GF",
			track_href: "https://api.spotify.com/v1/tracks/0z5ZPs57J2KERwM1tBM2GF",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0z5ZPs57J2KERwM1tBM2GF",
			duration_ms: 248587,
			time_signature: 4,
			doubletime: 158
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6YiHht3u7FFszle72kpbdQ" },
						href: "https://api.spotify.com/v1/artists/6YiHht3u7FFszle72kpbdQ",
						id: "6YiHht3u7FFszle72kpbdQ",
						name: "Lil Duval",
						type: "artist",
						uri: "spotify:artist:6YiHht3u7FFszle72kpbdQ"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3HCWkv1YtDDr9C7XFn6zlf" },
				href: "https://api.spotify.com/v1/albums/3HCWkv1YtDDr9C7XFn6zlf",
				id: "3HCWkv1YtDDr9C7XFn6zlf",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2734e7ad77cfced7b979d0a121a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e024e7ad77cfced7b979d0a121a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048514e7ad77cfced7b979d0a121a", width: 64 }
				],
				name: "Smile (Living My Best Life) [feat. Snoop Dogg & Ball Greezy & Midnight Star]",
				release_date: "2018-07-03",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:3HCWkv1YtDDr9C7XFn6zlf"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6YiHht3u7FFszle72kpbdQ" },
					href: "https://api.spotify.com/v1/artists/6YiHht3u7FFszle72kpbdQ",
					id: "6YiHht3u7FFszle72kpbdQ",
					name: "Lil Duval",
					type: "artist",
					uri: "spotify:artist:6YiHht3u7FFszle72kpbdQ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7hJcb9fa4alzcOq3EaNPoG" },
					href: "https://api.spotify.com/v1/artists/7hJcb9fa4alzcOq3EaNPoG",
					id: "7hJcb9fa4alzcOq3EaNPoG",
					name: "Snoop Dogg",
					type: "artist",
					uri: "spotify:artist:7hJcb9fa4alzcOq3EaNPoG"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2CxtLXJMW2AbYPyQShuDT1" },
					href: "https://api.spotify.com/v1/artists/2CxtLXJMW2AbYPyQShuDT1",
					id: "2CxtLXJMW2AbYPyQShuDT1",
					name: "Ball Greezy",
					type: "artist",
					uri: "spotify:artist:2CxtLXJMW2AbYPyQShuDT1"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0KMLfCXYb3Dhf1hLpu8cVd" },
					href: "https://api.spotify.com/v1/artists/0KMLfCXYb3Dhf1hLpu8cVd",
					id: "0KMLfCXYb3Dhf1hLpu8cVd",
					name: "Midnight Star",
					type: "artist",
					uri: "spotify:artist:0KMLfCXYb3Dhf1hLpu8cVd"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 214159,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1205940" },
			external_urls: { spotify: "https://open.spotify.com/track/17jeLyQcEUmKv3MXeEo79k" },
			href: "https://api.spotify.com/v1/tracks/17jeLyQcEUmKv3MXeEo79k",
			id: "17jeLyQcEUmKv3MXeEo79k",
			is_local: false,
			name: "Smile (Living My Best Life) (feat. Snoop Dogg, Ball Greezy & Midnight Star)",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/f3d0c9e53a8b7fbaaa102c5053806a38a82e35ed?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:17jeLyQcEUmKv3MXeEo79k"
		},
		features: {
			danceability: 0.874,
			energy: 0.727,
			key: 8,
			loudness: -7.689,
			mode: 1,
			speechiness: 0.0777,
			acousticness: 0.09,
			instrumentalness: 0.00000583,
			liveness: 0.0759,
			valence: 0.427,
			tempo: 99,
			type: "audio_features",
			id: "17jeLyQcEUmKv3MXeEo79k",
			uri: "spotify:track:17jeLyQcEUmKv3MXeEo79k",
			track_href: "https://api.spotify.com/v1/tracks/17jeLyQcEUmKv3MXeEo79k",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/17jeLyQcEUmKv3MXeEo79k",
			duration_ms: 214160,
			time_signature: 4,
			doubletime: 198
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/137W8MRPWKqSmrBGDBFSop" },
						href: "https://api.spotify.com/v1/artists/137W8MRPWKqSmrBGDBFSop",
						id: "137W8MRPWKqSmrBGDBFSop",
						name: "Wiz Khalifa",
						type: "artist",
						uri: "spotify:artist:137W8MRPWKqSmrBGDBFSop"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JP",
					"KW",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"RO",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0YFou4SbS16F4GhSADLDfz" },
				href: "https://api.spotify.com/v1/albums/0YFou4SbS16F4GhSADLDfz",
				id: "0YFou4SbS16F4GhSADLDfz",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273393d29e88d493bdab8af1617", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02393d29e88d493bdab8af1617", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851393d29e88d493bdab8af1617", width: 64 }
				],
				name: "Rolling Papers 2",
				release_date: "2018-07-13",
				release_date_precision: "day",
				total_tracks: 25,
				type: "album",
				uri: "spotify:album:0YFou4SbS16F4GhSADLDfz"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/137W8MRPWKqSmrBGDBFSop" },
					href: "https://api.spotify.com/v1/artists/137W8MRPWKqSmrBGDBFSop",
					id: "137W8MRPWKqSmrBGDBFSop",
					name: "Wiz Khalifa",
					type: "artist",
					uri: "spotify:artist:137W8MRPWKqSmrBGDBFSop"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0399oiMcmbOzzsYQDNYqxn" },
					href: "https://api.spotify.com/v1/artists/0399oiMcmbOzzsYQDNYqxn",
					id: "0399oiMcmbOzzsYQDNYqxn",
					name: "Problem",
					type: "artist",
					uri: "spotify:artist:0399oiMcmbOzzsYQDNYqxn"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JP",
				"KW",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"RO",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 153756,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21804149" },
			external_urls: { spotify: "https://open.spotify.com/track/1NX3nkD48kz4BLgxUhtt5s" },
			href: "https://api.spotify.com/v1/tracks/1NX3nkD48kz4BLgxUhtt5s",
			id: "1NX3nkD48kz4BLgxUhtt5s",
			is_local: false,
			name: "Gin and Drugs (feat. Problem)",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/d1c6341ac673f69bc0c07fe1cfec544edd98f7a7?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 18,
			type: "track",
			uri: "spotify:track:1NX3nkD48kz4BLgxUhtt5s"
		},
		features: {
			danceability: 0.829,
			energy: 0.803,
			key: 9,
			loudness: -4.153,
			mode: 1,
			speechiness: 0.258,
			acousticness: 0.131,
			instrumentalness: 0,
			liveness: 0.636,
			valence: 0.766,
			tempo: 99,
			type: "audio_features",
			id: "1NX3nkD48kz4BLgxUhtt5s",
			uri: "spotify:track:1NX3nkD48kz4BLgxUhtt5s",
			track_href: "https://api.spotify.com/v1/tracks/1NX3nkD48kz4BLgxUhtt5s",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1NX3nkD48kz4BLgxUhtt5s",
			duration_ms: 153757,
			time_signature: 4,
			doubletime: 198
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
						href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
						id: "3crnzLy8R4lVwaigKEOz7V",
						name: "E-40",
						type: "artist",
						uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
					}
				],
				available_markets: ["CA", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/42wO2hmYMe3tQGMoshwFsI" },
				href: "https://api.spotify.com/v1/albums/42wO2hmYMe3tQGMoshwFsI",
				id: "42wO2hmYMe3tQGMoshwFsI",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273be1f3453aef32a126279850f", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02be1f3453aef32a126279850f", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851be1f3453aef32a126279850f", width: 64 }
				],
				name: "Sharp On All 4 Corners (Deluxe Edition)",
				release_date: "2014-12-09",
				release_date_precision: "day",
				total_tracks: 28,
				type: "album",
				uri: "spotify:album:42wO2hmYMe3tQGMoshwFsI"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
					href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
					id: "3crnzLy8R4lVwaigKEOz7V",
					name: "E-40",
					type: "artist",
					uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
				}
			],
			available_markets: ["CA", "US"],
			disc_number: 1,
			duration_ms: 272720,
			episode: false,
			explicit: true,
			external_ids: { isrc: "US4KV1400050" },
			external_urls: { spotify: "https://open.spotify.com/track/5vIu19A3EEdHgFM4Cba6F4" },
			href: "https://api.spotify.com/v1/tracks/5vIu19A3EEdHgFM4Cba6F4",
			id: "5vIu19A3EEdHgFM4Cba6F4",
			is_local: false,
			name: "Choices (Yup)",
			popularity: 58,
			preview_url: "https://p.scdn.co/mp3-preview/b982205494996a241bc2c81bc95473b49eb25982?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 6,
			type: "track",
			uri: "spotify:track:5vIu19A3EEdHgFM4Cba6F4"
		},
		features: {
			danceability: 0.891,
			energy: 0.607,
			key: 9,
			loudness: -7.232,
			mode: 0,
			speechiness: 0.367,
			acousticness: 0.144,
			instrumentalness: 0.000314,
			liveness: 0.0909,
			valence: 0.244,
			tempo: 120,
			type: "audio_features",
			id: "5vIu19A3EEdHgFM4Cba6F4",
			uri: "spotify:track:5vIu19A3EEdHgFM4Cba6F4",
			track_href: "https://api.spotify.com/v1/tracks/5vIu19A3EEdHgFM4Cba6F4",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5vIu19A3EEdHgFM4Cba6F4",
			duration_ms: 272720,
			time_signature: 4,
			doubletime: 120
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0NbfKEOTQCcwd6o7wSDOHI" },
						href: "https://api.spotify.com/v1/artists/0NbfKEOTQCcwd6o7wSDOHI",
						id: "0NbfKEOTQCcwd6o7wSDOHI",
						name: "The Game",
						type: "artist",
						uri: "spotify:artist:0NbfKEOTQCcwd6o7wSDOHI"
					}
				],
				available_markets: ["BE", "CA", "LU", "NL", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/0QAaw1Xijzf56CDa0UkBzX" },
				href: "https://api.spotify.com/v1/albums/0QAaw1Xijzf56CDa0UkBzX",
				id: "0QAaw1Xijzf56CDa0UkBzX",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273b53cba9de61731ca294b4617", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02b53cba9de61731ca294b4617", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851b53cba9de61731ca294b4617", width: 64 }
				],
				name: "Jesus Piece",
				release_date: "2012-01-01",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:0QAaw1Xijzf56CDa0UkBzX"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0NbfKEOTQCcwd6o7wSDOHI" },
					href: "https://api.spotify.com/v1/artists/0NbfKEOTQCcwd6o7wSDOHI",
					id: "0NbfKEOTQCcwd6o7wSDOHI",
					name: "The Game",
					type: "artist",
					uri: "spotify:artist:0NbfKEOTQCcwd6o7wSDOHI"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp" },
					href: "https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp",
					id: "17lzZA2AlOHwCwFALHttmp",
					name: "2 Chainz",
					type: "artist",
					uri: "spotify:artist:17lzZA2AlOHwCwFALHttmp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1sBkRIssrMs1AbVkOJbc7a" },
					href: "https://api.spotify.com/v1/artists/1sBkRIssrMs1AbVkOJbc7a",
					id: "1sBkRIssrMs1AbVkOJbc7a",
					name: "Rick Ross",
					type: "artist",
					uri: "spotify:artist:1sBkRIssrMs1AbVkOJbc7a"
				}
			],
			available_markets: ["BE", "CA", "LU", "NL", "US"],
			disc_number: 1,
			duration_ms: 321600,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USUM71215155" },
			external_urls: { spotify: "https://open.spotify.com/track/5ytPD4l2eA7zggEloGLDUh" },
			href: "https://api.spotify.com/v1/tracks/5ytPD4l2eA7zggEloGLDUh",
			id: "5ytPD4l2eA7zggEloGLDUh",
			is_local: false,
			name: "Ali Bomaye",
			popularity: 30,
			preview_url: "https://p.scdn.co/mp3-preview/aa780afd8c69c5f51eb222ef674d631f813c7f09?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:5ytPD4l2eA7zggEloGLDUh"
		},
		features: {
			danceability: 0.525,
			energy: 0.747,
			key: 10,
			loudness: -4.383,
			mode: 0,
			speechiness: 0.242,
			acousticness: 0.0107,
			instrumentalness: 0,
			liveness: 0.339,
			valence: 0.27,
			tempo: 72,
			type: "audio_features",
			id: "5ytPD4l2eA7zggEloGLDUh",
			uri: "spotify:track:5ytPD4l2eA7zggEloGLDUh",
			track_href: "https://api.spotify.com/v1/tracks/5ytPD4l2eA7zggEloGLDUh",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5ytPD4l2eA7zggEloGLDUh",
			duration_ms: 321600,
			time_signature: 4,
			doubletime: 144
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7wg1qvie3KqDNQbAkTdbX0" },
						href: "https://api.spotify.com/v1/artists/7wg1qvie3KqDNQbAkTdbX0",
						id: "7wg1qvie3KqDNQbAkTdbX0",
						name: "Louis The Child",
						type: "artist",
						uri: "spotify:artist:7wg1qvie3KqDNQbAkTdbX0"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1ewyVtTZBqFYWIcepopRhp" },
						href: "https://api.spotify.com/v1/artists/1ewyVtTZBqFYWIcepopRhp",
						id: "1ewyVtTZBqFYWIcepopRhp",
						name: "Joey Purp",
						type: "artist",
						uri: "spotify:artist:1ewyVtTZBqFYWIcepopRhp"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5umCH0AoNKwl7R4TtEK8Zt" },
				href: "https://api.spotify.com/v1/albums/5umCH0AoNKwl7R4TtEK8Zt",
				id: "5umCH0AoNKwl7R4TtEK8Zt",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e91063962788bd62156fa2bd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e91063962788bd62156fa2bd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e91063962788bd62156fa2bd", width: 64 }
				],
				name: "Shake Something (feat. Joey Purp)",
				release_date: "2018-03-08",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5umCH0AoNKwl7R4TtEK8Zt"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7wg1qvie3KqDNQbAkTdbX0" },
					href: "https://api.spotify.com/v1/artists/7wg1qvie3KqDNQbAkTdbX0",
					id: "7wg1qvie3KqDNQbAkTdbX0",
					name: "Louis The Child",
					type: "artist",
					uri: "spotify:artist:7wg1qvie3KqDNQbAkTdbX0"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1ewyVtTZBqFYWIcepopRhp" },
					href: "https://api.spotify.com/v1/artists/1ewyVtTZBqFYWIcepopRhp",
					id: "1ewyVtTZBqFYWIcepopRhp",
					name: "Joey Purp",
					type: "artist",
					uri: "spotify:artist:1ewyVtTZBqFYWIcepopRhp"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 193512,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71802664" },
			external_urls: { spotify: "https://open.spotify.com/track/6mUwMth1MQT8NVSMI7lKjx" },
			href: "https://api.spotify.com/v1/tracks/6mUwMth1MQT8NVSMI7lKjx",
			id: "6mUwMth1MQT8NVSMI7lKjx",
			is_local: false,
			name: "Shake Something (feat. Joey Purp)",
			popularity: 60,
			preview_url: "https://p.scdn.co/mp3-preview/dde48d5cf9baf6d5c63aa328805145f590456975?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6mUwMth1MQT8NVSMI7lKjx"
		},
		features: {
			danceability: 0.895,
			energy: 0.526,
			key: 10,
			loudness: -7.969,
			mode: 0,
			speechiness: 0.183,
			acousticness: 0.0926,
			instrumentalness: 0.00539,
			liveness: 0.586,
			valence: 0.202,
			tempo: 88,
			type: "audio_features",
			id: "6mUwMth1MQT8NVSMI7lKjx",
			uri: "spotify:track:6mUwMth1MQT8NVSMI7lKjx",
			track_href: "https://api.spotify.com/v1/tracks/6mUwMth1MQT8NVSMI7lKjx",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6mUwMth1MQT8NVSMI7lKjx",
			duration_ms: 193513,
			time_signature: 4,
			doubletime: 176
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
						href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
						id: "3TVXtAsR1Inumwj472S9r4",
						name: "Drake",
						type: "artist",
						uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
					}
				],
				available_markets: ["CA", "MX", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/6jlrjFR9mJV3jd1IPSplXU" },
				href: "https://api.spotify.com/v1/albums/6jlrjFR9mJV3jd1IPSplXU",
				id: "6jlrjFR9mJV3jd1IPSplXU",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27311b21e8b868800918d21bb77", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0211b21e8b868800918d21bb77", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485111b21e8b868800918d21bb77", width: 64 }
				],
				name: "Thank Me Later",
				release_date: "2010-01-01",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:6jlrjFR9mJV3jd1IPSplXU"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
					href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
					id: "3TVXtAsR1Inumwj472S9r4",
					name: "Drake",
					type: "artist",
					uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4OBJLual30L7gRl5UkeRcT" },
					href: "https://api.spotify.com/v1/artists/4OBJLual30L7gRl5UkeRcT",
					id: "4OBJLual30L7gRl5UkeRcT",
					name: "T.I.",
					type: "artist",
					uri: "spotify:artist:4OBJLual30L7gRl5UkeRcT"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2cADQgiLMjNhbsfeN52Bf3" },
					href: "https://api.spotify.com/v1/artists/2cADQgiLMjNhbsfeN52Bf3",
					id: "2cADQgiLMjNhbsfeN52Bf3",
					name: "Swizz Beatz",
					type: "artist",
					uri: "spotify:artist:2cADQgiLMjNhbsfeN52Bf3"
				}
			],
			available_markets: ["CA", "MX", "US"],
			disc_number: 1,
			duration_ms: 319386,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51000256" },
			external_urls: { spotify: "https://open.spotify.com/track/3fpTMuD1u3gJlVI4FadVHs" },
			href: "https://api.spotify.com/v1/tracks/3fpTMuD1u3gJlVI4FadVHs",
			id: "3fpTMuD1u3gJlVI4FadVHs",
			is_local: false,
			name: "Fancy",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/b7f09cc76dea3b8c6cde7a185646e1fb4a5ddfae?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:3fpTMuD1u3gJlVI4FadVHs"
		},
		features: {
			danceability: 0.53,
			energy: 0.884,
			key: 0,
			loudness: -5.581,
			mode: 0,
			speechiness: 0.457,
			acousticness: 0.332,
			instrumentalness: 0.00000198,
			liveness: 0.355,
			valence: 0.28,
			tempo: 87,
			type: "audio_features",
			id: "3fpTMuD1u3gJlVI4FadVHs",
			uri: "spotify:track:3fpTMuD1u3gJlVI4FadVHs",
			track_href: "https://api.spotify.com/v1/tracks/3fpTMuD1u3gJlVI4FadVHs",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3fpTMuD1u3gJlVI4FadVHs",
			duration_ms: 319387,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
						href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
						id: "3TVXtAsR1Inumwj472S9r4",
						name: "Drake",
						type: "artist",
						uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6X1x82kppWZmDzlXXK3y3q" },
				href: "https://api.spotify.com/v1/albums/6X1x82kppWZmDzlXXK3y3q",
				id: "6X1x82kppWZmDzlXXK3y3q",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c7ea04a9b455e3f68ef82550", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c7ea04a9b455e3f68ef82550", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c7ea04a9b455e3f68ef82550", width: 64 }
				],
				name: "Take Care (Deluxe)",
				release_date: "2011-11-15",
				release_date_precision: "day",
				total_tracks: 19,
				type: "album",
				uri: "spotify:album:6X1x82kppWZmDzlXXK3y3q"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
					href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
					id: "3TVXtAsR1Inumwj472S9r4",
					name: "Drake",
					type: "artist",
					uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 219893,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51100505" },
			external_urls: { spotify: "https://open.spotify.com/track/7yfg0Eer6UZZt5tZ1XdsWz" },
			href: "https://api.spotify.com/v1/tracks/7yfg0Eer6UZZt5tZ1XdsWz",
			id: "7yfg0Eer6UZZt5tZ1XdsWz",
			is_local: false,
			name: "Make Me Proud",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/17210228f07d29ecb827b9b50246614b9ec80313?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:7yfg0Eer6UZZt5tZ1XdsWz"
		},
		features: {
			danceability: 0.684,
			energy: 0.486,
			key: 1,
			loudness: -10.155,
			mode: 1,
			speechiness: 0.132,
			acousticness: 0.00268,
			instrumentalness: 0.000148,
			liveness: 0.157,
			valence: 0.355,
			tempo: 132,
			type: "audio_features",
			id: "7yfg0Eer6UZZt5tZ1XdsWz",
			uri: "spotify:track:7yfg0Eer6UZZt5tZ1XdsWz",
			track_href: "https://api.spotify.com/v1/tracks/7yfg0Eer6UZZt5tZ1XdsWz",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7yfg0Eer6UZZt5tZ1XdsWz",
			duration_ms: 219893,
			time_signature: 4,
			doubletime: 132
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0NbfKEOTQCcwd6o7wSDOHI" },
						href: "https://api.spotify.com/v1/artists/0NbfKEOTQCcwd6o7wSDOHI",
						id: "0NbfKEOTQCcwd6o7wSDOHI",
						name: "The Game",
						type: "artist",
						uri: "spotify:artist:0NbfKEOTQCcwd6o7wSDOHI"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"DE",
					"DK",
					"DO",
					"EC",
					"EE",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JP",
					"LI",
					"LT",
					"LU",
					"LV",
					"MC",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"RO",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4PrPbmm0gKvaD3rerOXFg8" },
				href: "https://api.spotify.com/v1/albums/4PrPbmm0gKvaD3rerOXFg8",
				id: "4PrPbmm0gKvaD3rerOXFg8",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273b1d860ab1ba847e778b2796d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02b1d860ab1ba847e778b2796d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851b1d860ab1ba847e778b2796d", width: 64 }
				],
				name: "The Documentary",
				release_date: "2005",
				release_date_precision: "year",
				total_tracks: 18,
				type: "album",
				uri: "spotify:album:4PrPbmm0gKvaD3rerOXFg8"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0NbfKEOTQCcwd6o7wSDOHI" },
					href: "https://api.spotify.com/v1/artists/0NbfKEOTQCcwd6o7wSDOHI",
					id: "0NbfKEOTQCcwd6o7wSDOHI",
					name: "The Game",
					type: "artist",
					uri: "spotify:artist:0NbfKEOTQCcwd6o7wSDOHI"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3q7HBObVc0L8jNeTe5Gofh" },
					href: "https://api.spotify.com/v1/artists/3q7HBObVc0L8jNeTe5Gofh",
					id: "3q7HBObVc0L8jNeTe5Gofh",
					name: "50 Cent",
					type: "artist",
					uri: "spotify:artist:3q7HBObVc0L8jNeTe5Gofh"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"DE",
				"DK",
				"DO",
				"EC",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JP",
				"LI",
				"LT",
				"LU",
				"LV",
				"MC",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"RO",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 223066,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USIR10400647" },
			external_urls: { spotify: "https://open.spotify.com/track/0lOe1dR2TNkJMCjIcRuw6T" },
			href: "https://api.spotify.com/v1/tracks/0lOe1dR2TNkJMCjIcRuw6T",
			id: "0lOe1dR2TNkJMCjIcRuw6T",
			is_local: false,
			name: "Westside Story",
			popularity: 60,
			preview_url: "https://p.scdn.co/mp3-preview/a452a1d1ec8f73a9b7fad5a1a4d8828ba6e7d0ad?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:0lOe1dR2TNkJMCjIcRuw6T"
		},
		features: {
			danceability: 0.876,
			energy: 0.647,
			key: 11,
			loudness: -3.917,
			mode: 1,
			speechiness: 0.28,
			acousticness: 0.16,
			instrumentalness: 0,
			liveness: 0.238,
			valence: 0.961,
			tempo: 87,
			type: "audio_features",
			id: "0lOe1dR2TNkJMCjIcRuw6T",
			uri: "spotify:track:0lOe1dR2TNkJMCjIcRuw6T",
			track_href: "https://api.spotify.com/v1/tracks/0lOe1dR2TNkJMCjIcRuw6T",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0lOe1dR2TNkJMCjIcRuw6T",
			duration_ms: 223067,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/02kJSzxNuaWGqwubyUba0Z" },
						href: "https://api.spotify.com/v1/artists/02kJSzxNuaWGqwubyUba0Z",
						id: "02kJSzxNuaWGqwubyUba0Z",
						name: "G-Eazy",
						type: "artist",
						uri: "spotify:artist:02kJSzxNuaWGqwubyUba0Z"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6wDc63NhKy2PyXdbhkRmrl" },
				href: "https://api.spotify.com/v1/albums/6wDc63NhKy2PyXdbhkRmrl",
				id: "6wDc63NhKy2PyXdbhkRmrl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bdfe4efd674482cf5ac88c99", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bdfe4efd674482cf5ac88c99", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bdfe4efd674482cf5ac88c99", width: 64 }
				],
				name: "These Things Happen",
				release_date: "2014-06-20",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:6wDc63NhKy2PyXdbhkRmrl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/02kJSzxNuaWGqwubyUba0Z" },
					href: "https://api.spotify.com/v1/artists/02kJSzxNuaWGqwubyUba0Z",
					id: "02kJSzxNuaWGqwubyUba0Z",
					name: "G-Eazy",
					type: "artist",
					uri: "spotify:artist:02kJSzxNuaWGqwubyUba0Z"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4GSscYtVzmGRP2jbWhdaV1" },
					href: "https://api.spotify.com/v1/artists/4GSscYtVzmGRP2jbWhdaV1",
					id: "4GSscYtVzmGRP2jbWhdaV1",
					name: "John Michael Rouchell",
					type: "artist",
					uri: "spotify:artist:4GSscYtVzmGRP2jbWhdaV1"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 326813,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USRC11400740" },
			external_urls: { spotify: "https://open.spotify.com/track/5lffpGkK5A4SAQdJSfTJso" },
			href: "https://api.spotify.com/v1/tracks/5lffpGkK5A4SAQdJSfTJso",
			id: "5lffpGkK5A4SAQdJSfTJso",
			is_local: false,
			name: "Downtown Love (feat. John Michael Rouchell)",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/b92881aac438a826c65ea9d29faa0128de991594?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 9,
			type: "track",
			uri: "spotify:track:5lffpGkK5A4SAQdJSfTJso"
		},
		features: {
			danceability: 0.544,
			energy: 0.557,
			key: 7,
			loudness: -10.554,
			mode: 1,
			speechiness: 0.0765,
			acousticness: 0.217,
			instrumentalness: 0.000125,
			liveness: 0.0771,
			valence: 0.105,
			tempo: 88,
			type: "audio_features",
			id: "5lffpGkK5A4SAQdJSfTJso",
			uri: "spotify:track:5lffpGkK5A4SAQdJSfTJso",
			track_href: "https://api.spotify.com/v1/tracks/5lffpGkK5A4SAQdJSfTJso",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5lffpGkK5A4SAQdJSfTJso",
			duration_ms: 326813,
			time_signature: 4,
			doubletime: 176
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1ZwdS5xdxEREPySFridCfh" },
						href: "https://api.spotify.com/v1/artists/1ZwdS5xdxEREPySFridCfh",
						id: "1ZwdS5xdxEREPySFridCfh",
						name: "2Pac",
						type: "artist",
						uri: "spotify:artist:1ZwdS5xdxEREPySFridCfh"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4CzT5ueFBRpbILw34HQYxi" },
				href: "https://api.spotify.com/v1/albums/4CzT5ueFBRpbILw34HQYxi",
				id: "4CzT5ueFBRpbILw34HQYxi",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a786ad0992cfe0b2719729bf", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a786ad0992cfe0b2719729bf", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a786ad0992cfe0b2719729bf", width: 64 }
				],
				name: "All Eyez On Me",
				release_date: "1996-02-13",
				release_date_precision: "day",
				total_tracks: 27,
				type: "album",
				uri: "spotify:album:4CzT5ueFBRpbILw34HQYxi"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1ZwdS5xdxEREPySFridCfh" },
					href: "https://api.spotify.com/v1/artists/1ZwdS5xdxEREPySFridCfh",
					id: "1ZwdS5xdxEREPySFridCfh",
					name: "2Pac",
					type: "artist",
					uri: "spotify:artist:1ZwdS5xdxEREPySFridCfh"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 2,
			duration_ms: 253973,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USKO10404424" },
			external_urls: { spotify: "https://open.spotify.com/track/6EVKzzNM0ZhEvJTBk2SACX" },
			href: "https://api.spotify.com/v1/tracks/6EVKzzNM0ZhEvJTBk2SACX",
			id: "6EVKzzNM0ZhEvJTBk2SACX",
			is_local: false,
			name: "Ratha Be Ya N____",
			popularity: 61,
			preview_url: "https://p.scdn.co/mp3-preview/545d8e4a83b7ba35d1b41d187058d503f83fba56?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 9,
			type: "track",
			uri: "spotify:track:6EVKzzNM0ZhEvJTBk2SACX"
		},
		features: {
			danceability: 0.733,
			energy: 0.558,
			key: 11,
			loudness: -5.56,
			mode: 0,
			speechiness: 0.278,
			acousticness: 0.204,
			instrumentalness: 0,
			liveness: 0.695,
			valence: 0.566,
			tempo: 85,
			type: "audio_features",
			id: "6EVKzzNM0ZhEvJTBk2SACX",
			uri: "spotify:track:6EVKzzNM0ZhEvJTBk2SACX",
			track_href: "https://api.spotify.com/v1/tracks/6EVKzzNM0ZhEvJTBk2SACX",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6EVKzzNM0ZhEvJTBk2SACX",
			duration_ms: 253973,
			time_signature: 4,
			doubletime: 170
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0QHgL1lAIqAw0HtD7YldmP" },
						href: "https://api.spotify.com/v1/artists/0QHgL1lAIqAw0HtD7YldmP",
						id: "0QHgL1lAIqAw0HtD7YldmP",
						name: "DJ Khaled",
						type: "artist",
						uri: "spotify:artist:0QHgL1lAIqAw0HtD7YldmP"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7FyxsUO4kVqRfo2ne1aUOg" },
				href: "https://api.spotify.com/v1/albums/7FyxsUO4kVqRfo2ne1aUOg",
				id: "7FyxsUO4kVqRfo2ne1aUOg",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273dd87a2f68949c8fcbbec91be", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02dd87a2f68949c8fcbbec91be", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851dd87a2f68949c8fcbbec91be", width: 64 }
				],
				name: "We The Best Forever",
				release_date: "2011-01-01",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:7FyxsUO4kVqRfo2ne1aUOg"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0QHgL1lAIqAw0HtD7YldmP" },
					href: "https://api.spotify.com/v1/artists/0QHgL1lAIqAw0HtD7YldmP",
					id: "0QHgL1lAIqAw0HtD7YldmP",
					name: "DJ Khaled",
					type: "artist",
					uri: "spotify:artist:0QHgL1lAIqAw0HtD7YldmP"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4" },
					href: "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
					id: "3TVXtAsR1Inumwj472S9r4",
					name: "Drake",
					type: "artist",
					uri: "spotify:artist:3TVXtAsR1Inumwj472S9r4"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1sBkRIssrMs1AbVkOJbc7a" },
					href: "https://api.spotify.com/v1/artists/1sBkRIssrMs1AbVkOJbc7a",
					id: "1sBkRIssrMs1AbVkOJbc7a",
					name: "Rick Ross",
					type: "artist",
					uri: "spotify:artist:1sBkRIssrMs1AbVkOJbc7a"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
					href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
					id: "55Aa2cqylxrFIXC767Z865",
					name: "Lil Wayne",
					type: "artist",
					uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 296146,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM51100126" },
			external_urls: { spotify: "https://open.spotify.com/track/608a1wIsSd5KzMEqm1O7w3" },
			href: "https://api.spotify.com/v1/tracks/608a1wIsSd5KzMEqm1O7w3",
			id: "608a1wIsSd5KzMEqm1O7w3",
			is_local: false,
			name: "I'm On One",
			popularity: 65,
			preview_url: "https://p.scdn.co/mp3-preview/3de61f30d29056d2a6eeffa131c509622a545eb4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:608a1wIsSd5KzMEqm1O7w3"
		},
		features: {
			danceability: 0.413,
			energy: 0.807,
			key: 11,
			loudness: -3.499,
			mode: 0,
			speechiness: 0.318,
			acousticness: 0.0536,
			instrumentalness: 0,
			liveness: 0.631,
			valence: 0.438,
			tempo: 149,
			type: "audio_features",
			id: "608a1wIsSd5KzMEqm1O7w3",
			uri: "spotify:track:608a1wIsSd5KzMEqm1O7w3",
			track_href: "https://api.spotify.com/v1/tracks/608a1wIsSd5KzMEqm1O7w3",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/608a1wIsSd5KzMEqm1O7w3",
			duration_ms: 296147,
			time_signature: 4,
			doubletime: 149
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4LLpKhyESsyAXpc4laK94U" },
						href: "https://api.spotify.com/v1/artists/4LLpKhyESsyAXpc4laK94U",
						id: "4LLpKhyESsyAXpc4laK94U",
						name: "Mac Miller",
						type: "artist",
						uri: "spotify:artist:4LLpKhyESsyAXpc4laK94U"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4RRqzZEFULTx6pafDBvOqZ" },
				href: "https://api.spotify.com/v1/albums/4RRqzZEFULTx6pafDBvOqZ",
				id: "4RRqzZEFULTx6pafDBvOqZ",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27384bae70f69df07899a1f83c2", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0284bae70f69df07899a1f83c2", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485184bae70f69df07899a1f83c2", width: 64 }
				],
				name: "Programs",
				release_date: "2018-05-28",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4RRqzZEFULTx6pafDBvOqZ"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4LLpKhyESsyAXpc4laK94U" },
					href: "https://api.spotify.com/v1/artists/4LLpKhyESsyAXpc4laK94U",
					id: "4LLpKhyESsyAXpc4laK94U",
					name: "Mac Miller",
					type: "artist",
					uri: "spotify:artist:4LLpKhyESsyAXpc4laK94U"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 190186,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USWB11801058" },
			external_urls: { spotify: "https://open.spotify.com/track/1883mCuSqnfnrWoq8i3myH" },
			href: "https://api.spotify.com/v1/tracks/1883mCuSqnfnrWoq8i3myH",
			id: "1883mCuSqnfnrWoq8i3myH",
			is_local: false,
			name: "Programs",
			popularity: 65,
			preview_url: "https://p.scdn.co/mp3-preview/67cf5ca5847ff2b95d02d7d56975907fb8848bbb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1883mCuSqnfnrWoq8i3myH"
		},
		features: {
			danceability: 0.88,
			energy: 0.569,
			key: 10,
			loudness: -6.517,
			mode: 0,
			speechiness: 0.221,
			acousticness: 0.0809,
			instrumentalness: 0.0000582,
			liveness: 0.214,
			valence: 0.474,
			tempo: 135,
			type: "audio_features",
			id: "1883mCuSqnfnrWoq8i3myH",
			uri: "spotify:track:1883mCuSqnfnrWoq8i3myH",
			track_href: "https://api.spotify.com/v1/tracks/1883mCuSqnfnrWoq8i3myH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1883mCuSqnfnrWoq8i3myH",
			duration_ms: 190187,
			time_signature: 4,
			doubletime: 135
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4hcacKtQRVlDecmw4m1hWz" },
						href: "https://api.spotify.com/v1/artists/4hcacKtQRVlDecmw4m1hWz",
						id: "4hcacKtQRVlDecmw4m1hWz",
						name: "Safakash",
						type: "artist",
						uri: "spotify:artist:4hcacKtQRVlDecmw4m1hWz"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1Xn2xwiYd5kLphDCh2K4UW" },
				href: "https://api.spotify.com/v1/albums/1Xn2xwiYd5kLphDCh2K4UW",
				id: "1Xn2xwiYd5kLphDCh2K4UW",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273106681ee9a5af27151bcbec8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02106681ee9a5af27151bcbec8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851106681ee9a5af27151bcbec8", width: 64 }
				],
				name: "Diamond Jettaz",
				release_date: "2017-09-23",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1Xn2xwiYd5kLphDCh2K4UW"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4hcacKtQRVlDecmw4m1hWz" },
					href: "https://api.spotify.com/v1/artists/4hcacKtQRVlDecmw4m1hWz",
					id: "4hcacKtQRVlDecmw4m1hWz",
					name: "Safakash",
					type: "artist",
					uri: "spotify:artist:4hcacKtQRVlDecmw4m1hWz"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 286781,
			episode: false,
			explicit: true,
			external_ids: { isrc: "TCADH1706763" },
			external_urls: { spotify: "https://open.spotify.com/track/28YTU0pMcVD7dI39mfKhjo" },
			href: "https://api.spotify.com/v1/tracks/28YTU0pMcVD7dI39mfKhjo",
			id: "28YTU0pMcVD7dI39mfKhjo",
			is_local: false,
			name: "Diamond Jettaz",
			popularity: 14,
			preview_url: "https://p.scdn.co/mp3-preview/cdc4299a92392b4ff53181f33ee00e90c29af47f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:28YTU0pMcVD7dI39mfKhjo"
		},
		features: {
			danceability: 0.643,
			energy: 0.369,
			key: 1,
			loudness: -12.276,
			mode: 1,
			speechiness: 0.4,
			acousticness: 0.0928,
			instrumentalness: 0.000027,
			liveness: 0.0852,
			valence: 0.28,
			tempo: 87,
			type: "audio_features",
			id: "28YTU0pMcVD7dI39mfKhjo",
			uri: "spotify:track:28YTU0pMcVD7dI39mfKhjo",
			track_href: "https://api.spotify.com/v1/tracks/28YTU0pMcVD7dI39mfKhjo",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/28YTU0pMcVD7dI39mfKhjo",
			duration_ms: 286781,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3Zj2B8yAi8gHoR8vpsPatZ" },
						href: "https://api.spotify.com/v1/artists/3Zj2B8yAi8gHoR8vpsPatZ",
						id: "3Zj2B8yAi8gHoR8vpsPatZ",
						name: "Gideon",
						type: "artist",
						uri: "spotify:artist:3Zj2B8yAi8gHoR8vpsPatZ"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7MvOXPaapEpyCUsIXA2MFJ" },
				href: "https://api.spotify.com/v1/albums/7MvOXPaapEpyCUsIXA2MFJ",
				id: "7MvOXPaapEpyCUsIXA2MFJ",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27300158fb23234a6946eb50fcd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0200158fb23234a6946eb50fcd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485100158fb23234a6946eb50fcd", width: 64 }
				],
				name: "Cold",
				release_date: "2017-05-12",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:7MvOXPaapEpyCUsIXA2MFJ"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3Zj2B8yAi8gHoR8vpsPatZ" },
					href: "https://api.spotify.com/v1/artists/3Zj2B8yAi8gHoR8vpsPatZ",
					id: "3Zj2B8yAi8gHoR8vpsPatZ",
					name: "Gideon",
					type: "artist",
					uri: "spotify:artist:3Zj2B8yAi8gHoR8vpsPatZ"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 182785,
			episode: false,
			explicit: false,
			external_ids: { isrc: "US3X51634702" },
			external_urls: { spotify: "https://open.spotify.com/track/7oHcyBXv4E1Bf8IMkrKORG" },
			href: "https://api.spotify.com/v1/tracks/7oHcyBXv4E1Bf8IMkrKORG",
			id: "7oHcyBXv4E1Bf8IMkrKORG",
			is_local: false,
			name: "Cursed",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/760b62946d3f7c5b1931a87d45d56234bc6c3a09?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:7oHcyBXv4E1Bf8IMkrKORG"
		},
		features: {
			danceability: 0.65,
			energy: 0.979,
			key: 6,
			loudness: -3.778,
			mode: 1,
			speechiness: 0.07,
			acousticness: 0.00214,
			instrumentalness: 0,
			liveness: 0.834,
			valence: 0.473,
			tempo: 120,
			type: "audio_features",
			id: "7oHcyBXv4E1Bf8IMkrKORG",
			uri: "spotify:track:7oHcyBXv4E1Bf8IMkrKORG",
			track_href: "https://api.spotify.com/v1/tracks/7oHcyBXv4E1Bf8IMkrKORG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7oHcyBXv4E1Bf8IMkrKORG",
			duration_ms: 182786,
			time_signature: 4,
			doubletime: 120
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/31IZdHrCZ5pRhLz4zBxN3o" },
						href: "https://api.spotify.com/v1/artists/31IZdHrCZ5pRhLz4zBxN3o",
						id: "31IZdHrCZ5pRhLz4zBxN3o",
						name: "Riff Raff",
						type: "artist",
						uri: "spotify:artist:31IZdHrCZ5pRhLz4zBxN3o"
					}
				],
				available_markets: ["US"],
				external_urls: { spotify: "https://open.spotify.com/album/2DPmATqwTbFTztBvwT5V4b" },
				href: "https://api.spotify.com/v1/albums/2DPmATqwTbFTztBvwT5V4b",
				id: "2DPmATqwTbFTztBvwT5V4b",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273b2128cd9c6bef1b6bf984121", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02b2128cd9c6bef1b6bf984121", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851b2128cd9c6bef1b6bf984121", width: 64 }
				],
				name: "Neon Icon",
				release_date: "2014-06-24",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:2DPmATqwTbFTztBvwT5V4b"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/31IZdHrCZ5pRhLz4zBxN3o" },
					href: "https://api.spotify.com/v1/artists/31IZdHrCZ5pRhLz4zBxN3o",
					id: "31IZdHrCZ5pRhLz4zBxN3o",
					name: "Riff Raff",
					type: "artist",
					uri: "spotify:artist:31IZdHrCZ5pRhLz4zBxN3o"
				}
			],
			available_markets: ["US"],
			disc_number: 1,
			duration_ms: 246176,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QMCE31400020" },
			external_urls: { spotify: "https://open.spotify.com/track/7CaR9zo1EH6RoR4tEGKnGP" },
			href: "https://api.spotify.com/v1/tracks/7CaR9zo1EH6RoR4tEGKnGP",
			id: "7CaR9zo1EH6RoR4tEGKnGP",
			is_local: false,
			name: "Introducing The Icon",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/a7ee1e08855124f8eb974d9819c865fed558d807?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:7CaR9zo1EH6RoR4tEGKnGP"
		},
		features: {
			danceability: 0.616,
			energy: 0.968,
			key: 11,
			loudness: -1.972,
			mode: 1,
			speechiness: 0.341,
			acousticness: 0.0874,
			instrumentalness: 0,
			liveness: 0.285,
			valence: 0.725,
			tempo: 204,
			type: "audio_features",
			id: "7CaR9zo1EH6RoR4tEGKnGP",
			uri: "spotify:track:7CaR9zo1EH6RoR4tEGKnGP",
			track_href: "https://api.spotify.com/v1/tracks/7CaR9zo1EH6RoR4tEGKnGP",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7CaR9zo1EH6RoR4tEGKnGP",
			duration_ms: 246176,
			time_signature: 4,
			doubletime: 204
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
						href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
						id: "4xRYI6VqpkE3UwrDrAZL8L",
						name: "Logic",
						type: "artist",
						uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4F87p1aiFwHeU4uu65MaPV" },
				href: "https://api.spotify.com/v1/albums/4F87p1aiFwHeU4uu65MaPV",
				id: "4F87p1aiFwHeU4uu65MaPV",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e19b1b51cdd35051e17cf6dc", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e19b1b51cdd35051e17cf6dc", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e19b1b51cdd35051e17cf6dc", width: 64 }
				],
				name: "Bobby Tarantino II",
				release_date: "2018-03-09",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:4F87p1aiFwHeU4uu65MaPV"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
					href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
					id: "4xRYI6VqpkE3UwrDrAZL8L",
					name: "Logic",
					type: "artist",
					uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 173693,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71802494" },
			external_urls: { spotify: "https://open.spotify.com/track/0D5CXSUx8GOCHSY8KWgi9h" },
			href: "https://api.spotify.com/v1/tracks/0D5CXSUx8GOCHSY8KWgi9h",
			id: "0D5CXSUx8GOCHSY8KWgi9h",
			is_local: false,
			name: "Yuck",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/e4b39e1057f5f6b0828d2aa30b3e170a0bd0d1fa?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:0D5CXSUx8GOCHSY8KWgi9h"
		},
		features: {
			danceability: 0.619,
			energy: 0.798,
			key: 11,
			loudness: -5.517,
			mode: 0,
			speechiness: 0.381,
			acousticness: 0.168,
			instrumentalness: 0,
			liveness: 0.17,
			valence: 0.71,
			tempo: 156,
			type: "audio_features",
			id: "0D5CXSUx8GOCHSY8KWgi9h",
			uri: "spotify:track:0D5CXSUx8GOCHSY8KWgi9h",
			track_href: "https://api.spotify.com/v1/tracks/0D5CXSUx8GOCHSY8KWgi9h",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0D5CXSUx8GOCHSY8KWgi9h",
			duration_ms: 173693,
			time_signature: 4,
			doubletime: 156
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/246dkjvS1zLTtiykXe5h60" },
						href: "https://api.spotify.com/v1/artists/246dkjvS1zLTtiykXe5h60",
						id: "246dkjvS1zLTtiykXe5h60",
						name: "Post Malone",
						type: "artist",
						uri: "spotify:artist:246dkjvS1zLTtiykXe5h60"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6trNtQUgC8cgbWcqoMYkOR" },
				href: "https://api.spotify.com/v1/albums/6trNtQUgC8cgbWcqoMYkOR",
				id: "6trNtQUgC8cgbWcqoMYkOR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273b1c4b76e23414c9f20242268", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02b1c4b76e23414c9f20242268", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851b1c4b76e23414c9f20242268", width: 64 }
				],
				name: "beerbongs & bentleys",
				release_date: "2018-04-27",
				release_date_precision: "day",
				total_tracks: 18,
				type: "album",
				uri: "spotify:album:6trNtQUgC8cgbWcqoMYkOR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/246dkjvS1zLTtiykXe5h60" },
					href: "https://api.spotify.com/v1/artists/246dkjvS1zLTtiykXe5h60",
					id: "246dkjvS1zLTtiykXe5h60",
					name: "Post Malone",
					type: "artist",
					uri: "spotify:artist:246dkjvS1zLTtiykXe5h60"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/02kJSzxNuaWGqwubyUba0Z" },
					href: "https://api.spotify.com/v1/artists/02kJSzxNuaWGqwubyUba0Z",
					id: "02kJSzxNuaWGqwubyUba0Z",
					name: "G-Eazy",
					type: "artist",
					uri: "spotify:artist:02kJSzxNuaWGqwubyUba0Z"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0A0FS04o6zMoto8OKPsDwY" },
					href: "https://api.spotify.com/v1/artists/0A0FS04o6zMoto8OKPsDwY",
					id: "0A0FS04o6zMoto8OKPsDwY",
					name: "YG",
					type: "artist",
					uri: "spotify:artist:0A0FS04o6zMoto8OKPsDwY"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 212466,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71805174" },
			external_urls: { spotify: "https://open.spotify.com/track/688QpQAwqsLdBR6lr13wK1" },
			href: "https://api.spotify.com/v1/tracks/688QpQAwqsLdBR6lr13wK1",
			id: "688QpQAwqsLdBR6lr13wK1",
			is_local: false,
			name: "Same Bitches (feat. G-Eazy & YG)",
			popularity: 71,
			preview_url: "https://p.scdn.co/mp3-preview/aed297a17999f2a5caae96764d021c0f7fa5e02d?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 14,
			type: "track",
			uri: "spotify:track:688QpQAwqsLdBR6lr13wK1"
		},
		features: {
			danceability: 0.731,
			energy: 0.774,
			key: 10,
			loudness: -5.273,
			mode: 0,
			speechiness: 0.0555,
			acousticness: 0.434,
			instrumentalness: 0.00000334,
			liveness: 0.114,
			valence: 0.219,
			tempo: 100,
			type: "audio_features",
			id: "688QpQAwqsLdBR6lr13wK1",
			uri: "spotify:track:688QpQAwqsLdBR6lr13wK1",
			track_href: "https://api.spotify.com/v1/tracks/688QpQAwqsLdBR6lr13wK1",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/688QpQAwqsLdBR6lr13wK1",
			duration_ms: 212467,
			time_signature: 4,
			doubletime: 100
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4IVAbR2w4JJNJDDRFP3E83" },
						href: "https://api.spotify.com/v1/artists/4IVAbR2w4JJNJDDRFP3E83",
						id: "4IVAbR2w4JJNJDDRFP3E83",
						name: "6LACK",
						type: "artist",
						uri: "spotify:artist:4IVAbR2w4JJNJDDRFP3E83"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3fc97ZWLIMc1xawhxbKrh2" },
				href: "https://api.spotify.com/v1/albums/3fc97ZWLIMc1xawhxbKrh2",
				id: "3fc97ZWLIMc1xawhxbKrh2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e1530b42603367fdb2208d88", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e1530b42603367fdb2208d88", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e1530b42603367fdb2208d88", width: 64 }
				],
				name: "East Atlanta Love Letter",
				release_date: "2018-09-14",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:3fc97ZWLIMc1xawhxbKrh2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4IVAbR2w4JJNJDDRFP3E83" },
					href: "https://api.spotify.com/v1/artists/4IVAbR2w4JJNJDDRFP3E83",
					id: "4IVAbR2w4JJNJDDRFP3E83",
					name: "6LACK",
					type: "artist",
					uri: "spotify:artist:4IVAbR2w4JJNJDDRFP3E83"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 207071,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71807938" },
			external_urls: { spotify: "https://open.spotify.com/track/29ZZAShKhwRUuKULSNtxX6" },
			href: "https://api.spotify.com/v1/tracks/29ZZAShKhwRUuKULSNtxX6",
			id: "29ZZAShKhwRUuKULSNtxX6",
			is_local: false,
			name: "Switch",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/184125f9377c44a02ed9eba58b2e1a11a8e844d0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:29ZZAShKhwRUuKULSNtxX6"
		},
		features: {
			danceability: 0.66,
			energy: 0.658,
			key: 7,
			loudness: -6.127,
			mode: 1,
			speechiness: 0.0387,
			acousticness: 0.0409,
			instrumentalness: 0.00595,
			liveness: 0.102,
			valence: 0.153,
			tempo: 177,
			type: "audio_features",
			id: "29ZZAShKhwRUuKULSNtxX6",
			uri: "spotify:track:29ZZAShKhwRUuKULSNtxX6",
			track_href: "https://api.spotify.com/v1/tracks/29ZZAShKhwRUuKULSNtxX6",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/29ZZAShKhwRUuKULSNtxX6",
			duration_ms: 207071,
			time_signature: 4,
			doubletime: 177
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2cADQgiLMjNhbsfeN52Bf3" },
						href: "https://api.spotify.com/v1/artists/2cADQgiLMjNhbsfeN52Bf3",
						id: "2cADQgiLMjNhbsfeN52Bf3",
						name: "Swizz Beatz",
						type: "artist",
						uri: "spotify:artist:2cADQgiLMjNhbsfeN52Bf3"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7rXX47AyeMEW5jFyoSl8VA" },
				href: "https://api.spotify.com/v1/albums/7rXX47AyeMEW5jFyoSl8VA",
				id: "7rXX47AyeMEW5jFyoSl8VA",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730ac283482de7172084be7c4e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020ac283482de7172084be7c4e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510ac283482de7172084be7c4e", width: 64 }
				],
				name: "Pistol On My Side (P.O.M.S) (feat. Lil Wayne)",
				release_date: "2018-09-14",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:7rXX47AyeMEW5jFyoSl8VA"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2cADQgiLMjNhbsfeN52Bf3" },
					href: "https://api.spotify.com/v1/artists/2cADQgiLMjNhbsfeN52Bf3",
					id: "2cADQgiLMjNhbsfeN52Bf3",
					name: "Swizz Beatz",
					type: "artist",
					uri: "spotify:artist:2cADQgiLMjNhbsfeN52Bf3"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
					href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
					id: "55Aa2cqylxrFIXC767Z865",
					name: "Lil Wayne",
					type: "artist",
					uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 154962,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USSM11806878" },
			external_urls: { spotify: "https://open.spotify.com/track/4XMN5TxNxF9XNzwXKNHGp2" },
			href: "https://api.spotify.com/v1/tracks/4XMN5TxNxF9XNzwXKNHGp2",
			id: "4XMN5TxNxF9XNzwXKNHGp2",
			is_local: false,
			name: "Pistol On My Side (P.O.M.S) (feat. Lil Wayne)",
			popularity: 41,
			preview_url: "https://p.scdn.co/mp3-preview/e0af136804f3c51f533915f18e4e8c7f5cdb1f99?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4XMN5TxNxF9XNzwXKNHGp2"
		},
		features: {
			danceability: 0.525,
			energy: 0.949,
			key: 9,
			loudness: -1.809,
			mode: 1,
			speechiness: 0.344,
			acousticness: 0.536,
			instrumentalness: 0,
			liveness: 0.214,
			valence: 0.418,
			tempo: 88,
			type: "audio_features",
			id: "4XMN5TxNxF9XNzwXKNHGp2",
			uri: "spotify:track:4XMN5TxNxF9XNzwXKNHGp2",
			track_href: "https://api.spotify.com/v1/tracks/4XMN5TxNxF9XNzwXKNHGp2",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4XMN5TxNxF9XNzwXKNHGp2",
			duration_ms: 154963,
			time_signature: 4,
			doubletime: 176
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp" },
						href: "https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp",
						id: "5LHRHt1k9lMyONurDHEdrp",
						name: "Tyga",
						type: "artist",
						uri: "spotify:artist:5LHRHt1k9lMyONurDHEdrp"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
						href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
						id: "0hCNtLu0JehylgoiP8L4Gh",
						name: "Nicki Minaj",
						type: "artist",
						uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5oAJLGCjjlaa4EM4Rxmjza" },
				href: "https://api.spotify.com/v1/albums/5oAJLGCjjlaa4EM4Rxmjza",
				id: "5oAJLGCjjlaa4EM4Rxmjza",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733d35bfe03a7dcc9e5e07d5ac", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023d35bfe03a7dcc9e5e07d5ac", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513d35bfe03a7dcc9e5e07d5ac", width: 64 }
				],
				name: "Dip (feat. Nicki Minaj)",
				release_date: "2018-09-18",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5oAJLGCjjlaa4EM4Rxmjza"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp" },
					href: "https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp",
					id: "5LHRHt1k9lMyONurDHEdrp",
					name: "Tyga",
					type: "artist",
					uri: "spotify:artist:5LHRHt1k9lMyONurDHEdrp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh" },
					href: "https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh",
					id: "0hCNtLu0JehylgoiP8L4Gh",
					name: "Nicki Minaj",
					type: "artist",
					uri: "spotify:artist:0hCNtLu0JehylgoiP8L4Gh"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 195991,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1218039" },
			external_urls: { spotify: "https://open.spotify.com/track/2qfR91VvO7hRp4IajDT08h" },
			href: "https://api.spotify.com/v1/tracks/2qfR91VvO7hRp4IajDT08h",
			id: "2qfR91VvO7hRp4IajDT08h",
			is_local: false,
			name: "Dip (feat. Nicki Minaj)",
			popularity: 59,
			preview_url: "https://p.scdn.co/mp3-preview/dc2890abb7faa426872c79ade0d7b17b1bea7032?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2qfR91VvO7hRp4IajDT08h"
		},
		features: {
			danceability: 0.885,
			energy: 0.543,
			key: 2,
			loudness: -6.338,
			mode: 1,
			speechiness: 0.2,
			acousticness: 0.0311,
			instrumentalness: 0,
			liveness: 0.154,
			valence: 0.43,
			tempo: 99,
			type: "audio_features",
			id: "2qfR91VvO7hRp4IajDT08h",
			uri: "spotify:track:2qfR91VvO7hRp4IajDT08h",
			track_href: "https://api.spotify.com/v1/tracks/2qfR91VvO7hRp4IajDT08h",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2qfR91VvO7hRp4IajDT08h",
			duration_ms: 195992,
			time_signature: 4,
			doubletime: 198
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7dGJo4pcD2V6oG8kP0tJRR" },
						href: "https://api.spotify.com/v1/artists/7dGJo4pcD2V6oG8kP0tJRR",
						id: "7dGJo4pcD2V6oG8kP0tJRR",
						name: "Eminem",
						type: "artist",
						uri: "spotify:artist:7dGJo4pcD2V6oG8kP0tJRR"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/47BiFcV59TQi2s9SkBo2pb" },
				href: "https://api.spotify.com/v1/albums/47BiFcV59TQi2s9SkBo2pb",
				id: "47BiFcV59TQi2s9SkBo2pb",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c08d5fa5c0f1a834acef5100", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c08d5fa5c0f1a834acef5100", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c08d5fa5c0f1a834acef5100", width: 64 }
				],
				name: "Recovery",
				release_date: "2010-06-18",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:47BiFcV59TQi2s9SkBo2pb"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7dGJo4pcD2V6oG8kP0tJRR" },
					href: "https://api.spotify.com/v1/artists/7dGJo4pcD2V6oG8kP0tJRR",
					id: "7dGJo4pcD2V6oG8kP0tJRR",
					name: "Eminem",
					type: "artist",
					uri: "spotify:artist:7dGJo4pcD2V6oG8kP0tJRR"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 278640,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71015395" },
			external_urls: { spotify: "https://open.spotify.com/track/0sHW1jXe6Sou3437gJQNGA" },
			href: "https://api.spotify.com/v1/tracks/0sHW1jXe6Sou3437gJQNGA",
			id: "0sHW1jXe6Sou3437gJQNGA",
			is_local: false,
			name: "Space Bound",
			popularity: 69,
			preview_url: "https://p.scdn.co/mp3-preview/3e1b9ccdc1eef6b91e738e79c556ac533d49817d?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:0sHW1jXe6Sou3437gJQNGA"
		},
		features: {
			danceability: 0.668,
			energy: 0.886,
			key: 0,
			loudness: -3.474,
			mode: 1,
			speechiness: 0.117,
			acousticness: 0.0417,
			instrumentalness: 0,
			liveness: 0.459,
			valence: 0.503,
			tempo: 142,
			type: "audio_features",
			id: "0sHW1jXe6Sou3437gJQNGA",
			uri: "spotify:track:0sHW1jXe6Sou3437gJQNGA",
			track_href: "https://api.spotify.com/v1/tracks/0sHW1jXe6Sou3437gJQNGA",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0sHW1jXe6Sou3437gJQNGA",
			duration_ms: 278640,
			time_signature: 4,
			doubletime: 142
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0xOeVMOz2fVg5BJY3N6akT" },
						href: "https://api.spotify.com/v1/artists/0xOeVMOz2fVg5BJY3N6akT",
						id: "0xOeVMOz2fVg5BJY3N6akT",
						name: "Jaden",
						type: "artist",
						uri: "spotify:artist:0xOeVMOz2fVg5BJY3N6akT"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/71kz3StN2w22LQBLT1gFS8" },
				href: "https://api.spotify.com/v1/albums/71kz3StN2w22LQBLT1gFS8",
				id: "71kz3StN2w22LQBLT1gFS8",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f8c8ecc877fd4146e0cd3b18", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f8c8ecc877fd4146e0cd3b18", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f8c8ecc877fd4146e0cd3b18", width: 64 }
				],
				name: "GHOST",
				release_date: "2018-06-22",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:71kz3StN2w22LQBLT1gFS8"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0xOeVMOz2fVg5BJY3N6akT" },
					href: "https://api.spotify.com/v1/artists/0xOeVMOz2fVg5BJY3N6akT",
					id: "0xOeVMOz2fVg5BJY3N6akT",
					name: "Jaden",
					type: "artist",
					uri: "spotify:artist:0xOeVMOz2fVg5BJY3N6akT"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7cAlvWK5rgMmJ37j7woN8l" },
					href: "https://api.spotify.com/v1/artists/7cAlvWK5rgMmJ37j7woN8l",
					id: "7cAlvWK5rgMmJ37j7woN8l",
					name: "Christian Rich",
					type: "artist",
					uri: "spotify:artist:7cAlvWK5rgMmJ37j7woN8l"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 129733,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QMJMT1801741" },
			external_urls: { spotify: "https://open.spotify.com/track/0aWMostcnfyjuCEcO7sTz5" },
			href: "https://api.spotify.com/v1/tracks/0aWMostcnfyjuCEcO7sTz5",
			id: "0aWMostcnfyjuCEcO7sTz5",
			is_local: false,
			name: "GHOST",
			popularity: 66,
			preview_url: "https://p.scdn.co/mp3-preview/db89b1b4e18abe6f33b353d24adbc7e0ea709a90?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0aWMostcnfyjuCEcO7sTz5"
		},
		features: {
			danceability: 0.782,
			energy: 0.531,
			key: 1,
			loudness: -6.636,
			mode: 1,
			speechiness: 0.168,
			acousticness: 0.145,
			instrumentalness: 0.0501,
			liveness: 0.238,
			valence: 0.247,
			tempo: 148,
			type: "audio_features",
			id: "0aWMostcnfyjuCEcO7sTz5",
			uri: "spotify:track:0aWMostcnfyjuCEcO7sTz5",
			track_href: "https://api.spotify.com/v1/tracks/0aWMostcnfyjuCEcO7sTz5",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0aWMostcnfyjuCEcO7sTz5",
			duration_ms: 129733,
			time_signature: 4,
			doubletime: 148
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3L8FZaw2Rg1oUw3vB4gUME" },
						href: "https://api.spotify.com/v1/artists/3L8FZaw2Rg1oUw3vB4gUME",
						id: "3L8FZaw2Rg1oUw3vB4gUME",
						name: "Bazanji",
						type: "artist",
						uri: "spotify:artist:3L8FZaw2Rg1oUw3vB4gUME"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/7vYhkEChJInAAWg6YqcGMh" },
				href: "https://api.spotify.com/v1/albums/7vYhkEChJInAAWg6YqcGMh",
				id: "7vYhkEChJInAAWg6YqcGMh",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27356530c86b160468c677758be", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0256530c86b160468c677758be", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485156530c86b160468c677758be", width: 64 }
				],
				name: "Movin'",
				release_date: "2019-03-08",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:7vYhkEChJInAAWg6YqcGMh"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3L8FZaw2Rg1oUw3vB4gUME" },
					href: "https://api.spotify.com/v1/artists/3L8FZaw2Rg1oUw3vB4gUME",
					id: "3L8FZaw2Rg1oUw3vB4gUME",
					name: "Bazanji",
					type: "artist",
					uri: "spotify:artist:3L8FZaw2Rg1oUw3vB4gUME"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 142846,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QZDA81930738" },
			external_urls: { spotify: "https://open.spotify.com/track/5ZyijiszcAd04XEeDoHahO" },
			href: "https://api.spotify.com/v1/tracks/5ZyijiszcAd04XEeDoHahO",
			id: "5ZyijiszcAd04XEeDoHahO",
			is_local: false,
			name: "Movin'",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5ZyijiszcAd04XEeDoHahO"
		},
		features: {
			danceability: 0.764,
			energy: 0.643,
			key: 1,
			loudness: -7.614,
			mode: 0,
			speechiness: 0.161,
			acousticness: 0.0178,
			instrumentalness: 0,
			liveness: 0.12,
			valence: 0.321,
			tempo: 130,
			type: "audio_features",
			id: "5ZyijiszcAd04XEeDoHahO",
			uri: "spotify:track:5ZyijiszcAd04XEeDoHahO",
			track_href: "https://api.spotify.com/v1/tracks/5ZyijiszcAd04XEeDoHahO",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5ZyijiszcAd04XEeDoHahO",
			duration_ms: 142846,
			time_signature: 4,
			doubletime: 130
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3hEgzEeaZ0hb3UXx1U1JRR" },
						href: "https://api.spotify.com/v1/artists/3hEgzEeaZ0hb3UXx1U1JRR",
						id: "3hEgzEeaZ0hb3UXx1U1JRR",
						name: "Demrick",
						type: "artist",
						uri: "spotify:artist:3hEgzEeaZ0hb3UXx1U1JRR"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7zuoqJAXDtNaLzxxm4IShD" },
						href: "https://api.spotify.com/v1/artists/7zuoqJAXDtNaLzxxm4IShD",
						id: "7zuoqJAXDtNaLzxxm4IShD",
						name: "DJ Hoppa",
						type: "artist",
						uri: "spotify:artist:7zuoqJAXDtNaLzxxm4IShD"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/69E0a4MTl4exsRSMjpcwhu" },
				href: "https://api.spotify.com/v1/albums/69E0a4MTl4exsRSMjpcwhu",
				id: "69E0a4MTl4exsRSMjpcwhu",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f93a2a5b858d430909b49bf8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f93a2a5b858d430909b49bf8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f93a2a5b858d430909b49bf8", width: 64 }
				],
				name: "Show Love",
				release_date: "2019-02-22",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:69E0a4MTl4exsRSMjpcwhu"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3hEgzEeaZ0hb3UXx1U1JRR" },
					href: "https://api.spotify.com/v1/artists/3hEgzEeaZ0hb3UXx1U1JRR",
					id: "3hEgzEeaZ0hb3UXx1U1JRR",
					name: "Demrick",
					type: "artist",
					uri: "spotify:artist:3hEgzEeaZ0hb3UXx1U1JRR"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7zuoqJAXDtNaLzxxm4IShD" },
					href: "https://api.spotify.com/v1/artists/7zuoqJAXDtNaLzxxm4IShD",
					id: "7zuoqJAXDtNaLzxxm4IShD",
					name: "DJ Hoppa",
					type: "artist",
					uri: "spotify:artist:7zuoqJAXDtNaLzxxm4IShD"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5Z5jUyiNvFaqp0EVyLNf0p" },
					href: "https://api.spotify.com/v1/artists/5Z5jUyiNvFaqp0EVyLNf0p",
					id: "5Z5jUyiNvFaqp0EVyLNf0p",
					name: "Futuristic",
					type: "artist",
					uri: "spotify:artist:5Z5jUyiNvFaqp0EVyLNf0p"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 201479,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QM27T1950002" },
			external_urls: { spotify: "https://open.spotify.com/track/4LKtVGaRCWgVLQtFhyabBG" },
			href: "https://api.spotify.com/v1/tracks/4LKtVGaRCWgVLQtFhyabBG",
			id: "4LKtVGaRCWgVLQtFhyabBG",
			is_local: false,
			name: "Show Love",
			popularity: 5,
			preview_url: "https://p.scdn.co/mp3-preview/d8ae364cbd279560cf579f402955d2cf021f4f71?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4LKtVGaRCWgVLQtFhyabBG"
		},
		features: {
			danceability: 0.698,
			energy: 0.82,
			key: 0,
			loudness: -4.44,
			mode: 1,
			speechiness: 0.309,
			acousticness: 0.00833,
			instrumentalness: 0,
			liveness: 0.208,
			valence: 0.53,
			tempo: 115,
			type: "audio_features",
			id: "4LKtVGaRCWgVLQtFhyabBG",
			uri: "spotify:track:4LKtVGaRCWgVLQtFhyabBG",
			track_href: "https://api.spotify.com/v1/tracks/4LKtVGaRCWgVLQtFhyabBG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4LKtVGaRCWgVLQtFhyabBG",
			duration_ms: 201479,
			time_signature: 5,
			doubletime: 115
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2EMAnMvWE2eb56ToJVfCWs" },
						href: "https://api.spotify.com/v1/artists/2EMAnMvWE2eb56ToJVfCWs",
						id: "2EMAnMvWE2eb56ToJVfCWs",
						name: "Bryson Tiller",
						type: "artist",
						uri: "spotify:artist:2EMAnMvWE2eb56ToJVfCWs"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6eZdwrhB97A3EYx9QppGfl" },
				href: "https://api.spotify.com/v1/albums/6eZdwrhB97A3EYx9QppGfl",
				id: "6eZdwrhB97A3EYx9QppGfl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2731dbcbe3d662ed70f27c1286b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e021dbcbe3d662ed70f27c1286b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048511dbcbe3d662ed70f27c1286b", width: 64 }
				],
				name: "T R A P S O U L",
				release_date: "2015-10-02",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:6eZdwrhB97A3EYx9QppGfl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2EMAnMvWE2eb56ToJVfCWs" },
					href: "https://api.spotify.com/v1/artists/2EMAnMvWE2eb56ToJVfCWs",
					id: "2EMAnMvWE2eb56ToJVfCWs",
					name: "Bryson Tiller",
					type: "artist",
					uri: "spotify:artist:2EMAnMvWE2eb56ToJVfCWs"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 198293,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USRC11501051" },
			external_urls: { spotify: "https://open.spotify.com/track/3pXF1nA74528Edde4of9CC" },
			href: "https://api.spotify.com/v1/tracks/3pXF1nA74528Edde4of9CC",
			id: "3pXF1nA74528Edde4of9CC",
			is_local: false,
			name: "Don't",
			popularity: 78,
			preview_url: "https://p.scdn.co/mp3-preview/1e41c4b05fa5ccbdc8fcb296cead7d7175a23ae5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:3pXF1nA74528Edde4of9CC"
		},
		features: {
			danceability: 0.765,
			energy: 0.356,
			key: 11,
			loudness: -5.556,
			mode: 0,
			speechiness: 0.196,
			acousticness: 0.222,
			instrumentalness: 0,
			liveness: 0.0963,
			valence: 0.19,
			tempo: 97,
			type: "audio_features",
			id: "3pXF1nA74528Edde4of9CC",
			uri: "spotify:track:3pXF1nA74528Edde4of9CC",
			track_href: "https://api.spotify.com/v1/tracks/3pXF1nA74528Edde4of9CC",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3pXF1nA74528Edde4of9CC",
			duration_ms: 198293,
			time_signature: 4,
			doubletime: 194
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0tvpihdAsKiNnP6sWS3jUI" },
						href: "https://api.spotify.com/v1/artists/0tvpihdAsKiNnP6sWS3jUI",
						id: "0tvpihdAsKiNnP6sWS3jUI",
						name: "TroyBoi",
						type: "artist",
						uri: "spotify:artist:0tvpihdAsKiNnP6sWS3jUI"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7yimuyUPpF0jys1ruXtI7n" },
				href: "https://api.spotify.com/v1/albums/7yimuyUPpF0jys1ruXtI7n",
				id: "7yimuyUPpF0jys1ruXtI7n",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27316532ba1b00748846a3d1283", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0216532ba1b00748846a3d1283", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485116532ba1b00748846a3d1283", width: 64 }
				],
				name: "V!BEZ, Vol. 2",
				release_date: "2018-11-09",
				release_date_precision: "day",
				total_tracks: 7,
				type: "album",
				uri: "spotify:album:7yimuyUPpF0jys1ruXtI7n"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0tvpihdAsKiNnP6sWS3jUI" },
					href: "https://api.spotify.com/v1/artists/0tvpihdAsKiNnP6sWS3jUI",
					id: "0tvpihdAsKiNnP6sWS3jUI",
					name: "TroyBoi",
					type: "artist",
					uri: "spotify:artist:0tvpihdAsKiNnP6sWS3jUI"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/30B1R8mmBp9oqD5FLg0790" },
					href: "https://api.spotify.com/v1/artists/30B1R8mmBp9oqD5FLg0790",
					id: "30B1R8mmBp9oqD5FLg0790",
					name: "Destiny",
					type: "artist",
					uri: "spotify:artist:30B1R8mmBp9oqD5FLg0790"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 235424,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USZ4V1800185" },
			external_urls: { spotify: "https://open.spotify.com/track/6sCgkrYKENKyfMQIuU6GY3" },
			href: "https://api.spotify.com/v1/tracks/6sCgkrYKENKyfMQIuU6GY3",
			id: "6sCgkrYKENKyfMQIuU6GY3",
			is_local: false,
			name: "Frustrated",
			popularity: 39,
			preview_url: "https://p.scdn.co/mp3-preview/2094ad2b513efa3c9922b961bdc5bfb06c87fcfe?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:6sCgkrYKENKyfMQIuU6GY3"
		},
		features: {
			danceability: 0.614,
			energy: 0.604,
			key: 5,
			loudness: -3.261,
			mode: 0,
			speechiness: 0.0896,
			acousticness: 0.501,
			instrumentalness: 0.0166,
			liveness: 0.105,
			valence: 0.428,
			tempo: 131,
			type: "audio_features",
			id: "6sCgkrYKENKyfMQIuU6GY3",
			uri: "spotify:track:6sCgkrYKENKyfMQIuU6GY3",
			track_href: "https://api.spotify.com/v1/tracks/6sCgkrYKENKyfMQIuU6GY3",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6sCgkrYKENKyfMQIuU6GY3",
			duration_ms: 235424,
			time_signature: 4,
			doubletime: 131
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/35sCXuy5gN6Or69rZ9vqBs" },
						href: "https://api.spotify.com/v1/artists/35sCXuy5gN6Or69rZ9vqBs",
						id: "35sCXuy5gN6Or69rZ9vqBs",
						name: "Birdman",
						type: "artist",
						uri: "spotify:artist:35sCXuy5gN6Or69rZ9vqBs"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
						href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
						id: "55Aa2cqylxrFIXC767Z865",
						name: "Lil Wayne",
						type: "artist",
						uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
					}
				],
				available_markets: ["CA", "MX", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/3DLSu5fxSIaG7Ph8G5YVBp" },
				href: "https://api.spotify.com/v1/albums/3DLSu5fxSIaG7Ph8G5YVBp",
				id: "3DLSu5fxSIaG7Ph8G5YVBp",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273dd307b116993618f3ad171a5", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02dd307b116993618f3ad171a5", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851dd307b116993618f3ad171a5", width: 64 }
				],
				name: "Like Father Like Son",
				release_date: "2006-01-01",
				release_date_precision: "day",
				total_tracks: 25,
				type: "album",
				uri: "spotify:album:3DLSu5fxSIaG7Ph8G5YVBp"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/35sCXuy5gN6Or69rZ9vqBs" },
					href: "https://api.spotify.com/v1/artists/35sCXuy5gN6Or69rZ9vqBs",
					id: "35sCXuy5gN6Or69rZ9vqBs",
					name: "Birdman",
					type: "artist",
					uri: "spotify:artist:35sCXuy5gN6Or69rZ9vqBs"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865" },
					href: "https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865",
					id: "55Aa2cqylxrFIXC767Z865",
					name: "Lil Wayne",
					type: "artist",
					uri: "spotify:artist:55Aa2cqylxrFIXC767Z865"
				}
			],
			available_markets: ["CA", "MX", "US"],
			disc_number: 1,
			duration_ms: 267293,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USCM50600048" },
			external_urls: { spotify: "https://open.spotify.com/track/3rMyMv8EjKXoPnaRo2hdJN" },
			href: "https://api.spotify.com/v1/tracks/3rMyMv8EjKXoPnaRo2hdJN",
			id: "3rMyMv8EjKXoPnaRo2hdJN",
			is_local: false,
			name: "Stuntin' Like My Daddy - Street",
			popularity: 58,
			preview_url: "https://p.scdn.co/mp3-preview/8004018b3a806e3f0143ec69421911331dd114bb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:3rMyMv8EjKXoPnaRo2hdJN"
		},
		features: {
			danceability: 0.71,
			energy: 0.882,
			key: 5,
			loudness: -6.648,
			mode: 0,
			speechiness: 0.04,
			acousticness: 0.00908,
			instrumentalness: 0,
			liveness: 0.162,
			valence: 0.806,
			tempo: 160,
			type: "audio_features",
			id: "3rMyMv8EjKXoPnaRo2hdJN",
			uri: "spotify:track:3rMyMv8EjKXoPnaRo2hdJN",
			track_href: "https://api.spotify.com/v1/tracks/3rMyMv8EjKXoPnaRo2hdJN",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3rMyMv8EjKXoPnaRo2hdJN",
			duration_ms: 267293,
			time_signature: 4,
			doubletime: 160
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2Xu7q46Hf02xOoEIm4E1Qs" },
						href: "https://api.spotify.com/v1/artists/2Xu7q46Hf02xOoEIm4E1Qs",
						id: "2Xu7q46Hf02xOoEIm4E1Qs",
						name: "Big Pun",
						type: "artist",
						uri: "spotify:artist:2Xu7q46Hf02xOoEIm4E1Qs"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3IIHk2ZLXKWuVAjCbQ9g4Y" },
				href: "https://api.spotify.com/v1/albums/3IIHk2ZLXKWuVAjCbQ9g4Y",
				id: "3IIHk2ZLXKWuVAjCbQ9g4Y",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2738c7a8e68dc5c20bb72f713f2", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e028c7a8e68dc5c20bb72f713f2", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048518c7a8e68dc5c20bb72f713f2", width: 64 }
				],
				name: "Capital Punishment (Explicit Version)",
				release_date: "1999-08-28",
				release_date_precision: "day",
				total_tracks: 24,
				type: "album",
				uri: "spotify:album:3IIHk2ZLXKWuVAjCbQ9g4Y"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2Xu7q46Hf02xOoEIm4E1Qs" },
					href: "https://api.spotify.com/v1/artists/2Xu7q46Hf02xOoEIm4E1Qs",
					id: "2Xu7q46Hf02xOoEIm4E1Qs",
					name: "Big Pun",
					type: "artist",
					uri: "spotify:artist:2Xu7q46Hf02xOoEIm4E1Qs"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3ScY9CQxNLQei8Umvpx5g6" },
					href: "https://api.spotify.com/v1/artists/3ScY9CQxNLQei8Umvpx5g6",
					id: "3ScY9CQxNLQei8Umvpx5g6",
					name: "Fat Joe",
					type: "artist",
					uri: "spotify:artist:3ScY9CQxNLQei8Umvpx5g6"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 228173,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USLR59900121" },
			external_urls: { spotify: "https://open.spotify.com/track/0B8drtTSp68pZdkmVrG9ZA" },
			href: "https://api.spotify.com/v1/tracks/0B8drtTSp68pZdkmVrG9ZA",
			id: "0B8drtTSp68pZdkmVrG9ZA",
			is_local: false,
			name: "Twinz (Deep Cover 98) (feat. Fat Joe)",
			popularity: 64,
			preview_url: "https://p.scdn.co/mp3-preview/790ab77efb015671da4cb07d6b4f806ba2c3b5aa?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 17,
			type: "track",
			uri: "spotify:track:0B8drtTSp68pZdkmVrG9ZA"
		},
		features: {
			danceability: 0.633,
			energy: 0.764,
			key: 0,
			loudness: -7.212,
			mode: 1,
			speechiness: 0.323,
			acousticness: 0.32,
			instrumentalness: 0.0000034,
			liveness: 0.234,
			valence: 0.522,
			tempo: 95,
			type: "audio_features",
			id: "0B8drtTSp68pZdkmVrG9ZA",
			uri: "spotify:track:0B8drtTSp68pZdkmVrG9ZA",
			track_href: "https://api.spotify.com/v1/tracks/0B8drtTSp68pZdkmVrG9ZA",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0B8drtTSp68pZdkmVrG9ZA",
			duration_ms: 228173,
			time_signature: 4,
			doubletime: 190
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0sQ1wgSdRpoysgsa1VnI4G" },
						href: "https://api.spotify.com/v1/artists/0sQ1wgSdRpoysgsa1VnI4G",
						id: "0sQ1wgSdRpoysgsa1VnI4G",
						name: "Foreign Beggars",
						type: "artist",
						uri: "spotify:artist:0sQ1wgSdRpoysgsa1VnI4G"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HN",
					"HU",
					"IE",
					"IL",
					"IS",
					"IT",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PL",
					"PT",
					"PY",
					"RO",
					"SE",
					"SK",
					"SV",
					"TN",
					"TR",
					"US",
					"UY",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4soQBIgunzOy42ADTbO3yl" },
				href: "https://api.spotify.com/v1/albums/4soQBIgunzOy42ADTbO3yl",
				id: "4soQBIgunzOy42ADTbO3yl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273eb0848c2e13b514a1e7ba47c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02eb0848c2e13b514a1e7ba47c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851eb0848c2e13b514a1e7ba47c", width: 64 }
				],
				name: "2 2 Karma (Deluxe Version)",
				release_date: "2018-10-12",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:4soQBIgunzOy42ADTbO3yl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0sQ1wgSdRpoysgsa1VnI4G" },
					href: "https://api.spotify.com/v1/artists/0sQ1wgSdRpoysgsa1VnI4G",
					id: "0sQ1wgSdRpoysgsa1VnI4G",
					name: "Foreign Beggars",
					type: "artist",
					uri: "spotify:artist:0sQ1wgSdRpoysgsa1VnI4G"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1HMhQzj2QXxR40zGDdaK6y" },
					href: "https://api.spotify.com/v1/artists/1HMhQzj2QXxR40zGDdaK6y",
					id: "1HMhQzj2QXxR40zGDdaK6y",
					name: "Kojey Radical",
					type: "artist",
					uri: "spotify:artist:1HMhQzj2QXxR40zGDdaK6y"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0yWQz9ri2NtXJq7RRN1f3c" },
					href: "https://api.spotify.com/v1/artists/0yWQz9ri2NtXJq7RRN1f3c",
					id: "0yWQz9ri2NtXJq7RRN1f3c",
					name: "Bangzy",
					type: "artist",
					uri: "spotify:artist:0yWQz9ri2NtXJq7RRN1f3c"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HN",
				"HU",
				"IE",
				"IL",
				"IS",
				"IT",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PL",
				"PT",
				"PY",
				"RO",
				"SE",
				"SK",
				"SV",
				"TN",
				"TR",
				"US",
				"UY",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 198659,
			episode: false,
			explicit: true,
			external_ids: { isrc: "UKMGC1700010" },
			external_urls: { spotify: "https://open.spotify.com/track/5q0fGVESQSi76NRvmu2OnF" },
			href: "https://api.spotify.com/v1/tracks/5q0fGVESQSi76NRvmu2OnF",
			id: "5q0fGVESQSi76NRvmu2OnF",
			is_local: false,
			name: "Blood in the Sink",
			popularity: 9,
			preview_url: "https://p.scdn.co/mp3-preview/daddeae0aa3ed55ffd0c56637dc43225fb27f318?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:5q0fGVESQSi76NRvmu2OnF"
		},
		features: {
			danceability: 0.517,
			energy: 0.74,
			key: 11,
			loudness: -7.896,
			mode: 0,
			speechiness: 0.289,
			acousticness: 0.378,
			instrumentalness: 0,
			liveness: 0.248,
			valence: 0.253,
			tempo: 108,
			type: "audio_features",
			id: "5q0fGVESQSi76NRvmu2OnF",
			uri: "spotify:track:5q0fGVESQSi76NRvmu2OnF",
			track_href: "https://api.spotify.com/v1/tracks/5q0fGVESQSi76NRvmu2OnF",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5q0fGVESQSi76NRvmu2OnF",
			duration_ms: 198660,
			time_signature: 3,
			doubletime: 108
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/02kJSzxNuaWGqwubyUba0Z" },
						href: "https://api.spotify.com/v1/artists/02kJSzxNuaWGqwubyUba0Z",
						id: "02kJSzxNuaWGqwubyUba0Z",
						name: "G-Eazy",
						type: "artist",
						uri: "spotify:artist:02kJSzxNuaWGqwubyUba0Z"
					}
				],
				available_markets: [
					"AD",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JP",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"RO",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/09Q3WwGYsQe5ognkvVkmCu" },
				href: "https://api.spotify.com/v1/albums/09Q3WwGYsQe5ognkvVkmCu",
				id: "09Q3WwGYsQe5ognkvVkmCu",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27398acfa8c055deedc25e6081d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0298acfa8c055deedc25e6081d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485198acfa8c055deedc25e6081d", width: 64 }
				],
				name: "When It's Dark Out",
				release_date: "2015-12-04",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:09Q3WwGYsQe5ognkvVkmCu"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/02kJSzxNuaWGqwubyUba0Z" },
					href: "https://api.spotify.com/v1/artists/02kJSzxNuaWGqwubyUba0Z",
					id: "02kJSzxNuaWGqwubyUba0Z",
					name: "G-Eazy",
					type: "artist",
					uri: "spotify:artist:02kJSzxNuaWGqwubyUba0Z"
				}
			],
			available_markets: [
				"AD",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JP",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"RO",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 207986,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USRC11501723" },
			external_urls: { spotify: "https://open.spotify.com/track/4ztaHDRJVuQe61KVCIpgqw" },
			href: "https://api.spotify.com/v1/tracks/4ztaHDRJVuQe61KVCIpgqw",
			id: "4ztaHDRJVuQe61KVCIpgqw",
			is_local: false,
			name: "You Got Me",
			popularity: 58,
			preview_url: "https://p.scdn.co/mp3-preview/50c2472c27ccf456790668e9fb049121ec54ad4e?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:4ztaHDRJVuQe61KVCIpgqw"
		},
		features: {
			danceability: 0.745,
			energy: 0.635,
			key: 11,
			loudness: -9.735,
			mode: 1,
			speechiness: 0.269,
			acousticness: 0.013,
			instrumentalness: 0,
			liveness: 0.06,
			valence: 0.551,
			tempo: 95,
			type: "audio_features",
			id: "4ztaHDRJVuQe61KVCIpgqw",
			uri: "spotify:track:4ztaHDRJVuQe61KVCIpgqw",
			track_href: "https://api.spotify.com/v1/tracks/4ztaHDRJVuQe61KVCIpgqw",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4ztaHDRJVuQe61KVCIpgqw",
			duration_ms: 207987,
			time_signature: 4,
			doubletime: 190
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5IcR3N7QB1j6KBL8eImZ8m" },
						href: "https://api.spotify.com/v1/artists/5IcR3N7QB1j6KBL8eImZ8m",
						id: "5IcR3N7QB1j6KBL8eImZ8m",
						name: "ScHoolboy Q",
						type: "artist",
						uri: "spotify:artist:5IcR3N7QB1j6KBL8eImZ8m"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7Et3bSTLLqdABO1qCxUplS" },
				href: "https://api.spotify.com/v1/albums/7Et3bSTLLqdABO1qCxUplS",
				id: "7Et3bSTLLqdABO1qCxUplS",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27336977e237a8f70ec6c990636", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0236977e237a8f70ec6c990636", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485136977e237a8f70ec6c990636", width: 64 }
				],
				name: "Oxymoron (Deluxe)",
				release_date: "2014-01-01",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:7Et3bSTLLqdABO1qCxUplS"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5IcR3N7QB1j6KBL8eImZ8m" },
					href: "https://api.spotify.com/v1/artists/5IcR3N7QB1j6KBL8eImZ8m",
					id: "5IcR3N7QB1j6KBL8eImZ8m",
					name: "ScHoolboy Q",
					type: "artist",
					uri: "spotify:artist:5IcR3N7QB1j6KBL8eImZ8m"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4V8LLVI7PbaPR0K2TGSxFF" },
					href: "https://api.spotify.com/v1/artists/4V8LLVI7PbaPR0K2TGSxFF",
					id: "4V8LLVI7PbaPR0K2TGSxFF",
					name: "Tyler, The Creator",
					type: "artist",
					uri: "spotify:artist:4V8LLVI7PbaPR0K2TGSxFF"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6NyJIFHAePjHR1pFxwisqz" },
					href: "https://api.spotify.com/v1/artists/6NyJIFHAePjHR1pFxwisqz",
					id: "6NyJIFHAePjHR1pFxwisqz",
					name: "Kurupt",
					type: "artist",
					uri: "spotify:artist:6NyJIFHAePjHR1pFxwisqz"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 294053,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71400327" },
			external_urls: { spotify: "https://open.spotify.com/track/1oQJ26nHHgHh45WqyA59GF" },
			href: "https://api.spotify.com/v1/tracks/1oQJ26nHHgHh45WqyA59GF",
			id: "1oQJ26nHHgHh45WqyA59GF",
			is_local: false,
			name: "The Purge",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/c3a1465e1a77c0a954856add4e7248f933d99528?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:1oQJ26nHHgHh45WqyA59GF"
		},
		features: {
			danceability: 0.622,
			energy: 0.641,
			key: 10,
			loudness: -6.76,
			mode: 0,
			speechiness: 0.464,
			acousticness: 0.035,
			instrumentalness: 0,
			liveness: 0.259,
			valence: 0.387,
			tempo: 168,
			type: "audio_features",
			id: "1oQJ26nHHgHh45WqyA59GF",
			uri: "spotify:track:1oQJ26nHHgHh45WqyA59GF",
			track_href: "https://api.spotify.com/v1/tracks/1oQJ26nHHgHh45WqyA59GF",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1oQJ26nHHgHh45WqyA59GF",
			duration_ms: 294053,
			time_signature: 4,
			doubletime: 168
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
						href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
						id: "3crnzLy8R4lVwaigKEOz7V",
						name: "E-40",
						type: "artist",
						uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3VqKqWHOHYfZqttJ0WwQHl" },
				href: "https://api.spotify.com/v1/albums/3VqKqWHOHYfZqttJ0WwQHl",
				id: "3VqKqWHOHYfZqttJ0WwQHl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273323ddf04bbf79029f3142087", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02323ddf04bbf79029f3142087", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851323ddf04bbf79029f3142087", width: 64 }
				],
				name: "My Ghetto Report Card",
				release_date: "2006-03-14",
				release_date_precision: "day",
				total_tracks: 20,
				type: "album",
				uri: "spotify:album:3VqKqWHOHYfZqttJ0WwQHl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
					href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
					id: "3crnzLy8R4lVwaigKEOz7V",
					name: "E-40",
					type: "artist",
					uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1sPpJhevOYz54gNgeh2LaV" },
					href: "https://api.spotify.com/v1/artists/1sPpJhevOYz54gNgeh2LaV",
					id: "1sPpJhevOYz54gNgeh2LaV",
					name: "Keak Da Sneak",
					type: "artist",
					uri: "spotify:artist:1sPpJhevOYz54gNgeh2LaV"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 237666,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USWB10505461" },
			external_urls: { spotify: "https://open.spotify.com/track/7eJ5kRpMNPAk7ccCDKywjH" },
			href: "https://api.spotify.com/v1/tracks/7eJ5kRpMNPAk7ccCDKywjH",
			id: "7eJ5kRpMNPAk7ccCDKywjH",
			is_local: false,
			name: "Tell Me When to Go (feat. Keak da Sneak)",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/370a136f67e3adbd0e6184429936fb6e097c21f7?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:7eJ5kRpMNPAk7ccCDKywjH"
		},
		features: {
			danceability: 0.857,
			energy: 0.751,
			key: 1,
			loudness: -7.086,
			mode: 1,
			speechiness: 0.323,
			acousticness: 0.00642,
			instrumentalness: 0.000257,
			liveness: 0.104,
			valence: 0.293,
			tempo: 107,
			type: "audio_features",
			id: "7eJ5kRpMNPAk7ccCDKywjH",
			uri: "spotify:track:7eJ5kRpMNPAk7ccCDKywjH",
			track_href: "https://api.spotify.com/v1/tracks/7eJ5kRpMNPAk7ccCDKywjH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7eJ5kRpMNPAk7ccCDKywjH",
			duration_ms: 237667,
			time_signature: 4,
			doubletime: 107
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
						href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
						id: "3crnzLy8R4lVwaigKEOz7V",
						name: "E-40",
						type: "artist",
						uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6yt1MYALkwTXthb121Lm97" },
				href: "https://api.spotify.com/v1/albums/6yt1MYALkwTXthb121Lm97",
				id: "6yt1MYALkwTXthb121Lm97",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273adfe9b53238d9953d13b20a3", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02adfe9b53238d9953d13b20a3", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851adfe9b53238d9953d13b20a3", width: 64 }
				],
				name: "The Block Brochure: Welcome To The Soil 2",
				release_date: "2012-01-01",
				release_date_precision: "day",
				total_tracks: 18,
				type: "album",
				uri: "spotify:album:6yt1MYALkwTXthb121Lm97"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3crnzLy8R4lVwaigKEOz7V" },
					href: "https://api.spotify.com/v1/artists/3crnzLy8R4lVwaigKEOz7V",
					id: "3crnzLy8R4lVwaigKEOz7V",
					name: "E-40",
					type: "artist",
					uri: "spotify:artist:3crnzLy8R4lVwaigKEOz7V"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0A0FS04o6zMoto8OKPsDwY" },
					href: "https://api.spotify.com/v1/artists/0A0FS04o6zMoto8OKPsDwY",
					id: "0A0FS04o6zMoto8OKPsDwY",
					name: "YG",
					type: "artist",
					uri: "spotify:artist:0A0FS04o6zMoto8OKPsDwY"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2ZavqCJe7uqkRpISes0NFi" },
					href: "https://api.spotify.com/v1/artists/2ZavqCJe7uqkRpISes0NFi",
					id: "2ZavqCJe7uqkRpISes0NFi",
					name: "Iamsu!",
					type: "artist",
					uri: "spotify:artist:2ZavqCJe7uqkRpISes0NFi"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0399oiMcmbOzzsYQDNYqxn" },
					href: "https://api.spotify.com/v1/artists/0399oiMcmbOzzsYQDNYqxn",
					id: "0399oiMcmbOzzsYQDNYqxn",
					name: "Problem",
					type: "artist",
					uri: "spotify:artist:0399oiMcmbOzzsYQDNYqxn"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 259200,
			episode: false,
			explicit: true,
			external_ids: { isrc: "US4KV1200039" },
			external_urls: { spotify: "https://open.spotify.com/track/5PR09nMAHAOOklMQMJchch" },
			href: "https://api.spotify.com/v1/tracks/5PR09nMAHAOOklMQMJchch",
			id: "5PR09nMAHAOOklMQMJchch",
			is_local: false,
			name: "Function",
			popularity: 54,
			preview_url: "https://p.scdn.co/mp3-preview/c9172b275032608dcddcf0ecf4b62f64b5dca050?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:5PR09nMAHAOOklMQMJchch"
		},
		features: {
			danceability: 0.881,
			energy: 0.564,
			key: 2,
			loudness: -5.239,
			mode: 1,
			speechiness: 0.232,
			acousticness: 0.00138,
			instrumentalness: 0,
			liveness: 0.0983,
			valence: 0.366,
			tempo: 100,
			type: "audio_features",
			id: "5PR09nMAHAOOklMQMJchch",
			uri: "spotify:track:5PR09nMAHAOOklMQMJchch",
			track_href: "https://api.spotify.com/v1/tracks/5PR09nMAHAOOklMQMJchch",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5PR09nMAHAOOklMQMJchch",
			duration_ms: 259200,
			time_signature: 4,
			doubletime: 100
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4IVAbR2w4JJNJDDRFP3E83" },
						href: "https://api.spotify.com/v1/artists/4IVAbR2w4JJNJDDRFP3E83",
						id: "4IVAbR2w4JJNJDDRFP3E83",
						name: "6LACK",
						type: "artist",
						uri: "spotify:artist:4IVAbR2w4JJNJDDRFP3E83"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7iwGw8ob3YLqZrbKzGFnHi" },
				href: "https://api.spotify.com/v1/albums/7iwGw8ob3YLqZrbKzGFnHi",
				id: "7iwGw8ob3YLqZrbKzGFnHi",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e4f13cd87b3b1ead6735a520", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e4f13cd87b3b1ead6735a520", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e4f13cd87b3b1ead6735a520", width: 64 }
				],
				name: "FREE 6LACK",
				release_date: "2016-11-18",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:7iwGw8ob3YLqZrbKzGFnHi"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4IVAbR2w4JJNJDDRFP3E83" },
					href: "https://api.spotify.com/v1/artists/4IVAbR2w4JJNJDDRFP3E83",
					id: "4IVAbR2w4JJNJDDRFP3E83",
					name: "6LACK",
					type: "artist",
					uri: "spotify:artist:4IVAbR2w4JJNJDDRFP3E83"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 246773,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1102245" },
			external_urls: { spotify: "https://open.spotify.com/track/4AtZRwSR8BOTTQg5ihSggt" },
			href: "https://api.spotify.com/v1/tracks/4AtZRwSR8BOTTQg5ihSggt",
			id: "4AtZRwSR8BOTTQg5ihSggt",
			is_local: false,
			name: "PRBLMS",
			popularity: 72,
			preview_url: "https://p.scdn.co/mp3-preview/37933b2a5f9c6939565d3be0a1f7d1b8b4bf1322?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:4AtZRwSR8BOTTQg5ihSggt"
		},
		features: {
			danceability: 0.417,
			energy: 0.58,
			key: 9,
			loudness: -4.574,
			mode: 1,
			speechiness: 0.207,
			acousticness: 0.0307,
			instrumentalness: 0.00000145,
			liveness: 0.179,
			valence: 0.139,
			tempo: 69,
			type: "audio_features",
			id: "4AtZRwSR8BOTTQg5ihSggt",
			uri: "spotify:track:4AtZRwSR8BOTTQg5ihSggt",
			track_href: "https://api.spotify.com/v1/tracks/4AtZRwSR8BOTTQg5ihSggt",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4AtZRwSR8BOTTQg5ihSggt",
			duration_ms: 246773,
			time_signature: 5,
			doubletime: 138
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5K4W6rqBFWDnAN6FQUkS6x" },
						href: "https://api.spotify.com/v1/artists/5K4W6rqBFWDnAN6FQUkS6x",
						id: "5K4W6rqBFWDnAN6FQUkS6x",
						name: "Kanye West",
						type: "artist",
						uri: "spotify:artist:5K4W6rqBFWDnAN6FQUkS6x"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/0XTAmejG8F97wF5MWoVbaY" },
				href: "https://api.spotify.com/v1/albums/0XTAmejG8F97wF5MWoVbaY",
				id: "0XTAmejG8F97wF5MWoVbaY",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273074fbc426af3ca5d6e4b625a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02074fbc426af3ca5d6e4b625a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851074fbc426af3ca5d6e4b625a", width: 64 }
				],
				name: "Yeezus",
				release_date: "2013-01-01",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:0XTAmejG8F97wF5MWoVbaY"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5K4W6rqBFWDnAN6FQUkS6x" },
					href: "https://api.spotify.com/v1/artists/5K4W6rqBFWDnAN6FQUkS6x",
					id: "5K4W6rqBFWDnAN6FQUkS6x",
					name: "Kanye West",
					type: "artist",
					uri: "spotify:artist:5K4W6rqBFWDnAN6FQUkS6x"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 359800,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71307498" },
			external_urls: { spotify: "https://open.spotify.com/track/1HK6gMHUJyIhaNGmM46wvq" },
			href: "https://api.spotify.com/v1/tracks/1HK6gMHUJyIhaNGmM46wvq",
			id: "1HK6gMHUJyIhaNGmM46wvq",
			is_local: false,
			name: "Blood On The Leaves",
			popularity: 2,
			preview_url: null,
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:1HK6gMHUJyIhaNGmM46wvq"
		},
		features: {
			danceability: 0.412,
			energy: 0.68,
			key: 2,
			loudness: -4.099,
			mode: 0,
			speechiness: 0.144,
			acousticness: 0.374,
			instrumentalness: 0,
			liveness: 0.101,
			valence: 0.347,
			tempo: 86,
			type: "audio_features",
			id: "1HK6gMHUJyIhaNGmM46wvq",
			uri: "spotify:track:1HK6gMHUJyIhaNGmM46wvq",
			track_href: "https://api.spotify.com/v1/tracks/1HK6gMHUJyIhaNGmM46wvq",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1HK6gMHUJyIhaNGmM46wvq",
			duration_ms: 359800,
			time_signature: 4,
			doubletime: 172
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0huGjMyP507tBCARyzSkrv" },
						href: "https://api.spotify.com/v1/artists/0huGjMyP507tBCARyzSkrv",
						id: "0huGjMyP507tBCARyzSkrv",
						name: "YBN Cordae",
						type: "artist",
						uri: "spotify:artist:0huGjMyP507tBCARyzSkrv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6Pb7PMZtW0fuEM1lCGvCDu" },
				href: "https://api.spotify.com/v1/albums/6Pb7PMZtW0fuEM1lCGvCDu",
				id: "6Pb7PMZtW0fuEM1lCGvCDu",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e6d6d392a66a7f9172fe57c8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e6d6d392a66a7f9172fe57c8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e6d6d392a66a7f9172fe57c8", width: 64 }
				],
				name: "The Lost Boy",
				release_date: "2019-07-26",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:6Pb7PMZtW0fuEM1lCGvCDu"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0huGjMyP507tBCARyzSkrv" },
					href: "https://api.spotify.com/v1/artists/0huGjMyP507tBCARyzSkrv",
					id: "0huGjMyP507tBCARyzSkrv",
					name: "YBN Cordae",
					type: "artist",
					uri: "spotify:artist:0huGjMyP507tBCARyzSkrv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 196111,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USAT21903973" },
			external_urls: { spotify: "https://open.spotify.com/track/1faIb3PPSzEifCHUOJ691R" },
			href: "https://api.spotify.com/v1/tracks/1faIb3PPSzEifCHUOJ691R",
			id: "1faIb3PPSzEifCHUOJ691R",
			is_local: false,
			name: "Broke As Fuck",
			popularity: 70,
			preview_url: "https://p.scdn.co/mp3-preview/26b166ec6ed2cdf881dbba5045945529b64baa12?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:1faIb3PPSzEifCHUOJ691R"
		},
		features: {
			danceability: 0.616,
			energy: 0.669,
			key: 1,
			loudness: -5.791,
			mode: 1,
			speechiness: 0.32,
			acousticness: 0.0298,
			instrumentalness: 0,
			liveness: 0.127,
			valence: 0.275,
			tempo: 154,
			type: "audio_features",
			id: "1faIb3PPSzEifCHUOJ691R",
			uri: "spotify:track:1faIb3PPSzEifCHUOJ691R",
			track_href: "https://api.spotify.com/v1/tracks/1faIb3PPSzEifCHUOJ691R",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1faIb3PPSzEifCHUOJ691R",
			duration_ms: 196112,
			time_signature: 4,
			doubletime: 154
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/31zwOgFeoG3vPPWCohxh7l" },
				href: "https://api.spotify.com/v1/albums/31zwOgFeoG3vPPWCohxh7l",
				id: "31zwOgFeoG3vPPWCohxh7l",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273da5b4e9f1a5df4b26ef6c847", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02da5b4e9f1a5df4b26ef6c847", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851da5b4e9f1a5df4b26ef6c847", width: 64 }
				],
				name: "Rhythm + Flow Soundtrack: The Final Episode (Music from the Netflix Original Series)",
				release_date: "2019-10-23",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:31zwOgFeoG3vPPWCohxh7l"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0hfCvrogjeBd9cTtAYTyCs" },
					href: "https://api.spotify.com/v1/artists/0hfCvrogjeBd9cTtAYTyCs",
					id: "0hfCvrogjeBd9cTtAYTyCs",
					name: "Troyman",
					type: "artist",
					uri: "spotify:artist:0hfCvrogjeBd9cTtAYTyCs"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 149974,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QZ8BZ1900596" },
			external_urls: { spotify: "https://open.spotify.com/track/1Y4FrrNLB3uiouY9MEQtRL" },
			href: "https://api.spotify.com/v1/tracks/1Y4FrrNLB3uiouY9MEQtRL",
			id: "1Y4FrrNLB3uiouY9MEQtRL",
			is_local: false,
			name: "Streetlight",
			popularity: 56,
			preview_url: "https://p.scdn.co/mp3-preview/09654e9b7228382f071dbcc47e1241090270000e?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1Y4FrrNLB3uiouY9MEQtRL"
		},
		features: {
			danceability: 0.727,
			energy: 0.573,
			key: 1,
			loudness: -6.279,
			mode: 0,
			speechiness: 0.277,
			acousticness: 0.166,
			instrumentalness: 0,
			liveness: 0.1,
			valence: 0.466,
			tempo: 176,
			type: "audio_features",
			id: "1Y4FrrNLB3uiouY9MEQtRL",
			uri: "spotify:track:1Y4FrrNLB3uiouY9MEQtRL",
			track_href: "https://api.spotify.com/v1/tracks/1Y4FrrNLB3uiouY9MEQtRL",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1Y4FrrNLB3uiouY9MEQtRL",
			duration_ms: 149974,
			time_signature: 4,
			doubletime: 176
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6UBA15slIuadJ8h2lPRPos" },
						href: "https://api.spotify.com/v1/artists/6UBA15slIuadJ8h2lPRPos",
						id: "6UBA15slIuadJ8h2lPRPos",
						name: "Tech N9ne",
						type: "artist",
						uri: "spotify:artist:6UBA15slIuadJ8h2lPRPos"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/63uxYglJtSneGlHf5MKWfl" },
				href: "https://api.spotify.com/v1/albums/63uxYglJtSneGlHf5MKWfl",
				id: "63uxYglJtSneGlHf5MKWfl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2734b6ce6a88e6aa90472519aab", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e024b6ce6a88e6aa90472519aab", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048514b6ce6a88e6aa90472519aab", width: 64 }
				],
				name: "Special Effects",
				release_date: "2015-05-04",
				release_date_precision: "day",
				total_tracks: 24,
				type: "album",
				uri: "spotify:album:63uxYglJtSneGlHf5MKWfl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6UBA15slIuadJ8h2lPRPos" },
					href: "https://api.spotify.com/v1/artists/6UBA15slIuadJ8h2lPRPos",
					id: "6UBA15slIuadJ8h2lPRPos",
					name: "Tech N9ne",
					type: "artist",
					uri: "spotify:artist:6UBA15slIuadJ8h2lPRPos"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp" },
					href: "https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp",
					id: "17lzZA2AlOHwCwFALHttmp",
					name: "2 Chainz",
					type: "artist",
					uri: "spotify:artist:17lzZA2AlOHwCwFALHttmp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5ndkK3dpZLKtBklKjxNQwT" },
					href: "https://api.spotify.com/v1/artists/5ndkK3dpZLKtBklKjxNQwT",
					id: "5ndkK3dpZLKtBklKjxNQwT",
					name: "B.o.B",
					type: "artist",
					uri: "spotify:artist:5ndkK3dpZLKtBklKjxNQwT"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 225040,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USQY51534920" },
			external_urls: { spotify: "https://open.spotify.com/track/0kIHfcHGFGm5xb0dSlKEdp" },
			href: "https://api.spotify.com/v1/tracks/0kIHfcHGFGm5xb0dSlKEdp",
			id: "0kIHfcHGFGm5xb0dSlKEdp",
			is_local: false,
			name: "Hood Go Crazy",
			popularity: 62,
			preview_url: "https://p.scdn.co/mp3-preview/6f27cb7fbb72adb9dcc88bfa3c98323db1f02b8d?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 11,
			type: "track",
			uri: "spotify:track:0kIHfcHGFGm5xb0dSlKEdp"
		},
		features: {
			danceability: 0.912,
			energy: 0.644,
			key: 11,
			loudness: -6.632,
			mode: 1,
			speechiness: 0.287,
			acousticness: 0.00714,
			instrumentalness: 0,
			liveness: 0.107,
			valence: 0.492,
			tempo: 96,
			type: "audio_features",
			id: "0kIHfcHGFGm5xb0dSlKEdp",
			uri: "spotify:track:0kIHfcHGFGm5xb0dSlKEdp",
			track_href: "https://api.spotify.com/v1/tracks/0kIHfcHGFGm5xb0dSlKEdp",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0kIHfcHGFGm5xb0dSlKEdp",
			duration_ms: 225040,
			time_signature: 4,
			doubletime: 192
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/68kEuyFKyqrdQQLLsmiatm" },
						href: "https://api.spotify.com/v1/artists/68kEuyFKyqrdQQLLsmiatm",
						id: "68kEuyFKyqrdQQLLsmiatm",
						name: "Vince Staples",
						type: "artist",
						uri: "spotify:artist:68kEuyFKyqrdQQLLsmiatm"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2haR5qnQopCdVASZ92YTGn" },
				href: "https://api.spotify.com/v1/albums/2haR5qnQopCdVASZ92YTGn",
				id: "2haR5qnQopCdVASZ92YTGn",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2734e48a1dea0f70b856c3c0f72", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e024e48a1dea0f70b856c3c0f72", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048514e48a1dea0f70b856c3c0f72", width: 64 }
				],
				name: "Prima Donna",
				release_date: "2016-08-25",
				release_date_precision: "day",
				total_tracks: 7,
				type: "album",
				uri: "spotify:album:2haR5qnQopCdVASZ92YTGn"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/68kEuyFKyqrdQQLLsmiatm" },
					href: "https://api.spotify.com/v1/artists/68kEuyFKyqrdQQLLsmiatm",
					id: "68kEuyFKyqrdQQLLsmiatm",
					name: "Vince Staples",
					type: "artist",
					uri: "spotify:artist:68kEuyFKyqrdQQLLsmiatm"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7lsnwlX6puQ7lcpSEpJbZE" },
					href: "https://api.spotify.com/v1/artists/7lsnwlX6puQ7lcpSEpJbZE",
					id: "7lsnwlX6puQ7lcpSEpJbZE",
					name: "Kilo Kish",
					type: "artist",
					uri: "spotify:artist:7lsnwlX6puQ7lcpSEpJbZE"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 258333,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71606192" },
			external_urls: { spotify: "https://open.spotify.com/track/1UledP7E5IenOcwl2oZaSu" },
			href: "https://api.spotify.com/v1/tracks/1UledP7E5IenOcwl2oZaSu",
			id: "1UledP7E5IenOcwl2oZaSu",
			is_local: false,
			name: "Loco",
			popularity: 41,
			preview_url: "https://p.scdn.co/mp3-preview/3f41c0bb98b731866628ba62ebe567a91a6b67e9?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:1UledP7E5IenOcwl2oZaSu"
		},
		features: {
			danceability: 0.745,
			energy: 0.589,
			key: 1,
			loudness: -11.242,
			mode: 0,
			speechiness: 0.428,
			acousticness: 0.145,
			instrumentalness: 0.0000202,
			liveness: 0.226,
			valence: 0.395,
			tempo: 100,
			type: "audio_features",
			id: "1UledP7E5IenOcwl2oZaSu",
			uri: "spotify:track:1UledP7E5IenOcwl2oZaSu",
			track_href: "https://api.spotify.com/v1/tracks/1UledP7E5IenOcwl2oZaSu",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1UledP7E5IenOcwl2oZaSu",
			duration_ms: 258333,
			time_signature: 4,
			doubletime: 100
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
						href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
						id: "4xRYI6VqpkE3UwrDrAZL8L",
						name: "Logic",
						type: "artist",
						uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1Mk7Lei0Ra3hawezqmad5V" },
				href: "https://api.spotify.com/v1/albums/1Mk7Lei0Ra3hawezqmad5V",
				id: "1Mk7Lei0Ra3hawezqmad5V",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a4c35326f6fe6676c10e31ac", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a4c35326f6fe6676c10e31ac", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a4c35326f6fe6676c10e31ac", width: 64 }
				],
				name: "Under Pressure (Deluxe)",
				release_date: "2014-10-21",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:1Mk7Lei0Ra3hawezqmad5V"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4xRYI6VqpkE3UwrDrAZL8L" },
					href: "https://api.spotify.com/v1/artists/4xRYI6VqpkE3UwrDrAZL8L",
					id: "4xRYI6VqpkE3UwrDrAZL8L",
					name: "Logic",
					type: "artist",
					uri: "spotify:artist:4xRYI6VqpkE3UwrDrAZL8L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 213013,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71414235" },
			external_urls: { spotify: "https://open.spotify.com/track/4iEWnkDewJ72copeODWuOw" },
			href: "https://api.spotify.com/v1/tracks/4iEWnkDewJ72copeODWuOw",
			id: "4iEWnkDewJ72copeODWuOw",
			is_local: false,
			name: "Now",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/589208c897d1776846ce03abc95da3d67f2f31ce?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 14,
			type: "track",
			uri: "spotify:track:4iEWnkDewJ72copeODWuOw"
		},
		features: {
			danceability: 0.762,
			energy: 0.919,
			key: 9,
			loudness: -3.378,
			mode: 0,
			speechiness: 0.069,
			acousticness: 0.295,
			instrumentalness: 0,
			liveness: 0.126,
			valence: 0.603,
			tempo: 110,
			type: "audio_features",
			id: "4iEWnkDewJ72copeODWuOw",
			uri: "spotify:track:4iEWnkDewJ72copeODWuOw",
			track_href: "https://api.spotify.com/v1/tracks/4iEWnkDewJ72copeODWuOw",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4iEWnkDewJ72copeODWuOw",
			duration_ms: 213013,
			time_signature: 4,
			doubletime: 110
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2h93pZq0e7k5yf4dywlkpM" },
						href: "https://api.spotify.com/v1/artists/2h93pZq0e7k5yf4dywlkpM",
						id: "2h93pZq0e7k5yf4dywlkpM",
						name: "Frank Ocean",
						type: "artist",
						uri: "spotify:artist:2h93pZq0e7k5yf4dywlkpM"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3mH6qwIy9crq0I9YQbOuDf" },
				href: "https://api.spotify.com/v1/albums/3mH6qwIy9crq0I9YQbOuDf",
				id: "3mH6qwIy9crq0I9YQbOuDf",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c5649add07ed3720be9d5526", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c5649add07ed3720be9d5526", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c5649add07ed3720be9d5526", width: 64 }
				],
				name: "Blonde",
				release_date: "2016-08-20",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:3mH6qwIy9crq0I9YQbOuDf"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2h93pZq0e7k5yf4dywlkpM" },
					href: "https://api.spotify.com/v1/artists/2h93pZq0e7k5yf4dywlkpM",
					id: "2h93pZq0e7k5yf4dywlkpM",
					name: "Frank Ocean",
					type: "artist",
					uri: "spotify:artist:2h93pZq0e7k5yf4dywlkpM"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 307151,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QZ5C81600009" },
			external_urls: { spotify: "https://open.spotify.com/track/7eqoqGkKwgOaWNNHx90uEZ" },
			href: "https://api.spotify.com/v1/tracks/7eqoqGkKwgOaWNNHx90uEZ",
			id: "7eqoqGkKwgOaWNNHx90uEZ",
			is_local: false,
			name: "Nights",
			popularity: 77,
			preview_url: "https://p.scdn.co/mp3-preview/43abb77afc35b8eced064a1b062921a13f5c7b15?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 9,
			type: "track",
			uri: "spotify:track:7eqoqGkKwgOaWNNHx90uEZ"
		},
		features: {
			danceability: 0.466,
			energy: 0.548,
			key: 5,
			loudness: -9.362,
			mode: 0,
			speechiness: 0.118,
			acousticness: 0.42,
			instrumentalness: 0.00000101,
			liveness: 0.113,
			valence: 0.423,
			tempo: 90,
			type: "audio_features",
			id: "7eqoqGkKwgOaWNNHx90uEZ",
			uri: "spotify:track:7eqoqGkKwgOaWNNHx90uEZ",
			track_href: "https://api.spotify.com/v1/tracks/7eqoqGkKwgOaWNNHx90uEZ",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7eqoqGkKwgOaWNNHx90uEZ",
			duration_ms: 307151,
			time_signature: 4,
			doubletime: 180
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0RESbWvOMyua0yuyVrztJ5" },
						href: "https://api.spotify.com/v1/artists/0RESbWvOMyua0yuyVrztJ5",
						id: "0RESbWvOMyua0yuyVrztJ5",
						name: "Key Glock",
						type: "artist",
						uri: "spotify:artist:0RESbWvOMyua0yuyVrztJ5"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/12GZ5ewBjyylguigbdmqJ9" },
				href: "https://api.spotify.com/v1/albums/12GZ5ewBjyylguigbdmqJ9",
				id: "12GZ5ewBjyylguigbdmqJ9",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27377d6678d66fd48ecfed2cfe8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0277d6678d66fd48ecfed2cfe8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485177d6678d66fd48ecfed2cfe8", width: 64 }
				],
				name: "Yellow Tape",
				release_date: "2020-01-31",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:12GZ5ewBjyylguigbdmqJ9"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0RESbWvOMyua0yuyVrztJ5" },
					href: "https://api.spotify.com/v1/artists/0RESbWvOMyua0yuyVrztJ5",
					id: "0RESbWvOMyua0yuyVrztJ5",
					name: "Key Glock",
					type: "artist",
					uri: "spotify:artist:0RESbWvOMyua0yuyVrztJ5"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 198866,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUYG1291801" },
			external_urls: { spotify: "https://open.spotify.com/track/2rw5cbtHTyzy8iruujD28d" },
			href: "https://api.spotify.com/v1/tracks/2rw5cbtHTyzy8iruujD28d",
			id: "2rw5cbtHTyzy8iruujD28d",
			is_local: false,
			name: "Dough",
			popularity: 67,
			preview_url: "https://p.scdn.co/mp3-preview/88a79881b264bfd4c3d95f05a0c18de30c71393b?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:2rw5cbtHTyzy8iruujD28d"
		},
		features: {
			danceability: 0.876,
			energy: 0.463,
			key: 1,
			loudness: -6.607,
			mode: 1,
			speechiness: 0.289,
			acousticness: 0.00166,
			instrumentalness: 0.000492,
			liveness: 0.109,
			valence: 0.32,
			tempo: 163,
			type: "audio_features",
			id: "2rw5cbtHTyzy8iruujD28d",
			uri: "spotify:track:2rw5cbtHTyzy8iruujD28d",
			track_href: "https://api.spotify.com/v1/tracks/2rw5cbtHTyzy8iruujD28d",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2rw5cbtHTyzy8iruujD28d",
			duration_ms: 198867,
			time_signature: 4,
			doubletime: 163
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4r63FhuTkUYltbVAg5TQnk" },
						href: "https://api.spotify.com/v1/artists/4r63FhuTkUYltbVAg5TQnk",
						id: "4r63FhuTkUYltbVAg5TQnk",
						name: "DaBaby",
						type: "artist",
						uri: "spotify:artist:4r63FhuTkUYltbVAg5TQnk"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0O1PJ0t69iTO5yWrIeIga0" },
				href: "https://api.spotify.com/v1/albums/0O1PJ0t69iTO5yWrIeIga0",
				id: "0O1PJ0t69iTO5yWrIeIga0",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27374d72ebd51dd5781d5f83ffd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0274d72ebd51dd5781d5f83ffd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485174d72ebd51dd5781d5f83ffd", width: 64 }
				],
				name: "Baby On Baby",
				release_date: "2019-03-01",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:0O1PJ0t69iTO5yWrIeIga0"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4r63FhuTkUYltbVAg5TQnk" },
					href: "https://api.spotify.com/v1/artists/4r63FhuTkUYltbVAg5TQnk",
					id: "4r63FhuTkUYltbVAg5TQnk",
					name: "DaBaby",
					type: "artist",
					uri: "spotify:artist:4r63FhuTkUYltbVAg5TQnk"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4DdkRBBYG6Yk9Ka8tdJ9BW" },
					href: "https://api.spotify.com/v1/artists/4DdkRBBYG6Yk9Ka8tdJ9BW",
					id: "4DdkRBBYG6Yk9Ka8tdJ9BW",
					name: "Offset",
					type: "artist",
					uri: "spotify:artist:4DdkRBBYG6Yk9Ka8tdJ9BW"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 157693,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71902948" },
			external_urls: { spotify: "https://open.spotify.com/track/7f1zjZG77S891Uv4O68yfk" },
			href: "https://api.spotify.com/v1/tracks/7f1zjZG77S891Uv4O68yfk",
			id: "7f1zjZG77S891Uv4O68yfk",
			is_local: false,
			name: "Baby Sitter (feat. Offset)",
			popularity: 76,
			preview_url: "https://p.scdn.co/mp3-preview/32f4a16189b7545dfadeca5afc161322a56b95ec?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 6,
			type: "track",
			uri: "spotify:track:7f1zjZG77S891Uv4O68yfk"
		},
		features: {
			danceability: 0.852,
			energy: 0.73,
			key: 1,
			loudness: -5.803,
			mode: 1,
			speechiness: 0.0579,
			acousticness: 0.0219,
			instrumentalness: 0,
			liveness: 0.336,
			valence: 0.394,
			tempo: 93,
			type: "audio_features",
			id: "7f1zjZG77S891Uv4O68yfk",
			uri: "spotify:track:7f1zjZG77S891Uv4O68yfk",
			track_href: "https://api.spotify.com/v1/tracks/7f1zjZG77S891Uv4O68yfk",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7f1zjZG77S891Uv4O68yfk",
			duration_ms: 157693,
			time_signature: 4,
			doubletime: 186
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/78UUH1buA0gDtDnkX2dPgL" },
						href: "https://api.spotify.com/v1/artists/78UUH1buA0gDtDnkX2dPgL",
						id: "78UUH1buA0gDtDnkX2dPgL",
						name: "Craig Connelly",
						type: "artist",
						uri: "spotify:artist:78UUH1buA0gDtDnkX2dPgL"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7uaU14b424181HXBmK3js4" },
				href: "https://api.spotify.com/v1/albums/7uaU14b424181HXBmK3js4",
				id: "7uaU14b424181HXBmK3js4",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27363abe5f64206d420a3386e35", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0263abe5f64206d420a3386e35", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485163abe5f64206d420a3386e35", width: 64 }
				],
				name: "One Second Closer",
				release_date: "2017-02-24",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:7uaU14b424181HXBmK3js4"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/78UUH1buA0gDtDnkX2dPgL" },
					href: "https://api.spotify.com/v1/artists/78UUH1buA0gDtDnkX2dPgL",
					id: "78UUH1buA0gDtDnkX2dPgL",
					name: "Craig Connelly",
					type: "artist",
					uri: "spotify:artist:78UUH1buA0gDtDnkX2dPgL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6DINLiUlJYvgdqx0a1pcYg" },
					href: "https://api.spotify.com/v1/artists/6DINLiUlJYvgdqx0a1pcYg",
					id: "6DINLiUlJYvgdqx0a1pcYg",
					name: "Dan Dobson",
					type: "artist",
					uri: "spotify:artist:6DINLiUlJYvgdqx0a1pcYg"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7b1FMiWXZwOBsxi0uWw6wH" },
					href: "https://api.spotify.com/v1/artists/7b1FMiWXZwOBsxi0uWw6wH",
					id: "7b1FMiWXZwOBsxi0uWw6wH",
					name: "Elle Vee",
					type: "artist",
					uri: "spotify:artist:7b1FMiWXZwOBsxi0uWw6wH"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 310202,
			episode: false,
			explicit: false,
			external_ids: { isrc: "UKHYL1700005" },
			external_urls: { spotify: "https://open.spotify.com/track/1YmtX6evFjOHCWmlkC4XEi" },
			href: "https://api.spotify.com/v1/tracks/1YmtX6evFjOHCWmlkC4XEi",
			id: "1YmtX6evFjOHCWmlkC4XEi",
			is_local: false,
			name: "Battleground",
			popularity: 30,
			preview_url: "https://p.scdn.co/mp3-preview/d76fbf15db7c2f4d2f9853355be780df9e452e29?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:1YmtX6evFjOHCWmlkC4XEi"
		},
		features: {
			danceability: 0.517,
			energy: 0.876,
			key: 6,
			loudness: -6.135,
			mode: 1,
			speechiness: 0.0338,
			acousticness: 0.0179,
			instrumentalness: 0.16,
			liveness: 0.0707,
			valence: 0.226,
			tempo: 135,
			type: "audio_features",
			id: "1YmtX6evFjOHCWmlkC4XEi",
			uri: "spotify:track:1YmtX6evFjOHCWmlkC4XEi",
			track_href: "https://api.spotify.com/v1/tracks/1YmtX6evFjOHCWmlkC4XEi",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1YmtX6evFjOHCWmlkC4XEi",
			duration_ms: 310202,
			time_signature: 4,
			doubletime: 135
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
						href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
						id: "0SfsnGyD8FpIN4U4WCkBZ5",
						name: "Armin van Buuren",
						type: "artist",
						uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5aP2E8K4LY86fUERVzZlnX" },
						href: "https://api.spotify.com/v1/artists/5aP2E8K4LY86fUERVzZlnX",
						id: "5aP2E8K4LY86fUERVzZlnX",
						name: "Garibay",
						type: "artist",
						uri: "spotify:artist:5aP2E8K4LY86fUERVzZlnX"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7Fb4bPwUT0mrtDXt2qmJEp" },
						href: "https://api.spotify.com/v1/artists/7Fb4bPwUT0mrtDXt2qmJEp",
						id: "7Fb4bPwUT0mrtDXt2qmJEp",
						name: "Olaf Blackwood",
						type: "artist",
						uri: "spotify:artist:7Fb4bPwUT0mrtDXt2qmJEp"
					}
				],
				available_markets: [
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"CH",
					"CL",
					"CO",
					"CY",
					"CZ",
					"DE",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"FR",
					"GR",
					"HK",
					"HU",
					"ID",
					"IL",
					"IN",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MY",
					"NL",
					"NZ",
					"OM",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0Sa533Cv9nnbHGI729sO9x" },
				href: "https://api.spotify.com/v1/albums/0Sa533Cv9nnbHGI729sO9x",
				id: "0Sa533Cv9nnbHGI729sO9x",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736376856312daf5109561e9a4", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026376856312daf5109561e9a4", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516376856312daf5109561e9a4", width: 64 }
				],
				name: "I Need You (feat. Olaf Blackwood)",
				release_date: "2017-01-06",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0Sa533Cv9nnbHGI729sO9x"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
					href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
					id: "0SfsnGyD8FpIN4U4WCkBZ5",
					name: "Armin van Buuren",
					type: "artist",
					uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5aP2E8K4LY86fUERVzZlnX" },
					href: "https://api.spotify.com/v1/artists/5aP2E8K4LY86fUERVzZlnX",
					id: "5aP2E8K4LY86fUERVzZlnX",
					name: "Garibay",
					type: "artist",
					uri: "spotify:artist:5aP2E8K4LY86fUERVzZlnX"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7Fb4bPwUT0mrtDXt2qmJEp" },
					href: "https://api.spotify.com/v1/artists/7Fb4bPwUT0mrtDXt2qmJEp",
					id: "7Fb4bPwUT0mrtDXt2qmJEp",
					name: "Olaf Blackwood",
					type: "artist",
					uri: "spotify:artist:7Fb4bPwUT0mrtDXt2qmJEp"
				}
			],
			available_markets: [
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"CH",
				"CL",
				"CO",
				"CY",
				"CZ",
				"DE",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"FR",
				"GR",
				"HK",
				"HU",
				"ID",
				"IL",
				"IN",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MY",
				"NL",
				"NZ",
				"OM",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 206750,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLF711700198" },
			external_urls: { spotify: "https://open.spotify.com/track/4cCpGAUlYDh88uuU7pcdN8" },
			href: "https://api.spotify.com/v1/tracks/4cCpGAUlYDh88uuU7pcdN8",
			id: "4cCpGAUlYDh88uuU7pcdN8",
			is_local: false,
			name: "I Need You (feat. Olaf Blackwood)",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/1ee4edd1d2a8a0650e1b0f7da8cc83dcaf02b273?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4cCpGAUlYDh88uuU7pcdN8"
		},
		features: {
			danceability: 0.6,
			energy: 0.863,
			key: 8,
			loudness: -5.754,
			mode: 0,
			speechiness: 0.031,
			acousticness: 0.00168,
			instrumentalness: 0.00406,
			liveness: 0.0939,
			valence: 0.223,
			tempo: 107,
			type: "audio_features",
			id: "4cCpGAUlYDh88uuU7pcdN8",
			uri: "spotify:track:4cCpGAUlYDh88uuU7pcdN8",
			track_href: "https://api.spotify.com/v1/tracks/4cCpGAUlYDh88uuU7pcdN8",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4cCpGAUlYDh88uuU7pcdN8",
			duration_ms: 206750,
			time_signature: 4,
			doubletime: 107
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/63MQldklfxkjYDoUE4Tppz" },
						href: "https://api.spotify.com/v1/artists/63MQldklfxkjYDoUE4Tppz",
						id: "63MQldklfxkjYDoUE4Tppz",
						name: "M83",
						type: "artist",
						uri: "spotify:artist:63MQldklfxkjYDoUE4Tppz"
					}
				],
				available_markets: ["CA", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/6R0ynY7RF20ofs9GJR5TXR" },
				href: "https://api.spotify.com/v1/albums/6R0ynY7RF20ofs9GJR5TXR",
				id: "6R0ynY7RF20ofs9GJR5TXR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27389c5c957f376e8c87ed23dcc", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0289c5c957f376e8c87ed23dcc", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485189c5c957f376e8c87ed23dcc", width: 64 }
				],
				name: "Hurry Up, We're Dreaming",
				release_date: "2011",
				release_date_precision: "year",
				total_tracks: 22,
				type: "album",
				uri: "spotify:album:6R0ynY7RF20ofs9GJR5TXR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/63MQldklfxkjYDoUE4Tppz" },
					href: "https://api.spotify.com/v1/artists/63MQldklfxkjYDoUE4Tppz",
					id: "63MQldklfxkjYDoUE4Tppz",
					name: "M83",
					type: "artist",
					uri: "spotify:artist:63MQldklfxkjYDoUE4Tppz"
				}
			],
			available_markets: ["CA", "US"],
			disc_number: 1,
			duration_ms: 241440,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GB55H1100002" },
			external_urls: { spotify: "https://open.spotify.com/track/1eyzqe2QqGZUmfcPZtrIyt" },
			href: "https://api.spotify.com/v1/tracks/1eyzqe2QqGZUmfcPZtrIyt",
			id: "1eyzqe2QqGZUmfcPZtrIyt",
			is_local: false,
			name: "Midnight City",
			popularity: 70,
			preview_url: "https://p.scdn.co/mp3-preview/2620971cb1ef9fda9aa2d3a5ce3a74dc9be73dd2?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:1eyzqe2QqGZUmfcPZtrIyt"
		},
		features: {
			danceability: 0.526,
			energy: 0.712,
			key: 11,
			loudness: -6.525,
			mode: 0,
			speechiness: 0.0356,
			acousticness: 0.0161,
			instrumentalness: 0,
			liveness: 0.179,
			valence: 0.32,
			tempo: 105,
			type: "audio_features",
			id: "1eyzqe2QqGZUmfcPZtrIyt",
			uri: "spotify:track:1eyzqe2QqGZUmfcPZtrIyt",
			track_href: "https://api.spotify.com/v1/tracks/1eyzqe2QqGZUmfcPZtrIyt",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1eyzqe2QqGZUmfcPZtrIyt",
			duration_ms: 241440,
			time_signature: 4,
			doubletime: 105
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5aj3LEYRbuaabjjHkj5oE1" },
						href: "https://api.spotify.com/v1/artists/5aj3LEYRbuaabjjHkj5oE1",
						id: "5aj3LEYRbuaabjjHkj5oE1",
						name: "Death In Vegas",
						type: "artist",
						uri: "spotify:artist:5aj3LEYRbuaabjjHkj5oE1"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/0IJZSZO0juHc2ZlntHT5kR" },
				href: "https://api.spotify.com/v1/albums/0IJZSZO0juHc2ZlntHT5kR",
				id: "0IJZSZO0juHc2ZlntHT5kR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2735fbcb3fb364d50aa046ef33d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e025fbcb3fb364d50aa046ef33d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048515fbcb3fb364d50aa046ef33d", width: 64 }
				],
				name: "Your Loft My Acid",
				release_date: "2011-09-18",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:0IJZSZO0juHc2ZlntHT5kR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5aj3LEYRbuaabjjHkj5oE1" },
					href: "https://api.spotify.com/v1/artists/5aj3LEYRbuaabjjHkj5oE1",
					id: "5aj3LEYRbuaabjjHkj5oE1",
					name: "Death In Vegas",
					type: "artist",
					uri: "spotify:artist:5aj3LEYRbuaabjjHkj5oE1"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 305906,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBW8F1100026" },
			external_urls: { spotify: "https://open.spotify.com/track/7zLBBqsDyDNCaduwM3KF29" },
			href: "https://api.spotify.com/v1/tracks/7zLBBqsDyDNCaduwM3KF29",
			id: "7zLBBqsDyDNCaduwM3KF29",
			is_local: false,
			name: "Your Loft My Acid - Fearless Transhouse Mix Long",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:7zLBBqsDyDNCaduwM3KF29"
		},
		features: {
			danceability: 0.621,
			energy: 0.572,
			key: 7,
			loudness: -9.527,
			mode: 1,
			speechiness: 0.031,
			acousticness: 0.000668,
			instrumentalness: 0.577,
			liveness: 0.0909,
			valence: 0.199,
			tempo: 108,
			type: "audio_features",
			id: "7zLBBqsDyDNCaduwM3KF29",
			uri: "spotify:track:7zLBBqsDyDNCaduwM3KF29",
			track_href: "https://api.spotify.com/v1/tracks/7zLBBqsDyDNCaduwM3KF29",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7zLBBqsDyDNCaduwM3KF29",
			duration_ms: 305907,
			time_signature: 4,
			doubletime: 108
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7gRhy3MIPHQo5CXYfWaw9I" },
						href: "https://api.spotify.com/v1/artists/7gRhy3MIPHQo5CXYfWaw9I",
						id: "7gRhy3MIPHQo5CXYfWaw9I",
						name: "Azealia Banks",
						type: "artist",
						uri: "spotify:artist:7gRhy3MIPHQo5CXYfWaw9I"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/1ASKleFVsIsCZhUiTKgwPd" },
				href: "https://api.spotify.com/v1/albums/1ASKleFVsIsCZhUiTKgwPd",
				id: "1ASKleFVsIsCZhUiTKgwPd",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273d39999491972b2d973fd78f8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02d39999491972b2d973fd78f8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851d39999491972b2d973fd78f8", width: 64 }
				],
				name: "212 (feat. Lazy Jay) - Single",
				release_date: "2011-12-06",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1ASKleFVsIsCZhUiTKgwPd"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7gRhy3MIPHQo5CXYfWaw9I" },
					href: "https://api.spotify.com/v1/artists/7gRhy3MIPHQo5CXYfWaw9I",
					id: "7gRhy3MIPHQo5CXYfWaw9I",
					name: "Azealia Banks",
					type: "artist",
					uri: "spotify:artist:7gRhy3MIPHQo5CXYfWaw9I"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 205714,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USJ5T1100201" },
			external_urls: { spotify: "https://open.spotify.com/track/73j78RoOPZRLSxSHgn8eiS" },
			href: "https://api.spotify.com/v1/tracks/73j78RoOPZRLSxSHgn8eiS",
			id: "73j78RoOPZRLSxSHgn8eiS",
			is_local: false,
			name: "212 (feat. Lazy Jay)",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:73j78RoOPZRLSxSHgn8eiS"
		},
		features: {
			danceability: 0.855,
			energy: 0.781,
			key: 11,
			loudness: -7.491,
			mode: 0,
			speechiness: 0.274,
			acousticness: 0.0828,
			instrumentalness: 0,
			liveness: 0.0789,
			valence: 0.649,
			tempo: 126,
			type: "audio_features",
			id: "73j78RoOPZRLSxSHgn8eiS",
			uri: "spotify:track:73j78RoOPZRLSxSHgn8eiS",
			track_href: "https://api.spotify.com/v1/tracks/73j78RoOPZRLSxSHgn8eiS",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/73j78RoOPZRLSxSHgn8eiS",
			duration_ms: 205714,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5jQWZiaRwd5OXJ08MdyJ5D" },
						href: "https://api.spotify.com/v1/artists/5jQWZiaRwd5OXJ08MdyJ5D",
						id: "5jQWZiaRwd5OXJ08MdyJ5D",
						name: "Niteppl",
						type: "artist",
						uri: "spotify:artist:5jQWZiaRwd5OXJ08MdyJ5D"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7I9AsIFLg2i6XQOwXCfcIY" },
				href: "https://api.spotify.com/v1/albums/7I9AsIFLg2i6XQOwXCfcIY",
				id: "7I9AsIFLg2i6XQOwXCfcIY",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273552039eca5202c72cc0583ca", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02552039eca5202c72cc0583ca", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851552039eca5202c72cc0583ca", width: 64 }
				],
				name: "Warrior",
				release_date: "2014-06-18",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:7I9AsIFLg2i6XQOwXCfcIY"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5jQWZiaRwd5OXJ08MdyJ5D" },
					href: "https://api.spotify.com/v1/artists/5jQWZiaRwd5OXJ08MdyJ5D",
					id: "5jQWZiaRwd5OXJ08MdyJ5D",
					name: "Niteppl",
					type: "artist",
					uri: "spotify:artist:5jQWZiaRwd5OXJ08MdyJ5D"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 209905,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USMLM1306201" },
			external_urls: { spotify: "https://open.spotify.com/track/5UObrIUAd9t8fYFxhN7W1g" },
			href: "https://api.spotify.com/v1/tracks/5UObrIUAd9t8fYFxhN7W1g",
			id: "5UObrIUAd9t8fYFxhN7W1g",
			is_local: false,
			name: "Schatner - Original Mix",
			popularity: 22,
			preview_url: "https://p.scdn.co/mp3-preview/224ecf2b479095a712925ec13f2e060d3d7d0336?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5UObrIUAd9t8fYFxhN7W1g"
		},
		features: {
			danceability: 0.724,
			energy: 0.638,
			key: 9,
			loudness: -8.636,
			mode: 1,
			speechiness: 0.0599,
			acousticness: 0.000836,
			instrumentalness: 0.684,
			liveness: 0.382,
			valence: 0.188,
			tempo: 117,
			type: "audio_features",
			id: "5UObrIUAd9t8fYFxhN7W1g",
			uri: "spotify:track:5UObrIUAd9t8fYFxhN7W1g",
			track_href: "https://api.spotify.com/v1/tracks/5UObrIUAd9t8fYFxhN7W1g",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5UObrIUAd9t8fYFxhN7W1g",
			duration_ms: 209906,
			time_signature: 4,
			doubletime: 117
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0ycHhPwPvoaO4VGzmMnXGq" },
						href: "https://api.spotify.com/v1/artists/0ycHhPwPvoaO4VGzmMnXGq",
						id: "0ycHhPwPvoaO4VGzmMnXGq",
						name: "Zomboy",
						type: "artist",
						uri: "spotify:artist:0ycHhPwPvoaO4VGzmMnXGq"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/6y2Qz6bFmJRz6CdN0qlvGT" },
				href: "https://api.spotify.com/v1/albums/6y2Qz6bFmJRz6CdN0qlvGT",
				id: "6y2Qz6bFmJRz6CdN0qlvGT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273953041f26908673d7dd14a67", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02953041f26908673d7dd14a67", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851953041f26908673d7dd14a67", width: 64 }
				],
				name: "Neon Grave Remixed",
				release_date: "2017-02-06",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:6y2Qz6bFmJRz6CdN0qlvGT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4dvZ0abeUaiHm7Fu9Gj0PQ" },
					href: "https://api.spotify.com/v1/artists/4dvZ0abeUaiHm7Fu9Gj0PQ",
					id: "4dvZ0abeUaiHm7Fu9Gj0PQ",
					name: "Eptic",
					type: "artist",
					uri: "spotify:artist:4dvZ0abeUaiHm7Fu9Gj0PQ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0ycHhPwPvoaO4VGzmMnXGq" },
					href: "https://api.spotify.com/v1/artists/0ycHhPwPvoaO4VGzmMnXGq",
					id: "0ycHhPwPvoaO4VGzmMnXGq",
					name: "Zomboy",
					type: "artist",
					uri: "spotify:artist:0ycHhPwPvoaO4VGzmMnXGq"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/31DUXycJt0YIBoMXLI5UdV" },
					href: "https://api.spotify.com/v1/artists/31DUXycJt0YIBoMXLI5UdV",
					id: "31DUXycJt0YIBoMXLI5UdV",
					name: "Trampa",
					type: "artist",
					uri: "spotify:artist:31DUXycJt0YIBoMXLI5UdV"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 246400,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GB7YL1709903" },
			external_urls: { spotify: "https://open.spotify.com/track/5a3IzNu8AuVUh9fUppivyf" },
			href: "https://api.spotify.com/v1/tracks/5a3IzNu8AuVUh9fUppivyf",
			id: "5a3IzNu8AuVUh9fUppivyf",
			is_local: false,
			name: "Get With The Program Ft. O.V - Eptic & Trampa Remix",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:5a3IzNu8AuVUh9fUppivyf"
		},
		features: {
			danceability: 0.637,
			energy: 0.988,
			key: 11,
			loudness: -3.583,
			mode: 0,
			speechiness: 0.293,
			acousticness: 0.291,
			instrumentalness: 0.000965,
			liveness: 0.417,
			valence: 0.642,
			tempo: 150,
			type: "audio_features",
			id: "5a3IzNu8AuVUh9fUppivyf",
			uri: "spotify:track:5a3IzNu8AuVUh9fUppivyf",
			track_href: "https://api.spotify.com/v1/tracks/5a3IzNu8AuVUh9fUppivyf",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5a3IzNu8AuVUh9fUppivyf",
			duration_ms: 246400,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5FKchcZpQOkqFvXBj1aCvb" },
						href: "https://api.spotify.com/v1/artists/5FKchcZpQOkqFvXBj1aCvb",
						id: "5FKchcZpQOkqFvXBj1aCvb",
						name: "Excision",
						type: "artist",
						uri: "spotify:artist:5FKchcZpQOkqFvXBj1aCvb"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/2A0DOAT4uk5Ijrg3a45oR2" },
				href: "https://api.spotify.com/v1/albums/2A0DOAT4uk5Ijrg3a45oR2",
				id: "2A0DOAT4uk5Ijrg3a45oR2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2734cfbde571c0660d60fbf48ac", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e024cfbde571c0660d60fbf48ac", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048514cfbde571c0660d60fbf48ac", width: 64 }
				],
				name: "X Rated: The Remixes",
				release_date: "2012-09-03",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:2A0DOAT4uk5Ijrg3a45oR2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5FKchcZpQOkqFvXBj1aCvb" },
					href: "https://api.spotify.com/v1/artists/5FKchcZpQOkqFvXBj1aCvb",
					id: "5FKchcZpQOkqFvXBj1aCvb",
					name: "Excision",
					type: "artist",
					uri: "spotify:artist:5FKchcZpQOkqFvXBj1aCvb"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/48q2mPVwlKnlSaCx07i6Ta" },
					href: "https://api.spotify.com/v1/artists/48q2mPVwlKnlSaCx07i6Ta",
					id: "48q2mPVwlKnlSaCx07i6Ta",
					name: "Datsik",
					type: "artist",
					uri: "spotify:artist:48q2mPVwlKnlSaCx07i6Ta"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4zymhxzJ0UJc74tMHGyoWs" },
					href: "https://api.spotify.com/v1/artists/4zymhxzJ0UJc74tMHGyoWs",
					id: "4zymhxzJ0UJc74tMHGyoWs",
					name: "Dirtyphonics",
					type: "artist",
					uri: "spotify:artist:4zymhxzJ0UJc74tMHGyoWs"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 303865,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1200478" },
			external_urls: { spotify: "https://open.spotify.com/track/1LOrpJNa67WpBaBruo7Wja" },
			href: "https://api.spotify.com/v1/tracks/1LOrpJNa67WpBaBruo7Wja",
			id: "1LOrpJNa67WpBaBruo7Wja",
			is_local: false,
			name: "Deviance - Dirtyphonics Remix",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1LOrpJNa67WpBaBruo7Wja"
		},
		features: {
			danceability: 0.255,
			energy: 0.853,
			key: 2,
			loudness: -5.166,
			mode: 1,
			speechiness: 0.186,
			acousticness: 0.0000129,
			instrumentalness: 0.608,
			liveness: 0.197,
			valence: 0.162,
			tempo: 175,
			type: "audio_features",
			id: "1LOrpJNa67WpBaBruo7Wja",
			uri: "spotify:track:1LOrpJNa67WpBaBruo7Wja",
			track_href: "https://api.spotify.com/v1/tracks/1LOrpJNa67WpBaBruo7Wja",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1LOrpJNa67WpBaBruo7Wja",
			duration_ms: 303866,
			time_signature: 4,
			doubletime: 175
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2hL1EouqXLtBEB6JKnPF0h" },
						href: "https://api.spotify.com/v1/artists/2hL1EouqXLtBEB6JKnPF0h",
						id: "2hL1EouqXLtBEB6JKnPF0h",
						name: "Aly & Fila",
						type: "artist",
						uri: "spotify:artist:2hL1EouqXLtBEB6JKnPF0h"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1dGjozJcvmStpBR5J9nbiy" },
				href: "https://api.spotify.com/v1/albums/1dGjozJcvmStpBR5J9nbiy",
				id: "1dGjozJcvmStpBR5J9nbiy",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e8ab4d9c2c0f3ce170248618", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e8ab4d9c2c0f3ce170248618", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e8ab4d9c2c0f3ce170248618", width: 64 }
				],
				name: "Future Sound Of Egypt Episode 532",
				release_date: "2018-01-25",
				release_date_precision: "day",
				total_tracks: 28,
				type: "album",
				uri: "spotify:album:1dGjozJcvmStpBR5J9nbiy"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6NRvpo2ClOjfv7tdyWTAfp" },
					href: "https://api.spotify.com/v1/artists/6NRvpo2ClOjfv7tdyWTAfp",
					id: "6NRvpo2ClOjfv7tdyWTAfp",
					name: "Max Fragrant",
					type: "artist",
					uri: "spotify:artist:6NRvpo2ClOjfv7tdyWTAfp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3m91RDu6WNtDGSHblWjZ7w" },
					href: "https://api.spotify.com/v1/artists/3m91RDu6WNtDGSHblWjZ7w",
					id: "3m91RDu6WNtDGSHblWjZ7w",
					name: "Slow Fish",
					type: "artist",
					uri: "spotify:artist:3m91RDu6WNtDGSHblWjZ7w"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 205000,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLM1S1800033" },
			external_urls: { spotify: "https://open.spotify.com/track/0HdOOYU13Za9jbyoqFezxs" },
			href: "https://api.spotify.com/v1/tracks/0HdOOYU13Za9jbyoqFezxs",
			id: "0HdOOYU13Za9jbyoqFezxs",
			is_local: false,
			name: "Sweet Lies (FSOE 532)",
			popularity: 2,
			preview_url: "https://p.scdn.co/mp3-preview/f38a403f5c015aeb5e778aa3a9c21650ef92ff69?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:0HdOOYU13Za9jbyoqFezxs"
		},
		features: {
			danceability: 0.612,
			energy: 0.898,
			key: 2,
			loudness: -8.971,
			mode: 1,
			speechiness: 0.0491,
			acousticness: 0.0191,
			instrumentalness: 0.646,
			liveness: 0.162,
			valence: 0.0372,
			tempo: 122,
			type: "audio_features",
			id: "0HdOOYU13Za9jbyoqFezxs",
			uri: "spotify:track:0HdOOYU13Za9jbyoqFezxs",
			track_href: "https://api.spotify.com/v1/tracks/0HdOOYU13Za9jbyoqFezxs",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0HdOOYU13Za9jbyoqFezxs",
			duration_ms: 205000,
			time_signature: 4,
			doubletime: 122
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2hL1EouqXLtBEB6JKnPF0h" },
						href: "https://api.spotify.com/v1/artists/2hL1EouqXLtBEB6JKnPF0h",
						id: "2hL1EouqXLtBEB6JKnPF0h",
						name: "Aly & Fila",
						type: "artist",
						uri: "spotify:artist:2hL1EouqXLtBEB6JKnPF0h"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7HWZDqLdT72qEKhiQrOCu1" },
				href: "https://api.spotify.com/v1/albums/7HWZDqLdT72qEKhiQrOCu1",
				id: "7HWZDqLdT72qEKhiQrOCu1",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27390b350e598efa40cc9669a43", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0290b350e598efa40cc9669a43", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485190b350e598efa40cc9669a43", width: 64 }
				],
				name: "Armada Collected: Aly & Fila",
				release_date: "2016-07-15",
				release_date_precision: "day",
				total_tracks: 40,
				type: "album",
				uri: "spotify:album:7HWZDqLdT72qEKhiQrOCu1"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2hL1EouqXLtBEB6JKnPF0h" },
					href: "https://api.spotify.com/v1/artists/2hL1EouqXLtBEB6JKnPF0h",
					id: "2hL1EouqXLtBEB6JKnPF0h",
					name: "Aly & Fila",
					type: "artist",
					uri: "spotify:artist:2hL1EouqXLtBEB6JKnPF0h"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5Ft69LRmkksL2qyqsQ9XXp" },
					href: "https://api.spotify.com/v1/artists/5Ft69LRmkksL2qyqsQ9XXp",
					id: "5Ft69LRmkksL2qyqsQ9XXp",
					name: "Jwaydan",
					type: "artist",
					uri: "spotify:artist:5Ft69LRmkksL2qyqsQ9XXp"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 226673,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLF711100757" },
			external_urls: { spotify: "https://open.spotify.com/track/7LpshpG8snNJYdD7TnHS0I" },
			href: "https://api.spotify.com/v1/tracks/7LpshpG8snNJYdD7TnHS0I",
			id: "7LpshpG8snNJYdD7TnHS0I",
			is_local: false,
			name: "We Control The Sunlight",
			popularity: 47,
			preview_url: "https://p.scdn.co/mp3-preview/c0f3fb8124cc7bb6452142e2280a503d10cc5fed?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:7LpshpG8snNJYdD7TnHS0I"
		},
		features: {
			danceability: 0.408,
			energy: 0.921,
			key: 1,
			loudness: -6.509,
			mode: 0,
			speechiness: 0.208,
			acousticness: 0.0248,
			instrumentalness: 0.0281,
			liveness: 0.384,
			valence: 0.039,
			tempo: 140,
			type: "audio_features",
			id: "7LpshpG8snNJYdD7TnHS0I",
			uri: "spotify:track:7LpshpG8snNJYdD7TnHS0I",
			track_href: "https://api.spotify.com/v1/tracks/7LpshpG8snNJYdD7TnHS0I",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7LpshpG8snNJYdD7TnHS0I",
			duration_ms: 226673,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4RVnAU35WRWra6OZ3CbbMA" },
						href: "https://api.spotify.com/v1/artists/4RVnAU35WRWra6OZ3CbbMA",
						id: "4RVnAU35WRWra6OZ3CbbMA",
						name: "Kylie Minogue",
						type: "artist",
						uri: "spotify:artist:4RVnAU35WRWra6OZ3CbbMA"
					}
				],
				available_markets: ["US"],
				external_urls: { spotify: "https://open.spotify.com/album/2QDWFfsBr3EngvBwPtxoIY" },
				href: "https://api.spotify.com/v1/albums/2QDWFfsBr3EngvBwPtxoIY",
				id: "2QDWFfsBr3EngvBwPtxoIY",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736531dcfcbc99b82be7eec9f0", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026531dcfcbc99b82be7eec9f0", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516531dcfcbc99b82be7eec9f0", width: 64 }
				],
				name: "Fever (Deluxe Edition)",
				release_date: "2002-02-08",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:2QDWFfsBr3EngvBwPtxoIY"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4RVnAU35WRWra6OZ3CbbMA" },
					href: "https://api.spotify.com/v1/artists/4RVnAU35WRWra6OZ3CbbMA",
					id: "4RVnAU35WRWra6OZ3CbbMA",
					name: "Kylie Minogue",
					type: "artist",
					uri: "spotify:artist:4RVnAU35WRWra6OZ3CbbMA"
				}
			],
			available_markets: ["US"],
			disc_number: 1,
			duration_ms: 230640,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBAYE0100913" },
			external_urls: { spotify: "https://open.spotify.com/track/7MoKXLQeI0Bh2QodCjDO4K" },
			href: "https://api.spotify.com/v1/tracks/7MoKXLQeI0Bh2QodCjDO4K",
			id: "7MoKXLQeI0Bh2QodCjDO4K",
			is_local: false,
			name: "Can't Get You out of My Head",
			popularity: 50,
			preview_url: "https://p.scdn.co/mp3-preview/8698fb43a16503ad290e738649a19d1663b9cbc6?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:7MoKXLQeI0Bh2QodCjDO4K"
		},
		features: {
			danceability: 0.766,
			energy: 0.563,
			key: 9,
			loudness: -7.516,
			mode: 0,
			speechiness: 0.0339,
			acousticness: 0.0263,
			instrumentalness: 0.683,
			liveness: 0.115,
			valence: 0.964,
			tempo: 126,
			type: "audio_features",
			id: "7MoKXLQeI0Bh2QodCjDO4K",
			uri: "spotify:track:7MoKXLQeI0Bh2QodCjDO4K",
			track_href: "https://api.spotify.com/v1/tracks/7MoKXLQeI0Bh2QodCjDO4K",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7MoKXLQeI0Bh2QodCjDO4K",
			duration_ms: 230640,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5CdJjUi9f0cVgo9nFuJrFa" },
						href: "https://api.spotify.com/v1/artists/5CdJjUi9f0cVgo9nFuJrFa",
						id: "5CdJjUi9f0cVgo9nFuJrFa",
						name: "Adventure Club",
						type: "artist",
						uri: "spotify:artist:5CdJjUi9f0cVgo9nFuJrFa"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/45hTiiH7JpJx1P5TN6iDDG" },
				href: "https://api.spotify.com/v1/albums/45hTiiH7JpJx1P5TN6iDDG",
				id: "45hTiiH7JpJx1P5TN6iDDG",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2735070b25872d0db10607a61cd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e025070b25872d0db10607a61cd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048515070b25872d0db10607a61cd", width: 64 }
				],
				name: "Red // Blue",
				release_date: "2016-12-02",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:45hTiiH7JpJx1P5TN6iDDG"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5CdJjUi9f0cVgo9nFuJrFa" },
					href: "https://api.spotify.com/v1/artists/5CdJjUi9f0cVgo9nFuJrFa",
					id: "5CdJjUi9f0cVgo9nFuJrFa",
					name: "Adventure Club",
					type: "artist",
					uri: "spotify:artist:5CdJjUi9f0cVgo9nFuJrFa"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 187115,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QMRSZ1600895" },
			external_urls: { spotify: "https://open.spotify.com/track/5dYYc0OcjXLvthcJ6Chhuv" },
			href: "https://api.spotify.com/v1/tracks/5dYYc0OcjXLvthcJ6Chhuv",
			id: "5dYYc0OcjXLvthcJ6Chhuv",
			is_local: false,
			name: "Without You",
			popularity: 33,
			preview_url: "https://p.scdn.co/mp3-preview/3cda864f89dc2fcb9aad0af14f4750c5cda00d2f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5dYYc0OcjXLvthcJ6Chhuv"
		},
		features: {
			danceability: 0.628,
			energy: 0.809,
			key: 4,
			loudness: -2.806,
			mode: 0,
			speechiness: 0.0383,
			acousticness: 0.065,
			instrumentalness: 0.0000428,
			liveness: 0.124,
			valence: 0.378,
			tempo: 145,
			type: "audio_features",
			id: "5dYYc0OcjXLvthcJ6Chhuv",
			uri: "spotify:track:5dYYc0OcjXLvthcJ6Chhuv",
			track_href: "https://api.spotify.com/v1/tracks/5dYYc0OcjXLvthcJ6Chhuv",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5dYYc0OcjXLvthcJ6Chhuv",
			duration_ms: 187115,
			time_signature: 4,
			doubletime: 145
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
						href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
						id: "24neLwyYRyj4ItaGnFeIT0",
						name: "JOYRYDE",
						type: "artist",
						uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4mIPs9KZN79m1Gjx97rs3E" },
				href: "https://api.spotify.com/v1/albums/4mIPs9KZN79m1Gjx97rs3E",
				id: "4mIPs9KZN79m1Gjx97rs3E",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273433690cfb9bff4b97e2ce7fa", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02433690cfb9bff4b97e2ce7fa", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851433690cfb9bff4b97e2ce7fa", width: 64 }
				],
				name: "HOT DRUM",
				release_date: "2016-11-16",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4mIPs9KZN79m1Gjx97rs3E"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
					href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
					id: "24neLwyYRyj4ItaGnFeIT0",
					name: "JOYRYDE",
					type: "artist",
					uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 266879,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21603258" },
			external_urls: { spotify: "https://open.spotify.com/track/0gcPFlSLjkVqz84RcDhyJk" },
			href: "https://api.spotify.com/v1/tracks/0gcPFlSLjkVqz84RcDhyJk",
			id: "0gcPFlSLjkVqz84RcDhyJk",
			is_local: false,
			name: "HOT DRUM",
			popularity: 49,
			preview_url: "https://p.scdn.co/mp3-preview/ea2f872c31ac53869d7be3958bc426e4a270dd57?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0gcPFlSLjkVqz84RcDhyJk"
		},
		features: {
			danceability: 0.625,
			energy: 0.981,
			key: 7,
			loudness: -3.799,
			mode: 1,
			speechiness: 0.0597,
			acousticness: 0.0009,
			instrumentalness: 0.329,
			liveness: 0.357,
			valence: 0.156,
			tempo: 125,
			type: "audio_features",
			id: "0gcPFlSLjkVqz84RcDhyJk",
			uri: "spotify:track:0gcPFlSLjkVqz84RcDhyJk",
			track_href: "https://api.spotify.com/v1/tracks/0gcPFlSLjkVqz84RcDhyJk",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0gcPFlSLjkVqz84RcDhyJk",
			duration_ms: 266880,
			time_signature: 4,
			doubletime: 125
		}
	},
	{
		track: {
			album: {
				album_type: "compilation",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0S1PNLnoLH1CdncU5H724W" },
				href: "https://api.spotify.com/v1/albums/0S1PNLnoLH1CdncU5H724W",
				id: "0S1PNLnoLH1CdncU5H724W",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27331cf84b55b54efea6d18153d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0231cf84b55b54efea6d18153d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485131cf84b55b54efea6d18153d", width: 64 }
				],
				name: "wave 002",
				release_date: "2016-10-18",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:0S1PNLnoLH1CdncU5H724W"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4CRAZ1v62qreoYTNrbP5Yj" },
					href: "https://api.spotify.com/v1/artists/4CRAZ1v62qreoYTNrbP5Yj",
					id: "4CRAZ1v62qreoYTNrbP5Yj",
					name: "Trashlord",
					type: "artist",
					uri: "spotify:artist:4CRAZ1v62qreoYTNrbP5Yj"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2heDXXeSmrfHsjBATaCUXC" },
					href: "https://api.spotify.com/v1/artists/2heDXXeSmrfHsjBATaCUXC",
					id: "2heDXXeSmrfHsjBATaCUXC",
					name: "Madi Larson",
					type: "artist",
					uri: "spotify:artist:2heDXXeSmrfHsjBATaCUXC"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 217573,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GB-SMU-28-95297" },
			external_urls: { spotify: "https://open.spotify.com/track/7wTPOhjjOt02hjVUOaOD11" },
			href: "https://api.spotify.com/v1/tracks/7wTPOhjjOt02hjVUOaOD11",
			id: "7wTPOhjjOt02hjVUOaOD11",
			is_local: false,
			name: "Castle (feat. Madi Larson)",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/79f4f3aa9d4d44583f5cedfcdf3ad9cf08ab143f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:7wTPOhjjOt02hjVUOaOD11"
		},
		features: {
			danceability: 0.548,
			energy: 0.587,
			key: 1,
			loudness: -6.923,
			mode: 1,
			speechiness: 0.0328,
			acousticness: 0.0828,
			instrumentalness: 0.858,
			liveness: 0.105,
			valence: 0.0811,
			tempo: 150,
			type: "audio_features",
			id: "7wTPOhjjOt02hjVUOaOD11",
			uri: "spotify:track:7wTPOhjjOt02hjVUOaOD11",
			track_href: "https://api.spotify.com/v1/tracks/7wTPOhjjOt02hjVUOaOD11",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7wTPOhjjOt02hjVUOaOD11",
			duration_ms: 217574,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7q7puZ5wtpfQe3doDb4834" },
						href: "https://api.spotify.com/v1/artists/7q7puZ5wtpfQe3doDb4834",
						id: "7q7puZ5wtpfQe3doDb4834",
						name: "Culprate",
						type: "artist",
						uri: "spotify:artist:7q7puZ5wtpfQe3doDb4834"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/16PuI4guCivEH4KoyOVfvT" },
				href: "https://api.spotify.com/v1/albums/16PuI4guCivEH4KoyOVfvT",
				id: "16PuI4guCivEH4KoyOVfvT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c98bc9101cc04ffa980ae7ec", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c98bc9101cc04ffa980ae7ec", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c98bc9101cc04ffa980ae7ec", width: 64 }
				],
				name: "Unity Project, Pt. 2",
				release_date: "2017-09-22",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:16PuI4guCivEH4KoyOVfvT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7q7puZ5wtpfQe3doDb4834" },
					href: "https://api.spotify.com/v1/artists/7q7puZ5wtpfQe3doDb4834",
					id: "7q7puZ5wtpfQe3doDb4834",
					name: "Culprate",
					type: "artist",
					uri: "spotify:artist:7q7puZ5wtpfQe3doDb4834"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/40WIa01eubnEVkxUHeDZyF" },
					href: "https://api.spotify.com/v1/artists/40WIa01eubnEVkxUHeDZyF",
					id: "40WIa01eubnEVkxUHeDZyF",
					name: "Au5",
					type: "artist",
					uri: "spotify:artist:40WIa01eubnEVkxUHeDZyF"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 349050,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBKPL1788879" },
			external_urls: { spotify: "https://open.spotify.com/track/5iod3lCNQz7LZopI4fTFwm" },
			href: "https://api.spotify.com/v1/tracks/5iod3lCNQz7LZopI4fTFwm",
			id: "5iod3lCNQz7LZopI4fTFwm",
			is_local: false,
			name: "Impulse",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/7e36d0d2ff665b5de779dbeafbdc9987396e589c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:5iod3lCNQz7LZopI4fTFwm"
		},
		features: {
			danceability: 0.339,
			energy: 0.85,
			key: 6,
			loudness: -4.893,
			mode: 1,
			speechiness: 0.0722,
			acousticness: 0.115,
			instrumentalness: 0.844,
			liveness: 0.132,
			valence: 0.152,
			tempo: 170,
			type: "audio_features",
			id: "5iod3lCNQz7LZopI4fTFwm",
			uri: "spotify:track:5iod3lCNQz7LZopI4fTFwm",
			track_href: "https://api.spotify.com/v1/tracks/5iod3lCNQz7LZopI4fTFwm",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5iod3lCNQz7LZopI4fTFwm",
			duration_ms: 349051,
			time_signature: 4,
			doubletime: 170
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3OKg7YbOIatODzkRIbLJR4" },
						href: "https://api.spotify.com/v1/artists/3OKg7YbOIatODzkRIbLJR4",
						id: "3OKg7YbOIatODzkRIbLJR4",
						name: "TheFatRat",
						type: "artist",
						uri: "spotify:artist:3OKg7YbOIatODzkRIbLJR4"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/11pzBCbfnA2iCtvcS9TBSx" },
				href: "https://api.spotify.com/v1/albums/11pzBCbfnA2iCtvcS9TBSx",
				id: "11pzBCbfnA2iCtvcS9TBSx",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273729674862074dd809e633da5", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02729674862074dd809e633da5", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851729674862074dd809e633da5", width: 64 }
				],
				name: "The Calling",
				release_date: "2016-03-31",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:11pzBCbfnA2iCtvcS9TBSx"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3OKg7YbOIatODzkRIbLJR4" },
					href: "https://api.spotify.com/v1/artists/3OKg7YbOIatODzkRIbLJR4",
					id: "3OKg7YbOIatODzkRIbLJR4",
					name: "TheFatRat",
					type: "artist",
					uri: "spotify:artist:3OKg7YbOIatODzkRIbLJR4"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7ddnIV2r4SLjuwyGlgLIWt" },
					href: "https://api.spotify.com/v1/artists/7ddnIV2r4SLjuwyGlgLIWt",
					id: "7ddnIV2r4SLjuwyGlgLIWt",
					name: "Laura Brehm",
					type: "artist",
					uri: "spotify:artist:7ddnIV2r4SLjuwyGlgLIWt"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 233590,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QM4DW1615998" },
			external_urls: { spotify: "https://open.spotify.com/track/2k1bFfcPIRTMeCGO48F0OE" },
			href: "https://api.spotify.com/v1/tracks/2k1bFfcPIRTMeCGO48F0OE",
			id: "2k1bFfcPIRTMeCGO48F0OE",
			is_local: false,
			name: "The Calling",
			popularity: 59,
			preview_url: "https://p.scdn.co/mp3-preview/ccee7fc5abf43692faa6ad0650371b6b719a9ea6?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2k1bFfcPIRTMeCGO48F0OE"
		},
		features: {
			danceability: 0.672,
			energy: 0.504,
			key: 11,
			loudness: -8.284,
			mode: 0,
			speechiness: 0.0322,
			acousticness: 0.423,
			instrumentalness: 0.00885,
			liveness: 0.117,
			valence: 0.109,
			tempo: 110,
			type: "audio_features",
			id: "2k1bFfcPIRTMeCGO48F0OE",
			uri: "spotify:track:2k1bFfcPIRTMeCGO48F0OE",
			track_href: "https://api.spotify.com/v1/tracks/2k1bFfcPIRTMeCGO48F0OE",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2k1bFfcPIRTMeCGO48F0OE",
			duration_ms: 233591,
			time_signature: 4,
			doubletime: 110
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/20gsENnposVs2I4rQ5kvrf" },
						href: "https://api.spotify.com/v1/artists/20gsENnposVs2I4rQ5kvrf",
						id: "20gsENnposVs2I4rQ5kvrf",
						name: "Sam Feldt",
						type: "artist",
						uri: "spotify:artist:20gsENnposVs2I4rQ5kvrf"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1Ccd1TNxIFOJFCgtQMNLP3" },
				href: "https://api.spotify.com/v1/albums/1Ccd1TNxIFOJFCgtQMNLP3",
				id: "1Ccd1TNxIFOJFCgtQMNLP3",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27328baa1c1fcb8b1c52974fdd6", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0228baa1c1fcb8b1c52974fdd6", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485128baa1c1fcb8b1c52974fdd6", width: 64 }
				],
				name: "After The Sunset",
				release_date: "2018-02-19",
				release_date_precision: "day",
				total_tracks: 16,
				type: "album",
				uri: "spotify:album:1Ccd1TNxIFOJFCgtQMNLP3"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/20gsENnposVs2I4rQ5kvrf" },
					href: "https://api.spotify.com/v1/artists/20gsENnposVs2I4rQ5kvrf",
					id: "20gsENnposVs2I4rQ5kvrf",
					name: "Sam Feldt",
					type: "artist",
					uri: "spotify:artist:20gsENnposVs2I4rQ5kvrf"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7IVgVM49Z4ztdmOqOIxhvP" },
					href: "https://api.spotify.com/v1/artists/7IVgVM49Z4ztdmOqOIxhvP",
					id: "7IVgVM49Z4ztdmOqOIxhvP",
					name: "Toby Green",
					type: "artist",
					uri: "spotify:artist:7IVgVM49Z4ztdmOqOIxhvP"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/41hte6PS2wzmLT4MZ8yMXZ" },
					href: "https://api.spotify.com/v1/artists/41hte6PS2wzmLT4MZ8yMXZ",
					id: "41hte6PS2wzmLT4MZ8yMXZ",
					name: "RUMORS",
					type: "artist",
					uri: "spotify:artist:41hte6PS2wzmLT4MZ8yMXZ"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 165703,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLZ541800124" },
			external_urls: { spotify: "https://open.spotify.com/track/6MwSXjb15HDz3BsO1z6ndg" },
			href: "https://api.spotify.com/v1/tracks/6MwSXjb15HDz3BsO1z6ndg",
			id: "6MwSXjb15HDz3BsO1z6ndg",
			is_local: false,
			name: "Chasing After You (feat. RUMORS) - Paul Mayson Remix",
			popularity: 30,
			preview_url: "https://p.scdn.co/mp3-preview/a2fe15ba19ae96ee8129c8776a388261e726d0b7?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 6,
			type: "track",
			uri: "spotify:track:6MwSXjb15HDz3BsO1z6ndg"
		},
		features: {
			danceability: 0.643,
			energy: 0.82,
			key: 0,
			loudness: -6.368,
			mode: 0,
			speechiness: 0.109,
			acousticness: 0.469,
			instrumentalness: 0.0154,
			liveness: 0.227,
			valence: 0.276,
			tempo: 120,
			type: "audio_features",
			id: "6MwSXjb15HDz3BsO1z6ndg",
			uri: "spotify:track:6MwSXjb15HDz3BsO1z6ndg",
			track_href: "https://api.spotify.com/v1/tracks/6MwSXjb15HDz3BsO1z6ndg",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6MwSXjb15HDz3BsO1z6ndg",
			duration_ms: 165703,
			time_signature: 4,
			doubletime: 120
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/53M4Iv2RkzzxFFvW2B1jhC" },
						href: "https://api.spotify.com/v1/artists/53M4Iv2RkzzxFFvW2B1jhC",
						id: "53M4Iv2RkzzxFFvW2B1jhC",
						name: "Breathe Carolina",
						type: "artist",
						uri: "spotify:artist:53M4Iv2RkzzxFFvW2B1jhC"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/37obY6KAyQrGu95SqzKJlu" },
						href: "https://api.spotify.com/v1/artists/37obY6KAyQrGu95SqzKJlu",
						id: "37obY6KAyQrGu95SqzKJlu",
						name: "Sunstars",
						type: "artist",
						uri: "spotify:artist:37obY6KAyQrGu95SqzKJlu"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/515uFoqPZdZBSJhvMGPAYZ" },
				href: "https://api.spotify.com/v1/albums/515uFoqPZdZBSJhvMGPAYZ",
				id: "515uFoqPZdZBSJhvMGPAYZ",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2732acef0ab66d736e58309bd48", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e022acef0ab66d736e58309bd48", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048512acef0ab66d736e58309bd48", width: 64 }
				],
				name: "DYSYLM",
				release_date: "2018-01-05",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:515uFoqPZdZBSJhvMGPAYZ"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/53M4Iv2RkzzxFFvW2B1jhC" },
					href: "https://api.spotify.com/v1/artists/53M4Iv2RkzzxFFvW2B1jhC",
					id: "53M4Iv2RkzzxFFvW2B1jhC",
					name: "Breathe Carolina",
					type: "artist",
					uri: "spotify:artist:53M4Iv2RkzzxFFvW2B1jhC"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/37obY6KAyQrGu95SqzKJlu" },
					href: "https://api.spotify.com/v1/artists/37obY6KAyQrGu95SqzKJlu",
					id: "37obY6KAyQrGu95SqzKJlu",
					name: "Sunstars",
					type: "artist",
					uri: "spotify:artist:37obY6KAyQrGu95SqzKJlu"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 142500,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CYA111800005" },
			external_urls: { spotify: "https://open.spotify.com/track/26spYfEUtRfMBWvbHHq84O" },
			href: "https://api.spotify.com/v1/tracks/26spYfEUtRfMBWvbHHq84O",
			id: "26spYfEUtRfMBWvbHHq84O",
			is_local: false,
			name: "DYSYLM - Mixed",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:26spYfEUtRfMBWvbHHq84O"
		},
		features: {
			danceability: 0.729,
			energy: 0.989,
			key: 10,
			loudness: -2.259,
			mode: 0,
			speechiness: 0.059,
			acousticness: 0.136,
			instrumentalness: 0.028,
			liveness: 0.324,
			valence: 0.547,
			tempo: 128,
			type: "audio_features",
			id: "26spYfEUtRfMBWvbHHq84O",
			uri: "spotify:track:26spYfEUtRfMBWvbHHq84O",
			track_href: "https://api.spotify.com/v1/tracks/26spYfEUtRfMBWvbHHq84O",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/26spYfEUtRfMBWvbHHq84O",
			duration_ms: 142500,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1YYJxpOXYk1z1WtqdeLMkn" },
						href: "https://api.spotify.com/v1/artists/1YYJxpOXYk1z1WtqdeLMkn",
						id: "1YYJxpOXYk1z1WtqdeLMkn",
						name: "Habstrakt",
						type: "artist",
						uri: "spotify:artist:1YYJxpOXYk1z1WtqdeLMkn"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2sfSQ1BOzaFQa3LZj6OGwD" },
						href: "https://api.spotify.com/v1/artists/2sfSQ1BOzaFQa3LZj6OGwD",
						id: "2sfSQ1BOzaFQa3LZj6OGwD",
						name: "josh pan",
						type: "artist",
						uri: "spotify:artist:2sfSQ1BOzaFQa3LZj6OGwD"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/381rDd6BZu1JpNFjROVXGy" },
				href: "https://api.spotify.com/v1/albums/381rDd6BZu1JpNFjROVXGy",
				id: "381rDd6BZu1JpNFjROVXGy",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2735bf0769279376c8594c8e116", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e025bf0769279376c8594c8e116", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048515bf0769279376c8594c8e116", width: 64 }
				],
				name: "Movie",
				release_date: "2018-03-30",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:381rDd6BZu1JpNFjROVXGy"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1YYJxpOXYk1z1WtqdeLMkn" },
					href: "https://api.spotify.com/v1/artists/1YYJxpOXYk1z1WtqdeLMkn",
					id: "1YYJxpOXYk1z1WtqdeLMkn",
					name: "Habstrakt",
					type: "artist",
					uri: "spotify:artist:1YYJxpOXYk1z1WtqdeLMkn"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2sfSQ1BOzaFQa3LZj6OGwD" },
					href: "https://api.spotify.com/v1/artists/2sfSQ1BOzaFQa3LZj6OGwD",
					id: "2sfSQ1BOzaFQa3LZj6OGwD",
					name: "josh pan",
					type: "artist",
					uri: "spotify:artist:2sfSQ1BOzaFQa3LZj6OGwD"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 227362,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USZ4V1800040" },
			external_urls: { spotify: "https://open.spotify.com/track/4B66dqeGbZW3iLg3vgPLDP" },
			href: "https://api.spotify.com/v1/tracks/4B66dqeGbZW3iLg3vgPLDP",
			id: "4B66dqeGbZW3iLg3vgPLDP",
			is_local: false,
			name: "Movie",
			popularity: 45,
			preview_url: "https://p.scdn.co/mp3-preview/a62c39681757fa1bc93f8031cac828681d8fcb38?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4B66dqeGbZW3iLg3vgPLDP"
		},
		features: {
			danceability: 0.841,
			energy: 0.836,
			key: 2,
			loudness: -3.209,
			mode: 1,
			speechiness: 0.0974,
			acousticness: 0.00347,
			instrumentalness: 0.191,
			liveness: 0.727,
			valence: 0.373,
			tempo: 126,
			type: "audio_features",
			id: "4B66dqeGbZW3iLg3vgPLDP",
			uri: "spotify:track:4B66dqeGbZW3iLg3vgPLDP",
			track_href: "https://api.spotify.com/v1/tracks/4B66dqeGbZW3iLg3vgPLDP",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4B66dqeGbZW3iLg3vgPLDP",
			duration_ms: 227363,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
						href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
						id: "24neLwyYRyj4ItaGnFeIT0",
						name: "JOYRYDE",
						type: "artist",
						uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5MlDx2oRh8fVvRcA0WbUqg" },
				href: "https://api.spotify.com/v1/albums/5MlDx2oRh8fVvRcA0WbUqg",
				id: "5MlDx2oRh8fVvRcA0WbUqg",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27348ae35e36fb27ae6c31d067b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0248ae35e36fb27ae6c31d067b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485148ae35e36fb27ae6c31d067b", width: 64 }
				],
				name: "SPEED TRAP",
				release_date: "2016-11-04",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5MlDx2oRh8fVvRcA0WbUqg"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
					href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
					id: "24neLwyYRyj4ItaGnFeIT0",
					name: "JOYRYDE",
					type: "artist",
					uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 229511,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CA5KR1532952" },
			external_urls: { spotify: "https://open.spotify.com/track/1V7sPJKrG9BkVsAoezgQuB" },
			href: "https://api.spotify.com/v1/tracks/1V7sPJKrG9BkVsAoezgQuB",
			id: "1V7sPJKrG9BkVsAoezgQuB",
			is_local: false,
			name: "SPEED TRAP",
			popularity: 44,
			preview_url: "https://p.scdn.co/mp3-preview/b260bf493b1d882b6e21461dfc97bc561ef4d4fe?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1V7sPJKrG9BkVsAoezgQuB"
		},
		features: {
			danceability: 0.645,
			energy: 0.839,
			key: 1,
			loudness: -3.877,
			mode: 0,
			speechiness: 0.295,
			acousticness: 0.0179,
			instrumentalness: 0.0000204,
			liveness: 0.607,
			valence: 0.104,
			tempo: 128,
			type: "audio_features",
			id: "1V7sPJKrG9BkVsAoezgQuB",
			uri: "spotify:track:1V7sPJKrG9BkVsAoezgQuB",
			track_href: "https://api.spotify.com/v1/tracks/1V7sPJKrG9BkVsAoezgQuB",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1V7sPJKrG9BkVsAoezgQuB",
			duration_ms: 229511,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0gXx2aQ2mfovDfqCw10MQC" },
						href: "https://api.spotify.com/v1/artists/0gXx2aQ2mfovDfqCw10MQC",
						id: "0gXx2aQ2mfovDfqCw10MQC",
						name: "G Jones",
						type: "artist",
						uri: "spotify:artist:0gXx2aQ2mfovDfqCw10MQC"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2c2X6dr1PHctH24BxNOjHi" },
						href: "https://api.spotify.com/v1/artists/2c2X6dr1PHctH24BxNOjHi",
						id: "2c2X6dr1PHctH24BxNOjHi",
						name: "Eprom",
						type: "artist",
						uri: "spotify:artist:2c2X6dr1PHctH24BxNOjHi"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2WygzCKZh2ZtCeLvfwerCB" },
				href: "https://api.spotify.com/v1/albums/2WygzCKZh2ZtCeLvfwerCB",
				id: "2WygzCKZh2ZtCeLvfwerCB",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273d6cdd510248b1966869c0e3e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02d6cdd510248b1966869c0e3e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851d6cdd510248b1966869c0e3e", width: 64 }
				],
				name: "Hysteria",
				release_date: "2017-09-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:2WygzCKZh2ZtCeLvfwerCB"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0gXx2aQ2mfovDfqCw10MQC" },
					href: "https://api.spotify.com/v1/artists/0gXx2aQ2mfovDfqCw10MQC",
					id: "0gXx2aQ2mfovDfqCw10MQC",
					name: "G Jones",
					type: "artist",
					uri: "spotify:artist:0gXx2aQ2mfovDfqCw10MQC"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2c2X6dr1PHctH24BxNOjHi" },
					href: "https://api.spotify.com/v1/artists/2c2X6dr1PHctH24BxNOjHi",
					id: "2c2X6dr1PHctH24BxNOjHi",
					name: "Eprom",
					type: "artist",
					uri: "spotify:artist:2c2X6dr1PHctH24BxNOjHi"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 334352,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USQY51774016" },
			external_urls: { spotify: "https://open.spotify.com/track/0DOqYzxnmXHfacOZVz0SNW" },
			href: "https://api.spotify.com/v1/tracks/0DOqYzxnmXHfacOZVz0SNW",
			id: "0DOqYzxnmXHfacOZVz0SNW",
			is_local: false,
			name: "Hysteria",
			popularity: 20,
			preview_url: "https://p.scdn.co/mp3-preview/9910ed32e2ed399a40d99eb5d01ff3b781cea2a5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0DOqYzxnmXHfacOZVz0SNW"
		},
		features: {
			danceability: 0.457,
			energy: 0.984,
			key: 9,
			loudness: -6.14,
			mode: 1,
			speechiness: 0.229,
			acousticness: 0.00391,
			instrumentalness: 0.608,
			liveness: 0.602,
			valence: 0.0497,
			tempo: 124,
			type: "audio_features",
			id: "0DOqYzxnmXHfacOZVz0SNW",
			uri: "spotify:track:0DOqYzxnmXHfacOZVz0SNW",
			track_href: "https://api.spotify.com/v1/tracks/0DOqYzxnmXHfacOZVz0SNW",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0DOqYzxnmXHfacOZVz0SNW",
			duration_ms: 334353,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2amyu5pkgYMYdNQZmB3GgY" },
						href: "https://api.spotify.com/v1/artists/2amyu5pkgYMYdNQZmB3GgY",
						id: "2amyu5pkgYMYdNQZmB3GgY",
						name: "Dog Blood",
						type: "artist",
						uri: "spotify:artist:2amyu5pkgYMYdNQZmB3GgY"
					}
				],
				available_markets: ["AU", "CA", "NZ", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/1sGs88Uas5CNS9wVhm5jE8" },
				href: "https://api.spotify.com/v1/albums/1sGs88Uas5CNS9wVhm5jE8",
				id: "1sGs88Uas5CNS9wVhm5jE8",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273aa8a6d554b363acde439299b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02aa8a6d554b363acde439299b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851aa8a6d554b363acde439299b", width: 64 }
				],
				name: "Next Order/Middle Finger",
				release_date: "2012-08-14",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:1sGs88Uas5CNS9wVhm5jE8"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2amyu5pkgYMYdNQZmB3GgY" },
					href: "https://api.spotify.com/v1/artists/2amyu5pkgYMYdNQZmB3GgY",
					id: "2amyu5pkgYMYdNQZmB3GgY",
					name: "Dog Blood",
					type: "artist",
					uri: "spotify:artist:2amyu5pkgYMYdNQZmB3GgY"
				}
			],
			available_markets: ["AU", "CA", "NZ", "US"],
			disc_number: 1,
			duration_ms: 285650,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21203901" },
			external_urls: { spotify: "https://open.spotify.com/track/4rFbNHh4gX7kGTbfCGEOMF" },
			href: "https://api.spotify.com/v1/tracks/4rFbNHh4gX7kGTbfCGEOMF",
			id: "4rFbNHh4gX7kGTbfCGEOMF",
			is_local: false,
			name: "Next Order",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/f9030e3c88bfdcfc0dadc74c87ae8fa7540b3745?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4rFbNHh4gX7kGTbfCGEOMF"
		},
		features: {
			danceability: 0.76,
			energy: 0.944,
			key: 6,
			loudness: -3.793,
			mode: 0,
			speechiness: 0.0733,
			acousticness: 0.0155,
			instrumentalness: 0.85,
			liveness: 0.363,
			valence: 0.277,
			tempo: 124,
			type: "audio_features",
			id: "4rFbNHh4gX7kGTbfCGEOMF",
			uri: "spotify:track:4rFbNHh4gX7kGTbfCGEOMF",
			track_href: "https://api.spotify.com/v1/tracks/4rFbNHh4gX7kGTbfCGEOMF",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4rFbNHh4gX7kGTbfCGEOMF",
			duration_ms: 285651,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1OAjDaKgg00KCUYqDe68un" },
						href: "https://api.spotify.com/v1/artists/1OAjDaKgg00KCUYqDe68un",
						id: "1OAjDaKgg00KCUYqDe68un",
						name: "Gigi D'Agostino",
						type: "artist",
						uri: "spotify:artist:1OAjDaKgg00KCUYqDe68un"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3dvjLo2u1kao2ikKIJa6KP" },
				href: "https://api.spotify.com/v1/albums/3dvjLo2u1kao2ikKIJa6KP",
				id: "3dvjLo2u1kao2ikKIJa6KP",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273d84f459a905d4d06edff98d1", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02d84f459a905d4d06edff98d1", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851d84f459a905d4d06edff98d1", width: 64 }
				],
				name: "L'Amour Toujour",
				release_date: "2014-05-30",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:3dvjLo2u1kao2ikKIJa6KP"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1OAjDaKgg00KCUYqDe68un" },
					href: "https://api.spotify.com/v1/artists/1OAjDaKgg00KCUYqDe68un",
					id: "1OAjDaKgg00KCUYqDe68un",
					name: "Gigi D'Agostino",
					type: "artist",
					uri: "spotify:artist:1OAjDaKgg00KCUYqDe68un"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 242053,
			episode: false,
			explicit: false,
			external_ids: { isrc: "DEA310200623" },
			external_urls: { spotify: "https://open.spotify.com/track/0FkLMOUTkSTPSAYkIXQ579" },
			href: "https://api.spotify.com/v1/tracks/0FkLMOUTkSTPSAYkIXQ579",
			id: "0FkLMOUTkSTPSAYkIXQ579",
			is_local: false,
			name: "L'amour Toujours (Small Mix)",
			popularity: 69,
			preview_url: "https://p.scdn.co/mp3-preview/56e2440497c1cab2e02fb320c419f236745e5b32?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0FkLMOUTkSTPSAYkIXQ579"
		},
		features: {
			danceability: 0.637,
			energy: 0.878,
			key: 7,
			loudness: -4.449,
			mode: 1,
			speechiness: 0.0302,
			acousticness: 0.0775,
			instrumentalness: 0.0227,
			liveness: 0.364,
			valence: 0.742,
			tempo: 139,
			type: "audio_features",
			id: "0FkLMOUTkSTPSAYkIXQ579",
			uri: "spotify:track:0FkLMOUTkSTPSAYkIXQ579",
			track_href: "https://api.spotify.com/v1/tracks/0FkLMOUTkSTPSAYkIXQ579",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0FkLMOUTkSTPSAYkIXQ579",
			duration_ms: 242053,
			time_signature: 4,
			doubletime: 139
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
						href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
						id: "10gzBoINW3cLJfZUka8Zoe",
						name: "Above & Beyond",
						type: "artist",
						uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/3LOFci2RIEaXJqD3nIoekv" },
				href: "https://api.spotify.com/v1/albums/3LOFci2RIEaXJqD3nIoekv",
				id: "3LOFci2RIEaXJqD3nIoekv",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27356b609e46e342c8328664ade", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0256b609e46e342c8328664ade", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485156b609e46e342c8328664ade", width: 64 }
				],
				name: "Tri-State",
				release_date: "2006",
				release_date_precision: "year",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:3LOFci2RIEaXJqD3nIoekv"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
					href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
					id: "10gzBoINW3cLJfZUka8Zoe",
					name: "Above & Beyond",
					type: "artist",
					uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0Fn4agIyGMwQsKHrx1i8Dn" },
					href: "https://api.spotify.com/v1/artists/0Fn4agIyGMwQsKHrx1i8Dn",
					id: "0Fn4agIyGMwQsKHrx1i8Dn",
					name: "Andy Moor",
					type: "artist",
					uri: "spotify:artist:0Fn4agIyGMwQsKHrx1i8Dn"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 447933,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA0600014" },
			external_urls: { spotify: "https://open.spotify.com/track/7cGS8SUftlfTCGiKgLn4kr" },
			href: "https://api.spotify.com/v1/tracks/7cGS8SUftlfTCGiKgLn4kr",
			id: "7cGS8SUftlfTCGiKgLn4kr",
			is_local: false,
			name: "Air for Life (with Andy Moor)",
			popularity: 2,
			preview_url: null,
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:7cGS8SUftlfTCGiKgLn4kr"
		},
		features: {
			danceability: 0.571,
			energy: 0.82,
			key: 8,
			loudness: -7.43,
			mode: 0,
			speechiness: 0.12,
			acousticness: 0.00167,
			instrumentalness: 0.131,
			liveness: 0.563,
			valence: 0.358,
			tempo: 132,
			type: "audio_features",
			id: "7cGS8SUftlfTCGiKgLn4kr",
			uri: "spotify:track:7cGS8SUftlfTCGiKgLn4kr",
			track_href: "https://api.spotify.com/v1/tracks/7cGS8SUftlfTCGiKgLn4kr",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7cGS8SUftlfTCGiKgLn4kr",
			duration_ms: 447933,
			time_signature: 4,
			doubletime: 132
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/41gheHlTde3shn2kiwndm7" },
						href: "https://api.spotify.com/v1/artists/41gheHlTde3shn2kiwndm7",
						id: "41gheHlTde3shn2kiwndm7",
						name: "Sarina Paris",
						type: "artist",
						uri: "spotify:artist:41gheHlTde3shn2kiwndm7"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SK",
					"SV",
					"TN",
					"TR",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/10DeYFtP1dad87EfseOlpa" },
				href: "https://api.spotify.com/v1/albums/10DeYFtP1dad87EfseOlpa",
				id: "10DeYFtP1dad87EfseOlpa",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273184056fdc475a846cbaa2605", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02184056fdc475a846cbaa2605", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851184056fdc475a846cbaa2605", width: 64 }
				],
				name: "Sarina Paris",
				release_date: "2001-05-22",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:10DeYFtP1dad87EfseOlpa"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/41gheHlTde3shn2kiwndm7" },
					href: "https://api.spotify.com/v1/artists/41gheHlTde3shn2kiwndm7",
					id: "41gheHlTde3shn2kiwndm7",
					name: "Sarina Paris",
					type: "artist",
					uri: "spotify:artist:41gheHlTde3shn2kiwndm7"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SK",
				"SV",
				"TN",
				"TR",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 209786,
			episode: false,
			explicit: false,
			external_ids: { isrc: "ITD009900255" },
			external_urls: { spotify: "https://open.spotify.com/track/42MVI9N0ikM6m8QgrC1nUu" },
			href: "https://api.spotify.com/v1/tracks/42MVI9N0ikM6m8QgrC1nUu",
			id: "42MVI9N0ikM6m8QgrC1nUu",
			is_local: false,
			name: "Look At Us",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/f04041ba4cd8f59a936f3dffbe9b948fbaba2306?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:42MVI9N0ikM6m8QgrC1nUu"
		},
		features: {
			danceability: 0.815,
			energy: 0.832,
			key: 1,
			loudness: -7.295,
			mode: 1,
			speechiness: 0.033,
			acousticness: 0.165,
			instrumentalness: 0.00142,
			liveness: 0.0732,
			valence: 0.802,
			tempo: 133,
			type: "audio_features",
			id: "42MVI9N0ikM6m8QgrC1nUu",
			uri: "spotify:track:42MVI9N0ikM6m8QgrC1nUu",
			track_href: "https://api.spotify.com/v1/tracks/42MVI9N0ikM6m8QgrC1nUu",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/42MVI9N0ikM6m8QgrC1nUu",
			duration_ms: 209787,
			time_signature: 4,
			doubletime: 133
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/27IuDZNaLuEtupD8QZftiZ" },
						href: "https://api.spotify.com/v1/artists/27IuDZNaLuEtupD8QZftiZ",
						id: "27IuDZNaLuEtupD8QZftiZ",
						name: "Ian van Dahl",
						type: "artist",
						uri: "spotify:artist:27IuDZNaLuEtupD8QZftiZ"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4P5BZKgDIxksZu7Px0OhHL" },
				href: "https://api.spotify.com/v1/albums/4P5BZKgDIxksZu7Px0OhHL",
				id: "4P5BZKgDIxksZu7Px0OhHL",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27374415980fa5475e219f25b68", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0274415980fa5475e219f25b68", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485174415980fa5475e219f25b68", width: 64 }
				],
				name: "Castles In The Sky",
				release_date: "2015-04-27",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:4P5BZKgDIxksZu7Px0OhHL"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/27IuDZNaLuEtupD8QZftiZ" },
					href: "https://api.spotify.com/v1/artists/27IuDZNaLuEtupD8QZftiZ",
					id: "27IuDZNaLuEtupD8QZftiZ",
					name: "Ian van Dahl",
					type: "artist",
					uri: "spotify:artist:27IuDZNaLuEtupD8QZftiZ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/28Y5nsvbE8IdoUAGNgCk0Y" },
					href: "https://api.spotify.com/v1/artists/28Y5nsvbE8IdoUAGNgCk0Y",
					id: "28Y5nsvbE8IdoUAGNgCk0Y",
					name: "Marsha",
					type: "artist",
					uri: "spotify:artist:28Y5nsvbE8IdoUAGNgCk0Y"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 227133,
			episode: false,
			explicit: false,
			external_ids: { isrc: "BEZ460000020" },
			external_urls: { spotify: "https://open.spotify.com/track/3KhoIbIPMmoGthbBAPxgOK" },
			href: "https://api.spotify.com/v1/tracks/3KhoIbIPMmoGthbBAPxgOK",
			id: "3KhoIbIPMmoGthbBAPxgOK",
			is_local: false,
			name: "Castles In The Sky - Radio Mix",
			popularity: 57,
			preview_url: "https://p.scdn.co/mp3-preview/af051b8c85af9dc98639ba84480511e688fba454?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:3KhoIbIPMmoGthbBAPxgOK"
		},
		features: {
			danceability: 0.578,
			energy: 0.87,
			key: 0,
			loudness: -6.422,
			mode: 0,
			speechiness: 0.0323,
			acousticness: 0.00268,
			instrumentalness: 0.412,
			liveness: 0.0346,
			valence: 0.667,
			tempo: 140,
			type: "audio_features",
			id: "3KhoIbIPMmoGthbBAPxgOK",
			uri: "spotify:track:3KhoIbIPMmoGthbBAPxgOK",
			track_href: "https://api.spotify.com/v1/tracks/3KhoIbIPMmoGthbBAPxgOK",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3KhoIbIPMmoGthbBAPxgOK",
			duration_ms: 227133,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4z4m1P0iX2nRSPDBEZ8LBT" },
						href: "https://api.spotify.com/v1/artists/4z4m1P0iX2nRSPDBEZ8LBT",
						id: "4z4m1P0iX2nRSPDBEZ8LBT",
						name: "DJ Sammy",
						type: "artist",
						uri: "spotify:artist:4z4m1P0iX2nRSPDBEZ8LBT"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5SWX583ExJOL7cv8572Crs" },
						href: "https://api.spotify.com/v1/artists/5SWX583ExJOL7cv8572Crs",
						id: "5SWX583ExJOL7cv8572Crs",
						name: "Yanou",
						type: "artist",
						uri: "spotify:artist:5SWX583ExJOL7cv8572Crs"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7KHjkfgCVwog38yBI0NcmR" },
				href: "https://api.spotify.com/v1/albums/7KHjkfgCVwog38yBI0NcmR",
				id: "7KHjkfgCVwog38yBI0NcmR",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27302ef259a4ba1d9068aa3de1a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0202ef259a4ba1d9068aa3de1a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485102ef259a4ba1d9068aa3de1a", width: 64 }
				],
				name: "Heaven",
				release_date: "2002-02-26",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:7KHjkfgCVwog38yBI0NcmR"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4z4m1P0iX2nRSPDBEZ8LBT" },
					href: "https://api.spotify.com/v1/artists/4z4m1P0iX2nRSPDBEZ8LBT",
					id: "4z4m1P0iX2nRSPDBEZ8LBT",
					name: "DJ Sammy",
					type: "artist",
					uri: "spotify:artist:4z4m1P0iX2nRSPDBEZ8LBT"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5SWX583ExJOL7cv8572Crs" },
					href: "https://api.spotify.com/v1/artists/5SWX583ExJOL7cv8572Crs",
					id: "5SWX583ExJOL7cv8572Crs",
					name: "Yanou",
					type: "artist",
					uri: "spotify:artist:5SWX583ExJOL7cv8572Crs"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/512aANbakY9mEaeyKucQur" },
					href: "https://api.spotify.com/v1/artists/512aANbakY9mEaeyKucQur",
					id: "512aANbakY9mEaeyKucQur",
					name: "D/O",
					type: "artist",
					uri: "spotify:artist:512aANbakY9mEaeyKucQur"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 233600,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USRE50200157" },
			external_urls: { spotify: "https://open.spotify.com/track/72SpPFrMYCXLB3Fbw9tEgf" },
			href: "https://api.spotify.com/v1/tracks/72SpPFrMYCXLB3Fbw9tEgf",
			id: "72SpPFrMYCXLB3Fbw9tEgf",
			is_local: false,
			name: "Heaven (featuring Do)",
			popularity: 60,
			preview_url: "https://p.scdn.co/mp3-preview/f37349860ef1c59ecffb1c670530e6daa4c797df?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:72SpPFrMYCXLB3Fbw9tEgf"
		},
		features: {
			danceability: 0.571,
			energy: 0.953,
			key: 8,
			loudness: -5.601,
			mode: 1,
			speechiness: 0.0548,
			acousticness: 0.0011,
			instrumentalness: 0.000606,
			liveness: 0.226,
			valence: 0.601,
			tempo: 138,
			type: "audio_features",
			id: "72SpPFrMYCXLB3Fbw9tEgf",
			uri: "spotify:track:72SpPFrMYCXLB3Fbw9tEgf",
			track_href: "https://api.spotify.com/v1/tracks/72SpPFrMYCXLB3Fbw9tEgf",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/72SpPFrMYCXLB3Fbw9tEgf",
			duration_ms: 233600,
			time_signature: 4,
			doubletime: 138
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3NmuArRqqfxT4rvFSgb0cx" },
						href: "https://api.spotify.com/v1/artists/3NmuArRqqfxT4rvFSgb0cx",
						id: "3NmuArRqqfxT4rvFSgb0cx",
						name: "Gent & Jawns",
						type: "artist",
						uri: "spotify:artist:3NmuArRqqfxT4rvFSgb0cx"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/59JqOZjakXkQ0z9OBfNlyE" },
				href: "https://api.spotify.com/v1/albums/59JqOZjakXkQ0z9OBfNlyE",
				id: "59JqOZjakXkQ0z9OBfNlyE",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a3b68b966da968c7d287d375", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a3b68b966da968c7d287d375", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a3b68b966da968c7d287d375", width: 64 }
				],
				name: "The Meaning - EP",
				release_date: "2018-02-23",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:59JqOZjakXkQ0z9OBfNlyE"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3NmuArRqqfxT4rvFSgb0cx" },
					href: "https://api.spotify.com/v1/artists/3NmuArRqqfxT4rvFSgb0cx",
					id: "3NmuArRqqfxT4rvFSgb0cx",
					name: "Gent & Jawns",
					type: "artist",
					uri: "spotify:artist:3NmuArRqqfxT4rvFSgb0cx"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6t2Rja6dihuxH6Mrgyynp6" },
					href: "https://api.spotify.com/v1/artists/6t2Rja6dihuxH6Mrgyynp6",
					id: "6t2Rja6dihuxH6Mrgyynp6",
					name: "LIZ",
					type: "artist",
					uri: "spotify:artist:6t2Rja6dihuxH6Mrgyynp6"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 289837,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CA6D21800035" },
			external_urls: { spotify: "https://open.spotify.com/track/6vTXljG7vkFi4uXPUsZbGB" },
			href: "https://api.spotify.com/v1/tracks/6vTXljG7vkFi4uXPUsZbGB",
			id: "6vTXljG7vkFi4uXPUsZbGB",
			is_local: false,
			name: "Reconcile (feat. Liz)",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:6vTXljG7vkFi4uXPUsZbGB"
		},
		features: {
			danceability: 0.478,
			energy: 0.73,
			key: 1,
			loudness: -6.389,
			mode: 1,
			speechiness: 0.0397,
			acousticness: 0.00315,
			instrumentalness: 0.0352,
			liveness: 0.111,
			valence: 0.303,
			tempo: 154,
			type: "audio_features",
			id: "6vTXljG7vkFi4uXPUsZbGB",
			uri: "spotify:track:6vTXljG7vkFi4uXPUsZbGB",
			track_href: "https://api.spotify.com/v1/tracks/6vTXljG7vkFi4uXPUsZbGB",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6vTXljG7vkFi4uXPUsZbGB",
			duration_ms: 289837,
			time_signature: 4,
			doubletime: 154
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4RddZ3iHvSpGV4dvATac9X" },
						href: "https://api.spotify.com/v1/artists/4RddZ3iHvSpGV4dvATac9X",
						id: "4RddZ3iHvSpGV4dvATac9X",
						name: "Papa Roach",
						type: "artist",
						uri: "spotify:artist:4RddZ3iHvSpGV4dvATac9X"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/72iCiKwu6nu6Qq9emIwzYv" },
						href: "https://api.spotify.com/v1/artists/72iCiKwu6nu6Qq9emIwzYv",
						id: "72iCiKwu6nu6Qq9emIwzYv",
						name: "Kayzo",
						type: "artist",
						uri: "spotify:artist:72iCiKwu6nu6Qq9emIwzYv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0UHqmo8OW7bzZ74pHttnmd" },
				href: "https://api.spotify.com/v1/albums/0UHqmo8OW7bzZ74pHttnmd",
				id: "0UHqmo8OW7bzZ74pHttnmd",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27338954f55ca397e7fd58c8d9b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0238954f55ca397e7fd58c8d9b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485138954f55ca397e7fd58c8d9b", width: 64 }
				],
				name: "Last Resort (The Rework)",
				release_date: "2018-05-16",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0UHqmo8OW7bzZ74pHttnmd"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4RddZ3iHvSpGV4dvATac9X" },
					href: "https://api.spotify.com/v1/artists/4RddZ3iHvSpGV4dvATac9X",
					id: "4RddZ3iHvSpGV4dvATac9X",
					name: "Papa Roach",
					type: "artist",
					uri: "spotify:artist:4RddZ3iHvSpGV4dvATac9X"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/72iCiKwu6nu6Qq9emIwzYv" },
					href: "https://api.spotify.com/v1/artists/72iCiKwu6nu6Qq9emIwzYv",
					id: "72iCiKwu6nu6Qq9emIwzYv",
					name: "Kayzo",
					type: "artist",
					uri: "spotify:artist:72iCiKwu6nu6Qq9emIwzYv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 288000,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USUM71804830" },
			external_urls: { spotify: "https://open.spotify.com/track/7poA10I15kvSUH6m44fQkS" },
			href: "https://api.spotify.com/v1/tracks/7poA10I15kvSUH6m44fQkS",
			id: "7poA10I15kvSUH6m44fQkS",
			is_local: false,
			name: "Last Resort - The Rework",
			popularity: 59,
			preview_url: "https://p.scdn.co/mp3-preview/7b130b5585b5507879ff6755ea54e66608d4cffb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:7poA10I15kvSUH6m44fQkS"
		},
		features: {
			danceability: 0.551,
			energy: 0.962,
			key: 11,
			loudness: -3.856,
			mode: 0,
			speechiness: 0.237,
			acousticness: 0.000944,
			instrumentalness: 0.000174,
			liveness: 0.138,
			valence: 0.512,
			tempo: 155,
			type: "audio_features",
			id: "7poA10I15kvSUH6m44fQkS",
			uri: "spotify:track:7poA10I15kvSUH6m44fQkS",
			track_href: "https://api.spotify.com/v1/tracks/7poA10I15kvSUH6m44fQkS",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7poA10I15kvSUH6m44fQkS",
			duration_ms: 288000,
			time_signature: 4,
			doubletime: 155
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7GvVTb8yFV0ZrdI30Qce6T" },
						href: "https://api.spotify.com/v1/artists/7GvVTb8yFV0ZrdI30Qce6T",
						id: "7GvVTb8yFV0ZrdI30Qce6T",
						name: "Delta Heavy",
						type: "artist",
						uri: "spotify:artist:7GvVTb8yFV0ZrdI30Qce6T"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/62KR37LIVpLM0GtLIMfpaA" },
				href: "https://api.spotify.com/v1/albums/62KR37LIVpLM0GtLIMfpaA",
				id: "62KR37LIVpLM0GtLIMfpaA",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736802b6317d3c124ddd0746f7", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026802b6317d3c124ddd0746f7", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516802b6317d3c124ddd0746f7", width: 64 }
				],
				name: "Paradise Lost",
				release_date: "2016-03-18",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:62KR37LIVpLM0GtLIMfpaA"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7GvVTb8yFV0ZrdI30Qce6T" },
					href: "https://api.spotify.com/v1/artists/7GvVTb8yFV0ZrdI30Qce6T",
					id: "7GvVTb8yFV0ZrdI30Qce6T",
					name: "Delta Heavy",
					type: "artist",
					uri: "spotify:artist:7GvVTb8yFV0ZrdI30Qce6T"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 285760,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBBZH1500247" },
			external_urls: { spotify: "https://open.spotify.com/track/0FzyA9UfdcdOJLWNNwZFC8" },
			href: "https://api.spotify.com/v1/tracks/0FzyA9UfdcdOJLWNNwZFC8",
			id: "0FzyA9UfdcdOJLWNNwZFC8",
			is_local: false,
			name: "Paradise Lost",
			popularity: 36,
			preview_url: "https://p.scdn.co/mp3-preview/4f25b9ceef2604ded72b8f69d6964b9397f040d5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0FzyA9UfdcdOJLWNNwZFC8"
		},
		features: {
			danceability: 0.392,
			energy: 0.741,
			key: 2,
			loudness: -5.125,
			mode: 1,
			speechiness: 0.0335,
			acousticness: 0.000344,
			instrumentalness: 0.915,
			liveness: 0.347,
			valence: 0.0379,
			tempo: 90,
			type: "audio_features",
			id: "0FzyA9UfdcdOJLWNNwZFC8",
			uri: "spotify:track:0FzyA9UfdcdOJLWNNwZFC8",
			track_href: "https://api.spotify.com/v1/tracks/0FzyA9UfdcdOJLWNNwZFC8",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0FzyA9UfdcdOJLWNNwZFC8",
			duration_ms: 285760,
			time_signature: 4,
			doubletime: 180
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/45eNHdiiabvmbp4erw26rg" },
						href: "https://api.spotify.com/v1/artists/45eNHdiiabvmbp4erw26rg",
						id: "45eNHdiiabvmbp4erw26rg",
						name: "ILLENIUM",
						type: "artist",
						uri: "spotify:artist:45eNHdiiabvmbp4erw26rg"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4f9voI47wfAZIp0UgwGy6o" },
				href: "https://api.spotify.com/v1/albums/4f9voI47wfAZIp0UgwGy6o",
				id: "4f9voI47wfAZIp0UgwGy6o",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ef7e62898833c63fdeff40dc", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ef7e62898833c63fdeff40dc", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ef7e62898833c63fdeff40dc", width: 64 }
				],
				name: "Awake (Remixes)",
				release_date: "2018-06-18",
				release_date_precision: "day",
				total_tracks: 15,
				type: "album",
				uri: "spotify:album:4f9voI47wfAZIp0UgwGy6o"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/45eNHdiiabvmbp4erw26rg" },
					href: "https://api.spotify.com/v1/artists/45eNHdiiabvmbp4erw26rg",
					id: "45eNHdiiabvmbp4erw26rg",
					name: "ILLENIUM",
					type: "artist",
					uri: "spotify:artist:45eNHdiiabvmbp4erw26rg"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0kErUwb6xgWfkdn0RyZWHZ" },
					href: "https://api.spotify.com/v1/artists/0kErUwb6xgWfkdn0RyZWHZ",
					id: "0kErUwb6xgWfkdn0RyZWHZ",
					name: "Annika Wells",
					type: "artist",
					uri: "spotify:artist:0kErUwb6xgWfkdn0RyZWHZ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3a9qv6NLHnsVxJUtKOMHvD" },
					href: "https://api.spotify.com/v1/artists/3a9qv6NLHnsVxJUtKOMHvD",
					id: "3a9qv6NLHnsVxJUtKOMHvD",
					name: "The Glitch Mob",
					type: "artist",
					uri: "spotify:artist:3a9qv6NLHnsVxJUtKOMHvD"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 309677,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USA2P1812174" },
			external_urls: { spotify: "https://open.spotify.com/track/7kFTs2lzIfm612Iki5I02K" },
			href: "https://api.spotify.com/v1/tracks/7kFTs2lzIfm612Iki5I02K",
			id: "7kFTs2lzIfm612Iki5I02K",
			is_local: false,
			name: "Crawl Outta Love - The Glitch Mob Remix",
			popularity: 38,
			preview_url: "https://p.scdn.co/mp3-preview/2d2b77d934dc4e3760f2cb4aa781e58282667463?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:7kFTs2lzIfm612Iki5I02K"
		},
		features: {
			danceability: 0.476,
			energy: 0.798,
			key: 2,
			loudness: -5.405,
			mode: 1,
			speechiness: 0.0869,
			acousticness: 0.00677,
			instrumentalness: 0.0914,
			liveness: 0.583,
			valence: 0.0372,
			tempo: 93,
			type: "audio_features",
			id: "7kFTs2lzIfm612Iki5I02K",
			uri: "spotify:track:7kFTs2lzIfm612Iki5I02K",
			track_href: "https://api.spotify.com/v1/tracks/7kFTs2lzIfm612Iki5I02K",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7kFTs2lzIfm612Iki5I02K",
			duration_ms: 309677,
			time_signature: 4,
			doubletime: 186
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
						href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
						id: "3UCbp6D1lvILlxRJT9LnFa",
						name: "Koven",
						type: "artist",
						uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/76ngLsOFUbQbFl7LaIQ8Rx" },
				href: "https://api.spotify.com/v1/albums/76ngLsOFUbQbFl7LaIQ8Rx",
				id: "76ngLsOFUbQbFl7LaIQ8Rx",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bc1f616ca3cb360ebefdcf74", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bc1f616ca3cb360ebefdcf74", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bc1f616ca3cb360ebefdcf74", width: 64 }
				],
				name: "Retrospective",
				release_date: "2018-03-09",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:76ngLsOFUbQbFl7LaIQ8Rx"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
					href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
					id: "3UCbp6D1lvILlxRJT9LnFa",
					name: "Koven",
					type: "artist",
					uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 294524,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTMZ1700544" },
			external_urls: { spotify: "https://open.spotify.com/track/3FBUG59aivAuzNHixXhakX" },
			href: "https://api.spotify.com/v1/tracks/3FBUG59aivAuzNHixXhakX",
			id: "3FBUG59aivAuzNHixXhakX",
			is_local: false,
			name: "Lasting, Pt. 2",
			popularity: 26,
			preview_url: "https://p.scdn.co/mp3-preview/ae884ec656f157ec2f6e8be784950a6dcc0f9fd0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 8,
			type: "track",
			uri: "spotify:track:3FBUG59aivAuzNHixXhakX"
		},
		features: {
			danceability: 0.5,
			energy: 0.944,
			key: 11,
			loudness: -2.715,
			mode: 1,
			speechiness: 0.0993,
			acousticness: 0.000535,
			instrumentalness: 0.053,
			liveness: 0.0744,
			valence: 0.347,
			tempo: 144,
			type: "audio_features",
			id: "3FBUG59aivAuzNHixXhakX",
			uri: "spotify:track:3FBUG59aivAuzNHixXhakX",
			track_href: "https://api.spotify.com/v1/tracks/3FBUG59aivAuzNHixXhakX",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3FBUG59aivAuzNHixXhakX",
			duration_ms: 294524,
			time_signature: 4,
			doubletime: 144
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4akLvvJyLbJxlbpSXHTLvT" },
						href: "https://api.spotify.com/v1/artists/4akLvvJyLbJxlbpSXHTLvT",
						id: "4akLvvJyLbJxlbpSXHTLvT",
						name: "Dubloadz",
						type: "artist",
						uri: "spotify:artist:4akLvvJyLbJxlbpSXHTLvT"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2lWNMvLr72E4k9Ts0DoEZw" },
				href: "https://api.spotify.com/v1/albums/2lWNMvLr72E4k9Ts0DoEZw",
				id: "2lWNMvLr72E4k9Ts0DoEZw",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273899de93f3e9996e45bad6980", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02899de93f3e9996e45bad6980", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851899de93f3e9996e45bad6980", width: 64 }
				],
				name: "Dubloadz and the 9000 Ghosts",
				release_date: "2017-08-10",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:2lWNMvLr72E4k9Ts0DoEZw"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4akLvvJyLbJxlbpSXHTLvT" },
					href: "https://api.spotify.com/v1/artists/4akLvvJyLbJxlbpSXHTLvT",
					id: "4akLvvJyLbJxlbpSXHTLvT",
					name: "Dubloadz",
					type: "artist",
					uri: "spotify:artist:4akLvvJyLbJxlbpSXHTLvT"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1CXuuw8HJhyN80HlNzvL1e" },
					href: "https://api.spotify.com/v1/artists/1CXuuw8HJhyN80HlNzvL1e",
					id: "1CXuuw8HJhyN80HlNzvL1e",
					name: "Sullivan King",
					type: "artist",
					uri: "spotify:artist:1CXuuw8HJhyN80HlNzvL1e"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 244800,
			episode: false,
			explicit: true,
			external_ids: { isrc: "FR59R1764051" },
			external_urls: { spotify: "https://open.spotify.com/track/1ndtFtce8tttyqn3uVRk6Q" },
			href: "https://api.spotify.com/v1/tracks/1ndtFtce8tttyqn3uVRk6Q",
			id: "1ndtFtce8tttyqn3uVRk6Q",
			is_local: false,
			name: "Break the Rail (feat. Sullivan King)",
			popularity: 45,
			preview_url: "https://p.scdn.co/mp3-preview/1fc4fc312b105971ddd54f9a645704826f595b1a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 6,
			type: "track",
			uri: "spotify:track:1ndtFtce8tttyqn3uVRk6Q"
		},
		features: {
			danceability: 0.567,
			energy: 0.983,
			key: 11,
			loudness: -2.289,
			mode: 0,
			speechiness: 0.241,
			acousticness: 0.000364,
			instrumentalness: 0.000616,
			liveness: 0.689,
			valence: 0.338,
			tempo: 75,
			type: "audio_features",
			id: "1ndtFtce8tttyqn3uVRk6Q",
			uri: "spotify:track:1ndtFtce8tttyqn3uVRk6Q",
			track_href: "https://api.spotify.com/v1/tracks/1ndtFtce8tttyqn3uVRk6Q",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1ndtFtce8tttyqn3uVRk6Q",
			duration_ms: 244800,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
						href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
						id: "3UCbp6D1lvILlxRJT9LnFa",
						name: "Koven",
						type: "artist",
						uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/17orrZznh0gmxYtpNP47nK" },
				href: "https://api.spotify.com/v1/albums/17orrZznh0gmxYtpNP47nK",
				id: "17orrZznh0gmxYtpNP47nK",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739718999cf199fe427f3e2582", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029718999cf199fe427f3e2582", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519718999cf199fe427f3e2582", width: 64 }
				],
				name: "Another Home",
				release_date: "2014-02-19",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:17orrZznh0gmxYtpNP47nK"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
					href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
					id: "3UCbp6D1lvILlxRJT9LnFa",
					name: "Koven",
					type: "artist",
					uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 287916,
			episode: false,
			explicit: false,
			external_ids: { isrc: "FR4GL1074133" },
			external_urls: { spotify: "https://open.spotify.com/track/2TSCKsGHdDFiN2HpuAIeVZ" },
			href: "https://api.spotify.com/v1/tracks/2TSCKsGHdDFiN2HpuAIeVZ",
			id: "2TSCKsGHdDFiN2HpuAIeVZ",
			is_local: false,
			name: "Another Home",
			popularity: 27,
			preview_url: "https://p.scdn.co/mp3-preview/6654ccf4abe0735bcc02849d68110cf05f124403?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2TSCKsGHdDFiN2HpuAIeVZ"
		},
		features: {
			danceability: 0.325,
			energy: 0.634,
			key: 2,
			loudness: -8.014,
			mode: 0,
			speechiness: 0.0457,
			acousticness: 0.000437,
			instrumentalness: 0.0057,
			liveness: 0.119,
			valence: 0.0701,
			tempo: 144,
			type: "audio_features",
			id: "2TSCKsGHdDFiN2HpuAIeVZ",
			uri: "spotify:track:2TSCKsGHdDFiN2HpuAIeVZ",
			track_href: "https://api.spotify.com/v1/tracks/2TSCKsGHdDFiN2HpuAIeVZ",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2TSCKsGHdDFiN2HpuAIeVZ",
			duration_ms: 287917,
			time_signature: 4,
			doubletime: 144
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4YLQaW1UU3mrVetC8gNkg5" },
						href: "https://api.spotify.com/v1/artists/4YLQaW1UU3mrVetC8gNkg5",
						id: "4YLQaW1UU3mrVetC8gNkg5",
						name: "3LAU",
						type: "artist",
						uri: "spotify:artist:4YLQaW1UU3mrVetC8gNkg5"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6sBjS0wHbzcwe8Eh4bOm97" },
				href: "https://api.spotify.com/v1/albums/6sBjS0wHbzcwe8Eh4bOm97",
				id: "6sBjS0wHbzcwe8Eh4bOm97",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2731980419be49b38d9cc2e5b21", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e021980419be49b38d9cc2e5b21", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048511980419be49b38d9cc2e5b21", width: 64 }
				],
				name: "Ultraviolet",
				release_date: "2018-02-16",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:6sBjS0wHbzcwe8Eh4bOm97"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4YLQaW1UU3mrVetC8gNkg5" },
					href: "https://api.spotify.com/v1/artists/4YLQaW1UU3mrVetC8gNkg5",
					id: "4YLQaW1UU3mrVetC8gNkg5",
					name: "3LAU",
					type: "artist",
					uri: "spotify:artist:4YLQaW1UU3mrVetC8gNkg5"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 195200,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBKPL1898193" },
			external_urls: { spotify: "https://open.spotify.com/track/7GalIlpcDztcRU5GGm06yK" },
			href: "https://api.spotify.com/v1/tracks/7GalIlpcDztcRU5GGm06yK",
			id: "7GalIlpcDztcRU5GGm06yK",
			is_local: false,
			name: "Arcana",
			popularity: 35,
			preview_url: "https://p.scdn.co/mp3-preview/568107c9633619f709f0ee0ade9907be633e18b1?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:7GalIlpcDztcRU5GGm06yK"
		},
		features: {
			danceability: 0.483,
			energy: 0.898,
			key: 4,
			loudness: -5.623,
			mode: 0,
			speechiness: 0.0406,
			acousticness: 0.00268,
			instrumentalness: 0.944,
			liveness: 0.136,
			valence: 0.0393,
			tempo: 150,
			type: "audio_features",
			id: "7GalIlpcDztcRU5GGm06yK",
			uri: "spotify:track:7GalIlpcDztcRU5GGm06yK",
			track_href: "https://api.spotify.com/v1/tracks/7GalIlpcDztcRU5GGm06yK",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7GalIlpcDztcRU5GGm06yK",
			duration_ms: 195200,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/06MFEUOcADxVpRKLC9EZXn" },
						href: "https://api.spotify.com/v1/artists/06MFEUOcADxVpRKLC9EZXn",
						id: "06MFEUOcADxVpRKLC9EZXn",
						name: "Red Hood Squad",
						type: "artist",
						uri: "spotify:artist:06MFEUOcADxVpRKLC9EZXn"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5yf8LojiIUdBemvIhPiiuY" },
						href: "https://api.spotify.com/v1/artists/5yf8LojiIUdBemvIhPiiuY",
						id: "5yf8LojiIUdBemvIhPiiuY",
						name: "Morbid",
						type: "artist",
						uri: "spotify:artist:5yf8LojiIUdBemvIhPiiuY"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7MHhTZbxn2XRwXK4s2BFO6" },
						href: "https://api.spotify.com/v1/artists/7MHhTZbxn2XRwXK4s2BFO6",
						id: "7MHhTZbxn2XRwXK4s2BFO6",
						name: "Rico Act",
						type: "artist",
						uri: "spotify:artist:7MHhTZbxn2XRwXK4s2BFO6"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5BsUjCepjT6Xw5qVXRzPAT" },
				href: "https://api.spotify.com/v1/albums/5BsUjCepjT6Xw5qVXRzPAT",
				id: "5BsUjCepjT6Xw5qVXRzPAT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27393f7adf401ec8a42bbbb9df0", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0293f7adf401ec8a42bbbb9df0", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485193f7adf401ec8a42bbbb9df0", width: 64 }
				],
				name: "Blast Off",
				release_date: "2018-04-06",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5BsUjCepjT6Xw5qVXRzPAT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/06MFEUOcADxVpRKLC9EZXn" },
					href: "https://api.spotify.com/v1/artists/06MFEUOcADxVpRKLC9EZXn",
					id: "06MFEUOcADxVpRKLC9EZXn",
					name: "Red Hood Squad",
					type: "artist",
					uri: "spotify:artist:06MFEUOcADxVpRKLC9EZXn"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5yf8LojiIUdBemvIhPiiuY" },
					href: "https://api.spotify.com/v1/artists/5yf8LojiIUdBemvIhPiiuY",
					id: "5yf8LojiIUdBemvIhPiiuY",
					name: "Morbid",
					type: "artist",
					uri: "spotify:artist:5yf8LojiIUdBemvIhPiiuY"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7MHhTZbxn2XRwXK4s2BFO6" },
					href: "https://api.spotify.com/v1/artists/7MHhTZbxn2XRwXK4s2BFO6",
					id: "7MHhTZbxn2XRwXK4s2BFO6",
					name: "Rico Act",
					type: "artist",
					uri: "spotify:artist:7MHhTZbxn2XRwXK4s2BFO6"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 180079,
			episode: false,
			explicit: true,
			external_ids: { isrc: "NLF711802722" },
			external_urls: { spotify: "https://open.spotify.com/track/6wIvFp0zpLlFC1FO91bimW" },
			href: "https://api.spotify.com/v1/tracks/6wIvFp0zpLlFC1FO91bimW",
			id: "6wIvFp0zpLlFC1FO91bimW",
			is_local: false,
			name: "Blast Off",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/a17704f083d176998d72ed82267fc6831045d857?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6wIvFp0zpLlFC1FO91bimW"
		},
		features: {
			danceability: 0.565,
			energy: 0.99,
			key: 7,
			loudness: -3.096,
			mode: 1,
			speechiness: 0.301,
			acousticness: 0.00417,
			instrumentalness: 0.00000107,
			liveness: 0.0758,
			valence: 0.501,
			tempo: 150,
			type: "audio_features",
			id: "6wIvFp0zpLlFC1FO91bimW",
			uri: "spotify:track:6wIvFp0zpLlFC1FO91bimW",
			track_href: "https://api.spotify.com/v1/tracks/6wIvFp0zpLlFC1FO91bimW",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6wIvFp0zpLlFC1FO91bimW",
			duration_ms: 180079,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6TaaqqCMRMSpvNHClfnbEL" },
						href: "https://api.spotify.com/v1/artists/6TaaqqCMRMSpvNHClfnbEL",
						id: "6TaaqqCMRMSpvNHClfnbEL",
						name: "Maduk",
						type: "artist",
						uri: "spotify:artist:6TaaqqCMRMSpvNHClfnbEL"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0icAK90Eiv6ImfkI1k5HQF" },
				href: "https://api.spotify.com/v1/albums/0icAK90Eiv6ImfkI1k5HQF",
				id: "0icAK90Eiv6ImfkI1k5HQF",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27354290571f398bd37e7f19602", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0254290571f398bd37e7f19602", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485154290571f398bd37e7f19602", width: 64 }
				],
				name: "Never Give Up",
				release_date: "2016-04-29",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:0icAK90Eiv6ImfkI1k5HQF"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6TaaqqCMRMSpvNHClfnbEL" },
					href: "https://api.spotify.com/v1/artists/6TaaqqCMRMSpvNHClfnbEL",
					id: "6TaaqqCMRMSpvNHClfnbEL",
					name: "Maduk",
					type: "artist",
					uri: "spotify:artist:6TaaqqCMRMSpvNHClfnbEL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7rKQj8DUrHJcmEnQKCrh1L" },
					href: "https://api.spotify.com/v1/artists/7rKQj8DUrHJcmEnQKCrh1L",
					id: "7rKQj8DUrHJcmEnQKCrh1L",
					name: "MVE",
					type: "artist",
					uri: "spotify:artist:7rKQj8DUrHJcmEnQKCrh1L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 247586,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBCJY1600010" },
			external_urls: { spotify: "https://open.spotify.com/track/2DpfZvnUliPXDoLyamKsDw" },
			href: "https://api.spotify.com/v1/tracks/2DpfZvnUliPXDoLyamKsDw",
			id: "2DpfZvnUliPXDoLyamKsDw",
			is_local: false,
			name: "Falling",
			popularity: 38,
			preview_url: "https://p.scdn.co/mp3-preview/ba4b45c0b68b95b3bbe2e2c593e62326ce9c5116?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 11,
			type: "track",
			uri: "spotify:track:2DpfZvnUliPXDoLyamKsDw"
		},
		features: {
			danceability: 0.468,
			energy: 0.75,
			key: 9,
			loudness: -6.152,
			mode: 1,
			speechiness: 0.0452,
			acousticness: 0.000724,
			instrumentalness: 0.00428,
			liveness: 0.164,
			valence: 0.124,
			tempo: 174,
			type: "audio_features",
			id: "2DpfZvnUliPXDoLyamKsDw",
			uri: "spotify:track:2DpfZvnUliPXDoLyamKsDw",
			track_href: "https://api.spotify.com/v1/tracks/2DpfZvnUliPXDoLyamKsDw",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2DpfZvnUliPXDoLyamKsDw",
			duration_ms: 247586,
			time_signature: 4,
			doubletime: 174
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5O9MafawyW4O2WhJQKXj2d" },
						href: "https://api.spotify.com/v1/artists/5O9MafawyW4O2WhJQKXj2d",
						id: "5O9MafawyW4O2WhJQKXj2d",
						name: "Dustycloud",
						type: "artist",
						uri: "spotify:artist:5O9MafawyW4O2WhJQKXj2d"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6yOb0ocejs7jg4yrQh3FeC" },
				href: "https://api.spotify.com/v1/albums/6yOb0ocejs7jg4yrQh3FeC",
				id: "6yOb0ocejs7jg4yrQh3FeC",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e63e249032d0c1338bc84fea", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e63e249032d0c1338bc84fea", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e63e249032d0c1338bc84fea", width: 64 }
				],
				name: "Auspex EP",
				release_date: "2017-03-28",
				release_date_precision: "day",
				total_tracks: 3,
				type: "album",
				uri: "spotify:album:6yOb0ocejs7jg4yrQh3FeC"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5O9MafawyW4O2WhJQKXj2d" },
					href: "https://api.spotify.com/v1/artists/5O9MafawyW4O2WhJQKXj2d",
					id: "5O9MafawyW4O2WhJQKXj2d",
					name: "Dustycloud",
					type: "artist",
					uri: "spotify:artist:5O9MafawyW4O2WhJQKXj2d"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 286461,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USLD91701289" },
			external_urls: { spotify: "https://open.spotify.com/track/35ioSWQeKnwsyYga5tZTBM" },
			href: "https://api.spotify.com/v1/tracks/35ioSWQeKnwsyYga5tZTBM",
			id: "35ioSWQeKnwsyYga5tZTBM",
			is_local: false,
			name: "Bold",
			popularity: 47,
			preview_url: "https://p.scdn.co/mp3-preview/a6f91bc892b14f8eeb9a810f23e4d6cf5f4740da?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:35ioSWQeKnwsyYga5tZTBM"
		},
		features: {
			danceability: 0.808,
			energy: 0.794,
			key: 1,
			loudness: -3.541,
			mode: 1,
			speechiness: 0.0556,
			acousticness: 0.0146,
			instrumentalness: 0.0138,
			liveness: 0.0667,
			valence: 0.496,
			tempo: 124,
			type: "audio_features",
			id: "35ioSWQeKnwsyYga5tZTBM",
			uri: "spotify:track:35ioSWQeKnwsyYga5tZTBM",
			track_href: "https://api.spotify.com/v1/tracks/35ioSWQeKnwsyYga5tZTBM",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/35ioSWQeKnwsyYga5tZTBM",
			duration_ms: 286462,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "compilation",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/04EzEYc1Q1YHeDMxQAJR2P" },
				href: "https://api.spotify.com/v1/albums/04EzEYc1Q1YHeDMxQAJR2P",
				id: "04EzEYc1Q1YHeDMxQAJR2P",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739129c125ccd828fe58ed0f43", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029129c125ccd828fe58ed0f43", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519129c125ccd828fe58ed0f43", width: 64 }
				],
				name: "We Are Friends, Vol. 6",
				release_date: "2017-03-24",
				release_date_precision: "day",
				total_tracks: 21,
				type: "album",
				uri: "spotify:album:04EzEYc1Q1YHeDMxQAJR2P"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0I7HgbIetYEIweWq7nD6En" },
					href: "https://api.spotify.com/v1/artists/0I7HgbIetYEIweWq7nD6En",
					id: "0I7HgbIetYEIweWq7nD6En",
					name: "Notaker",
					type: "artist",
					uri: "spotify:artist:0I7HgbIetYEIweWq7nD6En"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 275423,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1301262" },
			external_urls: { spotify: "https://open.spotify.com/track/4wAssn566mNw6CWJomzGHB" },
			href: "https://api.spotify.com/v1/tracks/4wAssn566mNw6CWJomzGHB",
			id: "4wAssn566mNw6CWJomzGHB",
			is_local: false,
			name: "Abyss",
			popularity: 35,
			preview_url: "https://p.scdn.co/mp3-preview/327efa26eea3e17da51c54a92a25a06ed229d33f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 14,
			type: "track",
			uri: "spotify:track:4wAssn566mNw6CWJomzGHB"
		},
		features: {
			danceability: 0.607,
			energy: 0.628,
			key: 10,
			loudness: -9.974,
			mode: 0,
			speechiness: 0.0429,
			acousticness: 0.0637,
			instrumentalness: 0.779,
			liveness: 0.413,
			valence: 0.1,
			tempo: 101,
			type: "audio_features",
			id: "4wAssn566mNw6CWJomzGHB",
			uri: "spotify:track:4wAssn566mNw6CWJomzGHB",
			track_href: "https://api.spotify.com/v1/tracks/4wAssn566mNw6CWJomzGHB",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4wAssn566mNw6CWJomzGHB",
			duration_ms: 275424,
			time_signature: 4,
			doubletime: 101
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
						href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
						id: "5FWi1mowu6uiU2ZHwr1rby",
						name: "Feed Me",
						type: "artist",
						uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/28SpkSaiWTx5GgBg25FNNq" },
				href: "https://api.spotify.com/v1/albums/28SpkSaiWTx5GgBg25FNNq",
				id: "28SpkSaiWTx5GgBg25FNNq",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27317dc07317b8f989b2bb838cd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0217dc07317b8f989b2bb838cd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485117dc07317b8f989b2bb838cd", width: 64 }
				],
				name: "Feed Me's Big Adventure",
				release_date: "2011-01-22",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:28SpkSaiWTx5GgBg25FNNq"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
					href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
					id: "5FWi1mowu6uiU2ZHwr1rby",
					name: "Feed Me",
					type: "artist",
					uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7sLv4bED064cYa2XhF85og" },
					href: "https://api.spotify.com/v1/artists/7sLv4bED064cYa2XhF85og",
					id: "7sLv4bED064cYa2XhF85og",
					name: "Tasha Baxter",
					type: "artist",
					uri: "spotify:artist:7sLv4bED064cYa2XhF85og"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 319529,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1000247" },
			external_urls: { spotify: "https://open.spotify.com/track/2fO2ZlFoqhyIwO0Tf0qkt9" },
			href: "https://api.spotify.com/v1/tracks/2fO2ZlFoqhyIwO0Tf0qkt9",
			id: "2fO2ZlFoqhyIwO0Tf0qkt9",
			is_local: false,
			name: "Cloudburn",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/4c3b04f7f8d292cf1242ef89b6885601451ccb0b?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:2fO2ZlFoqhyIwO0Tf0qkt9"
		},
		features: {
			danceability: 0.641,
			energy: 0.756,
			key: 1,
			loudness: -6.689,
			mode: 1,
			speechiness: 0.046,
			acousticness: 0.00698,
			instrumentalness: 0.014,
			liveness: 0.0965,
			valence: 0.313,
			tempo: 140,
			type: "audio_features",
			id: "2fO2ZlFoqhyIwO0Tf0qkt9",
			uri: "spotify:track:2fO2ZlFoqhyIwO0Tf0qkt9",
			track_href: "https://api.spotify.com/v1/tracks/2fO2ZlFoqhyIwO0Tf0qkt9",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2fO2ZlFoqhyIwO0Tf0qkt9",
			duration_ms: 319530,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
						href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
						id: "5FWi1mowu6uiU2ZHwr1rby",
						name: "Feed Me",
						type: "artist",
						uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2x4G5Xs71NyrgjFmpTHM9h" },
				href: "https://api.spotify.com/v1/albums/2x4G5Xs71NyrgjFmpTHM9h",
				id: "2x4G5Xs71NyrgjFmpTHM9h",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e572be8fb294bf7338f5789f", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e572be8fb294bf7338f5789f", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e572be8fb294bf7338f5789f", width: 64 }
				],
				name: "Death By Robot",
				release_date: "2013-01-16",
				release_date_precision: "day",
				total_tracks: 3,
				type: "album",
				uri: "spotify:album:2x4G5Xs71NyrgjFmpTHM9h"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
					href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
					id: "5FWi1mowu6uiU2ZHwr1rby",
					name: "Feed Me",
					type: "artist",
					uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 329489,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1300531" },
			external_urls: { spotify: "https://open.spotify.com/track/29LgXO7ZRxiQ7RSGyLyRSm" },
			href: "https://api.spotify.com/v1/tracks/29LgXO7ZRxiQ7RSGyLyRSm",
			id: "29LgXO7ZRxiQ7RSGyLyRSm",
			is_local: false,
			name: "Gravel",
			popularity: 24,
			preview_url: "https://p.scdn.co/mp3-preview/e1c3c634bfdd38e9e71f50643c1ead3e579f6d1f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:29LgXO7ZRxiQ7RSGyLyRSm"
		},
		features: {
			danceability: 0.684,
			energy: 0.849,
			key: 1,
			loudness: -5.667,
			mode: 1,
			speechiness: 0.407,
			acousticness: 0.0344,
			instrumentalness: 0.516,
			liveness: 0.181,
			valence: 0.723,
			tempo: 128,
			type: "audio_features",
			id: "29LgXO7ZRxiQ7RSGyLyRSm",
			uri: "spotify:track:29LgXO7ZRxiQ7RSGyLyRSm",
			track_href: "https://api.spotify.com/v1/tracks/29LgXO7ZRxiQ7RSGyLyRSm",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/29LgXO7ZRxiQ7RSGyLyRSm",
			duration_ms: 329489,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
						href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
						id: "5FWi1mowu6uiU2ZHwr1rby",
						name: "Feed Me",
						type: "artist",
						uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5pURjDtRUYX2TqW8A0DhT3" },
				href: "https://api.spotify.com/v1/albums/5pURjDtRUYX2TqW8A0DhT3",
				id: "5pURjDtRUYX2TqW8A0DhT3",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e1944628e06d559df3d2e568", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e1944628e06d559df3d2e568", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e1944628e06d559df3d2e568", width: 64 }
				],
				name: "Feed Me's Escape from Electric Mountain",
				release_date: "2012-02-06",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:5pURjDtRUYX2TqW8A0DhT3"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
					href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
					id: "5FWi1mowu6uiU2ZHwr1rby",
					name: "Feed Me",
					type: "artist",
					uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 335098,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1100416" },
			external_urls: { spotify: "https://open.spotify.com/track/76Kue8CxsgmLL0WBlsGDhG" },
			href: "https://api.spotify.com/v1/tracks/76Kue8CxsgmLL0WBlsGDhG",
			id: "76Kue8CxsgmLL0WBlsGDhG",
			is_local: false,
			name: "Relocation",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/f71f974150d6a238edbeb35f38858a02e69edcfb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:76Kue8CxsgmLL0WBlsGDhG"
		},
		features: {
			danceability: 0.39,
			energy: 0.653,
			key: 1,
			loudness: -7.494,
			mode: 0,
			speechiness: 0.0288,
			acousticness: 0.0217,
			instrumentalness: 0.932,
			liveness: 0.111,
			valence: 0.0469,
			tempo: 128,
			type: "audio_features",
			id: "76Kue8CxsgmLL0WBlsGDhG",
			uri: "spotify:track:76Kue8CxsgmLL0WBlsGDhG",
			track_href: "https://api.spotify.com/v1/tracks/76Kue8CxsgmLL0WBlsGDhG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/76Kue8CxsgmLL0WBlsGDhG",
			duration_ms: 335099,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/26VFTg2z8YR0cCuwLzESi2" },
						href: "https://api.spotify.com/v1/artists/26VFTg2z8YR0cCuwLzESi2",
						id: "26VFTg2z8YR0cCuwLzESi2",
						name: "Halsey",
						type: "artist",
						uri: "spotify:artist:26VFTg2z8YR0cCuwLzESi2"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7CajNmpbOovFoOoasH2HaY" },
						href: "https://api.spotify.com/v1/artists/7CajNmpbOovFoOoasH2HaY",
						id: "7CajNmpbOovFoOoasH2HaY",
						name: "Calvin Harris",
						type: "artist",
						uri: "spotify:artist:7CajNmpbOovFoOoasH2HaY"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2ExGrw6XpbtUAJHTLtUXUD" },
						href: "https://api.spotify.com/v1/artists/2ExGrw6XpbtUAJHTLtUXUD",
						id: "2ExGrw6XpbtUAJHTLtUXUD",
						name: "Stefflon Don",
						type: "artist",
						uri: "spotify:artist:2ExGrw6XpbtUAJHTLtUXUD"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2RLbKom2FQkaes7qf3xLoa" },
				href: "https://api.spotify.com/v1/albums/2RLbKom2FQkaes7qf3xLoa",
				id: "2RLbKom2FQkaes7qf3xLoa",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e78ca25a967d525711df9cfe", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e78ca25a967d525711df9cfe", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e78ca25a967d525711df9cfe", width: 64 }
				],
				name: "Alone (Calvin Harris Remix) (Feat. Stefflon Don)",
				release_date: "2018-04-20",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:2RLbKom2FQkaes7qf3xLoa"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/26VFTg2z8YR0cCuwLzESi2" },
					href: "https://api.spotify.com/v1/artists/26VFTg2z8YR0cCuwLzESi2",
					id: "26VFTg2z8YR0cCuwLzESi2",
					name: "Halsey",
					type: "artist",
					uri: "spotify:artist:26VFTg2z8YR0cCuwLzESi2"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2ExGrw6XpbtUAJHTLtUXUD" },
					href: "https://api.spotify.com/v1/artists/2ExGrw6XpbtUAJHTLtUXUD",
					id: "2ExGrw6XpbtUAJHTLtUXUD",
					name: "Stefflon Don",
					type: "artist",
					uri: "spotify:artist:2ExGrw6XpbtUAJHTLtUXUD"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7CajNmpbOovFoOoasH2HaY" },
					href: "https://api.spotify.com/v1/artists/7CajNmpbOovFoOoasH2HaY",
					id: "7CajNmpbOovFoOoasH2HaY",
					name: "Calvin Harris",
					type: "artist",
					uri: "spotify:artist:7CajNmpbOovFoOoasH2HaY"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 199199,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USUM71804468" },
			external_urls: { spotify: "https://open.spotify.com/track/5K09638EBQjVMrZYXA89aC" },
			href: "https://api.spotify.com/v1/tracks/5K09638EBQjVMrZYXA89aC",
			id: "5K09638EBQjVMrZYXA89aC",
			is_local: false,
			name: "Alone (Calvin Harris Remix) (Feat. Stefflon Don)",
			popularity: 59,
			preview_url: "https://p.scdn.co/mp3-preview/aec75afc91309674e403e916982f69c074430e8f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5K09638EBQjVMrZYXA89aC"
		},
		features: {
			danceability: 0.829,
			energy: 0.819,
			key: 2,
			loudness: -3.43,
			mode: 0,
			speechiness: 0.131,
			acousticness: 0.137,
			instrumentalness: 0.00792,
			liveness: 0.282,
			valence: 0.35,
			tempo: 124,
			type: "audio_features",
			id: "5K09638EBQjVMrZYXA89aC",
			uri: "spotify:track:5K09638EBQjVMrZYXA89aC",
			track_href: "https://api.spotify.com/v1/tracks/5K09638EBQjVMrZYXA89aC",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5K09638EBQjVMrZYXA89aC",
			duration_ms: 199199,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3wl1SNzJlCXLGpeKcGlHqL" },
						href: "https://api.spotify.com/v1/artists/3wl1SNzJlCXLGpeKcGlHqL",
						id: "3wl1SNzJlCXLGpeKcGlHqL",
						name: "Hagrid",
						type: "artist",
						uri: "spotify:artist:3wl1SNzJlCXLGpeKcGlHqL"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/4P2MWE7JhEjfnMKtDMp2y0" },
				href: "https://api.spotify.com/v1/albums/4P2MWE7JhEjfnMKtDMp2y0",
				id: "4P2MWE7JhEjfnMKtDMp2y0",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730252223ed0a8607e4e52d3ca", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020252223ed0a8607e4e52d3ca", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510252223ed0a8607e4e52d3ca", width: 64 }
				],
				name: "Hagrid the Giant (feat. Ron)",
				release_date: "2019-04-13",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4P2MWE7JhEjfnMKtDMp2y0"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7aB2KbM3pphL9mU3dXbyh2" },
					href: "https://api.spotify.com/v1/artists/7aB2KbM3pphL9mU3dXbyh2",
					id: "7aB2KbM3pphL9mU3dXbyh2",
					name: "Far Out",
					type: "artist",
					uri: "spotify:artist:7aB2KbM3pphL9mU3dXbyh2"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6heMlLFM6RDDHRz99uKMqS" },
					href: "https://api.spotify.com/v1/artists/6heMlLFM6RDDHRz99uKMqS",
					id: "6heMlLFM6RDDHRz99uKMqS",
					name: "RetroVision",
					type: "artist",
					uri: "spotify:artist:6heMlLFM6RDDHRz99uKMqS"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/24CzPFC4y3bM4AkUnZfuAU" },
					href: "https://api.spotify.com/v1/artists/24CzPFC4y3bM4AkUnZfuAU",
					id: "24CzPFC4y3bM4AkUnZfuAU",
					name: "Karra",
					type: "artist",
					uri: "spotify:artist:24CzPFC4y3bM4AkUnZfuAU"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 204375,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USLZJ1812581" },
			external_urls: { spotify: "https://open.spotify.com/track/1coa6o9ko4mdpFajF6daS4" },
			href: "https://api.spotify.com/v1/tracks/1coa6o9ko4mdpFajF6daS4",
			id: "1coa6o9ko4mdpFajF6daS4",
			is_local: false,
			name: "Truest Lies (feat. Karra) - Retrovision Remix",
			popularity: 1,
			preview_url: null,
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:1coa6o9ko4mdpFajF6daS4"
		},
		features: {
			danceability: 0.58,
			energy: 0.83,
			key: 2,
			loudness: -5.756,
			mode: 1,
			speechiness: 0.143,
			acousticness: 0.211,
			instrumentalness: 0,
			liveness: 0.147,
			valence: 0.267,
			tempo: 128,
			type: "audio_features",
			id: "1coa6o9ko4mdpFajF6daS4",
			uri: "spotify:track:1coa6o9ko4mdpFajF6daS4",
			track_href: "https://api.spotify.com/v1/tracks/1coa6o9ko4mdpFajF6daS4",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1coa6o9ko4mdpFajF6daS4",
			duration_ms: 204375,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4BKyei61gtyDFxlKhcvBJJ" },
						href: "https://api.spotify.com/v1/artists/4BKyei61gtyDFxlKhcvBJJ",
						id: "4BKyei61gtyDFxlKhcvBJJ",
						name: "Celldweller",
						type: "artist",
						uri: "spotify:artist:4BKyei61gtyDFxlKhcvBJJ"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/40WIa01eubnEVkxUHeDZyF" },
						href: "https://api.spotify.com/v1/artists/40WIa01eubnEVkxUHeDZyF",
						id: "40WIa01eubnEVkxUHeDZyF",
						name: "Au5",
						type: "artist",
						uri: "spotify:artist:40WIa01eubnEVkxUHeDZyF"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4SumJoNyCnffSQChGOlceH" },
				href: "https://api.spotify.com/v1/albums/4SumJoNyCnffSQChGOlceH",
				id: "4SumJoNyCnffSQChGOlceH",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273cda06a56f221683b6338088e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02cda06a56f221683b6338088e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851cda06a56f221683b6338088e", width: 64 }
				],
				name: "Eon (Au5 Remix)",
				release_date: "2018-10-25",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4SumJoNyCnffSQChGOlceH"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4BKyei61gtyDFxlKhcvBJJ" },
					href: "https://api.spotify.com/v1/artists/4BKyei61gtyDFxlKhcvBJJ",
					id: "4BKyei61gtyDFxlKhcvBJJ",
					name: "Celldweller",
					type: "artist",
					uri: "spotify:artist:4BKyei61gtyDFxlKhcvBJJ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/40WIa01eubnEVkxUHeDZyF" },
					href: "https://api.spotify.com/v1/artists/40WIa01eubnEVkxUHeDZyF",
					id: "40WIa01eubnEVkxUHeDZyF",
					name: "Au5",
					type: "artist",
					uri: "spotify:artist:40WIa01eubnEVkxUHeDZyF"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 411789,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QM5LC1800319" },
			external_urls: { spotify: "https://open.spotify.com/track/3Ol8ZL9iaL4IfaSi7eTLTe" },
			href: "https://api.spotify.com/v1/tracks/3Ol8ZL9iaL4IfaSi7eTLTe",
			id: "3Ol8ZL9iaL4IfaSi7eTLTe",
			is_local: false,
			name: "Eon - Au5 Remix",
			popularity: 38,
			preview_url: "https://p.scdn.co/mp3-preview/4e204331d6aa012481740066ee0834d85cae48f4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3Ol8ZL9iaL4IfaSi7eTLTe"
		},
		features: {
			danceability: 0.519,
			energy: 0.905,
			key: 5,
			loudness: -5.735,
			mode: 0,
			speechiness: 0.0973,
			acousticness: 0.00465,
			instrumentalness: 0.0352,
			liveness: 0.071,
			valence: 0.114,
			tempo: 95,
			type: "audio_features",
			id: "3Ol8ZL9iaL4IfaSi7eTLTe",
			uri: "spotify:track:3Ol8ZL9iaL4IfaSi7eTLTe",
			track_href: "https://api.spotify.com/v1/tracks/3Ol8ZL9iaL4IfaSi7eTLTe",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3Ol8ZL9iaL4IfaSi7eTLTe",
			duration_ms: 411790,
			time_signature: 4,
			doubletime: 190
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
						href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
						id: "0SfsnGyD8FpIN4U4WCkBZ5",
						name: "Armin van Buuren",
						type: "artist",
						uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/66AE89GQTx88zLYhXn1wFK" },
						href: "https://api.spotify.com/v1/artists/66AE89GQTx88zLYhXn1wFK",
						id: "66AE89GQTx88zLYhXn1wFK",
						name: "Sam Martin",
						type: "artist",
						uri: "spotify:artist:66AE89GQTx88zLYhXn1wFK"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"BG",
					"BH",
					"BO",
					"BR",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DO",
					"DZ",
					"EC",
					"EG",
					"ES",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"SA",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0q52JLsFDkzToKF78irkss" },
				href: "https://api.spotify.com/v1/albums/0q52JLsFDkzToKF78irkss",
				id: "0q52JLsFDkzToKF78irkss",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f197fe78de0c1e1b69f85f00", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f197fe78de0c1e1b69f85f00", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f197fe78de0c1e1b69f85f00", width: 64 }
				],
				name: "Wild Wild Son (Club Mix)",
				release_date: "2018-10-19",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0q52JLsFDkzToKF78irkss"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
					href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
					id: "0SfsnGyD8FpIN4U4WCkBZ5",
					name: "Armin van Buuren",
					type: "artist",
					uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/66AE89GQTx88zLYhXn1wFK" },
					href: "https://api.spotify.com/v1/artists/66AE89GQTx88zLYhXn1wFK",
					id: "66AE89GQTx88zLYhXn1wFK",
					name: "Sam Martin",
					type: "artist",
					uri: "spotify:artist:66AE89GQTx88zLYhXn1wFK"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"BG",
				"BH",
				"BO",
				"BR",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DO",
				"DZ",
				"EC",
				"EG",
				"ES",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"SA",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 218200,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLF711811833" },
			external_urls: { spotify: "https://open.spotify.com/track/45Lu4PnbPH7fARZ82nMS3P" },
			href: "https://api.spotify.com/v1/tracks/45Lu4PnbPH7fARZ82nMS3P",
			id: "45Lu4PnbPH7fARZ82nMS3P",
			is_local: false,
			name: "Wild Wild Son - Club Mix",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/c2b99bc44781c6bf82670638695f51d80ff0ba82?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:45Lu4PnbPH7fARZ82nMS3P"
		},
		features: {
			danceability: 0.526,
			energy: 0.867,
			key: 5,
			loudness: -4.332,
			mode: 0,
			speechiness: 0.0659,
			acousticness: 0.00138,
			instrumentalness: 0.00064,
			liveness: 0.0975,
			valence: 0.12,
			tempo: 132,
			type: "audio_features",
			id: "45Lu4PnbPH7fARZ82nMS3P",
			uri: "spotify:track:45Lu4PnbPH7fARZ82nMS3P",
			track_href: "https://api.spotify.com/v1/tracks/45Lu4PnbPH7fARZ82nMS3P",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/45Lu4PnbPH7fARZ82nMS3P",
			duration_ms: 218200,
			time_signature: 4,
			doubletime: 132
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
						href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
						id: "10gzBoINW3cLJfZUka8Zoe",
						name: "Above & Beyond",
						type: "artist",
						uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3Wy0lPBBhFeSzeRU7AHMPr" },
				href: "https://api.spotify.com/v1/albums/3Wy0lPBBhFeSzeRU7AHMPr",
				id: "3Wy0lPBBhFeSzeRU7AHMPr",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273942567c077bc83eefe7b04bf", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02942567c077bc83eefe7b04bf", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851942567c077bc83eefe7b04bf", width: 64 }
				],
				name: "Rocket Science",
				release_date: "2018-09-07",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:3Wy0lPBBhFeSzeRU7AHMPr"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
					href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
					id: "10gzBoINW3cLJfZUka8Zoe",
					name: "Above & Beyond",
					type: "artist",
					uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 240000,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA1802470" },
			external_urls: { spotify: "https://open.spotify.com/track/6VN1zOfBxBHp2m2lPv42dG" },
			href: "https://api.spotify.com/v1/tracks/6VN1zOfBxBHp2m2lPv42dG",
			id: "6VN1zOfBxBHp2m2lPv42dG",
			is_local: false,
			name: "Rocket Science - Edit",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/5dfb627aa119412f81d12dbe5f4000d72e5ed3e9?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6VN1zOfBxBHp2m2lPv42dG"
		},
		features: {
			danceability: 0.565,
			energy: 0.77,
			key: 11,
			loudness: -6.843,
			mode: 0,
			speechiness: 0.0558,
			acousticness: 0.00637,
			instrumentalness: 0.91,
			liveness: 0.325,
			valence: 0.208,
			tempo: 128,
			type: "audio_features",
			id: "6VN1zOfBxBHp2m2lPv42dG",
			uri: "spotify:track:6VN1zOfBxBHp2m2lPv42dG",
			track_href: "https://api.spotify.com/v1/tracks/6VN1zOfBxBHp2m2lPv42dG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6VN1zOfBxBHp2m2lPv42dG",
			duration_ms: 240000,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
						href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
						id: "10gzBoINW3cLJfZUka8Zoe",
						name: "Above & Beyond",
						type: "artist",
						uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0qkneTDjJOJuBhHtHZ5NUT" },
				href: "https://api.spotify.com/v1/albums/0qkneTDjJOJuBhHtHZ5NUT",
				id: "0qkneTDjJOJuBhHtHZ5NUT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273cb76d19793aa34ce54ece7f9", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02cb76d19793aa34ce54ece7f9", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851cb76d19793aa34ce54ece7f9", width: 64 }
				],
				name: "Group Therapy 300 Live from Hong Kong (ABGT300)",
				release_date: "2018-10-05",
				release_date_precision: "day",
				total_tracks: 26,
				type: "album",
				uri: "spotify:album:0qkneTDjJOJuBhHtHZ5NUT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2Npo4Cfm48M2uKlvxiXMic" },
					href: "https://api.spotify.com/v1/artists/2Npo4Cfm48M2uKlvxiXMic",
					id: "2Npo4Cfm48M2uKlvxiXMic",
					name: "Oliver Smith",
					type: "artist",
					uri: "spotify:artist:2Npo4Cfm48M2uKlvxiXMic"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 268046,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA1802989" },
			external_urls: { spotify: "https://open.spotify.com/track/1VzgL3FggMbmCOpIqXdmsg" },
			href: "https://api.spotify.com/v1/tracks/1VzgL3FggMbmCOpIqXdmsg",
			id: "1VzgL3FggMbmCOpIqXdmsg",
			is_local: false,
			name: "Over You (ABGT300)",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/2afe1fb41e02e85ca0d900b0a0b3bcd706f3e2eb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 20,
			type: "track",
			uri: "spotify:track:1VzgL3FggMbmCOpIqXdmsg"
		},
		features: {
			danceability: 0.69,
			energy: 0.697,
			key: 11,
			loudness: -9.605,
			mode: 1,
			speechiness: 0.0353,
			acousticness: 0.000974,
			instrumentalness: 0.598,
			liveness: 0.124,
			valence: 0.246,
			tempo: 129,
			type: "audio_features",
			id: "1VzgL3FggMbmCOpIqXdmsg",
			uri: "spotify:track:1VzgL3FggMbmCOpIqXdmsg",
			track_href: "https://api.spotify.com/v1/tracks/1VzgL3FggMbmCOpIqXdmsg",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1VzgL3FggMbmCOpIqXdmsg",
			duration_ms: 268046,
			time_signature: 4,
			doubletime: 129
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
						href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
						id: "10gzBoINW3cLJfZUka8Zoe",
						name: "Above & Beyond",
						type: "artist",
						uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0qkneTDjJOJuBhHtHZ5NUT" },
				href: "https://api.spotify.com/v1/albums/0qkneTDjJOJuBhHtHZ5NUT",
				id: "0qkneTDjJOJuBhHtHZ5NUT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273cb76d19793aa34ce54ece7f9", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02cb76d19793aa34ce54ece7f9", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851cb76d19793aa34ce54ece7f9", width: 64 }
				],
				name: "Group Therapy 300 Live from Hong Kong (ABGT300)",
				release_date: "2018-10-05",
				release_date_precision: "day",
				total_tracks: 26,
				type: "album",
				uri: "spotify:album:0qkneTDjJOJuBhHtHZ5NUT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
					href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
					id: "10gzBoINW3cLJfZUka8Zoe",
					name: "Above & Beyond",
					type: "artist",
					uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0JtMH7U9d7Z8pOSBz2U8Wn" },
					href: "https://api.spotify.com/v1/artists/0JtMH7U9d7Z8pOSBz2U8Wn",
					id: "0JtMH7U9d7Z8pOSBz2U8Wn",
					name: "Marty Longstaff",
					type: "artist",
					uri: "spotify:artist:0JtMH7U9d7Z8pOSBz2U8Wn"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 364743,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA1802992" },
			external_urls: { spotify: "https://open.spotify.com/track/0TEW7oRDKD2mjJQH507ni4" },
			href: "https://api.spotify.com/v1/tracks/0TEW7oRDKD2mjJQH507ni4",
			id: "0TEW7oRDKD2mjJQH507ni4",
			is_local: false,
			name: "Flying by Candlelight (ABGT300) - Above & Beyond Club Mix",
			popularity: 47,
			preview_url: "https://p.scdn.co/mp3-preview/504f1d078dedb34c08ae23e60495a2e6100eec62?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 23,
			type: "track",
			uri: "spotify:track:0TEW7oRDKD2mjJQH507ni4"
		},
		features: {
			danceability: 0.532,
			energy: 0.664,
			key: 1,
			loudness: -9.804,
			mode: 1,
			speechiness: 0.0603,
			acousticness: 0.000312,
			instrumentalness: 0.0427,
			liveness: 0.303,
			valence: 0.075,
			tempo: 129,
			type: "audio_features",
			id: "0TEW7oRDKD2mjJQH507ni4",
			uri: "spotify:track:0TEW7oRDKD2mjJQH507ni4",
			track_href: "https://api.spotify.com/v1/tracks/0TEW7oRDKD2mjJQH507ni4",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0TEW7oRDKD2mjJQH507ni4",
			duration_ms: 364744,
			time_signature: 4,
			doubletime: 129
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2AmHV6vxRxvHdlxSHxnHE9" },
						href: "https://api.spotify.com/v1/artists/2AmHV6vxRxvHdlxSHxnHE9",
						id: "2AmHV6vxRxvHdlxSHxnHE9",
						name: "Matt Lange",
						type: "artist",
						uri: "spotify:artist:2AmHV6vxRxvHdlxSHxnHE9"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/7ryRiJ6X5Wy4OLWHyu9sym" },
				href: "https://api.spotify.com/v1/albums/7ryRiJ6X5Wy4OLWHyu9sym",
				id: "7ryRiJ6X5Wy4OLWHyu9sym",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27365e9c3fa7d32b510c830dfef", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0265e9c3fa7d32b510c830dfef", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485165e9c3fa7d32b510c830dfef", width: 64 }
				],
				name: "Bleed Together",
				release_date: "2017-12-13",
				release_date_precision: "day",
				total_tracks: 3,
				type: "album",
				uri: "spotify:album:7ryRiJ6X5Wy4OLWHyu9sym"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2AmHV6vxRxvHdlxSHxnHE9" },
					href: "https://api.spotify.com/v1/artists/2AmHV6vxRxvHdlxSHxnHE9",
					id: "2AmHV6vxRxvHdlxSHxnHE9",
					name: "Matt Lange",
					type: "artist",
					uri: "spotify:artist:2AmHV6vxRxvHdlxSHxnHE9"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 304560,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBKPL1792734" },
			external_urls: { spotify: "https://open.spotify.com/track/5TUTwtLNT5XvalvChApSlh" },
			href: "https://api.spotify.com/v1/tracks/5TUTwtLNT5XvalvChApSlh",
			id: "5TUTwtLNT5XvalvChApSlh",
			is_local: false,
			name: "Bleed Together",
			popularity: 25,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5TUTwtLNT5XvalvChApSlh"
		},
		features: {
			danceability: 0.482,
			energy: 0.597,
			key: 6,
			loudness: -7.243,
			mode: 0,
			speechiness: 0.0312,
			acousticness: 0.000561,
			instrumentalness: 0.000619,
			liveness: 0.104,
			valence: 0.277,
			tempo: 77,
			type: "audio_features",
			id: "5TUTwtLNT5XvalvChApSlh",
			uri: "spotify:track:5TUTwtLNT5XvalvChApSlh",
			track_href: "https://api.spotify.com/v1/tracks/5TUTwtLNT5XvalvChApSlh",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5TUTwtLNT5XvalvChApSlh",
			duration_ms: 304560,
			time_signature: 4,
			doubletime: 154
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/18fX4a2lpLLHmvJO2a5NkA" },
						href: "https://api.spotify.com/v1/artists/18fX4a2lpLLHmvJO2a5NkA",
						id: "18fX4a2lpLLHmvJO2a5NkA",
						name: "Chee",
						type: "artist",
						uri: "spotify:artist:18fX4a2lpLLHmvJO2a5NkA"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2FeBQXQHmYu9sSh2NbHuAl" },
				href: "https://api.spotify.com/v1/albums/2FeBQXQHmYu9sSh2NbHuAl",
				id: "2FeBQXQHmYu9sSh2NbHuAl",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730b6cd846a57b2cf70f83341c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020b6cd846a57b2cf70f83341c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510b6cd846a57b2cf70f83341c", width: 64 }
				],
				name: "Aggressive Generosity EP",
				release_date: "2018-09-05",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:2FeBQXQHmYu9sSh2NbHuAl"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/18fX4a2lpLLHmvJO2a5NkA" },
					href: "https://api.spotify.com/v1/artists/18fX4a2lpLLHmvJO2a5NkA",
					id: "18fX4a2lpLLHmvJO2a5NkA",
					name: "Chee",
					type: "artist",
					uri: "spotify:artist:18fX4a2lpLLHmvJO2a5NkA"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 198000,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CA5KR1821793" },
			external_urls: { spotify: "https://open.spotify.com/track/5WFJRmqawwVpZKJmyv62Tz" },
			href: "https://api.spotify.com/v1/tracks/5WFJRmqawwVpZKJmyv62Tz",
			id: "5WFJRmqawwVpZKJmyv62Tz",
			is_local: false,
			name: "Midnight",
			popularity: 23,
			preview_url: "https://p.scdn.co/mp3-preview/595868b98c38d1b624dc41bbb2e3104c86df5ac5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:5WFJRmqawwVpZKJmyv62Tz"
		},
		features: {
			danceability: 0.57,
			energy: 0.951,
			key: 5,
			loudness: -4.127,
			mode: 1,
			speechiness: 0.654,
			acousticness: 0.00199,
			instrumentalness: 0.000336,
			liveness: 0.265,
			valence: 0.349,
			tempo: 160,
			type: "audio_features",
			id: "5WFJRmqawwVpZKJmyv62Tz",
			uri: "spotify:track:5WFJRmqawwVpZKJmyv62Tz",
			track_href: "https://api.spotify.com/v1/tracks/5WFJRmqawwVpZKJmyv62Tz",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5WFJRmqawwVpZKJmyv62Tz",
			duration_ms: 198000,
			time_signature: 4,
			doubletime: 160
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3QqJ1L8cWsPFZ1YDPpUmvG" },
						href: "https://api.spotify.com/v1/artists/3QqJ1L8cWsPFZ1YDPpUmvG",
						id: "3QqJ1L8cWsPFZ1YDPpUmvG",
						name: "Gemini",
						type: "artist",
						uri: "spotify:artist:3QqJ1L8cWsPFZ1YDPpUmvG"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6YOdWyXAj6HYE5eaeyp49Z" },
				href: "https://api.spotify.com/v1/albums/6YOdWyXAj6HYE5eaeyp49Z",
				id: "6YOdWyXAj6HYE5eaeyp49Z",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ece35e6fee434c7ba64fbdc7", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ece35e6fee434c7ba64fbdc7", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ece35e6fee434c7ba64fbdc7", width: 64 }
				],
				name: "Graduation",
				release_date: "2011-09-19",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:6YOdWyXAj6HYE5eaeyp49Z"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3QqJ1L8cWsPFZ1YDPpUmvG" },
					href: "https://api.spotify.com/v1/artists/3QqJ1L8cWsPFZ1YDPpUmvG",
					id: "3QqJ1L8cWsPFZ1YDPpUmvG",
					name: "Gemini",
					type: "artist",
					uri: "spotify:artist:3QqJ1L8cWsPFZ1YDPpUmvG"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 308526,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBS5E1100011" },
			external_urls: { spotify: "https://open.spotify.com/track/1edWTWKaxtGeyXVRzQ1iND" },
			href: "https://api.spotify.com/v1/tracks/1edWTWKaxtGeyXVRzQ1iND",
			id: "1edWTWKaxtGeyXVRzQ1iND",
			is_local: false,
			name: "H.A.T.D",
			popularity: 21,
			preview_url: "https://p.scdn.co/mp3-preview/08ee366a2ae8f58785194fbe1e2f4aafbf9c2ae5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:1edWTWKaxtGeyXVRzQ1iND"
		},
		features: {
			danceability: 0.671,
			energy: 0.957,
			key: 2,
			loudness: -3.243,
			mode: 1,
			speechiness: 0.192,
			acousticness: 0.00256,
			instrumentalness: 0.109,
			liveness: 0.441,
			valence: 0.303,
			tempo: 110,
			type: "audio_features",
			id: "1edWTWKaxtGeyXVRzQ1iND",
			uri: "spotify:track:1edWTWKaxtGeyXVRzQ1iND",
			track_href: "https://api.spotify.com/v1/tracks/1edWTWKaxtGeyXVRzQ1iND",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1edWTWKaxtGeyXVRzQ1iND",
			duration_ms: 308526,
			time_signature: 4,
			doubletime: 110
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1tRsdSvjwp34PDvcmix6SJ" },
						href: "https://api.spotify.com/v1/artists/1tRsdSvjwp34PDvcmix6SJ",
						id: "1tRsdSvjwp34PDvcmix6SJ",
						name: "Karma Fields",
						type: "artist",
						uri: "spotify:artist:1tRsdSvjwp34PDvcmix6SJ"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0MoXIHcFwhIWnFgBfdvQ30" },
						href: "https://api.spotify.com/v1/artists/0MoXIHcFwhIWnFgBfdvQ30",
						id: "0MoXIHcFwhIWnFgBfdvQ30",
						name: "Little Boots",
						type: "artist",
						uri: "spotify:artist:0MoXIHcFwhIWnFgBfdvQ30"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/60Ube9bT8gge7XygaIRvUP" },
				href: "https://api.spotify.com/v1/albums/60Ube9bT8gge7XygaIRvUP",
				id: "60Ube9bT8gge7XygaIRvUP",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273af02a1de2b0f47c68113a436", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02af02a1de2b0f47c68113a436", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851af02a1de2b0f47c68113a436", width: 64 }
				],
				name: "You and Me",
				release_date: "2018-07-27",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:60Ube9bT8gge7XygaIRvUP"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1tRsdSvjwp34PDvcmix6SJ" },
					href: "https://api.spotify.com/v1/artists/1tRsdSvjwp34PDvcmix6SJ",
					id: "1tRsdSvjwp34PDvcmix6SJ",
					name: "Karma Fields",
					type: "artist",
					uri: "spotify:artist:1tRsdSvjwp34PDvcmix6SJ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0MoXIHcFwhIWnFgBfdvQ30" },
					href: "https://api.spotify.com/v1/artists/0MoXIHcFwhIWnFgBfdvQ30",
					id: "0MoXIHcFwhIWnFgBfdvQ30",
					name: "Little Boots",
					type: "artist",
					uri: "spotify:artist:0MoXIHcFwhIWnFgBfdvQ30"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 221444,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBKPL1813957" },
			external_urls: { spotify: "https://open.spotify.com/track/6ntme7WniJvsVFkLylyNQ8" },
			href: "https://api.spotify.com/v1/tracks/6ntme7WniJvsVFkLylyNQ8",
			id: "6ntme7WniJvsVFkLylyNQ8",
			is_local: false,
			name: "You and Me",
			popularity: 17,
			preview_url: "https://p.scdn.co/mp3-preview/181cb4259188cecd986d46bfef729cff5134a5b2?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:6ntme7WniJvsVFkLylyNQ8"
		},
		features: {
			danceability: 0.747,
			energy: 0.806,
			key: 10,
			loudness: -7.474,
			mode: 0,
			speechiness: 0.152,
			acousticness: 0.00608,
			instrumentalness: 0.00349,
			liveness: 0.0937,
			valence: 0.612,
			tempo: 110,
			type: "audio_features",
			id: "6ntme7WniJvsVFkLylyNQ8",
			uri: "spotify:track:6ntme7WniJvsVFkLylyNQ8",
			track_href: "https://api.spotify.com/v1/tracks/6ntme7WniJvsVFkLylyNQ8",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6ntme7WniJvsVFkLylyNQ8",
			duration_ms: 221444,
			time_signature: 4,
			doubletime: 110
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4BKyei61gtyDFxlKhcvBJJ" },
						href: "https://api.spotify.com/v1/artists/4BKyei61gtyDFxlKhcvBJJ",
						id: "4BKyei61gtyDFxlKhcvBJJ",
						name: "Celldweller",
						type: "artist",
						uri: "spotify:artist:4BKyei61gtyDFxlKhcvBJJ"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3bZQMYFzgQbk1uhPhCizFG" },
				href: "https://api.spotify.com/v1/albums/3bZQMYFzgQbk1uhPhCizFG",
				id: "3bZQMYFzgQbk1uhPhCizFG",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2730b1a248b603175e4fbf12f5c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e020b1a248b603175e4fbf12f5c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048510b1a248b603175e4fbf12f5c", width: 64 }
				],
				name: "Cry Little Sister vs. Hello Zepp",
				release_date: "2018-12-17",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:3bZQMYFzgQbk1uhPhCizFG"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4BKyei61gtyDFxlKhcvBJJ" },
					href: "https://api.spotify.com/v1/artists/4BKyei61gtyDFxlKhcvBJJ",
					id: "4BKyei61gtyDFxlKhcvBJJ",
					name: "Celldweller",
					type: "artist",
					uri: "spotify:artist:4BKyei61gtyDFxlKhcvBJJ"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 303642,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QM5LC1800377" },
			external_urls: { spotify: "https://open.spotify.com/track/3XLcHyh8dr65qWzaW194WM" },
			href: "https://api.spotify.com/v1/tracks/3XLcHyh8dr65qWzaW194WM",
			id: "3XLcHyh8dr65qWzaW194WM",
			is_local: false,
			name: "Cry Little Sister vs. Hello Zepp",
			popularity: 31,
			preview_url: "https://p.scdn.co/mp3-preview/fc845a2d9657e1499e22ab06707d0f08106d23b4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3XLcHyh8dr65qWzaW194WM"
		},
		features: {
			danceability: 0.545,
			energy: 0.74,
			key: 2,
			loudness: -6.656,
			mode: 1,
			speechiness: 0.0352,
			acousticness: 0.000276,
			instrumentalness: 0.221,
			liveness: 0.388,
			valence: 0.341,
			tempo: 140,
			type: "audio_features",
			id: "3XLcHyh8dr65qWzaW194WM",
			uri: "spotify:track:3XLcHyh8dr65qWzaW194WM",
			track_href: "https://api.spotify.com/v1/tracks/3XLcHyh8dr65qWzaW194WM",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3XLcHyh8dr65qWzaW194WM",
			duration_ms: 303643,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/4v6XOdonnfpdTKTRJArG7v" },
						href: "https://api.spotify.com/v1/artists/4v6XOdonnfpdTKTRJArG7v",
						id: "4v6XOdonnfpdTKTRJArG7v",
						name: "Tink",
						type: "artist",
						uri: "spotify:artist:4v6XOdonnfpdTKTRJArG7v"
					}
				],
				available_markets: ["US"],
				external_urls: { spotify: "https://open.spotify.com/album/57X8pUPWvj9yfg6bUPESGv" },
				href: "https://api.spotify.com/v1/albums/57X8pUPWvj9yfg6bUPESGv",
				id: "57X8pUPWvj9yfg6bUPESGv",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e1b03e1c808a1af0ad908008", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e1b03e1c808a1af0ad908008", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e1b03e1c808a1af0ad908008", width: 64 }
				],
				name: "Wet Dollars",
				release_date: "2015-08-28",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:57X8pUPWvj9yfg6bUPESGv"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4v6XOdonnfpdTKTRJArG7v" },
					href: "https://api.spotify.com/v1/artists/4v6XOdonnfpdTKTRJArG7v",
					id: "4v6XOdonnfpdTKTRJArG7v",
					name: "Tink",
					type: "artist",
					uri: "spotify:artist:4v6XOdonnfpdTKTRJArG7v"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2zVANZpVz1kX1Jy8vlLQcH" },
					href: "https://api.spotify.com/v1/artists/2zVANZpVz1kX1Jy8vlLQcH",
					id: "2zVANZpVz1kX1Jy8vlLQcH",
					name: "Tazer",
					type: "artist",
					uri: "spotify:artist:2zVANZpVz1kX1Jy8vlLQcH"
				}
			],
			available_markets: ["US"],
			disc_number: 1,
			duration_ms: 193706,
			episode: false,
			explicit: true,
			external_ids: { isrc: "GBARL1501300" },
			external_urls: { spotify: "https://open.spotify.com/track/7AmquDDKf4cYQu75jMrvXc" },
			href: "https://api.spotify.com/v1/tracks/7AmquDDKf4cYQu75jMrvXc",
			id: "7AmquDDKf4cYQu75jMrvXc",
			is_local: false,
			name: "Wet Dollars",
			popularity: 27,
			preview_url: "https://p.scdn.co/mp3-preview/ee608c624065224ebf13c5f46ed643e108990d2d?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:7AmquDDKf4cYQu75jMrvXc"
		},
		features: {
			danceability: 0.523,
			energy: 0.901,
			key: 7,
			loudness: -6.854,
			mode: 1,
			speechiness: 0.0694,
			acousticness: 0.0032,
			instrumentalness: 0.00106,
			liveness: 0.627,
			valence: 0.626,
			tempo: 124,
			type: "audio_features",
			id: "7AmquDDKf4cYQu75jMrvXc",
			uri: "spotify:track:7AmquDDKf4cYQu75jMrvXc",
			track_href: "https://api.spotify.com/v1/tracks/7AmquDDKf4cYQu75jMrvXc",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7AmquDDKf4cYQu75jMrvXc",
			duration_ms: 193707,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
						href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
						id: "24neLwyYRyj4ItaGnFeIT0",
						name: "JOYRYDE",
						type: "artist",
						uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX" },
						href: "https://api.spotify.com/v1/artists/5he5w2lnU9x7JFhnwcekXX",
						id: "5he5w2lnU9x7JFhnwcekXX",
						name: "Skrillex",
						type: "artist",
						uri: "spotify:artist:5he5w2lnU9x7JFhnwcekXX"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5Oc42yHyXbHNXD87yEwfA7" },
				href: "https://api.spotify.com/v1/albums/5Oc42yHyXbHNXD87yEwfA7",
				id: "5Oc42yHyXbHNXD87yEwfA7",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273bf49a72ca41badcaee8126c2", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02bf49a72ca41badcaee8126c2", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851bf49a72ca41badcaee8126c2", width: 64 }
				],
				name: "AGEN WIDA",
				release_date: "2018-10-19",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5Oc42yHyXbHNXD87yEwfA7"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
					href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
					id: "24neLwyYRyj4ItaGnFeIT0",
					name: "JOYRYDE",
					type: "artist",
					uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX" },
					href: "https://api.spotify.com/v1/artists/5he5w2lnU9x7JFhnwcekXX",
					id: "5he5w2lnU9x7JFhnwcekXX",
					name: "Skrillex",
					type: "artist",
					uri: "spotify:artist:5he5w2lnU9x7JFhnwcekXX"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 199047,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21811575" },
			external_urls: { spotify: "https://open.spotify.com/track/35V6qXUDCvwZdmbKe5PlPG" },
			href: "https://api.spotify.com/v1/tracks/35V6qXUDCvwZdmbKe5PlPG",
			id: "35V6qXUDCvwZdmbKe5PlPG",
			is_local: false,
			name: "AGEN WIDA",
			popularity: 56,
			preview_url: "https://p.scdn.co/mp3-preview/9a18a331b9330078bb0aa7583253c7015c8ba5cb?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:35V6qXUDCvwZdmbKe5PlPG"
		},
		features: {
			danceability: 0.784,
			energy: 0.913,
			key: 1,
			loudness: -1.208,
			mode: 1,
			speechiness: 0.177,
			acousticness: 0.0114,
			instrumentalness: 0.00162,
			liveness: 0.0831,
			valence: 0.59,
			tempo: 126,
			type: "audio_features",
			id: "35V6qXUDCvwZdmbKe5PlPG",
			uri: "spotify:track:35V6qXUDCvwZdmbKe5PlPG",
			track_href: "https://api.spotify.com/v1/tracks/35V6qXUDCvwZdmbKe5PlPG",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/35V6qXUDCvwZdmbKe5PlPG",
			duration_ms: 199048,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "compilation",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/15Apu6hDiNgqJcYjM4JG6L" },
				href: "https://api.spotify.com/v1/albums/15Apu6hDiNgqJcYjM4JG6L",
				id: "15Apu6hDiNgqJcYjM4JG6L",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2738d8af7eec57587dd1882eeaf", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e028d8af7eec57587dd1882eeaf", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048518d8af7eec57587dd1882eeaf", width: 64 }
				],
				name: "Who's Afraid Of 138?! (Mini Mix 002) - Armada Music",
				release_date: "2018-09-21",
				release_date_precision: "day",
				total_tracks: 20,
				type: "album",
				uri: "spotify:album:15Apu6hDiNgqJcYjM4JG6L"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2kd1zg9ZyGG6WjZO2dAsFd" },
					href: "https://api.spotify.com/v1/artists/2kd1zg9ZyGG6WjZO2dAsFd",
					id: "2kd1zg9ZyGG6WjZO2dAsFd",
					name: "MaRLo",
					type: "artist",
					uri: "spotify:artist:2kd1zg9ZyGG6WjZO2dAsFd"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 2,
			duration_ms: 217939,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLF711800498" },
			external_urls: { spotify: "https://open.spotify.com/track/296GSfRdCQZmdQcmamEGM4" },
			href: "https://api.spotify.com/v1/tracks/296GSfRdCQZmdQcmamEGM4",
			id: "296GSfRdCQZmdQcmamEGM4",
			is_local: false,
			name: "Enough Echo",
			popularity: 1,
			preview_url: "https://p.scdn.co/mp3-preview/36cbdf8732801b49fcb4f7f676fbb739ddd1236e?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:296GSfRdCQZmdQcmamEGM4"
		},
		features: {
			danceability: 0.321,
			energy: 0.949,
			key: 1,
			loudness: -3.689,
			mode: 1,
			speechiness: 0.0737,
			acousticness: 0.0309,
			instrumentalness: 0.642,
			liveness: 0.942,
			valence: 0.284,
			tempo: 135,
			type: "audio_features",
			id: "296GSfRdCQZmdQcmamEGM4",
			uri: "spotify:track:296GSfRdCQZmdQcmamEGM4",
			track_href: "https://api.spotify.com/v1/tracks/296GSfRdCQZmdQcmamEGM4",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/296GSfRdCQZmdQcmamEGM4",
			duration_ms: 217939,
			time_signature: 4,
			doubletime: 135
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2sfSQ1BOzaFQa3LZj6OGwD" },
						href: "https://api.spotify.com/v1/artists/2sfSQ1BOzaFQa3LZj6OGwD",
						id: "2sfSQ1BOzaFQa3LZj6OGwD",
						name: "josh pan",
						type: "artist",
						uri: "spotify:artist:2sfSQ1BOzaFQa3LZj6OGwD"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2ZmerElhvxg8uVKCmlZ4ij" },
						href: "https://api.spotify.com/v1/artists/2ZmerElhvxg8uVKCmlZ4ij",
						id: "2ZmerElhvxg8uVKCmlZ4ij",
						name: "AWAY",
						type: "artist",
						uri: "spotify:artist:2ZmerElhvxg8uVKCmlZ4ij"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1WyIbUAxO25r9wC6MZZ5ib" },
				href: "https://api.spotify.com/v1/albums/1WyIbUAxO25r9wC6MZZ5ib",
				id: "1WyIbUAxO25r9wC6MZZ5ib",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273536f0a65c0658fcca7f92deb", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02536f0a65c0658fcca7f92deb", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851536f0a65c0658fcca7f92deb", width: 64 }
				],
				name: "Mask (with AWAY)",
				release_date: "2018-11-21",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1WyIbUAxO25r9wC6MZZ5ib"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2sfSQ1BOzaFQa3LZj6OGwD" },
					href: "https://api.spotify.com/v1/artists/2sfSQ1BOzaFQa3LZj6OGwD",
					id: "2sfSQ1BOzaFQa3LZj6OGwD",
					name: "josh pan",
					type: "artist",
					uri: "spotify:artist:2sfSQ1BOzaFQa3LZj6OGwD"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2ZmerElhvxg8uVKCmlZ4ij" },
					href: "https://api.spotify.com/v1/artists/2ZmerElhvxg8uVKCmlZ4ij",
					id: "2ZmerElhvxg8uVKCmlZ4ij",
					name: "AWAY",
					type: "artist",
					uri: "spotify:artist:2ZmerElhvxg8uVKCmlZ4ij"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 217142,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21811166" },
			external_urls: { spotify: "https://open.spotify.com/track/2MYcQsk0MlyOqzlkSzCsCT" },
			href: "https://api.spotify.com/v1/tracks/2MYcQsk0MlyOqzlkSzCsCT",
			id: "2MYcQsk0MlyOqzlkSzCsCT",
			is_local: false,
			name: "Mask (with AWAY)",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/7fb5f60cc4671ad7a3ae56ea6adc342f0cb269e1?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2MYcQsk0MlyOqzlkSzCsCT"
		},
		features: {
			danceability: 0.624,
			energy: 0.655,
			key: 10,
			loudness: -3.384,
			mode: 1,
			speechiness: 0.111,
			acousticness: 0.083,
			instrumentalness: 0.000002,
			liveness: 0.43,
			valence: 0.553,
			tempo: 84,
			type: "audio_features",
			id: "2MYcQsk0MlyOqzlkSzCsCT",
			uri: "spotify:track:2MYcQsk0MlyOqzlkSzCsCT",
			track_href: "https://api.spotify.com/v1/tracks/2MYcQsk0MlyOqzlkSzCsCT",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2MYcQsk0MlyOqzlkSzCsCT",
			duration_ms: 217143,
			time_signature: 4,
			doubletime: 168
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6bWylzDlsTfR8khADRQJfd" },
						href: "https://api.spotify.com/v1/artists/6bWylzDlsTfR8khADRQJfd",
						id: "6bWylzDlsTfR8khADRQJfd",
						name: "Trevor Something",
						type: "artist",
						uri: "spotify:artist:6bWylzDlsTfR8khADRQJfd"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/11x7E30bHOhD1esPQBxLQW" },
				href: "https://api.spotify.com/v1/albums/11x7E30bHOhD1esPQBxLQW",
				id: "11x7E30bHOhD1esPQBxLQW",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2738c34a09fe8b54267cd91be6c", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e028c34a09fe8b54267cd91be6c", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048518c34a09fe8b54267cd91be6c", width: 64 }
				],
				name: "Ultraparanoia",
				release_date: "2018-10-12",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:11x7E30bHOhD1esPQBxLQW"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6bWylzDlsTfR8khADRQJfd" },
					href: "https://api.spotify.com/v1/artists/6bWylzDlsTfR8khADRQJfd",
					id: "6bWylzDlsTfR8khADRQJfd",
					name: "Trevor Something",
					type: "artist",
					uri: "spotify:artist:6bWylzDlsTfR8khADRQJfd"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 244715,
			episode: false,
			explicit: true,
			external_ids: { isrc: "UST8K1856060" },
			external_urls: { spotify: "https://open.spotify.com/track/2DhV8zoET5dlew43Dt05lD" },
			href: "https://api.spotify.com/v1/tracks/2DhV8zoET5dlew43Dt05lD",
			id: "2DhV8zoET5dlew43Dt05lD",
			is_local: false,
			name: "New High",
			popularity: 41,
			preview_url: "https://p.scdn.co/mp3-preview/00527128ae2bf3bdb544e12b8b3786bedf2d873d?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2DhV8zoET5dlew43Dt05lD"
		},
		features: {
			danceability: 0.329,
			energy: 0.599,
			key: 10,
			loudness: -9.947,
			mode: 0,
			speechiness: 0.0963,
			acousticness: 0.00231,
			instrumentalness: 0.928,
			liveness: 0.639,
			valence: 0.0563,
			tempo: 84,
			type: "audio_features",
			id: "2DhV8zoET5dlew43Dt05lD",
			uri: "spotify:track:2DhV8zoET5dlew43Dt05lD",
			track_href: "https://api.spotify.com/v1/tracks/2DhV8zoET5dlew43Dt05lD",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2DhV8zoET5dlew43Dt05lD",
			duration_ms: 244715,
			time_signature: 4,
			doubletime: 168
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3fMA5LH56qpFdPxW1kQe4A" },
						href: "https://api.spotify.com/v1/artists/3fMA5LH56qpFdPxW1kQe4A",
						id: "3fMA5LH56qpFdPxW1kQe4A",
						name: "DJ Shub",
						type: "artist",
						uri: "spotify:artist:3fMA5LH56qpFdPxW1kQe4A"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/32ubYcibtabKL0ZIM0AepT" },
				href: "https://api.spotify.com/v1/albums/32ubYcibtabKL0ZIM0AepT",
				id: "32ubYcibtabKL0ZIM0AepT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733fe884a485acf3a9e4a008be", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023fe884a485acf3a9e4a008be", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513fe884a485acf3a9e4a008be", width: 64 }
				],
				name: "PowWowStep",
				release_date: "2016-12-02",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:32ubYcibtabKL0ZIM0AepT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3fMA5LH56qpFdPxW1kQe4A" },
					href: "https://api.spotify.com/v1/artists/3fMA5LH56qpFdPxW1kQe4A",
					id: "3fMA5LH56qpFdPxW1kQe4A",
					name: "DJ Shub",
					type: "artist",
					uri: "spotify:artist:3fMA5LH56qpFdPxW1kQe4A"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7cKRgZFFib4BKtbEykBxQs" },
					href: "https://api.spotify.com/v1/artists/7cKRgZFFib4BKtbEykBxQs",
					id: "7cKRgZFFib4BKtbEykBxQs",
					name: "Northern Cree Singers",
					type: "artist",
					uri: "spotify:artist:7cKRgZFFib4BKtbEykBxQs"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 268469,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CAALL1600005" },
			external_urls: { spotify: "https://open.spotify.com/track/1VFFu5uIcIQT49LU3WIfTa" },
			href: "https://api.spotify.com/v1/tracks/1VFFu5uIcIQT49LU3WIfTa",
			id: "1VFFu5uIcIQT49LU3WIfTa",
			is_local: false,
			name: "M.O.S.T.C.O. (feat. Northern Cree Singers)",
			popularity: 22,
			preview_url: "https://p.scdn.co/mp3-preview/0920b12aab5aa701357eb027ddfde2a570fbdafc?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:1VFFu5uIcIQT49LU3WIfTa"
		},
		features: {
			danceability: 0.713,
			energy: 0.452,
			key: 2,
			loudness: -3.615,
			mode: 1,
			speechiness: 0.0398,
			acousticness: 0.00752,
			instrumentalness: 0.857,
			liveness: 0.0823,
			valence: 0.305,
			tempo: 150,
			type: "audio_features",
			id: "1VFFu5uIcIQT49LU3WIfTa",
			uri: "spotify:track:1VFFu5uIcIQT49LU3WIfTa",
			track_href: "https://api.spotify.com/v1/tracks/1VFFu5uIcIQT49LU3WIfTa",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1VFFu5uIcIQT49LU3WIfTa",
			duration_ms: 268469,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0Kc8I2nrf9po7TU4VH3lnK" },
						href: "https://api.spotify.com/v1/artists/0Kc8I2nrf9po7TU4VH3lnK",
						id: "0Kc8I2nrf9po7TU4VH3lnK",
						name: "Boogey the Beat",
						type: "artist",
						uri: "spotify:artist:0Kc8I2nrf9po7TU4VH3lnK"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1ouIlIuyJt0ieW6FxEPdTK" },
				href: "https://api.spotify.com/v1/albums/1ouIlIuyJt0ieW6FxEPdTK",
				id: "1ouIlIuyJt0ieW6FxEPdTK",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27324aee1d28bdbf0bd0880e722", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0224aee1d28bdbf0bd0880e722", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485124aee1d28bdbf0bd0880e722", width: 64 }
				],
				name: "Buffalo",
				release_date: "2016-06-21",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1ouIlIuyJt0ieW6FxEPdTK"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0Kc8I2nrf9po7TU4VH3lnK" },
					href: "https://api.spotify.com/v1/artists/0Kc8I2nrf9po7TU4VH3lnK",
					id: "0Kc8I2nrf9po7TU4VH3lnK",
					name: "Boogey the Beat",
					type: "artist",
					uri: "spotify:artist:0Kc8I2nrf9po7TU4VH3lnK"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 249519,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCACO1692041" },
			external_urls: { spotify: "https://open.spotify.com/track/5QLRneRLedCtUSxuI8Ty5z" },
			href: "https://api.spotify.com/v1/tracks/5QLRneRLedCtUSxuI8Ty5z",
			id: "5QLRneRLedCtUSxuI8Ty5z",
			is_local: false,
			name: "Buffalo",
			popularity: 12,
			preview_url: "https://p.scdn.co/mp3-preview/1695944025ddbf504c7f2767dc1fda4163c039a7?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5QLRneRLedCtUSxuI8Ty5z"
		},
		features: {
			danceability: 0.691,
			energy: 0.934,
			key: 9,
			loudness: -3.526,
			mode: 1,
			speechiness: 0.0722,
			acousticness: 0.011,
			instrumentalness: 0.00599,
			liveness: 0.104,
			valence: 0.141,
			tempo: 104,
			type: "audio_features",
			id: "5QLRneRLedCtUSxuI8Ty5z",
			uri: "spotify:track:5QLRneRLedCtUSxuI8Ty5z",
			track_href: "https://api.spotify.com/v1/tracks/5QLRneRLedCtUSxuI8Ty5z",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5QLRneRLedCtUSxuI8Ty5z",
			duration_ms: 249519,
			time_signature: 4,
			doubletime: 104
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2GVtgxcx7jg5xVCZsIHSGN" },
						href: "https://api.spotify.com/v1/artists/2GVtgxcx7jg5xVCZsIHSGN",
						id: "2GVtgxcx7jg5xVCZsIHSGN",
						name: "Dombresky",
						type: "artist",
						uri: "spotify:artist:2GVtgxcx7jg5xVCZsIHSGN"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/48d73i5ixdJIWZBoZJw0R1" },
				href: "https://api.spotify.com/v1/albums/48d73i5ixdJIWZBoZJw0R1",
				id: "48d73i5ixdJIWZBoZJw0R1",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739166d286187e84378dbdebb8", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029166d286187e84378dbdebb8", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519166d286187e84378dbdebb8", width: 64 }
				],
				name: "Utopia",
				release_date: "2016-10-11",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:48d73i5ixdJIWZBoZJw0R1"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2GVtgxcx7jg5xVCZsIHSGN" },
					href: "https://api.spotify.com/v1/artists/2GVtgxcx7jg5xVCZsIHSGN",
					id: "2GVtgxcx7jg5xVCZsIHSGN",
					name: "Dombresky",
					type: "artist",
					uri: "spotify:artist:2GVtgxcx7jg5xVCZsIHSGN"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 280952,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USLD90818700" },
			external_urls: { spotify: "https://open.spotify.com/track/3IVjcQvCFu1Bo7Kq3WRlNn" },
			href: "https://api.spotify.com/v1/tracks/3IVjcQvCFu1Bo7Kq3WRlNn",
			id: "3IVjcQvCFu1Bo7Kq3WRlNn",
			is_local: false,
			name: "Utopia",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/0896b7522d10a64a83c537711eb9b534fdb36a8f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3IVjcQvCFu1Bo7Kq3WRlNn"
		},
		features: {
			danceability: 0.754,
			energy: 0.833,
			key: 10,
			loudness: -5.143,
			mode: 0,
			speechiness: 0.0428,
			acousticness: 0.00338,
			instrumentalness: 0.54,
			liveness: 0.0666,
			valence: 0.105,
			tempo: 126,
			type: "audio_features",
			id: "3IVjcQvCFu1Bo7Kq3WRlNn",
			uri: "spotify:track:3IVjcQvCFu1Bo7Kq3WRlNn",
			track_href: "https://api.spotify.com/v1/tracks/3IVjcQvCFu1Bo7Kq3WRlNn",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3IVjcQvCFu1Bo7Kq3WRlNn",
			duration_ms: 280952,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6S5jf5noKu0JJjLLVUCZqP" },
						href: "https://api.spotify.com/v1/artists/6S5jf5noKu0JJjLLVUCZqP",
						id: "6S5jf5noKu0JJjLLVUCZqP",
						name: "Joker",
						type: "artist",
						uri: "spotify:artist:6S5jf5noKu0JJjLLVUCZqP"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5xJMWNdNhK7ackFQdTkWCm" },
				href: "https://api.spotify.com/v1/albums/5xJMWNdNhK7ackFQdTkWCm",
				id: "5xJMWNdNhK7ackFQdTkWCm",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27327e8d35ce7fcc1b26759bd1e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0227e8d35ce7fcc1b26759bd1e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485127e8d35ce7fcc1b26759bd1e", width: 64 }
				],
				name: "Anamorphic",
				release_date: "2018-03-23",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5xJMWNdNhK7ackFQdTkWCm"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6S5jf5noKu0JJjLLVUCZqP" },
					href: "https://api.spotify.com/v1/artists/6S5jf5noKu0JJjLLVUCZqP",
					id: "6S5jf5noKu0JJjLLVUCZqP",
					name: "Joker",
					type: "artist",
					uri: "spotify:artist:6S5jf5noKu0JJjLLVUCZqP"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 430471,
			episode: false,
			explicit: false,
			external_ids: { isrc: "UK7BN1822001" },
			external_urls: { spotify: "https://open.spotify.com/track/2ubI8PIEcGDkiN0F1dC0mH" },
			href: "https://api.spotify.com/v1/tracks/2ubI8PIEcGDkiN0F1dC0mH",
			id: "2ubI8PIEcGDkiN0F1dC0mH",
			is_local: false,
			name: "Anamorphic",
			popularity: 35,
			preview_url: "https://p.scdn.co/mp3-preview/7937d52f41937026ddaebeceb3bd1fbec4556eb0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2ubI8PIEcGDkiN0F1dC0mH"
		},
		features: {
			danceability: 0.325,
			energy: 0.719,
			key: 4,
			loudness: -6.21,
			mode: 0,
			speechiness: 0.0469,
			acousticness: 0.00134,
			instrumentalness: 0.743,
			liveness: 0.161,
			valence: 0.0554,
			tempo: 140,
			type: "audio_features",
			id: "2ubI8PIEcGDkiN0F1dC0mH",
			uri: "spotify:track:2ubI8PIEcGDkiN0F1dC0mH",
			track_href: "https://api.spotify.com/v1/tracks/2ubI8PIEcGDkiN0F1dC0mH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2ubI8PIEcGDkiN0F1dC0mH",
			duration_ms: 430471,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
						href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
						id: "10gzBoINW3cLJfZUka8Zoe",
						name: "Above & Beyond",
						type: "artist",
						uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
						href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
						id: "0SfsnGyD8FpIN4U4WCkBZ5",
						name: "Armin van Buuren",
						type: "artist",
						uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6CRr9qtC3ApJO9Qd1XKfB2" },
				href: "https://api.spotify.com/v1/albums/6CRr9qtC3ApJO9Qd1XKfB2",
				id: "6CRr9qtC3ApJO9Qd1XKfB2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739a80e47e71ddd8fab76a8a17", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029a80e47e71ddd8fab76a8a17", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519a80e47e71ddd8fab76a8a17", width: 64 }
				],
				name: "Show Me Love",
				release_date: "2019-03-01",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:6CRr9qtC3ApJO9Qd1XKfB2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe" },
					href: "https://api.spotify.com/v1/artists/10gzBoINW3cLJfZUka8Zoe",
					id: "10gzBoINW3cLJfZUka8Zoe",
					name: "Above & Beyond",
					type: "artist",
					uri: "spotify:artist:10gzBoINW3cLJfZUka8Zoe"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5" },
					href: "https://api.spotify.com/v1/artists/0SfsnGyD8FpIN4U4WCkBZ5",
					id: "0SfsnGyD8FpIN4U4WCkBZ5",
					name: "Armin van Buuren",
					type: "artist",
					uri: "spotify:artist:0SfsnGyD8FpIN4U4WCkBZ5"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 211655,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLF711901531" },
			external_urls: { spotify: "https://open.spotify.com/track/0jT6M1tT51b1p2s8qDUUkB" },
			href: "https://api.spotify.com/v1/tracks/0jT6M1tT51b1p2s8qDUUkB",
			id: "0jT6M1tT51b1p2s8qDUUkB",
			is_local: false,
			name: "Show Me Love",
			popularity: 52,
			preview_url: "https://p.scdn.co/mp3-preview/2f33a08189ce7826ffcc087f7af4c010e3504c1a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0jT6M1tT51b1p2s8qDUUkB"
		},
		features: {
			danceability: 0.46,
			energy: 0.878,
			key: 4,
			loudness: -5.203,
			mode: 0,
			speechiness: 0.0437,
			acousticness: 0.022,
			instrumentalness: 0.508,
			liveness: 0.157,
			valence: 0.454,
			tempo: 128,
			type: "audio_features",
			id: "0jT6M1tT51b1p2s8qDUUkB",
			uri: "spotify:track:0jT6M1tT51b1p2s8qDUUkB",
			track_href: "https://api.spotify.com/v1/tracks/0jT6M1tT51b1p2s8qDUUkB",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0jT6M1tT51b1p2s8qDUUkB",
			duration_ms: 211655,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
						href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
						id: "24neLwyYRyj4ItaGnFeIT0",
						name: "JOYRYDE",
						type: "artist",
						uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6jB6Ja81mc68nDB5zypsOm" },
				href: "https://api.spotify.com/v1/albums/6jB6Ja81mc68nDB5zypsOm",
				id: "6jB6Ja81mc68nDB5zypsOm",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273636ec0e3f3f65cf70a4d7ad6", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02636ec0e3f3f65cf70a4d7ad6", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851636ec0e3f3f65cf70a4d7ad6", width: 64 }
				],
				name: "IM GONE",
				release_date: "2019-02-22",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:6jB6Ja81mc68nDB5zypsOm"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/24neLwyYRyj4ItaGnFeIT0" },
					href: "https://api.spotify.com/v1/artists/24neLwyYRyj4ItaGnFeIT0",
					id: "24neLwyYRyj4ItaGnFeIT0",
					name: "JOYRYDE",
					type: "artist",
					uri: "spotify:artist:24neLwyYRyj4ItaGnFeIT0"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 285860,
			episode: false,
			explicit: true,
			external_ids: { isrc: "CA5KR1908647" },
			external_urls: { spotify: "https://open.spotify.com/track/1SYNgyiVRZEBhV0P4YFBk8" },
			href: "https://api.spotify.com/v1/tracks/1SYNgyiVRZEBhV0P4YFBk8",
			id: "1SYNgyiVRZEBhV0P4YFBk8",
			is_local: false,
			name: "IM GONE",
			popularity: 61,
			preview_url: "https://p.scdn.co/mp3-preview/b3123c5fdee68162927a9fd4534fd4977a9dd663?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1SYNgyiVRZEBhV0P4YFBk8"
		},
		features: {
			danceability: 0.664,
			energy: 0.953,
			key: 9,
			loudness: -3.794,
			mode: 1,
			speechiness: 0.249,
			acousticness: 0.00961,
			instrumentalness: 0.00665,
			liveness: 0.263,
			valence: 0.21,
			tempo: 126,
			type: "audio_features",
			id: "1SYNgyiVRZEBhV0P4YFBk8",
			uri: "spotify:track:1SYNgyiVRZEBhV0P4YFBk8",
			track_href: "https://api.spotify.com/v1/tracks/1SYNgyiVRZEBhV0P4YFBk8",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1SYNgyiVRZEBhV0P4YFBk8",
			duration_ms: 285860,
			time_signature: 4,
			doubletime: 126
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1HwM5zlC5qNWhJtM00yXzG" },
						href: "https://api.spotify.com/v1/artists/1HwM5zlC5qNWhJtM00yXzG",
						id: "1HwM5zlC5qNWhJtM00yXzG",
						name: "DMX",
						type: "artist",
						uri: "spotify:artist:1HwM5zlC5qNWhJtM00yXzG"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6BpfRDxrqSqAyoJctR5JyY" },
						href: "https://api.spotify.com/v1/artists/6BpfRDxrqSqAyoJctR5JyY",
						id: "6BpfRDxrqSqAyoJctR5JyY",
						name: "DARKO",
						type: "artist",
						uri: "spotify:artist:6BpfRDxrqSqAyoJctR5JyY"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0G8B1V9uLobCYNEqF5xTK5" },
				href: "https://api.spotify.com/v1/albums/0G8B1V9uLobCYNEqF5xTK5",
				id: "0G8B1V9uLobCYNEqF5xTK5",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27361e41f5395822b4c4a345c78", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0261e41f5395822b4c4a345c78", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485161e41f5395822b4c4a345c78", width: 64 }
				],
				name: "Party Up (Up in Here) - DARKO Remix",
				release_date: "2019-02-12",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:0G8B1V9uLobCYNEqF5xTK5"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1HwM5zlC5qNWhJtM00yXzG" },
					href: "https://api.spotify.com/v1/artists/1HwM5zlC5qNWhJtM00yXzG",
					id: "1HwM5zlC5qNWhJtM00yXzG",
					name: "DMX",
					type: "artist",
					uri: "spotify:artist:1HwM5zlC5qNWhJtM00yXzG"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6BpfRDxrqSqAyoJctR5JyY" },
					href: "https://api.spotify.com/v1/artists/6BpfRDxrqSqAyoJctR5JyY",
					id: "6BpfRDxrqSqAyoJctR5JyY",
					name: "DARKO",
					type: "artist",
					uri: "spotify:artist:6BpfRDxrqSqAyoJctR5JyY"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 163528,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QM6XS1900132" },
			external_urls: { spotify: "https://open.spotify.com/track/6XwqHJVEzlWWd7MWAL0MQm" },
			href: "https://api.spotify.com/v1/tracks/6XwqHJVEzlWWd7MWAL0MQm",
			id: "6XwqHJVEzlWWd7MWAL0MQm",
			is_local: false,
			name: "Party Up (Up in Here) - DARKO Remix",
			popularity: 28,
			preview_url: "https://p.scdn.co/mp3-preview/6e3d51a9512fe77ad3880d868e85c88782b6d43a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:6XwqHJVEzlWWd7MWAL0MQm"
		},
		features: {
			danceability: 0.703,
			energy: 0.906,
			key: 10,
			loudness: -4.093,
			mode: 0,
			speechiness: 0.163,
			acousticness: 0.0051,
			instrumentalness: 0.000229,
			liveness: 0.264,
			valence: 0.728,
			tempo: 124,
			type: "audio_features",
			id: "6XwqHJVEzlWWd7MWAL0MQm",
			uri: "spotify:track:6XwqHJVEzlWWd7MWAL0MQm",
			track_href: "https://api.spotify.com/v1/tracks/6XwqHJVEzlWWd7MWAL0MQm",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6XwqHJVEzlWWd7MWAL0MQm",
			duration_ms: 163528,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/44jVwc3zISBT0efwHhb1J7" },
						href: "https://api.spotify.com/v1/artists/44jVwc3zISBT0efwHhb1J7",
						id: "44jVwc3zISBT0efwHhb1J7",
						name: "Half Empty",
						type: "artist",
						uri: "spotify:artist:44jVwc3zISBT0efwHhb1J7"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4D1dSRIgqfBOXsxBw7HgKx" },
				href: "https://api.spotify.com/v1/albums/4D1dSRIgqfBOXsxBw7HgKx",
				id: "4D1dSRIgqfBOXsxBw7HgKx",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c4557b3584f23c15bcb3e187", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c4557b3584f23c15bcb3e187", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c4557b3584f23c15bcb3e187", width: 64 }
				],
				name: "Something About Smooth Seas and Bad Sailors",
				release_date: "2017-06-09",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4D1dSRIgqfBOXsxBw7HgKx"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/44jVwc3zISBT0efwHhb1J7" },
					href: "https://api.spotify.com/v1/artists/44jVwc3zISBT0efwHhb1J7",
					id: "44jVwc3zISBT0efwHhb1J7",
					name: "Half Empty",
					type: "artist",
					uri: "spotify:artist:44jVwc3zISBT0efwHhb1J7"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 379065,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCADC1735273" },
			external_urls: { spotify: "https://open.spotify.com/track/1QkCYzDLAMQgbMVpSghz5e" },
			href: "https://api.spotify.com/v1/tracks/1QkCYzDLAMQgbMVpSghz5e",
			id: "1QkCYzDLAMQgbMVpSghz5e",
			is_local: false,
			name: "Something About Smooth Seas and Bad Sailors",
			popularity: 30,
			preview_url: "https://p.scdn.co/mp3-preview/ad9853660339b025e22bf21466d1de44fc7b4d24?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1QkCYzDLAMQgbMVpSghz5e"
		},
		features: {
			danceability: 0.608,
			energy: 0.906,
			key: 7,
			loudness: -6.326,
			mode: 1,
			speechiness: 0.0495,
			acousticness: 0.00584,
			instrumentalness: 0.298,
			liveness: 0.613,
			valence: 0.162,
			tempo: 107,
			type: "audio_features",
			id: "1QkCYzDLAMQgbMVpSghz5e",
			uri: "spotify:track:1QkCYzDLAMQgbMVpSghz5e",
			track_href: "https://api.spotify.com/v1/tracks/1QkCYzDLAMQgbMVpSghz5e",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1QkCYzDLAMQgbMVpSghz5e",
			duration_ms: 379065,
			time_signature: 4,
			doubletime: 107
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0vqJkZ0RpLZixt3lTmD8vP" },
						href: "https://api.spotify.com/v1/artists/0vqJkZ0RpLZixt3lTmD8vP",
						id: "0vqJkZ0RpLZixt3lTmD8vP",
						name: "Whethan",
						type: "artist",
						uri: "spotify:artist:0vqJkZ0RpLZixt3lTmD8vP"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4oN0HoJVDsVKwJmquYy7d2" },
				href: "https://api.spotify.com/v1/albums/4oN0HoJVDsVKwJmquYy7d2",
				id: "4oN0HoJVDsVKwJmquYy7d2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273abc20d6fca3df753a2243a5f", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02abc20d6fca3df753a2243a5f", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851abc20d6fca3df753a2243a5f", width: 64 }
				],
				name: "Life of a Wallflower Vol. 1",
				release_date: "2018-11-09",
				release_date_precision: "day",
				total_tracks: 8,
				type: "album",
				uri: "spotify:album:4oN0HoJVDsVKwJmquYy7d2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0vqJkZ0RpLZixt3lTmD8vP" },
					href: "https://api.spotify.com/v1/artists/0vqJkZ0RpLZixt3lTmD8vP",
					id: "0vqJkZ0RpLZixt3lTmD8vP",
					name: "Whethan",
					type: "artist",
					uri: "spotify:artist:0vqJkZ0RpLZixt3lTmD8vP"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5r5Va4lVQ1zjEfbJSrmCsS" },
					href: "https://api.spotify.com/v1/artists/5r5Va4lVQ1zjEfbJSrmCsS",
					id: "5r5Va4lVQ1zjEfbJSrmCsS",
					name: "Broods",
					type: "artist",
					uri: "spotify:artist:5r5Va4lVQ1zjEfbJSrmCsS"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 161431,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21801028" },
			external_urls: { spotify: "https://open.spotify.com/track/1zRdhBRqRnMSLkZTODa5OL" },
			href: "https://api.spotify.com/v1/tracks/1zRdhBRqRnMSLkZTODa5OL",
			id: "1zRdhBRqRnMSLkZTODa5OL",
			is_local: false,
			name: "Be Like You (feat. Broods)",
			popularity: 55,
			preview_url: "https://p.scdn.co/mp3-preview/8789405cffa37a2af5194aad14046b75a1e9c97a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:1zRdhBRqRnMSLkZTODa5OL"
		},
		features: {
			danceability: 0.677,
			energy: 0.492,
			key: 1,
			loudness: -4.764,
			mode: 1,
			speechiness: 0.0597,
			acousticness: 0.118,
			instrumentalness: 0.0000252,
			liveness: 0.0844,
			valence: 0.166,
			tempo: 84,
			type: "audio_features",
			id: "1zRdhBRqRnMSLkZTODa5OL",
			uri: "spotify:track:1zRdhBRqRnMSLkZTODa5OL",
			track_href: "https://api.spotify.com/v1/tracks/1zRdhBRqRnMSLkZTODa5OL",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1zRdhBRqRnMSLkZTODa5OL",
			duration_ms: 161431,
			time_signature: 4,
			doubletime: 168
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7eMykQ9NjmtA5FnMarEG2F" },
						href: "https://api.spotify.com/v1/artists/7eMykQ9NjmtA5FnMarEG2F",
						id: "7eMykQ9NjmtA5FnMarEG2F",
						name: "Barren Gates",
						type: "artist",
						uri: "spotify:artist:7eMykQ9NjmtA5FnMarEG2F"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/454w9H2I0b7vWMDMRWzQCn" },
				href: "https://api.spotify.com/v1/albums/454w9H2I0b7vWMDMRWzQCn",
				id: "454w9H2I0b7vWMDMRWzQCn",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739862e1def7aa2b23ae87d93a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029862e1def7aa2b23ae87d93a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519862e1def7aa2b23ae87d93a", width: 64 }
				],
				name: "The Heist",
				release_date: "2018-06-12",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:454w9H2I0b7vWMDMRWzQCn"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7eMykQ9NjmtA5FnMarEG2F" },
					href: "https://api.spotify.com/v1/artists/7eMykQ9NjmtA5FnMarEG2F",
					id: "7eMykQ9NjmtA5FnMarEG2F",
					name: "Barren Gates",
					type: "artist",
					uri: "spotify:artist:7eMykQ9NjmtA5FnMarEG2F"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 185379,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USA2P1838619" },
			external_urls: { spotify: "https://open.spotify.com/track/2yWmApnV6e7LQdtQJoc6g4" },
			href: "https://api.spotify.com/v1/tracks/2yWmApnV6e7LQdtQJoc6g4",
			id: "2yWmApnV6e7LQdtQJoc6g4",
			is_local: false,
			name: "The Heist",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/2a2a15f877243047b0bc39c652cb4ff57d53f09a?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2yWmApnV6e7LQdtQJoc6g4"
		},
		features: {
			danceability: 0.431,
			energy: 0.936,
			key: 2,
			loudness: -5.751,
			mode: 1,
			speechiness: 0.592,
			acousticness: 0.00347,
			instrumentalness: 0.18,
			liveness: 0.656,
			valence: 0.548,
			tempo: 145,
			type: "audio_features",
			id: "2yWmApnV6e7LQdtQJoc6g4",
			uri: "spotify:track:2yWmApnV6e7LQdtQJoc6g4",
			track_href: "https://api.spotify.com/v1/tracks/2yWmApnV6e7LQdtQJoc6g4",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2yWmApnV6e7LQdtQJoc6g4",
			duration_ms: 185379,
			time_signature: 3,
			doubletime: 145
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/60lZ2sr01yS7uJQeq7zoPv" },
						href: "https://api.spotify.com/v1/artists/60lZ2sr01yS7uJQeq7zoPv",
						id: "60lZ2sr01yS7uJQeq7zoPv",
						name: "Dorfex Bos",
						type: "artist",
						uri: "spotify:artist:60lZ2sr01yS7uJQeq7zoPv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/0GhoggO7ClCSiPxFBXIBGz" },
				href: "https://api.spotify.com/v1/albums/0GhoggO7ClCSiPxFBXIBGz",
				id: "0GhoggO7ClCSiPxFBXIBGz",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273367656d65a0078eb45466f7a", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02367656d65a0078eb45466f7a", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851367656d65a0078eb45466f7a", width: 64 }
				],
				name: "Opinions",
				release_date: "2018-05-04",
				release_date_precision: "day",
				total_tracks: 4,
				type: "album",
				uri: "spotify:album:0GhoggO7ClCSiPxFBXIBGz"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/60lZ2sr01yS7uJQeq7zoPv" },
					href: "https://api.spotify.com/v1/artists/60lZ2sr01yS7uJQeq7zoPv",
					id: "60lZ2sr01yS7uJQeq7zoPv",
					name: "Dorfex Bos",
					type: "artist",
					uri: "spotify:artist:60lZ2sr01yS7uJQeq7zoPv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 261560,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QZCE61825493" },
			external_urls: { spotify: "https://open.spotify.com/track/5MNpS9Uhz8Sa2v0NVYnHVE" },
			href: "https://api.spotify.com/v1/tracks/5MNpS9Uhz8Sa2v0NVYnHVE",
			id: "5MNpS9Uhz8Sa2v0NVYnHVE",
			is_local: false,
			name: "Opinions",
			popularity: 37,
			preview_url: "https://p.scdn.co/mp3-preview/954cea29aa29d2d57680eb313bdb438d377030f0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5MNpS9Uhz8Sa2v0NVYnHVE"
		},
		features: {
			danceability: 0.452,
			energy: 0.859,
			key: 10,
			loudness: -4.855,
			mode: 0,
			speechiness: 0.0353,
			acousticness: 0.000128,
			instrumentalness: 0.944,
			liveness: 0.143,
			valence: 0.202,
			tempo: 140,
			type: "audio_features",
			id: "5MNpS9Uhz8Sa2v0NVYnHVE",
			uri: "spotify:track:5MNpS9Uhz8Sa2v0NVYnHVE",
			track_href: "https://api.spotify.com/v1/tracks/5MNpS9Uhz8Sa2v0NVYnHVE",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5MNpS9Uhz8Sa2v0NVYnHVE",
			duration_ms: 261560,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3mVwDyQRNVMy3ZNuTabf6f" },
						href: "https://api.spotify.com/v1/artists/3mVwDyQRNVMy3ZNuTabf6f",
						id: "3mVwDyQRNVMy3ZNuTabf6f",
						name: "Champagne Drip",
						type: "artist",
						uri: "spotify:artist:3mVwDyQRNVMy3ZNuTabf6f"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5yk9sNsBhjddrKp7lAcgXr" },
				href: "https://api.spotify.com/v1/albums/5yk9sNsBhjddrKp7lAcgXr",
				id: "5yk9sNsBhjddrKp7lAcgXr",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273237d7d9e53cbc31637b197ea", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02237d7d9e53cbc31637b197ea", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851237d7d9e53cbc31637b197ea", width: 64 }
				],
				name: "Of Course I Still Love You",
				release_date: "2016-12-13",
				release_date_precision: "day",
				total_tracks: 6,
				type: "album",
				uri: "spotify:album:5yk9sNsBhjddrKp7lAcgXr"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3mVwDyQRNVMy3ZNuTabf6f" },
					href: "https://api.spotify.com/v1/artists/3mVwDyQRNVMy3ZNuTabf6f",
					id: "3mVwDyQRNVMy3ZNuTabf6f",
					name: "Champagne Drip",
					type: "artist",
					uri: "spotify:artist:3mVwDyQRNVMy3ZNuTabf6f"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 274593,
			episode: false,
			explicit: false,
			external_ids: { isrc: "DEA371304666" },
			external_urls: { spotify: "https://open.spotify.com/track/2YonNPsOfBszCc1UvVCdn7" },
			href: "https://api.spotify.com/v1/tracks/2YonNPsOfBszCc1UvVCdn7",
			id: "2YonNPsOfBszCc1UvVCdn7",
			is_local: false,
			name: "Oni",
			popularity: 49,
			preview_url: "https://p.scdn.co/mp3-preview/dfd90072dd227842c5bbd4462e1da2ee43bdda25?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 3,
			type: "track",
			uri: "spotify:track:2YonNPsOfBszCc1UvVCdn7"
		},
		features: {
			danceability: 0.481,
			energy: 0.716,
			key: 9,
			loudness: -4.688,
			mode: 1,
			speechiness: 0.0281,
			acousticness: 0.002,
			instrumentalness: 0.49,
			liveness: 0.312,
			valence: 0.0673,
			tempo: 80,
			type: "audio_features",
			id: "2YonNPsOfBszCc1UvVCdn7",
			uri: "spotify:track:2YonNPsOfBszCc1UvVCdn7",
			track_href: "https://api.spotify.com/v1/tracks/2YonNPsOfBszCc1UvVCdn7",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2YonNPsOfBszCc1UvVCdn7",
			duration_ms: 274594,
			time_signature: 4,
			doubletime: 160
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
						href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
						id: "3UCbp6D1lvILlxRJT9LnFa",
						name: "Koven",
						type: "artist",
						uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/1Fv6BWmpqzdVbydgwkzlVm" },
				href: "https://api.spotify.com/v1/albums/1Fv6BWmpqzdVbydgwkzlVm",
				id: "1Fv6BWmpqzdVbydgwkzlVm",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2735fe562dc43f47ecb2296e2e7", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e025fe562dc43f47ecb2296e2e7", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048515fe562dc43f47ecb2296e2e7", width: 64 }
				],
				name: "Voices",
				release_date: "2018-07-27",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1Fv6BWmpqzdVbydgwkzlVm"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
					href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
					id: "3UCbp6D1lvILlxRJT9LnFa",
					name: "Koven",
					type: "artist",
					uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 203478,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CA6D21800179" },
			external_urls: { spotify: "https://open.spotify.com/track/4ckR53QqY5hkJylP5AdVxI" },
			href: "https://api.spotify.com/v1/tracks/4ckR53QqY5hkJylP5AdVxI",
			id: "4ckR53QqY5hkJylP5AdVxI",
			is_local: false,
			name: "Voices",
			popularity: 0,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4ckR53QqY5hkJylP5AdVxI"
		},
		features: {
			danceability: 0.419,
			energy: 0.841,
			key: 7,
			loudness: -3.81,
			mode: 0,
			speechiness: 0.0598,
			acousticness: 0.00353,
			instrumentalness: 0.0148,
			liveness: 0.103,
			valence: 0.17,
			tempo: 92,
			type: "audio_features",
			id: "4ckR53QqY5hkJylP5AdVxI",
			uri: "spotify:track:4ckR53QqY5hkJylP5AdVxI",
			track_href: "https://api.spotify.com/v1/tracks/4ckR53QqY5hkJylP5AdVxI",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4ckR53QqY5hkJylP5AdVxI",
			duration_ms: 203478,
			time_signature: 4,
			doubletime: 184
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/38m9yqy7fH2TiNa93BU9z7" },
						href: "https://api.spotify.com/v1/artists/38m9yqy7fH2TiNa93BU9z7",
						id: "38m9yqy7fH2TiNa93BU9z7",
						name: "Faux Tales",
						type: "artist",
						uri: "spotify:artist:38m9yqy7fH2TiNa93BU9z7"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7GP8DJyOZiEuqu3NveNQDm" },
				href: "https://api.spotify.com/v1/albums/7GP8DJyOZiEuqu3NveNQDm",
				id: "7GP8DJyOZiEuqu3NveNQDm",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736bc7d3e38a1990606481437f", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026bc7d3e38a1990606481437f", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516bc7d3e38a1990606481437f", width: 64 }
				],
				name: "Origins",
				release_date: "2018-06-08",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:7GP8DJyOZiEuqu3NveNQDm"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/38m9yqy7fH2TiNa93BU9z7" },
					href: "https://api.spotify.com/v1/artists/38m9yqy7fH2TiNa93BU9z7",
					id: "38m9yqy7fH2TiNa93BU9z7",
					name: "Faux Tales",
					type: "artist",
					uri: "spotify:artist:38m9yqy7fH2TiNa93BU9z7"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 242753,
			episode: false,
			explicit: false,
			external_ids: { isrc: "SEUM71800280" },
			external_urls: { spotify: "https://open.spotify.com/track/4nlK2jOjyST1zku3jDPqYd" },
			href: "https://api.spotify.com/v1/tracks/4nlK2jOjyST1zku3jDPqYd",
			id: "4nlK2jOjyST1zku3jDPqYd",
			is_local: false,
			name: "Origins",
			popularity: 32,
			preview_url: "https://p.scdn.co/mp3-preview/6b20535ba5876cbac290f321e6ed461fb4b32b10?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4nlK2jOjyST1zku3jDPqYd"
		},
		features: {
			danceability: 0.429,
			energy: 0.606,
			key: 7,
			loudness: -8.324,
			mode: 0,
			speechiness: 0.0343,
			acousticness: 0.00448,
			instrumentalness: 0.235,
			liveness: 0.116,
			valence: 0.0488,
			tempo: 135,
			type: "audio_features",
			id: "4nlK2jOjyST1zku3jDPqYd",
			uri: "spotify:track:4nlK2jOjyST1zku3jDPqYd",
			track_href: "https://api.spotify.com/v1/tracks/4nlK2jOjyST1zku3jDPqYd",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4nlK2jOjyST1zku3jDPqYd",
			duration_ms: 242753,
			time_signature: 4,
			doubletime: 135
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6fcTRFpz0yH79qSKfof7lp" },
						href: "https://api.spotify.com/v1/artists/6fcTRFpz0yH79qSKfof7lp",
						id: "6fcTRFpz0yH79qSKfof7lp",
						name: "Seven Lions",
						type: "artist",
						uri: "spotify:artist:6fcTRFpz0yH79qSKfof7lp"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3qnMl4DHT4gndzFAcG4FlM" },
						href: "https://api.spotify.com/v1/artists/3qnMl4DHT4gndzFAcG4FlM",
						id: "3qnMl4DHT4gndzFAcG4FlM",
						name: "Kill The Noise",
						type: "artist",
						uri: "spotify:artist:3qnMl4DHT4gndzFAcG4FlM"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7uoMa3Z5W676AUOhxe0Hxc" },
				href: "https://api.spotify.com/v1/albums/7uoMa3Z5W676AUOhxe0Hxc",
				id: "7uoMa3Z5W676AUOhxe0Hxc",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733afbad6f452c3c3cc6797bfd", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023afbad6f452c3c3cc6797bfd", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513afbad6f452c3c3cc6797bfd", width: 64 }
				],
				name: "The Blood",
				release_date: "2019-03-29",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:7uoMa3Z5W676AUOhxe0Hxc"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6fcTRFpz0yH79qSKfof7lp" },
					href: "https://api.spotify.com/v1/artists/6fcTRFpz0yH79qSKfof7lp",
					id: "6fcTRFpz0yH79qSKfof7lp",
					name: "Seven Lions",
					type: "artist",
					uri: "spotify:artist:6fcTRFpz0yH79qSKfof7lp"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3qnMl4DHT4gndzFAcG4FlM" },
					href: "https://api.spotify.com/v1/artists/3qnMl4DHT4gndzFAcG4FlM",
					id: "3qnMl4DHT4gndzFAcG4FlM",
					name: "Kill The Noise",
					type: "artist",
					uri: "spotify:artist:3qnMl4DHT4gndzFAcG4FlM"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 272291,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA1900830" },
			external_urls: { spotify: "https://open.spotify.com/track/0r6jGI9eAoUTSARgXPwdW7" },
			href: "https://api.spotify.com/v1/tracks/0r6jGI9eAoUTSARgXPwdW7",
			id: "0r6jGI9eAoUTSARgXPwdW7",
			is_local: false,
			name: "The Blood",
			popularity: 44,
			preview_url: "https://p.scdn.co/mp3-preview/67f23f5953843c754e78665f6019b2db0fdba002?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0r6jGI9eAoUTSARgXPwdW7"
		},
		features: {
			danceability: 0.504,
			energy: 0.767,
			key: 11,
			loudness: -5.12,
			mode: 0,
			speechiness: 0.0942,
			acousticness: 0.0194,
			instrumentalness: 0.477,
			liveness: 0.127,
			valence: 0.145,
			tempo: 112,
			type: "audio_features",
			id: "0r6jGI9eAoUTSARgXPwdW7",
			uri: "spotify:track:0r6jGI9eAoUTSARgXPwdW7",
			track_href: "https://api.spotify.com/v1/tracks/0r6jGI9eAoUTSARgXPwdW7",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0r6jGI9eAoUTSARgXPwdW7",
			duration_ms: 272291,
			time_signature: 3,
			doubletime: 112
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
						href: "https://api.spotify.com/v1/artists,/5FWi1mowu6uiU2ZHwr1rby",
						id: "5FWi1mowu6uiU2ZHwr1rby",
						name: "Feed Me",
						type: "artist",
						uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/10D96cw0tziudP0TZSZJJx" },
				href: "https://api.spotify.com/v1/albums/10D96cw0tziudP0TZSZJJx",
				id: "10D96cw0tziudP0TZSZJJx",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27382ecb4e7c2b8f0d5b8f17b65", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0282ecb4e7c2b8f0d5b8f17b65", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485182ecb4e7c2b8f0d5b8f17b65", width: 64 }
				],
				name: "High Street Creeps",
				release_date: "2019-02-22",
				release_date_precision: "day",
				total_tracks: 10,
				type: "album",
				uri: "spotify:album:10D96cw0tziudP0TZSZJJx"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5FWi1mowu6uiU2ZHwr1rby" },
					href: "https://api.spotify.com/v1/artists/5FWi1mowu6uiU2ZHwr1rby",
					id: "5FWi1mowu6uiU2ZHwr1rby",
					name: "Feed Me",
					type: "artist",
					uri: "spotify:artist:5FWi1mowu6uiU2ZHwr1rby"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5p4pJePZpvbPUi82Nvy4no" },
					href: "https://api.spotify.com/v1/artists/5p4pJePZpvbPUi82Nvy4no",
					id: "5p4pJePZpvbPUi82Nvy4no",
					name: "Lindsay",
					type: "artist",
					uri: "spotify:artist:5p4pJePZpvbPUi82Nvy4no"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 369672,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBTDG1301686" },
			external_urls: { spotify: "https://open.spotify.com/track/0VisfRkOp8rsbHLnHPPpgg" },
			href: "https://api.spotify.com/v1/tracks/0VisfRkOp8rsbHLnHPPpgg",
			id: "0VisfRkOp8rsbHLnHPPpgg",
			is_local: false,
			name: "Defiant",
			popularity: 31,
			preview_url: "https://p.scdn.co/mp3-preview/12e11a590680a954eb0c3a2c01705141acb66393?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:0VisfRkOp8rsbHLnHPPpgg"
		},
		features: {
			danceability: 0.575,
			energy: 0.663,
			key: 7,
			loudness: -5.697,
			mode: 0,
			speechiness: 0.0467,
			acousticness: 0.00141,
			instrumentalness: 0.000536,
			liveness: 0.334,
			valence: 0.153,
			tempo: 128,
			type: "audio_features",
			id: "0VisfRkOp8rsbHLnHPPpgg",
			uri: "spotify:track:0VisfRkOp8rsbHLnHPPpgg",
			track_href: "https://api.spotify.com/v1/tracks/0VisfRkOp8rsbHLnHPPpgg",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0VisfRkOp8rsbHLnHPPpgg",
			duration_ms: 369673,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5nPOO9iTcrs9k6yFffPxjH" },
						href: "https://api.spotify.com/v1/artists/5nPOO9iTcrs9k6yFffPxjH",
						id: "5nPOO9iTcrs9k6yFffPxjH",
						name: "Röyksopp",
						type: "artist",
						uri: "spotify:artist:5nPOO9iTcrs9k6yFffPxjH"
					}
				],
				available_markets: ["FR", "US"],
				external_urls: { spotify: "https://open.spotify.com/album/5q8ffowa7jVffTnxt6xlZV" },
				href: "https://api.spotify.com/v1/albums/5q8ffowa7jVffTnxt6xlZV",
				id: "5q8ffowa7jVffTnxt6xlZV",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27364d6dfd729df66d8e7417e74", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0264d6dfd729df66d8e7417e74", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485164d6dfd729df66d8e7417e74", width: 64 }
				],
				name: "Running To The Sea (Remixes)",
				release_date: "2013-01-01",
				release_date_precision: "day",
				total_tracks: 7,
				type: "album",
				uri: "spotify:album:5q8ffowa7jVffTnxt6xlZV"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5nPOO9iTcrs9k6yFffPxjH" },
					href: "https://api.spotify.com/v1/artists/5nPOO9iTcrs9k6yFffPxjH",
					id: "5nPOO9iTcrs9k6yFffPxjH",
					name: "Röyksopp",
					type: "artist",
					uri: "spotify:artist:5nPOO9iTcrs9k6yFffPxjH"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/54KCNI7URCrG6yjQK3Ukow" },
					href: "https://api.spotify.com/v1/artists/54KCNI7URCrG6yjQK3Ukow",
					id: "54KCNI7URCrG6yjQK3Ukow",
					name: "Susanne Sundfør",
					type: "artist",
					uri: "spotify:artist:54KCNI7URCrG6yjQK3Ukow"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6fcTRFpz0yH79qSKfof7lp" },
					href: "https://api.spotify.com/v1/artists/6fcTRFpz0yH79qSKfof7lp",
					id: "6fcTRFpz0yH79qSKfof7lp",
					name: "Seven Lions",
					type: "artist",
					uri: "spotify:artist:6fcTRFpz0yH79qSKfof7lp"
				}
			],
			available_markets: ["FR", "US"],
			disc_number: 1,
			duration_ms: 342400,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBW231300008" },
			external_urls: { spotify: "https://open.spotify.com/track/03hX1699FpP77Iii9LK50l" },
			href: "https://api.spotify.com/v1/tracks/03hX1699FpP77Iii9LK50l",
			id: "03hX1699FpP77Iii9LK50l",
			is_local: false,
			name: "Running To The Sea - Seven Lions Remix",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/2d97c2bf1d8adebbdbb037eb9551cc95b5ff81e1?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:03hX1699FpP77Iii9LK50l"
		},
		features: {
			danceability: 0.384,
			energy: 0.678,
			key: 6,
			loudness: -6.185,
			mode: 0,
			speechiness: 0.0617,
			acousticness: 0.145,
			instrumentalness: 0.0000372,
			liveness: 0.103,
			valence: 0.154,
			tempo: 138,
			type: "audio_features",
			id: "03hX1699FpP77Iii9LK50l",
			uri: "spotify:track:03hX1699FpP77Iii9LK50l",
			track_href: "https://api.spotify.com/v1/tracks/03hX1699FpP77Iii9LK50l",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/03hX1699FpP77Iii9LK50l",
			duration_ms: 342400,
			time_signature: 4,
			doubletime: 138
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3ssUeoVViu1S2RGl1hLmUh" },
						href: "https://api.spotify.com/v1/artists/3ssUeoVViu1S2RGl1hLmUh",
						id: "3ssUeoVViu1S2RGl1hLmUh",
						name: "Al'Tarba",
						type: "artist",
						uri: "spotify:artist:3ssUeoVViu1S2RGl1hLmUh"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7abaqPX14i31AxrQ3lFQgv" },
						href: "https://api.spotify.com/v1/artists/7abaqPX14i31AxrQ3lFQgv",
						id: "7abaqPX14i31AxrQ3lFQgv",
						name: "Senbeï",
						type: "artist",
						uri: "spotify:artist:7abaqPX14i31AxrQ3lFQgv"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3jfLx2bbGyao6gKha0ndUE" },
				href: "https://api.spotify.com/v1/albums/3jfLx2bbGyao6gKha0ndUE",
				id: "3jfLx2bbGyao6gKha0ndUE",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273f20c9701a9e82b5475a2e720", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02f20c9701a9e82b5475a2e720", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851f20c9701a9e82b5475a2e720", width: 64 }
				],
				name: "Rogue Monsters",
				release_date: "2019-02-08",
				release_date_precision: "day",
				total_tracks: 14,
				type: "album",
				uri: "spotify:album:3jfLx2bbGyao6gKha0ndUE"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3ssUeoVViu1S2RGl1hLmUh" },
					href: "https://api.spotify.com/v1/artists/3ssUeoVViu1S2RGl1hLmUh",
					id: "3ssUeoVViu1S2RGl1hLmUh",
					name: "Al'Tarba",
					type: "artist",
					uri: "spotify:artist:3ssUeoVViu1S2RGl1hLmUh"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7abaqPX14i31AxrQ3lFQgv" },
					href: "https://api.spotify.com/v1/artists/7abaqPX14i31AxrQ3lFQgv",
					id: "7abaqPX14i31AxrQ3lFQgv",
					name: "Senbeï",
					type: "artist",
					uri: "spotify:artist:7abaqPX14i31AxrQ3lFQgv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 298846,
			episode: false,
			explicit: false,
			external_ids: { isrc: "FRPHC1800045" },
			external_urls: { spotify: "https://open.spotify.com/track/6QVGnV4FDPsz9k9VhGZc7o" },
			href: "https://api.spotify.com/v1/tracks/6QVGnV4FDPsz9k9VhGZc7o",
			id: "6QVGnV4FDPsz9k9VhGZc7o",
			is_local: false,
			name: "Tarikh",
			popularity: 18,
			preview_url: "https://p.scdn.co/mp3-preview/d07eafb907aeff39b781ee54c4a650341cab3e8c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 10,
			type: "track",
			uri: "spotify:track:6QVGnV4FDPsz9k9VhGZc7o"
		},
		features: {
			danceability: 0.509,
			energy: 0.781,
			key: 6,
			loudness: -6.774,
			mode: 0,
			speechiness: 0.287,
			acousticness: 0.0476,
			instrumentalness: 0.0000644,
			liveness: 0.13,
			valence: 0.317,
			tempo: 78,
			type: "audio_features",
			id: "6QVGnV4FDPsz9k9VhGZc7o",
			uri: "spotify:track:6QVGnV4FDPsz9k9VhGZc7o",
			track_href: "https://api.spotify.com/v1/tracks/6QVGnV4FDPsz9k9VhGZc7o",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/6QVGnV4FDPsz9k9VhGZc7o",
			duration_ms: 298846,
			time_signature: 4,
			doubletime: 156
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0iDBD558yJl5IfRXg9Yfwt" },
						href: "https://api.spotify.com/v1/artists/0iDBD558yJl5IfRXg9Yfwt",
						id: "0iDBD558yJl5IfRXg9Yfwt",
						name: "ETC!ETC!",
						type: "artist",
						uri: "spotify:artist:0iDBD558yJl5IfRXg9Yfwt"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6d9SnuHI2bRer7c76d8sLq" },
						href: "https://api.spotify.com/v1/artists/6d9SnuHI2bRer7c76d8sLq",
						id: "6d9SnuHI2bRer7c76d8sLq",
						name: "Bro Safari",
						type: "artist",
						uri: "spotify:artist:6d9SnuHI2bRer7c76d8sLq"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2BS49jj60nOkjwEPa9sTN6" },
						href: "https://api.spotify.com/v1/artists/2BS49jj60nOkjwEPa9sTN6",
						id: "2BS49jj60nOkjwEPa9sTN6",
						name: "LO-DEF",
						type: "artist",
						uri: "spotify:artist:2BS49jj60nOkjwEPa9sTN6"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/6HRaEbYCNEVd2m0B3ou0Ep" },
				href: "https://api.spotify.com/v1/albums/6HRaEbYCNEVd2m0B3ou0Ep",
				id: "6HRaEbYCNEVd2m0B3ou0Ep",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273752a67c477e12c8eb2ae8ef6", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02752a67c477e12c8eb2ae8ef6", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851752a67c477e12c8eb2ae8ef6", width: 64 }
				],
				name: "Devil's Lettuce (feat. Sanjin) [LO-DEF Remix]",
				release_date: "2016-04-19",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:6HRaEbYCNEVd2m0B3ou0Ep"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0iDBD558yJl5IfRXg9Yfwt" },
					href: "https://api.spotify.com/v1/artists/0iDBD558yJl5IfRXg9Yfwt",
					id: "0iDBD558yJl5IfRXg9Yfwt",
					name: "ETC!ETC!",
					type: "artist",
					uri: "spotify:artist:0iDBD558yJl5IfRXg9Yfwt"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6d9SnuHI2bRer7c76d8sLq" },
					href: "https://api.spotify.com/v1/artists/6d9SnuHI2bRer7c76d8sLq",
					id: "6d9SnuHI2bRer7c76d8sLq",
					name: "Bro Safari",
					type: "artist",
					uri: "spotify:artist:6d9SnuHI2bRer7c76d8sLq"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4eubQnUM4b5sGZoi3fSRV3" },
					href: "https://api.spotify.com/v1/artists/4eubQnUM4b5sGZoi3fSRV3",
					id: "4eubQnUM4b5sGZoi3fSRV3",
					name: "Sanjin",
					type: "artist",
					uri: "spotify:artist:4eubQnUM4b5sGZoi3fSRV3"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2BS49jj60nOkjwEPa9sTN6" },
					href: "https://api.spotify.com/v1/artists/2BS49jj60nOkjwEPa9sTN6",
					id: "2BS49jj60nOkjwEPa9sTN6",
					name: "LO-DEF",
					type: "artist",
					uri: "spotify:artist:2BS49jj60nOkjwEPa9sTN6"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 188160,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USDM31682201" },
			external_urls: { spotify: "https://open.spotify.com/track/1klnm7QIrReZoLAyvmbTdX" },
			href: "https://api.spotify.com/v1/tracks/1klnm7QIrReZoLAyvmbTdX",
			id: "1klnm7QIrReZoLAyvmbTdX",
			is_local: false,
			name: "Devil's Lettuce (feat. Sanjin) - LO-DEF Remix",
			popularity: 21,
			preview_url: "https://p.scdn.co/mp3-preview/5865911aeb6a495f61d976cc49f00ce38c30d5d6?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1klnm7QIrReZoLAyvmbTdX"
		},
		features: {
			danceability: 0.878,
			energy: 0.721,
			key: 9,
			loudness: -4.442,
			mode: 1,
			speechiness: 0.18,
			acousticness: 0.00158,
			instrumentalness: 0.0495,
			liveness: 0.226,
			valence: 0.462,
			tempo: 125,
			type: "audio_features",
			id: "1klnm7QIrReZoLAyvmbTdX",
			uri: "spotify:track:1klnm7QIrReZoLAyvmbTdX",
			track_href: "https://api.spotify.com/v1/tracks/1klnm7QIrReZoLAyvmbTdX",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1klnm7QIrReZoLAyvmbTdX",
			duration_ms: 188160,
			time_signature: 4,
			doubletime: 125
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7CCjtD0hCK005Bvg2WG1a7" },
						href: "https://api.spotify.com/v1/artists/7CCjtD0hCK005Bvg2WG1a7",
						id: "7CCjtD0hCK005Bvg2WG1a7",
						name: "Carnage",
						type: "artist",
						uri: "spotify:artist:7CCjtD0hCK005Bvg2WG1a7"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/52GddglHbBcj6S4tuHHoVU" },
				href: "https://api.spotify.com/v1/albums/52GddglHbBcj6S4tuHHoVU",
				id: "52GddglHbBcj6S4tuHHoVU",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27397661000b22ea3d7560db391", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0297661000b22ea3d7560db391", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485197661000b22ea3d7560db391", width: 64 }
				],
				name: "Letting People Go (feat. Prinze George)",
				release_date: "2019-03-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:52GddglHbBcj6S4tuHHoVU"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7CCjtD0hCK005Bvg2WG1a7" },
					href: "https://api.spotify.com/v1/artists/7CCjtD0hCK005Bvg2WG1a7",
					id: "7CCjtD0hCK005Bvg2WG1a7",
					name: "Carnage",
					type: "artist",
					uri: "spotify:artist:7CCjtD0hCK005Bvg2WG1a7"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3o6TKTQIu0lCYcNtSO3i1G" },
					href: "https://api.spotify.com/v1/artists/3o6TKTQIu0lCYcNtSO3i1G",
					id: "3o6TKTQIu0lCYcNtSO3i1G",
					name: "Prinze George",
					type: "artist",
					uri: "spotify:artist:3o6TKTQIu0lCYcNtSO3i1G"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 240024,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USUYG1244692" },
			external_urls: { spotify: "https://open.spotify.com/track/3xVfvbf4EEcgh4vnvgdjeO" },
			href: "https://api.spotify.com/v1/tracks/3xVfvbf4EEcgh4vnvgdjeO",
			id: "3xVfvbf4EEcgh4vnvgdjeO",
			is_local: false,
			name: "Letting People Go (feat. Prinze George)",
			popularity: 51,
			preview_url: "https://p.scdn.co/mp3-preview/66f110aa3b06507ecd388e0c74456e4e192349fe?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3xVfvbf4EEcgh4vnvgdjeO"
		},
		features: {
			danceability: 0.795,
			energy: 0.695,
			key: 9,
			loudness: -9.097,
			mode: 1,
			speechiness: 0.0384,
			acousticness: 0.324,
			instrumentalness: 0.00746,
			liveness: 0.107,
			valence: 0.418,
			tempo: 120,
			type: "audio_features",
			id: "3xVfvbf4EEcgh4vnvgdjeO",
			uri: "spotify:track:3xVfvbf4EEcgh4vnvgdjeO",
			track_href: "https://api.spotify.com/v1/tracks/3xVfvbf4EEcgh4vnvgdjeO",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3xVfvbf4EEcgh4vnvgdjeO",
			duration_ms: 240024,
			time_signature: 4,
			doubletime: 120
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5MTN31B0DYG43RQJ9zT5fq" },
						href: "https://api.spotify.com/v1/artists/5MTN31B0DYG43RQJ9zT5fq",
						id: "5MTN31B0DYG43RQJ9zT5fq",
						name: "Social Kid",
						type: "artist",
						uri: "spotify:artist:5MTN31B0DYG43RQJ9zT5fq"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3uN4Qj6UREgOwEOQmY7Mst" },
						href: "https://api.spotify.com/v1/artists/3uN4Qj6UREgOwEOQmY7Mst",
						id: "3uN4Qj6UREgOwEOQmY7Mst",
						name: "Azcii",
						type: "artist",
						uri: "spotify:artist:3uN4Qj6UREgOwEOQmY7Mst"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4TyWevTsVStCq9SaIfKSwd" },
				href: "https://api.spotify.com/v1/albums/4TyWevTsVStCq9SaIfKSwd",
				id: "4TyWevTsVStCq9SaIfKSwd",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733b6953be1c364274d5e7c13b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023b6953be1c364274d5e7c13b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513b6953be1c364274d5e7c13b", width: 64 }
				],
				name: "Lyra",
				release_date: "2018-12-17",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4TyWevTsVStCq9SaIfKSwd"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5MTN31B0DYG43RQJ9zT5fq" },
					href: "https://api.spotify.com/v1/artists/5MTN31B0DYG43RQJ9zT5fq",
					id: "5MTN31B0DYG43RQJ9zT5fq",
					name: "Social Kid",
					type: "artist",
					uri: "spotify:artist:5MTN31B0DYG43RQJ9zT5fq"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3uN4Qj6UREgOwEOQmY7Mst" },
					href: "https://api.spotify.com/v1/artists/3uN4Qj6UREgOwEOQmY7Mst",
					id: "3uN4Qj6UREgOwEOQmY7Mst",
					name: "Azcii",
					type: "artist",
					uri: "spotify:artist:3uN4Qj6UREgOwEOQmY7Mst"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 197330,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCADZ1876958" },
			external_urls: { spotify: "https://open.spotify.com/track/2bZxkp52ghcqGrc7r7PUix" },
			href: "https://api.spotify.com/v1/tracks/2bZxkp52ghcqGrc7r7PUix",
			id: "2bZxkp52ghcqGrc7r7PUix",
			is_local: false,
			name: "Lyra",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/2356e3a2f087dac35506e1121ea2ddc708628246?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:2bZxkp52ghcqGrc7r7PUix"
		},
		features: {
			danceability: 0.617,
			energy: 0.895,
			key: 1,
			loudness: -4.46,
			mode: 1,
			speechiness: 0.112,
			acousticness: 0.0104,
			instrumentalness: 0.552,
			liveness: 0.391,
			valence: 0.468,
			tempo: 100,
			type: "audio_features",
			id: "2bZxkp52ghcqGrc7r7PUix",
			uri: "spotify:track:2bZxkp52ghcqGrc7r7PUix",
			track_href: "https://api.spotify.com/v1/tracks/2bZxkp52ghcqGrc7r7PUix",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2bZxkp52ghcqGrc7r7PUix",
			duration_ms: 197331,
			time_signature: 4,
			doubletime: 100
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1Itil4naIwgkm48BNTjZ2A" },
						href: "https://api.spotify.com/v1/artists/1Itil4naIwgkm48BNTjZ2A",
						id: "1Itil4naIwgkm48BNTjZ2A",
						name: "Hidden Face",
						type: "artist",
						uri: "spotify:artist:1Itil4naIwgkm48BNTjZ2A"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/2IAatI1WBc254nY5jBP3UT" },
				href: "https://api.spotify.com/v1/albums/2IAatI1WBc254nY5jBP3UT",
				id: "2IAatI1WBc254nY5jBP3UT",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273b3ba57d770655e7f099d73ee", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02b3ba57d770655e7f099d73ee", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851b3ba57d770655e7f099d73ee", width: 64 }
				],
				name: "I Am Nobody",
				release_date: "2018-11-16",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:2IAatI1WBc254nY5jBP3UT"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1Itil4naIwgkm48BNTjZ2A" },
					href: "https://api.spotify.com/v1/artists/1Itil4naIwgkm48BNTjZ2A",
					id: "1Itil4naIwgkm48BNTjZ2A",
					name: "Hidden Face",
					type: "artist",
					uri: "spotify:artist:1Itil4naIwgkm48BNTjZ2A"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 316097,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QZDA51857992" },
			external_urls: { spotify: "https://open.spotify.com/track/0X5be1i8M3KWCW77cNbulL" },
			href: "https://api.spotify.com/v1/tracks/0X5be1i8M3KWCW77cNbulL",
			id: "0X5be1i8M3KWCW77cNbulL",
			is_local: false,
			name: "I Am Nobody",
			popularity: 38,
			preview_url: "https://p.scdn.co/mp3-preview/6af1b5877883a164e6d38621736890da1dee22de?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0X5be1i8M3KWCW77cNbulL"
		},
		features: {
			danceability: 0.568,
			energy: 0.634,
			key: 2,
			loudness: -7.887,
			mode: 1,
			speechiness: 0.16,
			acousticness: 0.583,
			instrumentalness: 0.878,
			liveness: 0.087,
			valence: 0.0735,
			tempo: 123,
			type: "audio_features",
			id: "0X5be1i8M3KWCW77cNbulL",
			uri: "spotify:track:0X5be1i8M3KWCW77cNbulL",
			track_href: "https://api.spotify.com/v1/tracks/0X5be1i8M3KWCW77cNbulL",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0X5be1i8M3KWCW77cNbulL",
			duration_ms: 316098,
			time_signature: 4,
			doubletime: 123
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/42crL07E4WPfVovyUtMpvC" },
						href: "https://api.spotify.com/v1/artists/42crL07E4WPfVovyUtMpvC",
						id: "42crL07E4WPfVovyUtMpvC",
						name: "Robert DeLong",
						type: "artist",
						uri: "spotify:artist:42crL07E4WPfVovyUtMpvC"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3ufL0LoXla0FS28AKPeOlc" },
				href: "https://api.spotify.com/v1/albums/3ufL0LoXla0FS28AKPeOlc",
				id: "3ufL0LoXla0FS28AKPeOlc",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27391dc039c2b2b08cd9f1d55f3", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0291dc039c2b2b08cd9f1d55f3", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485191dc039c2b2b08cd9f1d55f3", width: 64 }
				],
				name: "In the Cards",
				release_date: "2015-09-18",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:3ufL0LoXla0FS28AKPeOlc"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/42crL07E4WPfVovyUtMpvC" },
					href: "https://api.spotify.com/v1/artists/42crL07E4WPfVovyUtMpvC",
					id: "42crL07E4WPfVovyUtMpvC",
					name: "Robert DeLong",
					type: "artist",
					uri: "spotify:artist:42crL07E4WPfVovyUtMpvC"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN"
			],
			disc_number: 1,
			duration_ms: 258546,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USYAH1500082" },
			external_urls: { spotify: "https://open.spotify.com/track/0sVxtgav9DmLJsIlCFxvdr" },
			href: "https://api.spotify.com/v1/tracks/0sVxtgav9DmLJsIlCFxvdr",
			id: "0sVxtgav9DmLJsIlCFxvdr",
			is_local: false,
			name: "Possessed",
			popularity: 25,
			preview_url: "https://p.scdn.co/mp3-preview/b07bf7f86eca950db518fcb1c2865318ce06d34f?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:0sVxtgav9DmLJsIlCFxvdr"
		},
		features: {
			danceability: 0.79,
			energy: 0.699,
			key: 7,
			loudness: -5.142,
			mode: 0,
			speechiness: 0.0782,
			acousticness: 0.0333,
			instrumentalness: 0.000147,
			liveness: 0.168,
			valence: 0.61,
			tempo: 112,
			type: "audio_features",
			id: "0sVxtgav9DmLJsIlCFxvdr",
			uri: "spotify:track:0sVxtgav9DmLJsIlCFxvdr",
			track_href: "https://api.spotify.com/v1/tracks/0sVxtgav9DmLJsIlCFxvdr",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0sVxtgav9DmLJsIlCFxvdr",
			duration_ms: 258547,
			time_signature: 4,
			doubletime: 112
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5CMaNobmJYgXcfiT0zYOwi" },
						href: "https://api.spotify.com/v1/artists/5CMaNobmJYgXcfiT0zYOwi",
						id: "5CMaNobmJYgXcfiT0zYOwi",
						name: "WHIPPED CREAM",
						type: "artist",
						uri: "spotify:artist:5CMaNobmJYgXcfiT0zYOwi"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/13Kq3xIPcYtFfou8Up3BKt" },
				href: "https://api.spotify.com/v1/albums/13Kq3xIPcYtFfou8Up3BKt",
				id: "13Kq3xIPcYtFfou8Up3BKt",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273ed4af8e407d9daa7ad57460b", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02ed4af8e407d9daa7ad57460b", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851ed4af8e407d9daa7ad57460b", width: 64 }
				],
				name: "Bad For Me",
				release_date: "2018-11-02",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:13Kq3xIPcYtFfou8Up3BKt"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5CMaNobmJYgXcfiT0zYOwi" },
					href: "https://api.spotify.com/v1/artists/5CMaNobmJYgXcfiT0zYOwi",
					id: "5CMaNobmJYgXcfiT0zYOwi",
					name: "WHIPPED CREAM",
					type: "artist",
					uri: "spotify:artist:5CMaNobmJYgXcfiT0zYOwi"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 191007,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USAT21811716" },
			external_urls: { spotify: "https://open.spotify.com/track/0aQXKkpgnoTgCXBRNeWGrU" },
			href: "https://api.spotify.com/v1/tracks/0aQXKkpgnoTgCXBRNeWGrU",
			id: "0aQXKkpgnoTgCXBRNeWGrU",
			is_local: false,
			name: "Bad For Me",
			popularity: 38,
			preview_url: "https://p.scdn.co/mp3-preview/0507922d374192c998601c7d0422703c2678a229?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0aQXKkpgnoTgCXBRNeWGrU"
		},
		features: {
			danceability: 0.596,
			energy: 0.894,
			key: 5,
			loudness: -4.63,
			mode: 1,
			speechiness: 0.0513,
			acousticness: 0.0272,
			instrumentalness: 0.592,
			liveness: 0.115,
			valence: 0.0363,
			tempo: 105,
			type: "audio_features",
			id: "0aQXKkpgnoTgCXBRNeWGrU",
			uri: "spotify:track:0aQXKkpgnoTgCXBRNeWGrU",
			track_href: "https://api.spotify.com/v1/tracks/0aQXKkpgnoTgCXBRNeWGrU",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0aQXKkpgnoTgCXBRNeWGrU",
			duration_ms: 191007,
			time_signature: 4,
			doubletime: 105
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/3koHmmPvpgZWHcVmK8AKDq" },
						href: "https://api.spotify.com/v1/artists/3koHmmPvpgZWHcVmK8AKDq",
						id: "3koHmmPvpgZWHcVmK8AKDq",
						name: "HVDES",
						type: "artist",
						uri: "spotify:artist:3koHmmPvpgZWHcVmK8AKDq"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4erNQhGjzQcodIPYBfbYhC" },
				href: "https://api.spotify.com/v1/albums/4erNQhGjzQcodIPYBfbYhC",
				id: "4erNQhGjzQcodIPYBfbYhC",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27370eba601c3efb66f42314d3f", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0270eba601c3efb66f42314d3f", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485170eba601c3efb66f42314d3f", width: 64 }
				],
				name: "Fuck My Nose Up",
				release_date: "2017-11-15",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:4erNQhGjzQcodIPYBfbYhC"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3koHmmPvpgZWHcVmK8AKDq" },
					href: "https://api.spotify.com/v1/artists/3koHmmPvpgZWHcVmK8AKDq",
					id: "3koHmmPvpgZWHcVmK8AKDq",
					name: "HVDES",
					type: "artist",
					uri: "spotify:artist:3koHmmPvpgZWHcVmK8AKDq"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 233846,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QM42K1735898" },
			external_urls: { spotify: "https://open.spotify.com/track/7r9MY22t7LctUxngY2FexI" },
			href: "https://api.spotify.com/v1/tracks/7r9MY22t7LctUxngY2FexI",
			id: "7r9MY22t7LctUxngY2FexI",
			is_local: false,
			name: "Fuck My Nose Up",
			popularity: 36,
			preview_url: "https://p.scdn.co/mp3-preview/a42ca47b538c11e32800e1ac21fa6a3c5cc6ff94?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:7r9MY22t7LctUxngY2FexI"
		},
		features: {
			danceability: 0.599,
			energy: 0.884,
			key: 1,
			loudness: -5.369,
			mode: 1,
			speechiness: 0.0711,
			acousticness: 0.00909,
			instrumentalness: 0.141,
			liveness: 0.096,
			valence: 0.405,
			tempo: 117,
			type: "audio_features",
			id: "7r9MY22t7LctUxngY2FexI",
			uri: "spotify:track:7r9MY22t7LctUxngY2FexI",
			track_href: "https://api.spotify.com/v1/tracks/7r9MY22t7LctUxngY2FexI",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/7r9MY22t7LctUxngY2FexI",
			duration_ms: 233846,
			time_signature: 4,
			doubletime: 117
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7i9D3b5D9UQPnnG58MJfn7" },
						href: "https://api.spotify.com/v1/artists/7i9D3b5D9UQPnnG58MJfn7",
						id: "7i9D3b5D9UQPnnG58MJfn7",
						name: "SNOWMASS",
						type: "artist",
						uri: "spotify:artist:7i9D3b5D9UQPnnG58MJfn7"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/6mLoXZQPyVJgzOqKLkJQoC" },
						href: "https://api.spotify.com/v1/artists/6mLoXZQPyVJgzOqKLkJQoC",
						id: "6mLoXZQPyVJgzOqKLkJQoC",
						name: "Synymata",
						type: "artist",
						uri: "spotify:artist:6mLoXZQPyVJgzOqKLkJQoC"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5iqkaf7gnBEEmpZTN9zABh" },
				href: "https://api.spotify.com/v1/albums/5iqkaf7gnBEEmpZTN9zABh",
				id: "5iqkaf7gnBEEmpZTN9zABh",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27356186aea91f8507fb993625d", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0256186aea91f8507fb993625d", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485156186aea91f8507fb993625d", width: 64 }
				],
				name: "The Future",
				release_date: "2018-11-14",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5iqkaf7gnBEEmpZTN9zABh"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7i9D3b5D9UQPnnG58MJfn7" },
					href: "https://api.spotify.com/v1/artists/7i9D3b5D9UQPnnG58MJfn7",
					id: "7i9D3b5D9UQPnnG58MJfn7",
					name: "SNOWMASS",
					type: "artist",
					uri: "spotify:artist:7i9D3b5D9UQPnnG58MJfn7"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/6mLoXZQPyVJgzOqKLkJQoC" },
					href: "https://api.spotify.com/v1/artists/6mLoXZQPyVJgzOqKLkJQoC",
					id: "6mLoXZQPyVJgzOqKLkJQoC",
					name: "Synymata",
					type: "artist",
					uri: "spotify:artist:6mLoXZQPyVJgzOqKLkJQoC"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 205360,
			episode: false,
			explicit: false,
			external_ids: { isrc: "TCADY1834224" },
			external_urls: { spotify: "https://open.spotify.com/track/4VjklGcjIjEyztEorjhXHh" },
			href: "https://api.spotify.com/v1/tracks/4VjklGcjIjEyztEorjhXHh",
			id: "4VjklGcjIjEyztEorjhXHh",
			is_local: false,
			name: "The Future",
			popularity: 22,
			preview_url: "https://p.scdn.co/mp3-preview/b5eeab295be585291d3c056cb05996d1b1f5f50c?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:4VjklGcjIjEyztEorjhXHh"
		},
		features: {
			danceability: 0.555,
			energy: 0.841,
			key: 4,
			loudness: -2.838,
			mode: 1,
			speechiness: 0.395,
			acousticness: 0.217,
			instrumentalness: 0.282,
			liveness: 0.324,
			valence: 0.232,
			tempo: 194,
			type: "audio_features",
			id: "4VjklGcjIjEyztEorjhXHh",
			uri: "spotify:track:4VjklGcjIjEyztEorjhXHh",
			track_href: "https://api.spotify.com/v1/tracks/4VjklGcjIjEyztEorjhXHh",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/4VjklGcjIjEyztEorjhXHh",
			duration_ms: 205361,
			time_signature: 4,
			doubletime: 194
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1YOw6jUy5uUo7rNMb2wj4Q" },
						href: "https://api.spotify.com/v1/artists/1YOw6jUy5uUo7rNMb2wj4Q",
						id: "1YOw6jUy5uUo7rNMb2wj4Q",
						name: "Nebbra",
						type: "artist",
						uri: "spotify:artist:1YOw6jUy5uUo7rNMb2wj4Q"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7IPZDKZsATQ4Xdxi5AZDO7" },
				href: "https://api.spotify.com/v1/albums/7IPZDKZsATQ4Xdxi5AZDO7",
				id: "7IPZDKZsATQ4Xdxi5AZDO7",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2731b612877c6bb835d638f5764", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e021b612877c6bb835d638f5764", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048511b612877c6bb835d638f5764", width: 64 }
				],
				name: "Naked Flame",
				release_date: "2018-12-14",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:7IPZDKZsATQ4Xdxi5AZDO7"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1YOw6jUy5uUo7rNMb2wj4Q" },
					href: "https://api.spotify.com/v1/artists/1YOw6jUy5uUo7rNMb2wj4Q",
					id: "1YOw6jUy5uUo7rNMb2wj4Q",
					name: "Nebbra",
					type: "artist",
					uri: "spotify:artist:1YOw6jUy5uUo7rNMb2wj4Q"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1qo3qvulyeKNNWjFCPXwwb" },
					href: "https://api.spotify.com/v1/artists/1qo3qvulyeKNNWjFCPXwwb",
					id: "1qo3qvulyeKNNWjFCPXwwb",
					name: "LeyeT",
					type: "artist",
					uri: "spotify:artist:1qo3qvulyeKNNWjFCPXwwb"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 259909,
			episode: false,
			explicit: false,
			external_ids: { isrc: "QM6P41883728" },
			external_urls: { spotify: "https://open.spotify.com/track/5Xjc8o2NdSMZRoNREsiG2D" },
			href: "https://api.spotify.com/v1/tracks/5Xjc8o2NdSMZRoNREsiG2D",
			id: "5Xjc8o2NdSMZRoNREsiG2D",
			is_local: false,
			name: "Naked Flame (feat. LeyeT)",
			popularity: 43,
			preview_url: "https://p.scdn.co/mp3-preview/b03c44e518f01d12b6c1253bf80efd3515a3a436?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:5Xjc8o2NdSMZRoNREsiG2D"
		},
		features: {
			danceability: 0.615,
			energy: 0.679,
			key: 8,
			loudness: -8.858,
			mode: 0,
			speechiness: 0.353,
			acousticness: 0.605,
			instrumentalness: 0.000194,
			liveness: 0.148,
			valence: 0.295,
			tempo: 110,
			type: "audio_features",
			id: "5Xjc8o2NdSMZRoNREsiG2D",
			uri: "spotify:track:5Xjc8o2NdSMZRoNREsiG2D",
			track_href: "https://api.spotify.com/v1/tracks/5Xjc8o2NdSMZRoNREsiG2D",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/5Xjc8o2NdSMZRoNREsiG2D",
			duration_ms: 259909,
			time_signature: 4,
			doubletime: 110
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7lm68Uw3UZDD1vlAWpLeDL" },
						href: "https://api.spotify.com/v1/artists/7lm68Uw3UZDD1vlAWpLeDL",
						id: "7lm68Uw3UZDD1vlAWpLeDL",
						name: "Falcons",
						type: "artist",
						uri: "spotify:artist:7lm68Uw3UZDD1vlAWpLeDL"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1XERqJZ0Y9BhtGQWixYXRO" },
				href: "https://api.spotify.com/v1/albums/1XERqJZ0Y9BhtGQWixYXRO",
				id: "1XERqJZ0Y9BhtGQWixYXRO",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2739c1690f37137522886fb6a41", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e029c1690f37137522886fb6a41", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048519c1690f37137522886fb6a41", width: 64 }
				],
				name: "Aquafina (2K19 Remix)",
				release_date: "2019-05-31",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1XERqJZ0Y9BhtGQWixYXRO"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7lm68Uw3UZDD1vlAWpLeDL" },
					href: "https://api.spotify.com/v1/artists/7lm68Uw3UZDD1vlAWpLeDL",
					id: "7lm68Uw3UZDD1vlAWpLeDL",
					name: "Falcons",
					type: "artist",
					uri: "spotify:artist:7lm68Uw3UZDD1vlAWpLeDL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5XenQ7XfcvQdfIbpLEFaKQ" },
					href: "https://api.spotify.com/v1/artists/5XenQ7XfcvQdfIbpLEFaKQ",
					id: "5XenQ7XfcvQdfIbpLEFaKQ",
					name: "GoldLink",
					type: "artist",
					uri: "spotify:artist:5XenQ7XfcvQdfIbpLEFaKQ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3BYzEWh3pY0DZpMN0hFufv" },
					href: "https://api.spotify.com/v1/artists/3BYzEWh3pY0DZpMN0hFufv",
					id: "3BYzEWh3pY0DZpMN0hFufv",
					name: "Chaz French",
					type: "artist",
					uri: "spotify:artist:3BYzEWh3pY0DZpMN0hFufv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 185962,
			episode: false,
			explicit: true,
			external_ids: { isrc: "QMSDU1900022" },
			external_urls: { spotify: "https://open.spotify.com/track/3XnP6MqGgIXhNxak52EjGH" },
			href: "https://api.spotify.com/v1/tracks/3XnP6MqGgIXhNxak52EjGH",
			id: "3XnP6MqGgIXhNxak52EjGH",
			is_local: false,
			name: "Aquafina - 2K19 Remix",
			popularity: 16,
			preview_url: "https://p.scdn.co/mp3-preview/303dfe8549077cf8896303583200e151231a1168?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3XnP6MqGgIXhNxak52EjGH"
		},
		features: {
			danceability: 0.807,
			energy: 0.825,
			key: 11,
			loudness: -5.92,
			mode: 1,
			speechiness: 0.256,
			acousticness: 0.00534,
			instrumentalness: 0,
			liveness: 0.171,
			valence: 0.76,
			tempo: 132,
			type: "audio_features",
			id: "3XnP6MqGgIXhNxak52EjGH",
			uri: "spotify:track:3XnP6MqGgIXhNxak52EjGH",
			track_href: "https://api.spotify.com/v1/tracks/3XnP6MqGgIXhNxak52EjGH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3XnP6MqGgIXhNxak52EjGH",
			duration_ms: 185962,
			time_signature: 4,
			doubletime: 132
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/21mKp7DqtSNHhCAU2ugvUw" },
						href: "https://api.spotify.com/v1/artists/21mKp7DqtSNHhCAU2ugvUw",
						id: "21mKp7DqtSNHhCAU2ugvUw",
						name: "ODESZA",
						type: "artist",
						uri: "spotify:artist:21mKp7DqtSNHhCAU2ugvUw"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/2SrWifjYv7b5tR8EzEmn1x" },
						href: "https://api.spotify.com/v1/artists/2SrWifjYv7b5tR8EzEmn1x",
						id: "2SrWifjYv7b5tR8EzEmn1x",
						name: "Golden Features",
						type: "artist",
						uri: "spotify:artist:2SrWifjYv7b5tR8EzEmn1x"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5gddKxtBEbT4a9Q6uLeMiM" },
				href: "https://api.spotify.com/v1/albums/5gddKxtBEbT4a9Q6uLeMiM",
				id: "5gddKxtBEbT4a9Q6uLeMiM",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273635738d5f6709c1864fc0954", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02635738d5f6709c1864fc0954", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851635738d5f6709c1864fc0954", width: 64 }
				],
				name: "Falls (Golden Features Remix)",
				release_date: "2018-10-10",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:5gddKxtBEbT4a9Q6uLeMiM"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/21mKp7DqtSNHhCAU2ugvUw" },
					href: "https://api.spotify.com/v1/artists/21mKp7DqtSNHhCAU2ugvUw",
					id: "21mKp7DqtSNHhCAU2ugvUw",
					name: "ODESZA",
					type: "artist",
					uri: "spotify:artist:21mKp7DqtSNHhCAU2ugvUw"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4xnihxcoXWK3UqryOSnbw5" },
					href: "https://api.spotify.com/v1/artists/4xnihxcoXWK3UqryOSnbw5",
					id: "4xnihxcoXWK3UqryOSnbw5",
					name: "Sasha Sloan",
					type: "artist",
					uri: "spotify:artist:4xnihxcoXWK3UqryOSnbw5"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2SrWifjYv7b5tR8EzEmn1x" },
					href: "https://api.spotify.com/v1/artists/2SrWifjYv7b5tR8EzEmn1x",
					id: "2SrWifjYv7b5tR8EzEmn1x",
					name: "Golden Features",
					type: "artist",
					uri: "spotify:artist:2SrWifjYv7b5tR8EzEmn1x"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 305806,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBCFB1800246" },
			external_urls: { spotify: "https://open.spotify.com/track/3Q8N40f3RvtQoaPnEwYj6d" },
			href: "https://api.spotify.com/v1/tracks/3Q8N40f3RvtQoaPnEwYj6d",
			id: "3Q8N40f3RvtQoaPnEwYj6d",
			is_local: false,
			name: "Falls - Golden Features Remix",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/745e3abc0e44218dbe02e7da6f93cf6fb12a8532?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3Q8N40f3RvtQoaPnEwYj6d"
		},
		features: {
			danceability: 0.797,
			energy: 0.78,
			key: 10,
			loudness: -8.943,
			mode: 0,
			speechiness: 0.184,
			acousticness: 0.478,
			instrumentalness: 0.896,
			liveness: 0.379,
			valence: 0.207,
			tempo: 124,
			type: "audio_features",
			id: "3Q8N40f3RvtQoaPnEwYj6d",
			uri: "spotify:track:3Q8N40f3RvtQoaPnEwYj6d",
			track_href: "https://api.spotify.com/v1/tracks/3Q8N40f3RvtQoaPnEwYj6d",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3Q8N40f3RvtQoaPnEwYj6d",
			duration_ms: 305806,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1yoZuH2j43vVSWsOwYuQyn" },
						href: "https://api.spotify.com/v1/artists/1yoZuH2j43vVSWsOwYuQyn",
						id: "1yoZuH2j43vVSWsOwYuQyn",
						name: "Ilan Bluestone",
						type: "artist",
						uri: "spotify:artist:1yoZuH2j43vVSWsOwYuQyn"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1KWL7LvN5Ty009GeAwLCEs" },
				href: "https://api.spotify.com/v1/albums/1KWL7LvN5Ty009GeAwLCEs",
				id: "1KWL7LvN5Ty009GeAwLCEs",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c12dc6c887fe27c95fa69d11", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c12dc6c887fe27c95fa69d11", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c12dc6c887fe27c95fa69d11", width: 64 }
				],
				name: "Scars (Remixed)",
				release_date: "2018-12-21",
				release_date_precision: "day",
				total_tracks: 21,
				type: "album",
				uri: "spotify:album:1KWL7LvN5Ty009GeAwLCEs"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1yoZuH2j43vVSWsOwYuQyn" },
					href: "https://api.spotify.com/v1/artists/1yoZuH2j43vVSWsOwYuQyn",
					id: "1yoZuH2j43vVSWsOwYuQyn",
					name: "Ilan Bluestone",
					type: "artist",
					uri: "spotify:artist:1yoZuH2j43vVSWsOwYuQyn"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3UCbp6D1lvILlxRJT9LnFa" },
					href: "https://api.spotify.com/v1/artists/3UCbp6D1lvILlxRJT9LnFa",
					id: "3UCbp6D1lvILlxRJT9LnFa",
					name: "Koven",
					type: "artist",
					uri: "spotify:artist:3UCbp6D1lvILlxRJT9LnFa"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 265779,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBEWA1702922" },
			external_urls: { spotify: "https://open.spotify.com/track/14Rt6rnr5xmTFtUoGbZPah" },
			href: "https://api.spotify.com/v1/tracks/14Rt6rnr5xmTFtUoGbZPah",
			id: "14Rt6rnr5xmTFtUoGbZPah",
			is_local: false,
			name: "Another Lover - Koven Remix",
			popularity: 29,
			preview_url: "https://p.scdn.co/mp3-preview/25e93118654d9e7e6cd470fc3957f12324f9e0f7?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 9,
			type: "track",
			uri: "spotify:track:14Rt6rnr5xmTFtUoGbZPah"
		},
		features: {
			danceability: 0.383,
			energy: 0.742,
			key: 10,
			loudness: -7.544,
			mode: 1,
			speechiness: 0.044,
			acousticness: 0.00216,
			instrumentalness: 0.687,
			liveness: 0.102,
			valence: 0.273,
			tempo: 150,
			type: "audio_features",
			id: "14Rt6rnr5xmTFtUoGbZPah",
			uri: "spotify:track:14Rt6rnr5xmTFtUoGbZPah",
			track_href: "https://api.spotify.com/v1/tracks/14Rt6rnr5xmTFtUoGbZPah",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/14Rt6rnr5xmTFtUoGbZPah",
			duration_ms: 265780,
			time_signature: 4,
			doubletime: 150
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5Igpc9iLZ3YGtKeYfSrrOE" },
						href: "https://api.spotify.com/v1/artists/5Igpc9iLZ3YGtKeYfSrrOE",
						id: "5Igpc9iLZ3YGtKeYfSrrOE",
						name: "Chris Lake",
						type: "artist",
						uri: "spotify:artist:5Igpc9iLZ3YGtKeYfSrrOE"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1o8Ne8qNSOE8el1rY5mWWz" },
				href: "https://api.spotify.com/v1/albums/1o8Ne8qNSOE8el1rY5mWWz",
				id: "1o8Ne8qNSOE8el1rY5mWWz",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2736355530a4ff8ccb1f303d541", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e026355530a4ff8ccb1f303d541", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048516355530a4ff8ccb1f303d541", width: 64 }
				],
				name: "Stay With Me",
				release_date: "2019-05-24",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1o8Ne8qNSOE8el1rY5mWWz"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5Igpc9iLZ3YGtKeYfSrrOE" },
					href: "https://api.spotify.com/v1/artists/5Igpc9iLZ3YGtKeYfSrrOE",
					id: "5Igpc9iLZ3YGtKeYfSrrOE",
					name: "Chris Lake",
					type: "artist",
					uri: "spotify:artist:5Igpc9iLZ3YGtKeYfSrrOE"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 224576,
			episode: false,
			explicit: false,
			external_ids: { isrc: "CA5KR1927261" },
			external_urls: { spotify: "https://open.spotify.com/track/0VgtjIiWXKMxqtYnhHmQ8U" },
			href: "https://api.spotify.com/v1/tracks/0VgtjIiWXKMxqtYnhHmQ8U",
			id: "0VgtjIiWXKMxqtYnhHmQ8U",
			is_local: false,
			name: "Stay With Me",
			popularity: 54,
			preview_url: "https://p.scdn.co/mp3-preview/275928464b0a71506de080223c6722401cb127b3?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:0VgtjIiWXKMxqtYnhHmQ8U"
		},
		features: {
			danceability: 0.706,
			energy: 0.846,
			key: 6,
			loudness: -5.475,
			mode: 1,
			speechiness: 0.04,
			acousticness: 0.00653,
			instrumentalness: 0.161,
			liveness: 0.0908,
			valence: 0.241,
			tempo: 124,
			type: "audio_features",
			id: "0VgtjIiWXKMxqtYnhHmQ8U",
			uri: "spotify:track:0VgtjIiWXKMxqtYnhHmQ8U",
			track_href: "https://api.spotify.com/v1/tracks/0VgtjIiWXKMxqtYnhHmQ8U",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0VgtjIiWXKMxqtYnhHmQ8U",
			duration_ms: 224577,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/37PZXblQTqpEWGdjctNcGP" },
						href: "https://api.spotify.com/v1/artists/37PZXblQTqpEWGdjctNcGP",
						id: "37PZXblQTqpEWGdjctNcGP",
						name: "Space Laces",
						type: "artist",
						uri: "spotify:artist:37PZXblQTqpEWGdjctNcGP"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/09hi6jlzQufoBBDooaW32y" },
				href: "https://api.spotify.com/v1/albums/09hi6jlzQufoBBDooaW32y",
				id: "09hi6jlzQufoBBDooaW32y",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2737e2f0e73756ff7179ffc34cc", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e027e2f0e73756ff7179ffc34cc", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048517e2f0e73756ff7179ffc34cc", width: 64 }
				],
				name: "Vaultage 001",
				release_date: "2018-11-20",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:09hi6jlzQufoBBDooaW32y"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/37PZXblQTqpEWGdjctNcGP" },
					href: "https://api.spotify.com/v1/artists/37PZXblQTqpEWGdjctNcGP",
					id: "37PZXblQTqpEWGdjctNcGP",
					name: "Space Laces",
					type: "artist",
					uri: "spotify:artist:37PZXblQTqpEWGdjctNcGP"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 866772,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GB7YL1883801" },
			external_urls: { spotify: "https://open.spotify.com/track/1EJyVXiLX7tB6CEx77Y6JZ" },
			href: "https://api.spotify.com/v1/tracks/1EJyVXiLX7tB6CEx77Y6JZ",
			id: "1EJyVXiLX7tB6CEx77Y6JZ",
			is_local: false,
			name: "Vaultage 001",
			popularity: 34,
			preview_url: "https://p.scdn.co/mp3-preview/443b6aa1226dab3689921724c6a48610d39774a1?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1EJyVXiLX7tB6CEx77Y6JZ"
		},
		features: {
			danceability: 0.407,
			energy: 0.888,
			key: 1,
			loudness: -3.078,
			mode: 1,
			speechiness: 0.333,
			acousticness: 0.00187,
			instrumentalness: 0.104,
			liveness: 0.172,
			valence: 0.293,
			tempo: 124,
			type: "audio_features",
			id: "1EJyVXiLX7tB6CEx77Y6JZ",
			uri: "spotify:track:1EJyVXiLX7tB6CEx77Y6JZ",
			track_href: "https://api.spotify.com/v1/tracks/1EJyVXiLX7tB6CEx77Y6JZ",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1EJyVXiLX7tB6CEx77Y6JZ",
			duration_ms: 866773,
			time_signature: 4,
			doubletime: 124
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/64rxQRJsLgZwHHyWKB8fiF" },
						href: "https://api.spotify.com/v1/artists/64rxQRJsLgZwHHyWKB8fiF",
						id: "64rxQRJsLgZwHHyWKB8fiF",
						name: "Eiffel 65",
						type: "artist",
						uri: "spotify:artist:64rxQRJsLgZwHHyWKB8fiF"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/54vbD17F1t5q3yHkj1cX37" },
				href: "https://api.spotify.com/v1/albums/54vbD17F1t5q3yHkj1cX37",
				id: "54vbD17F1t5q3yHkj1cX37",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2733d11d480688e4df6b5709384", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e023d11d480688e4df6b5709384", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048513d11d480688e4df6b5709384", width: 64 }
				],
				name: "Europop",
				release_date: "2011-01-05",
				release_date_precision: "day",
				total_tracks: 19,
				type: "album",
				uri: "spotify:album:54vbD17F1t5q3yHkj1cX37"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/64rxQRJsLgZwHHyWKB8fiF" },
					href: "https://api.spotify.com/v1/artists/64rxQRJsLgZwHHyWKB8fiF",
					id: "64rxQRJsLgZwHHyWKB8fiF",
					name: "Eiffel 65",
					type: "artist",
					uri: "spotify:artist:64rxQRJsLgZwHHyWKB8fiF"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5ENS85nZShljwNgg4wFD7D" },
					href: "https://api.spotify.com/v1/artists/5ENS85nZShljwNgg4wFD7D",
					id: "5ENS85nZShljwNgg4wFD7D",
					name: "Gabry Ponte",
					type: "artist",
					uri: "spotify:artist:5ENS85nZShljwNgg4wFD7D"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 283747,
			episode: false,
			explicit: false,
			external_ids: { isrc: "ITT019810102" },
			external_urls: { spotify: "https://open.spotify.com/track/2yAVzRiEQooPEJ9SYx11L3" },
			href: "https://api.spotify.com/v1/tracks/2yAVzRiEQooPEJ9SYx11L3",
			id: "2yAVzRiEQooPEJ9SYx11L3",
			is_local: false,
			name: "Blue (Da Ba Dee) - Gabry Ponte Ice Pop Radio",
			popularity: 73,
			preview_url: "https://p.scdn.co/mp3-preview/6ee8cf3fc9a09831eb8538a7d696c89b3efb51d4?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:2yAVzRiEQooPEJ9SYx11L3"
		},
		features: {
			danceability: 0.822,
			energy: 0.969,
			key: 7,
			loudness: -11.471,
			mode: 0,
			speechiness: 0.0582,
			acousticness: 0.259,
			instrumentalness: 0.000162,
			liveness: 0.39,
			valence: 0.765,
			tempo: 128,
			type: "audio_features",
			id: "2yAVzRiEQooPEJ9SYx11L3",
			uri: "spotify:track:2yAVzRiEQooPEJ9SYx11L3",
			track_href: "https://api.spotify.com/v1/tracks/2yAVzRiEQooPEJ9SYx11L3",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2yAVzRiEQooPEJ9SYx11L3",
			duration_ms: 283748,
			time_signature: 4,
			doubletime: 128
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/7jZM5w05mGhw6wTB1okhD9" },
						href: "https://api.spotify.com/v1/artists/7jZM5w05mGhw6wTB1okhD9",
						id: "7jZM5w05mGhw6wTB1okhD9",
						name: "ATB",
						type: "artist",
						uri: "spotify:artist:7jZM5w05mGhw6wTB1okhD9"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"OM",
					"PA",
					"PE",
					"PH",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/4DfD9bqzlfSbEf5kWgufPk" },
				href: "https://api.spotify.com/v1/albums/4DfD9bqzlfSbEf5kWgufPk",
				id: "4DfD9bqzlfSbEf5kWgufPk",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27326971635f39cfc30b37ecf05", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0226971635f39cfc30b37ecf05", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485126971635f39cfc30b37ecf05", width: 64 }
				],
				name: "Movin' Melodies",
				release_date: "1999-04-26",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:4DfD9bqzlfSbEf5kWgufPk"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/7jZM5w05mGhw6wTB1okhD9" },
					href: "https://api.spotify.com/v1/artists/7jZM5w05mGhw6wTB1okhD9",
					id: "7jZM5w05mGhw6wTB1okhD9",
					name: "ATB",
					type: "artist",
					uri: "spotify:artist:7jZM5w05mGhw6wTB1okhD9"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"OM",
				"PA",
				"PE",
				"PH",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 193880,
			episode: false,
			explicit: false,
			external_ids: { isrc: "DEN060301020" },
			external_urls: { spotify: "https://open.spotify.com/track/1CgbwsrNDlFrRuk2ebQ7zr" },
			href: "https://api.spotify.com/v1/tracks/1CgbwsrNDlFrRuk2ebQ7zr",
			id: "1CgbwsrNDlFrRuk2ebQ7zr",
			is_local: false,
			name: "9Pm (Till I Come)",
			popularity: 61,
			preview_url: "https://p.scdn.co/mp3-preview/05d17559491d30d20f5fd017d50ab55ccdbfeda8?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 5,
			type: "track",
			uri: "spotify:track:1CgbwsrNDlFrRuk2ebQ7zr"
		},
		features: {
			danceability: 0.672,
			energy: 0.941,
			key: 9,
			loudness: -6.427,
			mode: 0,
			speechiness: 0.0494,
			acousticness: 0.0276,
			instrumentalness: 0.926,
			liveness: 0.149,
			valence: 0.754,
			tempo: 130,
			type: "audio_features",
			id: "1CgbwsrNDlFrRuk2ebQ7zr",
			uri: "spotify:track:1CgbwsrNDlFrRuk2ebQ7zr",
			track_href: "https://api.spotify.com/v1/tracks/1CgbwsrNDlFrRuk2ebQ7zr",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1CgbwsrNDlFrRuk2ebQ7zr",
			duration_ms: 193880,
			time_signature: 4,
			doubletime: 130
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5mADpqv2E8KIHDmEhH7wmr" },
						href: "https://api.spotify.com/v1/artists/5mADpqv2E8KIHDmEhH7wmr",
						id: "5mADpqv2E8KIHDmEhH7wmr",
						name: "Figure",
						type: "artist",
						uri: "spotify:artist:5mADpqv2E8KIHDmEhH7wmr"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7raxGJzj4moLdSVKuKOsMP" },
				href: "https://api.spotify.com/v1/albums/7raxGJzj4moLdSVKuKOsMP",
				id: "7raxGJzj4moLdSVKuKOsMP",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273e8f44f8e45d30df1eca69046", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02e8f44f8e45d30df1eca69046", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851e8f44f8e45d30df1eca69046", width: 64 }
				],
				name: "Monsters Vol. 4",
				release_date: "2013-10-15",
				release_date_precision: "day",
				total_tracks: 13,
				type: "album",
				uri: "spotify:album:7raxGJzj4moLdSVKuKOsMP"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5mADpqv2E8KIHDmEhH7wmr" },
					href: "https://api.spotify.com/v1/artists/5mADpqv2E8KIHDmEhH7wmr",
					id: "5mADpqv2E8KIHDmEhH7wmr",
					name: "Figure",
					type: "artist",
					uri: "spotify:artist:5mADpqv2E8KIHDmEhH7wmr"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5a6quSHBeFVG3gERVLPtam" },
					href: "https://api.spotify.com/v1/artists/5a6quSHBeFVG3gERVLPtam",
					id: "5a6quSHBeFVG3gERVLPtam",
					name: "Khadfi Dub",
					type: "artist",
					uri: "spotify:artist:5a6quSHBeFVG3gERVLPtam"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 250285,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USA2P1371847" },
			external_urls: { spotify: "https://open.spotify.com/track/1TW1K2OGqva989zNkSxVRI" },
			href: "https://api.spotify.com/v1/tracks/1TW1K2OGqva989zNkSxVRI",
			id: "1TW1K2OGqva989zNkSxVRI",
			is_local: false,
			name: "The Crypt (feat. Khadfi Dub) - Original Mix",
			popularity: 26,
			preview_url: "https://p.scdn.co/mp3-preview/2ee24907e0791c01de32206023aca679a1ad5277?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 2,
			type: "track",
			uri: "spotify:track:1TW1K2OGqva989zNkSxVRI"
		},
		features: {
			danceability: 0.537,
			energy: 0.998,
			key: 1,
			loudness: -2.061,
			mode: 1,
			speechiness: 0.11,
			acousticness: 0.0000918,
			instrumentalness: 0.138,
			liveness: 0.296,
			valence: 0.125,
			tempo: 140,
			type: "audio_features",
			id: "1TW1K2OGqva989zNkSxVRI",
			uri: "spotify:track:1TW1K2OGqva989zNkSxVRI",
			track_href: "https://api.spotify.com/v1/tracks/1TW1K2OGqva989zNkSxVRI",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1TW1K2OGqva989zNkSxVRI",
			duration_ms: 250286,
			time_signature: 4,
			doubletime: 140
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1cXYBodyKDRnjYZ4IBkoDc" },
						href: "https://api.spotify.com/v1/artists/1cXYBodyKDRnjYZ4IBkoDc",
						id: "1cXYBodyKDRnjYZ4IBkoDc",
						name: "Beat Crusher",
						type: "artist",
						uri: "spotify:artist:1cXYBodyKDRnjYZ4IBkoDc"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/1V15nf9ACvIygrnCe0b4Cj" },
						href: "https://api.spotify.com/v1/artists/1V15nf9ACvIygrnCe0b4Cj",
						id: "1V15nf9ACvIygrnCe0b4Cj",
						name: "DJ Tiger",
						type: "artist",
						uri: "spotify:artist:1V15nf9ACvIygrnCe0b4Cj"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/5AqSqa9H3BuKMcJNfgh32I" },
				href: "https://api.spotify.com/v1/albums/5AqSqa9H3BuKMcJNfgh32I",
				id: "5AqSqa9H3BuKMcJNfgh32I",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273a6a7fbb330a0126c35341419", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02a6a7fbb330a0126c35341419", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851a6a7fbb330a0126c35341419", width: 64 }
				],
				name: "Black Pearl",
				release_date: "2018-10-01",
				release_date_precision: "day",
				total_tracks: 2,
				type: "album",
				uri: "spotify:album:5AqSqa9H3BuKMcJNfgh32I"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1cXYBodyKDRnjYZ4IBkoDc" },
					href: "https://api.spotify.com/v1/artists/1cXYBodyKDRnjYZ4IBkoDc",
					id: "1cXYBodyKDRnjYZ4IBkoDc",
					name: "Beat Crusher",
					type: "artist",
					uri: "spotify:artist:1cXYBodyKDRnjYZ4IBkoDc"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/1V15nf9ACvIygrnCe0b4Cj" },
					href: "https://api.spotify.com/v1/artists/1V15nf9ACvIygrnCe0b4Cj",
					id: "1V15nf9ACvIygrnCe0b4Cj",
					name: "DJ Tiger",
					type: "artist",
					uri: "spotify:artist:1V15nf9ACvIygrnCe0b4Cj"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 478037,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBKQU1850646" },
			external_urls: { spotify: "https://open.spotify.com/track/3IT8ymEvRhgaBxtChL2O7z" },
			href: "https://api.spotify.com/v1/tracks/3IT8ymEvRhgaBxtChL2O7z",
			id: "3IT8ymEvRhgaBxtChL2O7z",
			is_local: false,
			name: "Black Pearl",
			popularity: 0,
			preview_url: "https://p.scdn.co/mp3-preview/0d901ce728f47a59dab54a5f0841f791bfc0cac0?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:3IT8ymEvRhgaBxtChL2O7z"
		},
		features: {
			danceability: 0.794,
			energy: 0.712,
			key: 2,
			loudness: -9.115,
			mode: 1,
			speechiness: 0.0358,
			acousticness: 0.0239,
			instrumentalness: 0.305,
			liveness: 0.181,
			valence: 0.0392,
			tempo: 121,
			type: "audio_features",
			id: "3IT8ymEvRhgaBxtChL2O7z",
			uri: "spotify:track:3IT8ymEvRhgaBxtChL2O7z",
			track_href: "https://api.spotify.com/v1/tracks/3IT8ymEvRhgaBxtChL2O7z",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/3IT8ymEvRhgaBxtChL2O7z",
			duration_ms: 478037,
			time_signature: 4,
			doubletime: 121
		}
	},
	{
		track: {
			album: {
				album_type: "single",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/053q0ukIDRgzwTr4vNSwab" },
						href: "https://api.spotify.com/v1/artists/053q0ukIDRgzwTr4vNSwab",
						id: "053q0ukIDRgzwTr4vNSwab",
						name: "Grimes",
						type: "artist",
						uri: "spotify:artist:053q0ukIDRgzwTr4vNSwab"
					},
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0y42IQBDFigO5mmEd1bGQG" },
						href: "https://api.spotify.com/v1/artists/0y42IQBDFigO5mmEd1bGQG",
						id: "0y42IQBDFigO5mmEd1bGQG",
						name: "i_o",
						type: "artist",
						uri: "spotify:artist:0y42IQBDFigO5mmEd1bGQG"
					}
				],
				available_markets: [],
				external_urls: { spotify: "https://open.spotify.com/album/1BUgR3IIl0oNNhr7oWlN21" },
				href: "https://api.spotify.com/v1/albums/1BUgR3IIl0oNNhr7oWlN21",
				id: "1BUgR3IIl0oNNhr7oWlN21",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273c6469e1f945a7fad9da8bdba", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02c6469e1f945a7fad9da8bdba", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851c6469e1f945a7fad9da8bdba", width: 64 }
				],
				name: "Violence",
				release_date: "2019-09-05",
				release_date_precision: "day",
				total_tracks: 1,
				type: "album",
				uri: "spotify:album:1BUgR3IIl0oNNhr7oWlN21"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/053q0ukIDRgzwTr4vNSwab" },
					href: "https://api.spotify.com/v1/artists/053q0ukIDRgzwTr4vNSwab",
					id: "053q0ukIDRgzwTr4vNSwab",
					name: "Grimes",
					type: "artist",
					uri: "spotify:artist:053q0ukIDRgzwTr4vNSwab"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0y42IQBDFigO5mmEd1bGQG" },
					href: "https://api.spotify.com/v1/artists/0y42IQBDFigO5mmEd1bGQG",
					id: "0y42IQBDFigO5mmEd1bGQG",
					name: "i_o",
					type: "artist",
					uri: "spotify:artist:0y42IQBDFigO5mmEd1bGQG"
				}
			],
			available_markets: [],
			disc_number: 1,
			duration_ms: 220800,
			episode: false,
			explicit: false,
			external_ids: { isrc: "GBAFL1900329" },
			external_urls: { spotify: "https://open.spotify.com/track/1AL43xNYEG5KSoqf9Yd6Cr" },
			href: "https://api.spotify.com/v1/tracks/1AL43xNYEG5KSoqf9Yd6Cr",
			id: "1AL43xNYEG5KSoqf9Yd6Cr",
			is_local: false,
			name: "Violence",
			popularity: 29,
			preview_url: null,
			track: true,
			track_number: 1,
			type: "track",
			uri: "spotify:track:1AL43xNYEG5KSoqf9Yd6Cr"
		},
		features: {
			danceability: 0.499,
			energy: 0.914,
			key: 5,
			loudness: -4.252,
			mode: 0,
			speechiness: 0.0511,
			acousticness: 0.000621,
			instrumentalness: 0.529,
			liveness: 0.117,
			valence: 0.0789,
			tempo: 100,
			type: "audio_features",
			id: "1AL43xNYEG5KSoqf9Yd6Cr",
			uri: "spotify:track:1AL43xNYEG5KSoqf9Yd6Cr",
			track_href: "https://api.spotify.com/v1/tracks/1AL43xNYEG5KSoqf9Yd6Cr",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1AL43xNYEG5KSoqf9Yd6Cr",
			duration_ms: 220800,
			time_signature: 4,
			doubletime: 100
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0uOUEsjCUSv2YvZmZtmBsX" },
						href: "https://api.spotify.com/v1/artists/0uOUEsjCUSv2YvZmZtmBsX",
						id: "0uOUEsjCUSv2YvZmZtmBsX",
						name: "Psymbionic",
						type: "artist",
						uri: "spotify:artist:0uOUEsjCUSv2YvZmZtmBsX"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1Sld9NCi8ARLdCnyUM4g6o" },
				href: "https://api.spotify.com/v1/albums/1Sld9NCi8ARLdCnyUM4g6o",
				id: "1Sld9NCi8ARLdCnyUM4g6o",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b27324be3555331912eb0951d44e", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e0224be3555331912eb0951d44e", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d0000485124be3555331912eb0951d44e", width: 64 }
				],
				name: "Parallels Remixed",
				release_date: "2014-12-09",
				release_date_precision: "day",
				total_tracks: 12,
				type: "album",
				uri: "spotify:album:1Sld9NCi8ARLdCnyUM4g6o"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0uOUEsjCUSv2YvZmZtmBsX" },
					href: "https://api.spotify.com/v1/artists/0uOUEsjCUSv2YvZmZtmBsX",
					id: "0uOUEsjCUSv2YvZmZtmBsX",
					name: "Psymbionic",
					type: "artist",
					uri: "spotify:artist:0uOUEsjCUSv2YvZmZtmBsX"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/4WoeMzXhDQyoFCKdji4FlL" },
					href: "https://api.spotify.com/v1/artists/4WoeMzXhDQyoFCKdji4FlL",
					id: "4WoeMzXhDQyoFCKdji4FlL",
					name: "Amp Live",
					type: "artist",
					uri: "spotify:artist:4WoeMzXhDQyoFCKdji4FlL"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5BKXCIdVnAwBQKUoGNqfZj" },
					href: "https://api.spotify.com/v1/artists/5BKXCIdVnAwBQKUoGNqfZj",
					id: "5BKXCIdVnAwBQKUoGNqfZj",
					name: "Cristina Soto",
					type: "artist",
					uri: "spotify:artist:5BKXCIdVnAwBQKUoGNqfZj"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 261401,
			episode: false,
			explicit: false,
			external_ids: { isrc: "USLZJ1466416" },
			external_urls: { spotify: "https://open.spotify.com/track/1nj3fP1BRNJWfWZOFZ56nu" },
			href: "https://api.spotify.com/v1/tracks/1nj3fP1BRNJWfWZOFZ56nu",
			id: "1nj3fP1BRNJWfWZOFZ56nu",
			is_local: false,
			name: "One Thing (feat. Cristina Soto) - Amp Live Remix",
			popularity: 48,
			preview_url: "https://p.scdn.co/mp3-preview/61875b88156c13227b279763a0c384380be753f5?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:1nj3fP1BRNJWfWZOFZ56nu"
		},
		features: {
			danceability: 0.548,
			energy: 0.731,
			key: 8,
			loudness: -6.287,
			mode: 0,
			speechiness: 0.0334,
			acousticness: 0.0000947,
			instrumentalness: 0.0118,
			liveness: 0.361,
			valence: 0.484,
			tempo: 157,
			type: "audio_features",
			id: "1nj3fP1BRNJWfWZOFZ56nu",
			uri: "spotify:track:1nj3fP1BRNJWfWZOFZ56nu",
			track_href: "https://api.spotify.com/v1/tracks/1nj3fP1BRNJWfWZOFZ56nu",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/1nj3fP1BRNJWfWZOFZ56nu",
			duration_ms: 261401,
			time_signature: 4,
			doubletime: 157
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/54EYfCxN1dGJKec029vO7S" },
						href: "https://api.spotify.com/v1/artists/54EYfCxN1dGJKec029vO7S",
						id: "54EYfCxN1dGJKec029vO7S",
						name: "Nicholas Gunn",
						type: "artist",
						uri: "spotify:artist:54EYfCxN1dGJKec029vO7S"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/7LZMIeuQrRMtlqtNDRNlnu" },
				href: "https://api.spotify.com/v1/albums/7LZMIeuQrRMtlqtNDRNlnu",
				id: "7LZMIeuQrRMtlqtNDRNlnu",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b2738cf5551f97954a782a3e5bb3", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e028cf5551f97954a782a3e5bb3", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d000048518cf5551f97954a782a3e5bb3", width: 64 }
				],
				name: "Riding the Thermals (Deluxe Edition)",
				release_date: "2019-08-23",
				release_date_precision: "day",
				total_tracks: 17,
				type: "album",
				uri: "spotify:album:7LZMIeuQrRMtlqtNDRNlnu"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/54EYfCxN1dGJKec029vO7S" },
					href: "https://api.spotify.com/v1/artists/54EYfCxN1dGJKec029vO7S",
					id: "54EYfCxN1dGJKec029vO7S",
					name: "Nicholas Gunn",
					type: "artist",
					uri: "spotify:artist:54EYfCxN1dGJKec029vO7S"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0ijMivCSLUlNYGIhqFXIEZ" },
					href: "https://api.spotify.com/v1/artists/0ijMivCSLUlNYGIhqFXIEZ",
					id: "0ijMivCSLUlNYGIhqFXIEZ",
					name: "Alina Renae",
					type: "artist",
					uri: "spotify:artist:0ijMivCSLUlNYGIhqFXIEZ"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/3pHzhNMn89uU2Sux4KW1qN" },
					href: "https://api.spotify.com/v1/artists/3pHzhNMn89uU2Sux4KW1qN",
					id: "3pHzhNMn89uU2Sux4KW1qN",
					name: "Kaimo K",
					type: "artist",
					uri: "spotify:artist:3pHzhNMn89uU2Sux4KW1qN"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 229565,
			episode: false,
			explicit: false,
			external_ids: { isrc: "NLC731900269" },
			external_urls: { spotify: "https://open.spotify.com/track/0gRpjoYvLy7rmHD21DFDOH" },
			href: "https://api.spotify.com/v1/tracks/0gRpjoYvLy7rmHD21DFDOH",
			id: "0gRpjoYvLy7rmHD21DFDOH",
			is_local: false,
			name: "I'll Always (feat. Alina Renae) - Kaimo K Remix",
			popularity: 4,
			preview_url: "https://p.scdn.co/mp3-preview/29c4592115a362b113b829d8084da41600d8f8ea?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 15,
			type: "track",
			uri: "spotify:track:0gRpjoYvLy7rmHD21DFDOH"
		},
		features: {
			danceability: 0.452,
			energy: 0.938,
			key: 9,
			loudness: -6.328,
			mode: 0,
			speechiness: 0.114,
			acousticness: 0.14,
			instrumentalness: 0.468,
			liveness: 0.361,
			valence: 0.178,
			tempo: 138,
			type: "audio_features",
			id: "0gRpjoYvLy7rmHD21DFDOH",
			uri: "spotify:track:0gRpjoYvLy7rmHD21DFDOH",
			track_href: "https://api.spotify.com/v1/tracks/0gRpjoYvLy7rmHD21DFDOH",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/0gRpjoYvLy7rmHD21DFDOH",
			duration_ms: 229565,
			time_signature: 4,
			doubletime: 138
		}
	},
	{
		track: {
			album: {
				album_type: "compilation",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of" },
						href: "https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of",
						id: "0LyfQWJT6nXafLPZqxe9Of",
						name: "Various Artists",
						type: "artist",
						uri: "spotify:artist:0LyfQWJT6nXafLPZqxe9Of"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/3qfy1fiQWdax8bW10h0qz2" },
				href: "https://api.spotify.com/v1/albums/3qfy1fiQWdax8bW10h0qz2",
				id: "3qfy1fiQWdax8bW10h0qz2",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273de1d8e472c6fd254b9546256", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02de1d8e472c6fd254b9546256", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851de1d8e472c6fd254b9546256", width: 64 }
				],
				name: "You Never Know",
				release_date: "2013-08-20",
				release_date_precision: "day",
				total_tracks: 9,
				type: "album",
				uri: "spotify:album:3qfy1fiQWdax8bW10h0qz2"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/0lX8r8LhCNAS5u40ykQlwv" },
					href: "https://api.spotify.com/v1/artists/0lX8r8LhCNAS5u40ykQlwv",
					id: "0lX8r8LhCNAS5u40ykQlwv",
					name: "Beatgrinder",
					type: "artist",
					uri: "spotify:artist:0lX8r8LhCNAS5u40ykQlwv"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 314418,
			episode: false,
			explicit: false,
			external_ids: { isrc: "UK2721300015" },
			external_urls: { spotify: "https://open.spotify.com/track/2v4JiGY9JFwbUgUgnQFQl0" },
			href: "https://api.spotify.com/v1/tracks/2v4JiGY9JFwbUgUgnQFQl0",
			id: "2v4JiGY9JFwbUgUgnQFQl0",
			is_local: false,
			name: "Deisel - Original Mix",
			popularity: 0,
			preview_url: "https://p.scdn.co/mp3-preview/fdcb31d03c7204ccd191b035a584943cea2858c2?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 4,
			type: "track",
			uri: "spotify:track:2v4JiGY9JFwbUgUgnQFQl0"
		},
		features: {
			danceability: 0.797,
			energy: 0.892,
			key: 6,
			loudness: -5.167,
			mode: 0,
			speechiness: 0.131,
			acousticness: 0.0129,
			instrumentalness: 0.784,
			liveness: 0.244,
			valence: 0.505,
			tempo: 129,
			type: "audio_features",
			id: "2v4JiGY9JFwbUgUgnQFQl0",
			uri: "spotify:track:2v4JiGY9JFwbUgUgnQFQl0",
			track_href: "https://api.spotify.com/v1/tracks/2v4JiGY9JFwbUgUgnQFQl0",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2v4JiGY9JFwbUgUgnQFQl0",
			duration_ms: 314419,
			time_signature: 4,
			doubletime: 129
		}
	},
	{
		track: {
			album: {
				album_type: "album",
				artists: [
					{
						external_urls: { spotify: "https://open.spotify.com/artist/5mADpqv2E8KIHDmEhH7wmr" },
						href: "https://api.spotify.com/v1/artists/5mADpqv2E8KIHDmEhH7wmr",
						id: "5mADpqv2E8KIHDmEhH7wmr",
						name: "Figure",
						type: "artist",
						uri: "spotify:artist:5mADpqv2E8KIHDmEhH7wmr"
					}
				],
				available_markets: [
					"AD",
					"AE",
					"AR",
					"AT",
					"AU",
					"BE",
					"BG",
					"BH",
					"BO",
					"BR",
					"CA",
					"CH",
					"CL",
					"CO",
					"CR",
					"CY",
					"CZ",
					"DE",
					"DK",
					"DO",
					"DZ",
					"EC",
					"EE",
					"EG",
					"ES",
					"FI",
					"FR",
					"GB",
					"GR",
					"GT",
					"HK",
					"HN",
					"HU",
					"ID",
					"IE",
					"IL",
					"IN",
					"IS",
					"IT",
					"JO",
					"JP",
					"KW",
					"LB",
					"LI",
					"LT",
					"LU",
					"LV",
					"MA",
					"MC",
					"MT",
					"MX",
					"MY",
					"NI",
					"NL",
					"NO",
					"NZ",
					"OM",
					"PA",
					"PE",
					"PH",
					"PL",
					"PS",
					"PT",
					"PY",
					"QA",
					"RO",
					"SA",
					"SE",
					"SG",
					"SK",
					"SV",
					"TH",
					"TN",
					"TR",
					"TW",
					"US",
					"UY",
					"VN",
					"ZA"
				],
				external_urls: { spotify: "https://open.spotify.com/album/1meoeDK3eTx1pyZVCKPydy" },
				href: "https://api.spotify.com/v1/albums/1meoeDK3eTx1pyZVCKPydy",
				id: "1meoeDK3eTx1pyZVCKPydy",
				images: [
					{ height: 640, url: "https://i.scdn.co/image/ab67616d0000b273452bc3484facb159ddc5c476", width: 640 },
					{ height: 300, url: "https://i.scdn.co/image/ab67616d00001e02452bc3484facb159ddc5c476", width: 300 },
					{ height: 64, url: "https://i.scdn.co/image/ab67616d00004851452bc3484facb159ddc5c476", width: 64 }
				],
				name: "Monsters 8",
				release_date: "2017-10-13",
				release_date_precision: "day",
				total_tracks: 11,
				type: "album",
				uri: "spotify:album:1meoeDK3eTx1pyZVCKPydy"
			},
			artists: [
				{
					external_urls: { spotify: "https://open.spotify.com/artist/5mADpqv2E8KIHDmEhH7wmr" },
					href: "https://api.spotify.com/v1/artists/5mADpqv2E8KIHDmEhH7wmr",
					id: "5mADpqv2E8KIHDmEhH7wmr",
					name: "Figure",
					type: "artist",
					uri: "spotify:artist:5mADpqv2E8KIHDmEhH7wmr"
				},
				{
					external_urls: { spotify: "https://open.spotify.com/artist/2L30u4C0XjzkJgLvhKQn0L" },
					href: "https://api.spotify.com/v1/artists/2L30u4C0XjzkJgLvhKQn0L",
					id: "2L30u4C0XjzkJgLvhKQn0L",
					name: "Hatch",
					type: "artist",
					uri: "spotify:artist:2L30u4C0XjzkJgLvhKQn0L"
				}
			],
			available_markets: [
				"AD",
				"AE",
				"AR",
				"AT",
				"AU",
				"BE",
				"BG",
				"BH",
				"BO",
				"BR",
				"CA",
				"CH",
				"CL",
				"CO",
				"CR",
				"CY",
				"CZ",
				"DE",
				"DK",
				"DO",
				"DZ",
				"EC",
				"EE",
				"EG",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"GT",
				"HK",
				"HN",
				"HU",
				"ID",
				"IE",
				"IL",
				"IN",
				"IS",
				"IT",
				"JO",
				"JP",
				"KW",
				"LB",
				"LI",
				"LT",
				"LU",
				"LV",
				"MA",
				"MC",
				"MT",
				"MX",
				"MY",
				"NI",
				"NL",
				"NO",
				"NZ",
				"OM",
				"PA",
				"PE",
				"PH",
				"PL",
				"PS",
				"PT",
				"PY",
				"QA",
				"RO",
				"SA",
				"SE",
				"SG",
				"SK",
				"SV",
				"TH",
				"TN",
				"TR",
				"TW",
				"US",
				"UY",
				"VN",
				"ZA"
			],
			disc_number: 1,
			duration_ms: 307200,
			episode: false,
			explicit: true,
			external_ids: { isrc: "USQY51772095" },
			external_urls: { spotify: "https://open.spotify.com/track/2nfxTnusLJzEh9l9g67ovc" },
			href: "https://api.spotify.com/v1/tracks/2nfxTnusLJzEh9l9g67ovc",
			id: "2nfxTnusLJzEh9l9g67ovc",
			is_local: false,
			name: "The Twilight Zone",
			popularity: 20,
			preview_url: "https://p.scdn.co/mp3-preview/a0b1b8d3bb8a3fd6a8dee808005b0a2264c62231?cid=dd71362980ad40bb9820af4e02f5c39e",
			track: true,
			track_number: 7,
			type: "track",
			uri: "spotify:track:2nfxTnusLJzEh9l9g67ovc"
		},
		features: {
			danceability: 0.561,
			energy: 0.977,
			key: 8,
			loudness: -3.529,
			mode: 1,
			speechiness: 0.141,
			acousticness: 0.00259,
			instrumentalness: 0.0641,
			liveness: 0.284,
			valence: 0.184,
			tempo: 150,
			type: "audio_features",
			id: "2nfxTnusLJzEh9l9g67ovc",
			uri: "spotify:track:2nfxTnusLJzEh9l9g67ovc",
			track_href: "https://api.spotify.com/v1/tracks/2nfxTnusLJzEh9l9g67ovc",
			analysis_url: "https://api.spotify.com/v1/audio-analysis/2nfxTnusLJzEh9l9g67ovc",
			duration_ms: 307200,
			time_signature: 4,
			doubletime: 150
		}
	}
];
export default features;
